import { ref as q, getCurrentScope as y7, onScopeDispose as V7, watch as h5, computed as $, toValue as e5, shallowRef as A7, getCurrentInstance as F1, onMounted as y1, unref as V, defineComponent as R, mergeModels as l5, useModel as d5, onBeforeUnmount as P1, createBlock as L, openBlock as f, resolveDynamicComponent as V5, withCtx as w, renderSlot as p, createVNode as W, Transition as J5, createElementBlock as M, createCommentVNode as C, withKeys as Il, normalizeClass as J, normalizeStyle as m5, h as u1, Fragment as o5, createTextVNode as P, toDisplayString as O, mergeProps as Q, createElementVNode as A, withModifiers as K5, Teleport as ql, renderList as c5, createSlots as r5, nextTick as _5, useTemplateRef as x1, useSlots as Fl, withDirectives as Y5, vModelText as $7, vModelCheckbox as C7, readonly as Z1, normalizeProps as C5, guardReactiveProps as H5, isRef as D1, hasInjectionContext as Pl, inject as H7, watchEffect as Zl, onDeactivated as Ul, onActivated as jl, shallowReadonly as o1, vModelRadio as z7, vShow as Gl, render as pe, createApp as Wl, toRaw as Kl, resolveComponent as h1, toHandlers as Xl, TransitionGroup as Jl } from "vue";
function k7(l) {
  return l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const Yl = (l) => l.charAt(0).toUpperCase() + l.slice(1), m1 = (l) => l.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), ""), Ql = (l, e) => [...l.matchAll(new RegExp(k7(e), "gi"))].length > 0, p1 = (l, e) => Ql(l, e), He = (l, e) => e ? l.filter(
  (t) => p1(m1(t.label || ""), e) || p1(m1(t.detail || ""), e) || p1(t.label || "", e) || p1(t.detail || "", e)
) : l, et = (l, e) => {
  const t = m1(e);
  return l.find((n) => n.value === t);
};
function he(l) {
  return `${l}px`;
}
function ze(l) {
  const e = q();
  function t(n) {
    const { width: o } = n.getBoundingClientRect();
    e.value = {
      [`--${l}--dropdown-width`]: he(o)
    };
  }
  return {
    dropdownContentStyle: e,
    updateDropdownContentStyle: t
  };
}
function B7(l) {
  return y7() ? (V7(l), !0) : !1;
}
const lt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const tt = Object.prototype.toString, at = (l) => tt.call(l) === "[object Object]";
function r0(l) {
  return Array.isArray(l) ? l : [l];
}
function nt(l, e, t) {
  return h5(
    l,
    e,
    {
      ...t,
      immediate: !0
    }
  );
}
const L7 = lt ? window : void 0;
function me(l) {
  var e;
  const t = e5(l);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function Je(...l) {
  const e = [], t = () => {
    e.forEach((c) => c()), e.length = 0;
  }, n = (c, u, v, h) => (c.addEventListener(u, v, h), () => c.removeEventListener(u, v, h)), o = $(() => {
    const c = r0(e5(l[0])).filter((u) => u != null);
    return c.every((u) => typeof u != "string") ? c : void 0;
  }), r = nt(
    () => {
      var c, u;
      return [
        (u = (c = o.value) == null ? void 0 : c.map((v) => me(v))) != null ? u : [L7].filter((v) => v != null),
        r0(e5(o.value ? l[1] : l[0])),
        r0(V(o.value ? l[2] : l[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        e5(o.value ? l[3] : l[2])
      ];
    },
    ([c, u, v, h]) => {
      if (t(), !(c != null && c.length) || !(u != null && u.length) || !(v != null && v.length))
        return;
      const m = at(h) ? { ...h } : h;
      e.push(
        ...c.flatMap(
          (b) => u.flatMap(
            (g) => v.map((y) => n(b, g, y, m))
          )
        )
      );
    },
    { flush: "post" }
  ), s = () => {
    r(), t();
  };
  return B7(t), s;
}
function ot() {
  const l = A7(!1), e = F1();
  return e && y1(() => {
    l.value = !0;
  }, e), l;
}
function rt(l) {
  const e = ot();
  return $(() => (e.value, !!l()));
}
function V1(l, e, t = {}) {
  const { window: n = L7, ...o } = t;
  let r;
  const s = rt(() => n && "ResizeObserver" in n), c = () => {
    r && (r.disconnect(), r = void 0);
  }, u = $(() => {
    const m = e5(l);
    return Array.isArray(m) ? m.map((b) => me(b)) : [me(m)];
  }), v = h5(
    u,
    (m) => {
      if (c(), s.value && n) {
        r = new ResizeObserver(e);
        for (const b of m)
          b && r.observe(b, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), h = () => {
    c(), v();
  };
  return B7(h), {
    isSupported: s,
    stop: h
  };
}
const ke = /* @__PURE__ */ R({
  __name: "TotemDropdown",
  props: /* @__PURE__ */ l5({
    tag: { default: "div" },
    position: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["expand", "collapse", "requestTargetRender"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, n = d5(l, "modelValue"), o = q(), r = q(), s = q(), c = () => {
      n.value = !n.value;
    }, u = () => {
      c();
    }, v = () => {
      o.value && l.position;
    }, h = () => {
      o.value && (t("requestTargetRender", o.value), v());
    }, m = {}, b = (D) => {
      var B, k;
      if (!D.target)
        throw new Error("Target de l'évènement introuvable.");
      const F = D.target;
      !((B = r.value) != null && B.contains(F)) && !((k = o.value) != null && k.contains(F)) && c();
    }, g = () => {
      setTimeout(() => {
        if (!m.bodyClick) {
          const D = Je(document.body, ["click", "touchestart"], b);
          m.bodyClick = { stop: D };
        }
      }, 0);
    }, y = () => {
      var D;
      (D = m.bodyClick) == null || D.stop(), m.bodyClick = void 0;
    }, z = () => {
      if (!m.triggerResize) {
        const { stop: D } = V1(o, h);
        m.triggerResize = { stop: D };
      }
    }, _ = () => {
      var D;
      (D = m.triggerResize) == null || D.stop(), m.triggerResize = void 0;
    }, H = () => {
      if (!m.windowResize) {
        const D = Je("resize", h, { passive: !0 });
        m.windowResize = { stop: D };
      }
    }, E = () => {
      var D;
      (D = m.windowResize) == null || D.stop(), m.windowResize = void 0;
    };
    function x() {
      const D = r.value, F = o.value;
      if (!D || !F)
        return !1;
      const B = D.getBoundingClientRect(), k = F.getBoundingClientRect();
      return window.innerHeight - k.bottom < B.height;
    }
    return h5(n, async (D) => {
      D ? (t("expand"), g(), z(), H()) : (t("collapse"), y(), _(), E());
    }), P1(() => {
      y(), _(), E();
    }), (D, F) => (f(), L(V5(D.tag), {
      ref_key: "triggerElement",
      ref: o,
      class: "totem-dropdown"
    }, {
      default: w(() => [
        p(D.$slots, "trigger", {
          toggle: c,
          isExpanded: n.value
        }, () => [
          p(D.$slots, "default", {
            toggle: c,
            isExpanded: n.value
          })
        ]),
        W(J5, { name: "totem-dropdown__target-" }, {
          default: w(() => [
            n.value ? (f(), M("div", {
              key: 0,
              ref_key: "targetElement",
              ref: r,
              style: m5(s.value),
              class: J(["totem-dropdown__target", {
                "totem-dropdown__target--above": x()
              }]),
              onKeyup: Il(u, ["esc"])
            }, [
              p(D.$slots, "target", {
                toggle: c,
                isExpanded: n.value,
                triggerEl: D.$el
              })
            ], 38)) : C("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 512));
  }
}), st = (l) => l !== void 0, A1 = (l, e) => {
  const t = l.__vccOpts || l;
  for (const [n, o] of e)
    t[n] = o;
  return t;
}, it = {}, dt = { class: "totem-highlight-mark" };
function ut(l, e) {
  return f(), M("mark", dt, [
    p(l.$slots, "default")
  ]);
}
const ct = /* @__PURE__ */ A1(it, [["render", ut]]), Ye = /* @__PURE__ */ R({
  __name: "TotemHighlightText",
  props: {
    content: {},
    search: {},
    tag: { default: "div" }
  },
  setup(l) {
    function e(s, c) {
      if (s.length === 0)
        throw new TypeError("Invalid search");
      return [...c.matchAll(new RegExp(k7(s), "gi"))].map(({ index: h }) => h).filter(st);
    }
    function t(s, c, u) {
      const v = [];
      if (!c || !u || s.length === 0)
        v.push({ text: u ?? "", match: !1 });
      else {
        const h = u.slice(0, s[0]);
        h && v.push({ text: h, match: !1 }), s.forEach((m, b) => {
          const g = m + c.length;
          v.push({ text: u.slice(m, g), match: !0 }), v.push({ text: u.slice(g, s[b + 1]), match: !1 });
        });
      }
      return v;
    }
    const n = $(() => l.content ? m1(l.content) : void 0), o = $(() => l.search ? m1(l.search) : void 0), r = R(() => () => {
      const s = o.value && n.value ? e(o.value, n.value) : [], u = t(s, l.search, l.content).map(({ match: v, text: h }) => v ? u1(ct, {}, () => h) : h);
      return u1(l.tag, u);
    });
    return (s, c) => (f(), L(V(r), { class: "totem-highlight-text" }));
  }
});
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const fe = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, vt = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], pt = () => {
}, ht = (l) => l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && // uppercase letter
(l.charCodeAt(2) > 122 || l.charCodeAt(2) < 97), U1 = Object.assign, x5 = Array.isArray, Q5 = (l) => typeof l == "function", q5 = (l) => typeof l == "string", mt = (l) => typeof l == "symbol", U5 = (l) => l !== null && typeof l == "object";
let Qe;
const j1 = () => Qe || (Qe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Be(l) {
  if (x5(l)) {
    const e = {};
    for (let t = 0; t < l.length; t++) {
      const n = l[t], o = q5(n) ? bt(n) : Be(n);
      if (o)
        for (const r in o)
          e[r] = o[r];
    }
    return e;
  } else if (q5(l) || U5(l))
    return l;
}
const ft = /;(?![^(]*\))/g, gt = /:([^]+)/, wt = /\/\*[^]*?\*\//g;
function bt(l) {
  const e = {};
  return l.replace(wt, "").split(ft).forEach((t) => {
    if (t) {
      const n = t.split(gt);
      n.length > 1 && (e[n[0].trim()] = n[1].trim());
    }
  }), e;
}
function Le(l) {
  let e = "";
  if (q5(l))
    e = l;
  else if (x5(l))
    for (let t = 0; t < l.length; t++) {
      const n = Le(l[t]);
      n && (e += n + " ");
    }
  else if (U5(l))
    for (const t in l)
      l[t] && (e += t + " ");
  return e.trim();
}
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((l) => l !== "arguments" && l !== "caller").map((l) => Symbol[l]).filter(mt)
);
function _7(l) {
  return ge(l) ? _7(l.__v_raw) : !!(l && l.__v_isReactive);
}
function ge(l) {
  return !!(l && l.__v_isReadonly);
}
function s0(l) {
  return !!(l && l.__v_isShallow);
}
function we(l) {
  return l ? !!l.__v_raw : !1;
}
function j5(l) {
  const e = l && l.__v_raw;
  return e ? j5(e) : l;
}
function _e(l) {
  return l ? l.__v_isRef === !0 : !1;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const G5 = [];
function Mt(l) {
  G5.push(l);
}
function yt() {
  G5.pop();
}
let i0 = !1;
function f1(l, ...e) {
  if (i0) return;
  i0 = !0;
  const t = G5.length ? G5[G5.length - 1].component : null, n = t && t.appContext.config.warnHandler, o = Vt();
  if (n)
    Te(
      n,
      t,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        l + e.map((r) => {
          var s, c;
          return (c = (s = r.toString) == null ? void 0 : s.call(r)) != null ? c : JSON.stringify(r);
        }).join(""),
        t && t.proxy,
        o.map(
          ({ vnode: r }) => `at <${j7(t, r.type)}>`
        ).join(`
`),
        o
      ]
    );
  else {
    const r = [`[Vue warn]: ${l}`, ...e];
    o.length && r.push(`
`, ...At(o)), console.warn(...r);
  }
  i0 = !1;
}
function Vt() {
  let l = G5[G5.length - 1];
  if (!l)
    return [];
  const e = [];
  for (; l; ) {
    const t = e[0];
    t && t.vnode === l ? t.recurseCount++ : e.push({
      vnode: l,
      recurseCount: 0
    });
    const n = l.component && l.component.parent;
    l = n && n.vnode;
  }
  return e;
}
function At(l) {
  const e = [];
  return l.forEach((t, n) => {
    e.push(...n === 0 ? [] : [`
`], ...$t(t));
  }), e;
}
function $t({ vnode: l, recurseCount: e }) {
  const t = e > 0 ? `... (${e} recursive calls)` : "", n = l.component ? l.component.parent == null : !1, o = ` at <${j7(
    l.component,
    l.type,
    n
  )}`, r = ">" + t;
  return l.props ? [o, ...Ct(l.props), r] : [o + r];
}
function Ct(l) {
  const e = [], t = Object.keys(l);
  return t.slice(0, 3).forEach((n) => {
    e.push(...T7(n, l[n]));
  }), t.length > 3 && e.push(" ..."), e;
}
function T7(l, e, t) {
  return q5(e) ? (e = JSON.stringify(e), t ? e : [`${l}=${e}`]) : typeof e == "number" || typeof e == "boolean" || e == null ? t ? e : [`${l}=${e}`] : _e(e) ? (e = T7(l, j5(e.value), !0), t ? e : [`${l}=Ref<`, e, ">"]) : Q5(e) ? [`${l}=fn${e.name ? `<${e.name}>` : ""}`] : (e = j5(e), t ? e : [`${l}=`, e]);
}
const S7 = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Te(l, e, t, n) {
  try {
    return n ? l(...n) : l();
  } catch (o) {
    x7(o, e, t);
  }
}
function x7(l, e, t, n = !0) {
  const o = e ? e.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: s } = e && e.appContext.config || fe;
  if (e) {
    let c = e.parent;
    const u = e.proxy, v = process.env.NODE_ENV !== "production" ? S7[t] : `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; c; ) {
      const h = c.ec;
      if (h) {
        for (let m = 0; m < h.length; m++)
          if (h[m](l, u, v) === !1)
            return;
      }
      c = c.parent;
    }
    if (r) {
      Te(r, null, 10, [
        l,
        u,
        v
      ]);
      return;
    }
  }
  Ht(l, t, o, n, s);
}
function Ht(l, e, t, n = !0, o = !1) {
  if (process.env.NODE_ENV !== "production") {
    const r = S7[e];
    if (t && Mt(t), f1(`Unhandled error${r ? ` during execution of ${r}` : ""}`), t && yt(), n)
      throw l;
    console.error(l);
  } else {
    if (o)
      throw l;
    console.error(l);
  }
}
const y5 = [];
let R5 = -1;
const i1 = [];
let I5 = null, r1 = 0;
const zt = /* @__PURE__ */ Promise.resolve();
let be = null;
const kt = 100;
function Bt(l) {
  let e = R5 + 1, t = y5.length;
  for (; e < t; ) {
    const n = e + t >>> 1, o = y5[n], r = g1(o);
    r < l || r === l && o.flags & 2 ? e = n + 1 : t = n;
  }
  return e;
}
function Lt(l) {
  if (!(l.flags & 1)) {
    const e = g1(l), t = y5[y5.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(l.flags & 2) && e >= g1(t) ? y5.push(l) : y5.splice(Bt(e), 0, l), l.flags |= 1, D7();
  }
}
function D7() {
  be || (be = zt.then(E7));
}
function _t(l) {
  x5(l) ? i1.push(...l) : I5 && l.id === -1 ? I5.splice(r1 + 1, 0, l) : l.flags & 1 || (i1.push(l), l.flags |= 1), D7();
}
function Tt(l) {
  if (i1.length) {
    const e = [...new Set(i1)].sort(
      (t, n) => g1(t) - g1(n)
    );
    if (i1.length = 0, I5) {
      I5.push(...e);
      return;
    }
    for (I5 = e, process.env.NODE_ENV !== "production" && (l = l || /* @__PURE__ */ new Map()), r1 = 0; r1 < I5.length; r1++) {
      const t = I5[r1];
      process.env.NODE_ENV !== "production" && R7(l, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
    }
    I5 = null, r1 = 0;
  }
}
const g1 = (l) => l.id == null ? l.flags & 2 ? -1 : 1 / 0 : l.id;
function E7(l) {
  process.env.NODE_ENV !== "production" && (l = l || /* @__PURE__ */ new Map());
  const e = process.env.NODE_ENV !== "production" ? (t) => R7(l, t) : pt;
  try {
    for (R5 = 0; R5 < y5.length; R5++) {
      const t = y5[R5];
      if (t && !(t.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && e(t))
          continue;
        t.flags & 4 && (t.flags &= -2), Te(
          t,
          t.i,
          t.i ? 15 : 14
        ), t.flags & 4 || (t.flags &= -2);
      }
    }
  } finally {
    for (; R5 < y5.length; R5++) {
      const t = y5[R5];
      t && (t.flags &= -2);
    }
    R5 = -1, y5.length = 0, Tt(l), be = null, (y5.length || i1.length) && E7(l);
  }
}
function R7(l, e) {
  const t = l.get(e) || 0;
  if (t > kt) {
    const n = e.i, o = n && U7(n.type);
    return x7(
      `Maximum recursive updates exceeded${o ? ` in component <${o}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return l.set(e, t + 1), !1;
}
const d0 = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (j1().__VUE_HMR_RUNTIME__ = {
  createRecord: u0(St),
  rerender: u0(xt),
  reload: u0(Dt)
});
const E1 = /* @__PURE__ */ new Map();
function St(l, e) {
  return E1.has(l) ? !1 : (E1.set(l, {
    initialDef: R1(e),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function R1(l) {
  return G7(l) ? l.__vccOpts : l;
}
function xt(l, e) {
  const t = E1.get(l);
  t && (t.initialDef.render = e, [...t.instances].forEach((n) => {
    e && (n.render = e, R1(n.type).render = e), n.renderCache = [], n.update();
  }));
}
function Dt(l, e) {
  const t = E1.get(l);
  if (!t) return;
  e = R1(e), e2(t.initialDef, e);
  const n = [...t.instances];
  for (let o = 0; o < n.length; o++) {
    const r = n[o], s = R1(r.type);
    let c = d0.get(s);
    c || (s !== t.initialDef && e2(s, e), d0.set(s, c = /* @__PURE__ */ new Set())), c.add(r), r.appContext.propsCache.delete(r.type), r.appContext.emitsCache.delete(r.type), r.appContext.optionsCache.delete(r.type), r.ceReload ? (c.add(r), r.ceReload(e.styles), c.delete(r)) : r.parent ? Lt(() => {
      r.parent.update(), c.delete(r);
    }) : r.appContext.reload ? r.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), r.root.ce && r !== r.root && r.root.ce._removeChildStyle(s);
  }
  _t(() => {
    d0.clear();
  });
}
function e2(l, e) {
  U1(l, e);
  for (const t in l)
    t !== "__file" && !(t in e) && delete l[t];
}
function u0(l) {
  return (e, t) => {
    try {
      return l(e, t);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let O1 = null, Et = null;
const Rt = (l) => l.__isTeleport;
function O7(l, e) {
  l.shapeFlag & 6 && l.component ? (l.transition = e, O7(l.component.subTree, e)) : l.shapeFlag & 128 ? (l.ssContent.transition = e.clone(l.ssContent), l.ssFallback.transition = e.clone(l.ssFallback)) : l.transition = e;
}
j1().requestIdleCallback;
j1().cancelIdleCallback;
const Ot = Symbol.for("v-ndc");
process.env.NODE_ENV;
const Nt = {}, N7 = (l) => Object.getPrototypeOf(l) === Nt, It = (l) => l.__isSuspense, I7 = Symbol.for("v-fgt"), qt = Symbol.for("v-txt"), Ft = Symbol.for("v-cmt"), Pt = Symbol.for("v-stc"), _1 = [];
let z5 = null;
function i(l = !1) {
  _1.push(z5 = l ? null : []);
}
function Zt() {
  _1.pop(), z5 = _1[_1.length - 1] || null;
}
function Ut(l) {
  return l.dynamicChildren = z5 || vt, Zt(), z5 && z5.push(l), l;
}
function d(l, e, t, n, o, r) {
  return Ut(
    a(
      l,
      e,
      t,
      n,
      o,
      r,
      !0
    )
  );
}
function jt(l) {
  return l ? l.__v_isVNode === !0 : !1;
}
const Gt = (...l) => P7(
  ...l
), q7 = ({ key: l }) => l ?? null, T1 = ({
  ref: l,
  ref_key: e,
  ref_for: t
}) => (typeof l == "number" && (l = "" + l), l != null ? q5(l) || _e(l) || Q5(l) ? { i: O1, r: l, k: e, f: !!t } : l : null);
function a(l, e = null, t = null, n = 0, o = null, r = l === I7 ? 0 : 1, s = !1, c = !1) {
  const u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: l,
    props: e,
    key: e && q7(e),
    ref: e && T1(e),
    scopeId: Et,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: n,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: O1
  };
  return c ? (Se(u, t), r & 128 && l.normalize(u)) : t && (u.shapeFlag |= q5(t) ? 8 : 16), process.env.NODE_ENV !== "production" && u.key !== u.key && f1("VNode created with invalid key (NaN). VNode type:", u.type), // avoid a block node from tracking itself
  !s && // has current parent block
  z5 && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (u.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  u.patchFlag !== 32 && z5.push(u), u;
}
const F7 = process.env.NODE_ENV !== "production" ? Gt : P7;
function P7(l, e = null, t = null, n = 0, o = null, r = !1) {
  if ((!l || l === Ot) && (process.env.NODE_ENV !== "production" && !l && f1(`Invalid vnode type when creating vnode: ${l}.`), l = Ft), jt(l)) {
    const c = N1(
      l,
      e,
      !0
      /* mergeRef: true */
    );
    return t && Se(c, t), !r && z5 && (c.shapeFlag & 6 ? z5[z5.indexOf(l)] = c : z5.push(c)), c.patchFlag = -2, c;
  }
  if (G7(l) && (l = l.__vccOpts), e) {
    e = Wt(e);
    let { class: c, style: u } = e;
    c && !q5(c) && (e.class = Le(c)), U5(u) && (we(u) && !x5(u) && (u = U1({}, u)), e.style = Be(u));
  }
  const s = q5(l) ? 1 : It(l) ? 128 : Rt(l) ? 64 : U5(l) ? 4 : Q5(l) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && s & 4 && we(l) && (l = j5(l), f1(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    l
  )), a(
    l,
    e,
    t,
    n,
    o,
    s,
    r,
    !0
  );
}
function Wt(l) {
  return l ? we(l) || N7(l) ? U1({}, l) : l : null;
}
function N1(l, e, t = !1, n = !1) {
  const { props: o, ref: r, patchFlag: s, children: c, transition: u } = l, v = e ? Xt(o || {}, e) : o, h = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: l.type,
    props: v,
    key: v && q7(v),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && r ? x5(r) ? r.concat(T1(e)) : [r, T1(e)] : T1(e)
    ) : r,
    scopeId: l.scopeId,
    slotScopeIds: l.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && s === -1 && x5(c) ? c.map(Z7) : c,
    target: l.target,
    targetStart: l.targetStart,
    targetAnchor: l.targetAnchor,
    staticCount: l.staticCount,
    shapeFlag: l.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && l.type !== I7 ? s === -1 ? 16 : s | 16 : s,
    dynamicProps: l.dynamicProps,
    dynamicChildren: l.dynamicChildren,
    appContext: l.appContext,
    dirs: l.dirs,
    transition: u,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: l.component,
    suspense: l.suspense,
    ssContent: l.ssContent && N1(l.ssContent),
    ssFallback: l.ssFallback && N1(l.ssFallback),
    el: l.el,
    anchor: l.anchor,
    ctx: l.ctx,
    ce: l.ce
  };
  return u && n && O7(
    h,
    u.clone(h)
  ), h;
}
function Z7(l) {
  const e = N1(l);
  return x5(l.children) && (e.children = l.children.map(Z7)), e;
}
function Kt(l = " ", e = 0) {
  return F7(qt, null, l, e);
}
function s5(l, e) {
  const t = F7(Pt, null, l);
  return t.staticCount = e, t;
}
function Se(l, e) {
  let t = 0;
  const { shapeFlag: n } = l;
  if (e == null)
    e = null;
  else if (x5(e))
    t = 16;
  else if (typeof e == "object")
    if (n & 65) {
      const o = e.default;
      o && (o._c && (o._d = !1), Se(l, o()), o._c && (o._d = !0));
      return;
    } else
      t = 32, !e._ && !N7(e) && (e._ctx = O1);
  else Q5(e) ? (e = { default: e, _ctx: O1 }, t = 32) : (e = String(e), n & 64 ? (t = 16, e = [Kt(e)]) : t = 8);
  l.children = e, l.shapeFlag |= t;
}
function Xt(...l) {
  const e = {};
  for (let t = 0; t < l.length; t++) {
    const n = l[t];
    for (const o in n)
      if (o === "class")
        e.class !== n.class && (e.class = Le([e.class, n.class]));
      else if (o === "style")
        e.style = Be([e.style, n.style]);
      else if (ht(o)) {
        const r = e[o], s = n[o];
        s && r !== s && !(x5(r) && r.includes(s)) && (e[o] = r ? [].concat(r, s) : s);
      } else o !== "" && (e[o] = n[o]);
  }
  return e;
}
{
  const l = j1(), e = (t, n) => {
    let o;
    return (o = l[t]) || (o = l[t] = []), o.push(n), (r) => {
      o.length > 1 ? o.forEach((s) => s(r)) : o[0](r);
    };
  };
  e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => t
  ), e(
    "__VUE_SSR_SETTERS__",
    (t) => t
  );
}
process.env.NODE_ENV;
const Jt = /(?:^|[-_])(\w)/g, Yt = (l) => l.replace(Jt, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function U7(l, e = !0) {
  return Q5(l) ? l.displayName || l.name : l.name || e && l.__name;
}
function j7(l, e, t = !1) {
  let n = U7(e);
  if (!n && e.__file) {
    const o = e.__file.match(/([^/\\]+)\.\w+$/);
    o && (n = o[1]);
  }
  if (!n && l && l.parent) {
    const o = (r) => {
      for (const s in r)
        if (r[s] === e)
          return s;
    };
    n = o(
      l.components || l.parent.type.components
    ) || o(l.appContext.components);
  }
  return n ? Yt(n) : t ? "App" : "Anonymous";
}
function G7(l) {
  return Q5(l) && "__vccOpts" in l;
}
function Qt() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const l = { style: "color:#3ba776" }, e = { style: "color:#1677ff" }, t = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, o = {
    __vue_custom_formatter: !0,
    header(m) {
      return U5(m) ? m.__isVue ? ["div", l, "VueInstance"] : _e(m) ? [
        "div",
        {},
        ["span", l, h(m)],
        "<",
        // avoid debugger accessing value affecting behavior
        c("_value" in m ? m._value : m),
        ">"
      ] : _7(m) ? [
        "div",
        {},
        ["span", l, s0(m) ? "ShallowReactive" : "Reactive"],
        "<",
        c(m),
        `>${ge(m) ? " (readonly)" : ""}`
      ] : ge(m) ? [
        "div",
        {},
        ["span", l, s0(m) ? "ShallowReadonly" : "Readonly"],
        "<",
        c(m),
        ">"
      ] : null : null;
    },
    hasBody(m) {
      return m && m.__isVue;
    },
    body(m) {
      if (m && m.__isVue)
        return [
          "div",
          {},
          ...r(m.$)
        ];
    }
  };
  function r(m) {
    const b = [];
    m.type.props && m.props && b.push(s("props", j5(m.props))), m.setupState !== fe && b.push(s("setup", m.setupState)), m.data !== fe && b.push(s("data", j5(m.data)));
    const g = u(m, "computed");
    g && b.push(s("computed", g));
    const y = u(m, "inject");
    return y && b.push(s("injected", y)), b.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: m }]
    ]), b;
  }
  function s(m, b) {
    return b = U1({}, b), Object.keys(b).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        m
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(b).map((g) => [
          "div",
          {},
          ["span", n, g + ": "],
          c(b[g], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function c(m, b = !0) {
    return typeof m == "number" ? ["span", e, m] : typeof m == "string" ? ["span", t, JSON.stringify(m)] : typeof m == "boolean" ? ["span", n, m] : U5(m) ? ["object", { object: b ? j5(m) : m }] : ["span", t, String(m)];
  }
  function u(m, b) {
    const g = m.type;
    if (Q5(g))
      return;
    const y = {};
    for (const z in m.ctx)
      v(g, z, b) && (y[z] = m.ctx[z]);
    return y;
  }
  function v(m, b, g) {
    const y = m[g];
    if (x5(y) && y.includes(b) || U5(y) && b in y || m.extends && v(m.extends, b, g) || m.mixins && m.mixins.some((z) => v(z, b, g)))
      return !0;
  }
  function h(m) {
    return s0(m) ? "ShallowRef" : m.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : window.devtoolsFormatters = [o];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ea() {
  Qt();
}
process.env.NODE_ENV !== "production" && ea();
const la = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ta(l, e) {
  return i(), d("svg", la, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm14.814 10.526a.65.65 0 0 0 .186-.455 7.1 7.1 0 0 0-2.05-5A6.96 6.96 0 0 0 12 3a6.96 6.96 0 0 0-4.95 2.071 7.1 7.1 0 0 0-2.05 5c0 2.69.989 3.655 1.784 4.43l.003.003c.625.608 1.077 1.049 1.077 2.317a4.2 4.2 0 0 0 1.213 2.954A4.12 4.12 0 0 0 12 21c1.193 0 2.212-.511 3.036-1.52a.64.64 0 0 0 .08-.717.64.64 0 0 0-.38-.317.63.63 0 0 0-.681.216c-.587.718-1.24 1.052-2.055 1.052-.76 0-1.488-.304-2.025-.847a2.9 2.9 0 0 1-.839-2.046c0-1.81-.774-2.567-1.46-3.237l-.006-.006c-.719-.7-1.397-1.362-1.397-3.507 0-1.534.603-3.006 1.677-4.09A5.7 5.7 0 0 1 12 4.285c1.519 0 2.976.61 4.05 1.694a5.82 5.82 0 0 1 1.677 4.091c0 .17.067.334.187.455a.633.633 0 0 0 .9 0Zm-3.082 4.051a.63.63 0 0 1 .53.472c.044.164.02.34-.064.487a1.894 1.894 0 0 1-2.147.897 1.9 1.9 0 0 1-1.02-.688 1.94 1.94 0 0 1-.395-1.174c0-1.177.574-1.95 1.08-2.633l.002-.002c.444-.598.828-1.115.828-1.865 0-.682-.269-1.336-.746-1.818A2.53 2.53 0 0 0 12 7.5a2.53 2.53 0 0 0-1.8.753 2.6 2.6 0 0 0-.745 1.818.65.65 0 0 1-.187.455.633.633 0 0 1-.9 0 .65.65 0 0 1-.186-.455c0-1.023.402-2.004 1.118-2.727a3.8 3.8 0 0 1 2.7-1.13 3.8 3.8 0 0 1 2.7 1.13 3.88 3.88 0 0 1 1.118 2.727c0 1.178-.574 1.951-1.08 2.634l-.002.002c-.444.598-.827 1.115-.827 1.864a.65.65 0 0 0 .472.622.63.63 0 0 0 .716-.3.64.64 0 0 1 .635-.316",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const aa = { render: ta }, na = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oa(l, e) {
  return i(), d("svg", na, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm1.371 8.824c0-1.07.216-1.965.584-2.568.352-.574.832-.878 1.474-.878.735 0 1.196.167 1.774.38.683.25 1.47.54 2.797.54s2.114-.29 2.797-.54c.578-.213 1.04-.38 1.774-.38.642 0 1.122.304 1.474.878.368.603.584 1.498.584 2.568 0 1.326-.328 2.126-.71 3.053l-.006.013c-.218.526-.458 1.109-.635 1.821-.151.607-.21 1.448-.265 2.25l-.004.052c-.07 1.014-.142 2.003-.338 2.74-.098.367-.21.604-.32.737-.087.109-.152.132-.237.132-.006 0-.024.002-.072-.043-.067-.062-.156-.182-.26-.397-.209-.436-.382-1.05-.586-1.787l-.012-.044c-.234-.844-.508-1.833-.93-2.61-.436-.8-1.132-1.552-2.254-1.552s-1.818.752-2.254 1.552c-.422.777-.696 1.766-.93 2.61l-.012.044c-.204.737-.377 1.351-.587 1.787-.103.215-.192.335-.259.397-.048.045-.066.043-.071.043h-.001c-.085 0-.15-.023-.238-.132-.108-.133-.221-.37-.319-.738-.196-.736-.268-1.724-.338-2.739l-.004-.053c-.055-.8-.114-1.642-.265-2.249-.177-.712-.418-1.295-.635-1.82l-.005-.014c-.383-.927-.71-1.727-.71-3.053ZM7.43 4c-1.187 0-2.079.615-2.642 1.534C4.242 6.425 4 7.598 4 8.824c0 1.607.417 2.616.811 3.57l.004.011c.22.534.426 1.034.577 1.64.118.475.17 1.196.23 2.064l.004.044c.067.961.144 2.077.378 2.956.12.446.295.9.581 1.253.307.378.743.638 1.3.638.844 0 1.31-.682 1.567-1.218.27-.56.472-1.292.66-1.974l.013-.043c.249-.898.486-1.74.825-2.362.333-.612.662-.835 1.05-.835s.717.223 1.05.835c.34.623.576 1.464.825 2.362l.012.043c.19.682.392 1.414.661 1.974.258.536.723 1.218 1.566 1.218.558 0 .994-.26 1.3-.638.287-.353.463-.807.582-1.253.234-.879.311-1.995.378-2.956l.003-.044c.06-.868.113-1.589.231-2.064.151-.606.356-1.106.577-1.64l.004-.01c.394-.955.811-1.964.811-3.57 0-1.227-.242-2.4-.787-3.29C18.65 4.614 17.758 4 16.57 4c-.984 0-1.636.24-2.232.458l-.014.005c-.633.233-1.24.456-2.325.456s-1.692-.223-2.325-.456l-.014-.005C9.065 4.24 8.413 4 7.43 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ra = { render: oa }, sa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ia(l, e) {
  return i(), d("svg", sa, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm14.575 12.616c.225.058.436.16.62.302h.003a1.73 1.73 0 0 1-.276 2.923l-.031.014-2.733 1.163-.084.028-4.5 1.125a.6.6 0 0 1-.136.017H4.125A1.125 1.125 0 0 1 3 17.063V14.25a1.125 1.125 0 0 1 1.125-1.125h2.017l1.59-1.589a2.24 2.24 0 0 1 1.038-.59c-.48-.796-.707-1.547-.707-2.32 0-1.862 1.496-3.376 3.336-3.376a3.35 3.35 0 0 1 2.57 1.178 3.34 3.34 0 0 1 2.569-1.178c1.84 0 3.337 1.514 3.337 3.375 0 1.3-.668 2.625-1.988 3.958a1.7 1.7 0 0 1 .688.033M12.628 6.73a2.2 2.2 0 0 0-1.229-.355c-1.198 0-2.211 1.03-2.211 2.25 0 .712.284 1.432.891 2.25h2.765a1.968 1.968 0 0 1 1.916 2.422l.78-.179c2.1-1.57 3.21-3.121 3.21-4.493 0-1.22-1.013-2.25-2.212-2.25a2.19 2.19 0 0 0-2.049 1.336.562.562 0 0 1-1.04 0 2.2 2.2 0 0 0-.821-.98Zm-6.816 7.52H4.125v2.813h1.688zm9.945 1.715 2.672-1.138h-.002a.604.604 0 0 0-.443-1.118l-.022.006-4.711 1.084a.6.6 0 0 1-.126.014h-2.25a.562.562 0 1 1 0-1.125h1.969a.844.844 0 0 0 0-1.688h-3.52a1.12 1.12 0 0 0-.795.33l-1.591 1.59v3.143h4.43z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const da = { render: ia }, ua = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ca(l, e) {
  return i(), d("svg", ua, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm.256 12a7.744 7.744 0 1 1 15.488 0 7.744 7.744 0 0 1-15.488 0M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M9.28 7.814a.628.628 0 0 0-1.257 0v8.372a.628.628 0 1 0 1.256 0v-3.558h5.442v3.558a.628.628 0 0 0 1.256 0V7.814a.628.628 0 1 0-1.256 0v3.558H9.279z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const va = { render: ca }, pa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ha(l, e) {
  return i(), d("svg", pa, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm17.041 2.96c.306.283.459.655.459 1.07s-.153.788-.437 1.094l-1.07 1.071.459.46c.262.24.393.568.393.917s-.153.678-.393.919l-.611.612.152.153c.59.59.59 1.574 0 2.165a1.5 1.5 0 0 1-1.091.459c-.306 0-.568-.066-.808-.219v.765c0 .59-.218 1.137-.633 1.553l-6.9 6.887a2.16 2.16 0 0 1-1.55.634 2.16 2.16 0 0 1-1.55-.634l-4.322-4.33a2.18 2.18 0 0 1 0-3.082l6.92-6.91a2.16 2.16 0 0 1 1.55-.633h.765a1.526 1.526 0 0 1 .218-1.88c.306-.307.699-.46 1.092-.46s.786.175 1.07.46l.152.153.612-.613a1.22 1.22 0 0 1 .917-.393c.35 0 .677.153.917.393l.458.46 1.07-1.072a1.54 1.54 0 0 1 1.092-.459c.393 0 .786.175 1.07.46Zm-3.82 9.466c0 .35-.131.678-.393.919l-6.9 6.909c-.24.24-.567.393-.916.393s-.677-.13-.917-.393l-4.323-4.33a1.3 1.3 0 0 1-.393-.918c0-.35.13-.678.393-.918l1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .305-.132.423.423 0 0 0 0-.612l-1.55-1.552.917-.919.917.919a.43.43 0 0 0 .306.131.43.43 0 0 0 .305-.131.423.423 0 0 0 0-.612l-.917-.919.917-.918 1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .306-.132.423.423 0 0 0 0-.612l-1.55-1.552.917-.918.917.918a.43.43 0 0 0 .305.131.43.43 0 0 0 .306-.131.423.423 0 0 0 0-.612l-.917-.919.917-.918 1.55 1.552a.43.43 0 0 0 .306.132.43.43 0 0 0 .305-.132.423.423 0 0 0 0-.612l-1.55-1.552.11-.11c.24-.24.567-.393.916-.393h1.572l4.061 4.067zm2.14-1.596a.673.673 0 0 1-.918 0l-.458-.459-4.345-4.329-.458-.46a.635.635 0 0 1 0-.917.63.63 0 0 1 .458-.197c.175 0 .35.065.459.197l5.24 5.247c.262.24.262.656.021.918Zm1.07-6.34-1.376 1.399a.423.423 0 0 0 0 .612l.764.765a.43.43 0 0 1 .13.306c0 .11-.043.22-.13.307l-.611.634-3.712-3.717.611-.612c.175-.175.459-.175.612 0l.764.765a.42.42 0 0 0 .611 0l1.397-1.4c.24-.24.677-.24.917 0a.63.63 0 0 1 .197.46.54.54 0 0 1-.175.48Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ma = { render: ha }, fa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ga(l, e) {
  return i(), d("svg", fa, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm17.487 11.745a1.39 1.39 0 0 1 .465 1.44c-.283 1.071-1.15 3.109-3.779 4.714-2.61 1.601-4.924 1.601-6.167 1.601h-.012c-1.246 0-3.549 0-6.168-1.6-2.628-1.606-3.496-3.644-3.778-4.715a1.39 1.39 0 0 1 .468-1.44c.136-.107.292-.186.458-.23a6 6 0 0 1 1.848-.19c-.328-1.693-.078-3.03.172-3.823a1.37 1.37 0 0 1 .608-.773 1.32 1.32 0 0 1 .958-.155 7 7 0 0 1 2.38 1.033 8 8 0 0 1 2.259-2.833 1.32 1.32 0 0 1 1.605 0 8 8 0 0 1 2.26 2.833 7 7 0 0 1 2.38-1.033 1.32 1.32 0 0 1 .957.155c.29.171.507.447.608.773.255.793.505 2.131.172 3.823a6 6 0 0 1 1.848.19c.166.044.322.123.458.23M6.262 7.92l.007-.01a.02.02 0 0 1 .013-.003c.775.18 1.507.518 2.15.995-.292.98-.438 2-.431 3.026 0 1.597.314 2.898.76 3.945a10.5 10.5 0 0 1-1.63-2.17C5.63 11.03 5.943 8.932 6.263 7.921Zm.25 8.808c-2.222-1.357-2.943-3.02-3.178-3.902a4.9 4.9 0 0 1 1.875-.1q.314.86.763 1.654a12 12 0 0 0 2.833 3.372 9.5 9.5 0 0 1-2.296-1.024zM12.002 18c-.778-.591-2.667-2.406-2.667-6.07 0-3.62 1.865-5.45 2.667-6.066.801.618 2.667 2.447 2.667 6.067 0 3.663-1.89 5.478-2.667 6.069m3.568-9.097a5.8 5.8 0 0 1 2.152-.994q.006 0 .012.003l.007.01c.32 1.01.632 3.108-.87 5.782a10.5 10.5 0 0 1-1.628 2.172c.445-1.045.76-2.347.76-3.944a10.3 10.3 0 0 0-.433-3.03Zm5.1 3.925c-.231.874-.95 2.541-3.175 3.901a9.5 9.5 0 0 1-2.296 1.023c1.14-.936 2.1-2.079 2.833-3.372.3-.528.554-1.082.763-1.654a4.9 4.9 0 0 1 1.875.102",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wa = { render: ga }, ba = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ma(l, e) {
  return i(), d("svg", ba, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm18.799 1.203a4.106 4.106 0 0 0-5.807 0l-7.826 7.824a4.106 4.106 0 0 0 5.807 5.807l7.827-7.825a4.11 4.11 0 0 0-.001-5.806m-10.73 13.6c.763 0 1.494-.303 2.032-.841l3.477-3.477-4.063-4.062-3.477 3.476a2.873 2.873 0 0 0 2.032 4.904Zm6.38-5.19 3.478-3.476a2.872 2.872 0 0 0-4.063-4.062L10.387 9.55zm2.422-4.915a.617.617 0 0 0-1.006-.2l-1.85 1.85a.617.617 0 0 0 .872.873l1.85-1.85a.62.62 0 0 0 .134-.673",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ya = { render: Ma }, Va = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Aa(l, e) {
  return i(), d("svg", Va, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm12 4.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-1.389 5.829a2.5 2.5 0 1 0 2.778-4.157 2.5 2.5 0 0 0-2.778 4.157m8.55-5.333c1.471 1.471 2.133 2.94 2.16 3a.63.63 0 0 1 0 .509c-.027.061-.689 1.529-2.16 3-1.96 1.96-4.436 2.995-7.161 2.995s-5.2-1.036-7.16-2.995c-1.472-1.471-2.134-2.939-2.161-3a.63.63 0 0 1 0-.508c.024-.06.689-1.53 2.16-3C6.8 6.785 9.275 5.75 12 5.75s5.2 1.036 7.16 2.996ZM12 17c-2.405 0-4.505-.874-6.245-2.598A10.4 10.4 0 0 1 3.953 12a10.4 10.4 0 0 1 1.802-2.402C7.495 7.874 9.595 7 12 7s4.506.874 6.244 2.598A10.4 10.4 0 0 1 20.051 12c-.563 1.052-3.017 5-8.051 5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $a = { render: Aa }, Ca = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ha(l, e) {
  return i(), d("svg", Ca, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm13.904 14.52a.937.937 0 1 0-1.558-1.04.937.937 0 0 0 1.558 1.04m-1.463 4.825a3.76 3.76 0 0 0 1.266-2.275v-.002a3.125 3.125 0 1 0-1.268-.021A2.505 2.505 0 0 1 14 19h-1.875a2.5 2.5 0 0 1-2.5-2.5v-3.166C12.084 13.02 14 10.876 14 8.31V5.25A1.25 1.25 0 0 0 12.75 4H11.5a.625.625 0 1 0 0 1.25h1.25v3.06c0 2.077-1.66 3.788-3.7 3.815a3.75 3.75 0 0 1-3.8-3.75V5.25H6.5A.625.625 0 0 0 6.5 4H5.25A1.25 1.25 0 0 0 4 5.25v3.125a5 5 0 0 0 4.375 4.96V16.5a3.754 3.754 0 0 0 3.75 3.75H14a3.76 3.76 0 0 0 2.441-.905m2.243-6.387a1.875 1.875 0 1 1-3.118 2.084 1.875 1.875 0 0 1 3.118-2.084",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const za = { render: Ha }, ka = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ba(l, e) {
  return i(), d("svg", ka, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-.308 5h16.616a.69.69 0 0 1 .692.7v12.6a.7.7 0 0 1-.203.495.7.7 0 0 1-.49.205H3.693a.7.7 0 0 1-.49-.205A.7.7 0 0 1 3 18.3V5.7c0-.186.073-.364.203-.495A.7.7 0 0 1 3.693 5Zm4.846 5.6v2.8h6.923v-2.8zm-4.153 0v2.8h2.769v-2.8zm15.23 0h-2.769v2.8h2.77v-2.8Zm-6.923-1.4h6.923V6.4h-6.923zm-1.384 0V6.4H4.385v2.8zm0 5.6H4.385v2.8h6.923zm1.384 0v2.8h6.923v-2.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const La = { render: Ba }, _a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ta(l, e) {
  return i(), d("svg", _a, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.294 1.279a.75.75 0 0 1 .927.515l2.845 9.956H18a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.721-.544l-3-10.5a.75.75 0 0 1 .515-.927",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.853 11.838a.75.75 0 0 1 .309 1.015l-4 7.5a.75.75 0 0 1-1.324-.706l4-7.5a.75.75 0 0 1 1.015-.309m4.83-.018a.75.75 0 0 1 .997.363l3.5 7.5a.75.75 0 1 1-1.36.634l-3.5-7.5a.75.75 0 0 1 .363-.996Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.223 17.466a.75.75 0 0 1 1.06.007 12.25 12.25 0 0 0 17.433 0 .75.75 0 0 1 1.068 1.054 13.75 13.75 0 0 1-19.568 0 .75.75 0 0 1 .007-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sa = { render: Ta }, xa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Da(l, e) {
  return i(), d("svg", xa, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M6.166 4.329a.562.562 0 1 0-1.082.309l2.25 7.875c.07.241.29.408.541.408h1.312l-2.312 4.337a9 9 0 0 1-1.412-1.17.562.562 0 1 0-.8.79 10.314 10.314 0 0 0 14.675 0 .562.562 0 1 0-.8-.79 9 9 0 0 1-1.389 1.153l-2.016-4.32H16.5a.563.563 0 0 0 0-1.125H8.3zm10.01 13.487-2.284-4.895h-3.43l-2.616 4.906a9.19 9.19 0 0 0 8.33-.011",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ea = { render: Da }, Ra = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oa(l, e) {
  return i(), d("svg", Ra, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.625 3.45a5.253 5.253 0 0 0-7.175 1.925l-.011.017-8.593 13.99a1.265 1.265 0 1 0 2.214 1.226l8.566-13.99a2.75 2.75 0 0 1 3.76-1.011 2.75 2.75 0 0 1 .997 3.772 1.249 1.249 0 1 0 2.165 1.25l.002-.004a5.254 5.254 0 0 0-1.925-7.175M14.25 1.477a6.753 6.753 0 0 1 7.6 9.896 2.751 2.751 0 1 1-4.76-2.753 1.249 1.249 0 1 0-2.165-1.25l-.012.02-8.568 13.994a2.765 2.765 0 1 1-4.784-2.776l8.595-13.991a6.75 6.75 0 0 1 4.094-3.139Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Na = { render: Oa }, Ia = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qa(l, e) {
  return i(), d("svg", Ia, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m1.971-18.804a3.94 3.94 0 0 1 4.434 5.774l-.002.003a.938.938 0 1 1-1.624-.937 2.06 2.06 0 0 0-1.513-3.088 2.06 2.06 0 0 0-2.054 1.017L6.787 18.458l-.008.015a.95.95 0 0 1-1.652-.935l6.445-10.492.007-.013a3.94 3.94 0 0 1 2.392-1.837m3.552-.582a5.065 5.065 0 0 0-6.914 1.85L4.163 16.957l-.01.015a2.074 2.074 0 0 0 3.598 2.067l6.425-10.494.01-.015a.937.937 0 1 1 1.623.937 2.063 2.063 0 1 0 3.571 2.064 5.065 5.065 0 0 0-1.857-6.917",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fa = { render: qa }, Pa = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Za(l, e) {
  return i(), d("svg", Pa, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.75 3.75V5a.75.75 0 0 1-.75.75H3.75v14.5h10.5V3.75zm6 16.5h4.5V9.75h-4.5v2.5H17a.75.75 0 0 1 0 1.5h-1.25v2.5H17a.75.75 0 0 1 0 1.5h-1.25zm0-12V3.6a1.35 1.35 0 0 0-1.35-1.35H9.6A1.35 1.35 0 0 0 8.25 3.6v.65H3.6A1.35 1.35 0 0 0 2.25 5.6v14.8a1.35 1.35 0 0 0 1.35 1.35h16.8a1.35 1.35 0 0 0 1.35-1.35V9.6a1.35 1.35 0 0 0-1.35-1.35zm-8.236.194a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm4 0a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm-4 4a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm4 0a.75.75 0 0 1 .051 1.06l-.01.01a.75.75 0 0 1-1.11-1.008l.01-.011a.75.75 0 0 1 1.06-.051Zm-4 4a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.012a.75.75 0 0 1 1.06-.05Zm4 0a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.012a.75.75 0 0 1 1.06-.05Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ua = { render: Za }, ja = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ga(l, e) {
  return i(), d("svg", ja, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M10.27 6.615v-.961h3.46v12.692H5.655V7.192h4.038a.577.577 0 0 0 .577-.577m8.076 11.731h-3.461v-1.923h.961a.577.577 0 0 0 0-1.154h-.961v-1.923h.961a.577.577 0 0 0 0-1.154h-.961V10.27h3.461v8.077ZM14.885 5.538v3.577h3.577a1.04 1.04 0 0 1 1.038 1.039v8.308a1.04 1.04 0 0 1-1.038 1.038H5.538A1.04 1.04 0 0 1 4.5 18.462V7.077a1.04 1.04 0 0 1 1.038-1.039h3.577v-.5A1.04 1.04 0 0 1 10.154 4.5h3.692a1.04 1.04 0 0 1 1.039 1.038M8.588 10.08a.577.577 0 1 0-.853-.777l-.008.009a.577.577 0 0 0 .854.776zm3.077 0a.577.577 0 0 0-.853-.777l-.008.009a.577.577 0 1 0 .854.776zm-3.077 3.076a.577.577 0 1 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776l.007-.008Zm3.077 0a.577.577 0 0 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776l.007-.008Zm-3.077 3.077a.577.577 0 0 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776zm3.077 0a.577.577 0 1 0-.853-.776l-.008.009a.577.577 0 1 0 .854.776z",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const Wa = { render: Ga }, Ka = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xa(l, e) {
  return i(), d("svg", Ka, e[0] || (e[0] = [
    a("path", { d: "M3.75 9.187a.75.75 0 0 1 .75.75V21h3.75v-5.625a1.875 1.875 0 0 1 1.875-1.875h3.75a1.875 1.875 0 0 1 1.875 1.875V21h3.75V9.937a.75.75 0 0 1 1.5 0V21a1.5 1.5 0 0 1-1.5 1.5H15a.75.75 0 0 1-.75-.75v-6.375a.375.375 0 0 0-.375-.375h-3.75a.375.375 0 0 0-.375.375v6.375a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 21V9.937a.75.75 0 0 1 .75-.75" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 9.187a.75.75 0 0 1 .75.75v.23L11.985 3h.03l7.485 7.165v-.229a.75.75 0 0 1 1.5 0v1.665l.981.94a.75.75 0 1 0 1.038-1.084L19.5 8.09V3a.75.75 0 0 0-.75-.75H16.5a.75.75 0 0 0-.75.75v1.5l-2.71-2.595c-.304-.308-.72-.404-1.037-.404-.319 0-.736.094-1.042.404l-9.98 9.553a.75.75 0 0 0 1.038 1.084l.981-.94V9.937a.75.75 0 0 1 .75-.75M18 3.75v2.904l-.75-.718V3.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ja = { render: Xa }, Ya = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qa(l, e) {
  return i(), d("svg", Ya, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m.766-19.21 1.936 1.853V5.571c0-.295.24-.535.536-.535h1.607c.296 0 .536.24.536.535v3.636l2.513 2.406a.536.536 0 1 1-.74.774l-.702-.67v6.712a1.07 1.07 0 0 1-1.071 1.072h-3.215a.536.536 0 0 1-.535-.536V14.41a.27.27 0 0 0-.268-.268h-2.679a.27.27 0 0 0-.268.268v4.554c0 .296-.24.535-.536.535H6.666a1.07 1.07 0 0 1-1.071-1.07v-6.714l-.701.671a.536.536 0 1 1-.741-.774L11.28 4.79c.219-.221.517-.289.744-.289s.524.069.74.29Zm-.732.782 5.347 5.119v7.738h-2.679v-4.018a1.34 1.34 0 0 0-1.34-1.34h-2.678a1.34 1.34 0 0 0-1.34 1.34v4.018H6.667V10.69l5.347-5.118zm4.275 2.61V6.107h-.536V7.67z",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const en = { render: Qa }, ln = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tn(l, e) {
  return i(), d("svg", ln, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.513 3.971C4.371 2.606 5.495 1.5 6.825 1.5h10.35c1.328 0 2.456 1.105 2.311 2.472-.32 3.074-1.55 4.624-2.697 5.713a24 24 0 0 1-.572.521l-.2.18a7 7 0 0 0-.582.575C15.14 11.298 15 11.598 15 12c0 .406.141.709.432 1.051.154.182.344.366.577.58l.212.193c.174.158.365.332.552.512 1.137 1.092 2.367 2.638 2.713 5.686.156 1.376-.989 2.478-2.312 2.478H6.825c-1.322 0-2.468-1.102-2.31-2.478m-.002-16.05c.32 3.074 1.553 4.613 2.7 5.697.19.179.383.35.558.507l.213.19c.234.212.425.393.58.573.292.339.436.643.436 1.061 0 .421-.144.73-.434 1.072-.215.255-.458.474-.758.745-.173.156-.364.329-.58.535-1.136 1.086-2.367 2.621-2.714 5.67M6.825 3c-.526 0-.861.42-.82.816.275 2.64 1.288 3.866 2.238 4.762.173.164.338.311.506.46l.24.214c.242.22.491.453.71.708.458.53.801 1.169.801 2.04 0 .867-.337 1.508-.789 2.042-.278.328-.647.663-.997.98-.157.142-.31.281-.45.414-.948.906-1.962 2.135-2.26 4.755-.043.384.288.809.821.809h10.35c.533 0 .864-.425.82-.809-.297-2.621-1.313-3.862-2.26-4.774-.173-.165-.337-.314-.504-.466l-.238-.216a8 8 0 0 1-.703-.712c-.45-.529-.79-1.163-.79-2.023 0-.863.346-1.497.801-2.022a8 8 0 0 1 .71-.705l.225-.201c.172-.154.342-.306.52-.475.95-.902 1.964-2.14 2.239-4.781v-.002c.042-.393-.293-.814-.82-.814H6.824Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M16.092 20.25H7.928c-.731 0-.938-.844-.425-1.367 1.242-1.258 3.747-2.159 3.747-3.602V10.5c0-.93-1.781-1.64-2.883-3.15-.182-.249-.164-.6.298-.6h6.69c.395 0 .48.348.3.598C14.57 8.859 12.75 9.565 12.75 10.5v4.781c0 1.431 2.611 2.203 3.769 3.603.466.565.303 1.366-.427 1.366" }, null, -1)
  ]));
}
const an = { render: tn }, nn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function on(l, e) {
  return i(), d("svg", nn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M8.304 4.5c-.95 0-1.753.79-1.652 1.765.23 2.197 1.11 3.296 1.929 4.07.135.128.273.25.399.362l.151.136c.168.15.304.28.415.41.208.241.311.458.311.757 0 .301-.103.522-.31.766-.153.182-.327.338-.541.532-.124.111-.26.235-.415.382-.811.776-1.69 1.872-1.938 4.05-.112.983.706 1.77 1.65 1.77h7.393c.945 0 1.763-.787 1.651-1.77-.247-2.177-1.126-3.282-1.937-4.062-.134-.128-.27-.252-.395-.365l-.152-.138a5 5 0 0 1-.411-.414c-.208-.245-.31-.461-.31-.751 0-.287.101-.5.311-.742a5 5 0 0 1 .416-.41l.143-.13c.128-.114.27-.24.409-.372.819-.778 1.698-1.885 1.927-4.08.103-.977-.703-1.766-1.652-1.766zm-.586 1.654c-.03-.283.21-.583.586-.583h7.392c.377 0 .616.301.586.582v.001c-.197 1.887-.92 2.771-1.6 3.415-.126.12-.248.23-.37.34l-.161.143a6 6 0 0 0-.507.504c-.325.375-.573.827-.573 1.444 0 .614.243 1.067.565 1.445.154.182.33.35.502.508l.17.155c.118.108.236.215.36.333.677.651 1.402 1.538 1.615 3.41.03.274-.206.578-.587.578H8.304c-.381 0-.618-.304-.586-.578.212-1.872.937-2.75 1.614-3.396q.152-.144.32-.296c.251-.227.515-.466.713-.7.323-.382.564-.84.564-1.459 0-.622-.245-1.079-.572-1.457a6 6 0 0 0-.508-.506l-.17-.152a16 16 0 0 1-.363-.33c-.678-.64-1.402-1.515-1.598-3.401m1.373 11.739h5.832c.521 0 .638-.572.305-.976-.33-.4-.828-.728-1.304-1.043-.716-.473-1.388-.917-1.388-1.53v-3.415c0-.367.391-.684.873-1.074.396-.321.852-.691 1.202-1.178.129-.178.068-.427-.214-.427H9.618c-.33 0-.343.25-.213.429.351.481.8.849 1.188 1.167.482.395.871.715.871 1.083v3.415c0 .668-.752 1.174-1.523 1.691-.418.281-.841.566-1.153.881-.366.374-.219.977.303.977",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const rn = { render: on }, sn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function dn(l, e) {
  return i(), d("svg", sn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.8 9.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341c1.029-.515 2.398-.812 3.87-.812s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812a4.5 4.5 0 0 1-1.018-.68c-.9.315-1.973.492-3.112.492-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 1.5 0c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.851 0 1.636-.115 2.298-.307a2 2 0 0 1-.048-.443c0-1.127.895-1.946 1.88-2.438M3 12.25a.75.75 0 0 1 .75.75c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.831 0 1.6-.11 2.251-.293a.75.75 0 0 1 1.499.043c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097a.75.75 0 1 1 1.5 0c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.526-.262-1.027-.618-1.378-1.065A9.8 9.8 0 0 1 8 16.25c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3 4.75a.75.75 0 0 1 .75.75v11c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.83 0 1.598-.11 2.25-.293V10.5a.75.75 0 1 1 1.5 0v8c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097v-8a.75.75 0 1 1 1.5 0v8c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.684-.341-1.323-.84-1.651-1.49A10 10 0 0 1 8 19.75c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438v-11A.75.75 0 0 1 3 4.75m10 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.8 4.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341C5.158 2.547 6.527 2.25 8 2.25s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.985-.492-1.88-1.31-1.88-2.438 0-1.127.895-1.946 1.88-2.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const un = { render: dn }, cn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function vn(l, e) {
  return i(), d("svg", cn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M5.654 7c0-.195.173-.526.808-.844.6-.3 1.47-.502 2.461-.502.992 0 1.861.202 2.462.502.634.318.807.65.807.844s-.173.526-.807.844c-.6.3-1.47.502-2.462.502s-1.861-.202-2.461-.502c-.635-.318-.808-.65-.808-.844M4.5 7c0-.867.688-1.497 1.446-1.876.791-.396 1.845-.624 2.977-.624s2.186.228 2.978.624c.757.38 1.445 1.009 1.445 1.876v1.535a7.8 7.8 0 0 1 1.73-.189c1.133 0 2.187.229 2.979.625.757.378 1.445 1.008 1.445 1.875V17c0 .867-.688 1.497-1.445 1.875-.792.396-1.846.625-2.978.625s-2.186-.229-2.978-.625c-.525-.262-1.017-.646-1.27-1.145a7.7 7.7 0 0 1-1.906.231c-1.132 0-2.186-.228-2.977-.624-.758-.379-1.446-1.009-1.446-1.876zm7.692 1.714v.211l-.093.046c-.757.378-1.445 1.008-1.445 1.875v.352a6.5 6.5 0 0 1-1.73.225c-.993 0-1.862-.202-2.462-.502-.635-.318-.808-.65-.808-.844V8.714q.143.087.292.162c.791.396 1.845.624 2.977.624s2.186-.228 2.978-.624a4 4 0 0 0 .291-.162M5.654 12.77v-.978q.143.087.292.162c.791.396 1.845.624 2.977.624a7.7 7.7 0 0 0 1.73-.189v1.502a6.4 6.4 0 0 1-1.73.225c-.992 0-1.861-.202-2.461-.502-.635-.318-.808-.65-.808-.844m6.154 1.154v-1.362q.143.087.291.16c.792.397 1.846.625 2.978.625s2.186-.228 2.978-.624q.148-.075.291-.161v1.362c0 .194-.173.526-.808.844-.6.3-1.47.502-2.461.502-.992 0-1.861-.202-2.462-.502-.634-.318-.807-.65-.807-.844m6.247 1.876q.148-.075.291-.161V17c0 .194-.173.526-.808.843-.6.3-1.47.503-2.461.503-.992 0-1.861-.202-2.462-.503-.634-.317-.807-.649-.807-.843v-1.362q.143.086.291.16c.792.397 1.846.625 2.978.625s2.186-.228 2.978-.624Zm-9.132-.53a7.7 7.7 0 0 0 1.73-.189v1.502a6.4 6.4 0 0 1-1.73.226c-.992 0-1.861-.203-2.461-.503-.635-.317-.808-.65-.808-.844v-.977q.143.087.292.16c.791.397 1.845.625 2.977.625m3.692-5.267q.165-.082.354-.153l.006-.002c.566-.213 1.293-.347 2.102-.347.992 0 1.861.202 2.461.502.635.318.808.65.808.844 0 .195-.173.526-.808.844-.6.3-1.47.502-2.461.502-.992 0-1.861-.202-2.462-.502-.634-.318-.807-.65-.807-.844s.173-.526.807-.844",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const pn = { render: vn }, hn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function mn(l, e) {
  return i(), d("svg", hn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 1.25a.75.75 0 0 1 .554.244 16.05 16.05 0 0 1 4.196 10.522 16.05 16.05 0 0 1-4.196 10.49.75.75 0 0 1-1.108 0A16.05 16.05 0 0 1 7.25 11.984a16.05 16.05 0 0 1 4.196-10.49A.75.75 0 0 1 12 1.25M8.75 12A14.55 14.55 0 0 0 12 20.851 14.55 14.55 0 0 0 15.25 12 14.55 14.55 0 0 0 12 3.149 14.55 14.55 0 0 0 8.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const fn = { render: mn }, gn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function wn(l, e) {
  return i(), d("svg", gn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M10.722 5.18a6.94 6.94 0 0 0-5.637 6.258h3.377c.15-2.262.937-4.43 2.26-6.258M12 3.938a8.063 8.063 0 1 0 0 16.125 8.063 8.063 0 0 0 0-16.125m1.278 1.242a12.04 12.04 0 0 1 2.26 6.258h3.377a6.94 6.94 0 0 0-5.637-6.258m1.133 6.258A10.9 10.9 0 0 0 12 5.362a10.9 10.9 0 0 0-2.41 6.075zm0 1.124A10.9 10.9 0 0 1 12 18.64a10.9 10.9 0 0 1-2.41-6.076h4.82Zm-5.95 0H5.086a6.94 6.94 0 0 0 5.637 6.258 12.04 12.04 0 0 1-2.26-6.258Zm4.817 6.258a12.04 12.04 0 0 0 2.26-6.258h3.377a6.94 6.94 0 0 1-5.637 6.258",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const bn = { render: wn }, Mn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function yn(l, e) {
  return i(), d("svg", Mn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.906 12.844a7.03 7.03 0 0 0-7.03 7.031V21a.844.844 0 1 1-1.688 0v-1.125a8.719 8.719 0 0 1 17.437 0V21a.844.844 0 1 1-1.687 0v-1.125a7.03 7.03 0 0 0-7.032-7.031",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.906 3.844a3.656 3.656 0 1 0 0 7.312 3.656 3.656 0 0 0 0-7.312M6.563 7.5a5.344 5.344 0 1 1 10.687 0 5.344 5.344 0 0 1-10.687 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Vn = { render: yn }, An = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $n(l, e) {
  return i(), d("svg", An, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M9.164 8.625a2.742 2.742 0 1 1 5.485 0 2.742 2.742 0 0 1-5.485 0m5.154 3.201a4.008 4.008 0 1 0-4.823 0 6.54 6.54 0 0 0-4.128 6.08v.844a.633.633 0 1 0 1.266 0v-.844a5.273 5.273 0 0 1 10.547 0v.844a.633.633 0 1 0 1.265 0v-.844c0-2.76-1.71-5.12-4.127-6.08",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Cn = { render: $n }, Hn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function zn(l, e) {
  return i(), d("svg", Hn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.906 12.631A3.577 3.577 0 0 0 8.33 16.21v.841a.631.631 0 0 1-1.263 0v-.841a4.84 4.84 0 0 1 9.68 0v.841a.631.631 0 0 1-1.262 0v-.841a3.577 3.577 0 0 0-3.578-3.578Zm-6.733 1.684a1.894 1.894 0 0 0-1.894 1.894v.841a.631.631 0 0 1-1.263 0v-.841a3.157 3.157 0 0 1 3.157-3.157zm13.467 0c1.046 0 1.894.848 1.894 1.894v.841a.631.631 0 0 0 1.263 0v-.841a3.157 3.157 0 0 0-3.157-3.157z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.906 7.581a1.894 1.894 0 1 0 0 3.788 1.894 1.894 0 0 0 0-3.788M8.75 9.475a3.156 3.156 0 1 1 6.313 0 3.156 3.156 0 0 1-6.313 0m-3.577 1.473a1.052 1.052 0 1 0 0 2.104 1.052 1.052 0 0 0 0-2.104M2.858 12a2.315 2.315 0 1 1 4.63 0 2.315 2.315 0 0 1-4.63 0m15.782-1.052a1.052 1.052 0 1 0 0 2.104 1.052 1.052 0 0 0 0-2.104M16.326 12a2.315 2.315 0 1 1 4.629 0 2.315 2.315 0 0 1-4.63 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kn = { render: zn }, Bn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ln(l, e) {
  return i(), d("svg", Bn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m-1.514-13.894a1.42 1.42 0 1 1 2.84 0 1.42 1.42 0 0 1-2.84 0m2.987 1.775a2.367 2.367 0 1 0-3.133 0 3.63 3.63 0 0 0-2.064 3.275v.632a.473.473 0 1 0 .947 0v-.632a2.683 2.683 0 0 1 5.366 0v.632a.474.474 0 0 0 .947 0v-.632a3.63 3.63 0 0 0-2.063-3.275m-8.037 3.275c0-.784.636-1.42 1.42-1.42a1.736 1.736 0 1 0-1.285-.568 2.37 2.37 0 0 0-1.082 1.988v.632a.473.473 0 0 0 .947 0zm11.52-1.42a1.42 1.42 0 0 1 1.421 1.42v.632a.473.473 0 0 0 .947 0v-.632c0-.834-.43-1.567-1.082-1.988a1.736 1.736 0 1 0-1.285.568Zm-10.1-2.525a.79.79 0 1 0 0 1.578.79.79 0 0 0 0-1.578m9.312.79a.79.79 0 1 1 1.578 0 .79.79 0 0 1-1.578 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _n = { render: Ln }, Tn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Sn(l, e) {
  return i(), d("svg", Tn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .75.75v.026c5.45.385 9.75 4.927 9.75 10.474a.75.75 0 0 1-1.28.53 2.434 2.434 0 0 0-3.44 0 .75.75 0 0 1-1.06 0 2.92 2.92 0 0 0-3.816-.27l-.154.115v7.125a2.25 2.25 0 0 1-4.5 0 .75.75 0 0 1 1.5 0 .75.75 0 1 0 1.5 0v-7.125l-.154-.116a2.92 2.92 0 0 0-3.816.271.75.75 0 0 1-1.06 0 2.43 2.43 0 0 0-3.44 0 .75.75 0 0 1-1.28-.53c0-5.547 4.3-10.09 9.75-10.474V2.25A.75.75 0 0 1 12 1.5m0 10.312.004-.003a4.42 4.42 0 0 1 5.252-.038 3.93 3.93 0 0 1 3.631-.45 9.002 9.002 0 0 0-17.774 0 3.93 3.93 0 0 1 3.631.45 4.42 4.42 0 0 1 5.252.038z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xn = { render: Sn }, Dn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function En(l, e) {
  return i(), d("svg", Dn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m.536-18.964a.536.536 0 1 0-1.072 0v.019a7.5 7.5 0 0 0-6.964 7.48.536.536 0 0 0 .915.38 1.737 1.737 0 0 1 2.456 0c.21.209.549.209.758 0a2.085 2.085 0 0 1 2.725-.194l.11.082v5.09a.536.536 0 0 1-1.071 0 .536.536 0 0 0-1.072 0 1.607 1.607 0 0 0 3.215 0v-5.09l.11-.082a2.086 2.086 0 0 1 2.725.194c.21.209.549.209.758 0a1.737 1.737 0 0 1 2.456 0 .536.536 0 0 0 .915-.38 7.5 7.5 0 0 0-6.964-7.48zm-.533 6.828-.003.002-.003-.002a3.16 3.16 0 0 0-3.751-.027 2.81 2.81 0 0 0-2.594-.322 6.43 6.43 0 0 1 12.696 0 2.8 2.8 0 0 0-2.594.322 3.16 3.16 0 0 0-3.751.027",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const Rn = { render: En }, On = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Nn(l, e) {
  return i(), d("svg", On, e[0] || (e[0] = [
    a("path", { d: "M19 17.583c1.25-1.5 2-3.5 2-5.583 0-4.917-4-9-9-9s-9 4.083-9 9 4 9 9 9c2.833 0 5.333-1.333 7-3.417M12 4.25a7.647 7.647 0 0 1 7.667 7.667c0 1.583-.5 3.083-1.334 4.333-.916-.75-2.916-2.083-6.333-2.083s-5.5 1.25-6.333 2.083a7.83 7.83 0 0 1-1.334-4.333C4.333 7.75 7.75 4.25 12 4.25m0 15.5a7.68 7.68 0 0 1-5.583-2.417c.666-.583 2.416-1.75 5.583-1.75s4.917 1.167 5.583 1.75C16.167 18.75 14.167 19.75 12 19.75" }, null, -1),
    a("path", { d: "M12.004 12.563c1.71 0 3.094-1.403 3.094-3.136 0-1.732-1.385-3.052-3.094-3.052-1.71 0-3.094 1.402-3.094 3.135s1.384 3.053 3.094 3.053m0-4.95c.977 0 1.79.824 1.79 1.814s-.813 1.816-1.79 1.816-1.791-.825-1.791-1.816c0-.99.814-1.814 1.79-1.814Z" }, null, -1)
  ]));
}
const In = { render: Nn }, qn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Fn(l, e) {
  return i(), d("svg", qn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m6.75-12a6.6 6.6 0 0 1-1.5 4.188C16 17.75 14.125 18.75 12 18.75c-3.75 0-6.75-3.063-6.75-6.75 0-3.688 3-6.75 6.75-6.75s6.75 3.063 6.75 6.75m-1-.063A5.735 5.735 0 0 0 12 6.188c-3.188 0-5.75 2.625-5.75 5.75a5.87 5.87 0 0 0 1 3.25c.625-.624 2.188-1.562 4.75-1.562 2.563 0 4.063 1 4.75 1.563a5.87 5.87 0 0 0 1-3.25ZM7.812 16A5.76 5.76 0 0 0 12 17.813c1.625 0 3.125-.75 4.188-1.813-.5-.438-1.813-1.313-4.188-1.313S8.312 15.563 7.812 16m6.511-5.93c0 1.3-1.038 2.352-2.32 2.352s-2.32-.99-2.32-2.29c0-1.299 1.038-2.35 2.32-2.35s2.32.99 2.32 2.289Zm-.977 0c0-.742-.61-1.36-1.343-1.36s-1.344.618-1.344 1.36.611 1.362 1.344 1.362 1.343-.619 1.343-1.361Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const Pn = { render: Fn }, Zn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Un(l, e) {
  return i(), d("svg", Zn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.055 2.055A2.75 2.75 0 0 1 11 1.25h2A2.75 2.75 0 0 1 15.75 4v4.25H20A2.75 2.75 0 0 1 22.75 11v2A2.75 2.75 0 0 1 20 15.75h-4.25V20A2.75 2.75 0 0 1 13 22.75h-2A2.756 2.756 0 0 1 8.25 20v-4.25H4A2.756 2.756 0 0 1 1.25 13v-2A2.75 2.75 0 0 1 4 8.25h4.25V4c0-.73.29-1.429.805-1.945M11 2.75A1.25 1.25 0 0 0 9.75 4v5a.75.75 0 0 1-.75.75H4A1.25 1.25 0 0 0 2.75 11v2c0 .686.564 1.25 1.25 1.25h5a.75.75 0 0 1 .75.75v5c0 .686.564 1.25 1.25 1.25h2A1.25 1.25 0 0 0 14.25 20v-5a.75.75 0 0 1 .75-.75h5A1.25 1.25 0 0 0 21.25 13v-2A1.25 1.25 0 0 0 20 9.75h-5a.75.75 0 0 1-.75-.75V4A1.25 1.25 0 0 0 13 2.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const jn = { render: Un }, Gn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Wn(l, e) {
  return i(), d("svg", Gn, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M9.946 5.062c.36-.36.848-.562 1.356-.562h1.396a1.92 1.92 0 0 1 1.918 1.919v2.965h2.965a1.92 1.92 0 0 1 1.919 1.918v1.396a1.92 1.92 0 0 1-1.919 1.918h-2.965v2.965a1.92 1.92 0 0 1-1.918 1.919h-1.396a1.923 1.923 0 0 1-1.918-1.919v-2.965H6.419A1.923 1.923 0 0 1 4.5 12.698v-1.396a1.92 1.92 0 0 1 1.919-1.918h2.965V6.419c0-.51.202-.997.562-1.357m.74.74a.87.87 0 0 1 .616-.255h1.396a.87.87 0 0 1 .872.872v3.488c0 .289.234.523.523.523h3.488a.87.87 0 0 1 .872.872v1.396a.87.87 0 0 1-.872.872h-3.488a.523.523 0 0 0-.523.523v3.488a.87.87 0 0 1-.872.872h-1.396a.876.876 0 0 1-.872-.872v-3.488a.523.523 0 0 0-.523-.523H6.419a.876.876 0 0 1-.872-.872v-1.396a.87.87 0 0 1 .872-.872h3.488a.523.523 0 0 0 .523-.523V6.419a.87.87 0 0 1 .256-.617",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("rect", {
          width: "24",
          height: "24",
          rx: "12"
        })
      ])
    ], -1)
  ]));
}
const Kn = { render: Wn }, Xn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Jn(l, e) {
  return i(), d("svg", Xn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1 0-1.5h3.25V8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Yn = { render: Jn }, Qn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function e3(l, e) {
  return i(), d("svg", Qn, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5H13a.75.75 0 0 1 0 1.5H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6A1.35 1.35 0 0 1 3.6 2.25h16.8a1.35 1.35 0 0 1 1.35 1.35V13a.75.75 0 0 1-1.5 0V3.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-1.945-.695a2.75 2.75 0 1 1 3.89 3.89 2.75 2.75 0 0 1-3.89-3.89m-4.35 6.256a.75.75 0 0 1 .605.006l5.5 2.5a.75.75 0 0 1-.62 1.366l-5.2-2.363-6.696 2.87a.75.75 0 0 1-.59-1.38zM19 15.25a.75.75 0 0 1 .75.75v2.25H22a.75.75 0 1 1 0 1.5h-2.25V22a.75.75 0 1 1-1.5 0v-2.25H16a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const l3 = { render: e3 }, t3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a3(l, e) {
  return i(), d("svg", t3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m12 6.015 1.832 1.56 2.4.192.192 2.4L17.986 12l-1.563 1.832-.191 2.4-2.4.192L12 17.985l-1.832-1.562-2.4-.191-.192-2.4L6.015 12l1.56-1.832.192-2.4 2.4-.192zm0 1.97-1.23 1.047-1.61.129-.128 1.61-1.047 1.23 1.047 1.228.129 1.61 1.611.128 1.229 1.048 1.229-1.047 1.608-.129.129-1.61 1.048-1.23-1.047-1.228-.129-1.61-1.61-.129z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M10.47 15.695 12 17V7l-1.53 1.304-2.006.16-.16 2.005L7 12l1.304 1.53.16 2.006z" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zM2.646 2.645A1.35 1.35 0 0 1 3.6 2.25h16.8a1.35 1.35 0 0 1 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.396-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const n3 = { render: a3 }, o3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function r3(l, e) {
  return i(), d("svg", o3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0V4.75H5A1.25 1.25 0 0 0 3.75 6v3.25h16.5V6A1.25 1.25 0 0 0 19 4.75h-.5a.75.75 0 0 1 0-1.5h.5A2.75 2.75 0 0 1 21.75 6v13A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V6A2.75 2.75 0 0 1 5 3.25h1.25V2A.75.75 0 0 1 7 1.25m13.25 9.5H3.75V19A1.25 1.25 0 0 0 5 20.25h14A1.25 1.25 0 0 0 20.25 19zM15 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V4.75H10.5a.75.75 0 0 1 0-1.5h3.75V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const s3 = { render: r3 }, i3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function d3(l, e) {
  return i(), d("svg", i3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.227 6.227a.75.75 0 0 1 1.06 0L12 10.939l4.712-4.712a.75.75 0 0 1 1.061 1.06L13.061 12l4.712 4.712a.75.75 0 1 1-1.06 1.06L12 13.062l-4.712 4.712a.75.75 0 0 1-1.06-1.06L10.94 12 6.227 7.288a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const u3 = { render: d3 }, c3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function v3(l, e) {
  return i(), d("svg", c3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.47 12.47a.75.75 0 0 1 1.06 0L9 15.94l9.47-9.47a.75.75 0 0 1 1.06 1.06l-10 10a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const p3 = { render: v3 }, h3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function m3(l, e) {
  return i(), d("svg", h3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.47 11.97a.75.75 0 0 1 1.06 0L10 14.44l6.47-6.47a.75.75 0 1 1 1.06 1.06l-7 7a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const f3 = { render: m3 }, g3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function w3(l, e) {
  return i(), d("svg", g3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 20V6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5zM14.75 4a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v9a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.319 2.417c-.32.377-.466.855-.529 1.215-.086.5-.475.982-1.04 1.094V6.25h6.5V4.726c-.565-.112-.954-.594-1.04-1.094-.063-.36-.21-.838-.529-1.215-.293-.346-.781-.667-1.68-.667-.9 0-1.389.321-1.682.667m-1.144-.97C9.762.755 10.674.25 12 .25s2.238.505 2.826 1.197c.52.614.742 1.322.84 1.814A1.25 1.25 0 0 1 16.75 4.5v1.9a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 6.4V4.5a1.25 1.25 0 0 1 1.084-1.24c.098-.491.32-1.2.84-1.813ZM14.97 19.97a.75.75 0 0 1 1.06 0l1.47 1.47 4.47-4.47a.75.75 0 0 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b3 = { render: w3 }, M3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function y3(l, e) {
  return i(), d("svg", M3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.75 9.75v10.5h10.5V9.75zM8.645 8.645A1.35 1.35 0 0 1 9.6 8.25h10.8a1.35 1.35 0 0 1 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V9.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v10.5h10.5V3.75zM2.645 2.645A1.35 1.35 0 0 1 3.6 2.25h10.8a1.35 1.35 0 0 1 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const V3 = { render: y3 }, A3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function $3(l, e) {
  return i(), d("svg", A3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.75 9.75v9.5h9.5v-9.5zM8.645 8.645A1.35 1.35 0 0 1 9.6 8.25h9.8a1.35 1.35 0 0 1 1.35 1.35v9.8a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V9.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.645 3.645A1.35 1.35 0 0 1 4.6 3.25h9.8a1.35 1.35 0 0 1 1.35 1.35V9a.75.75 0 0 1-1.5 0V4.75h-9.5v9.5H9a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V4.6c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const C3 = { render: $3 }, H3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function z3(l, e) {
  return i(), d("svg", H3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.35 3A1.35 1.35 0 0 0 3 4.35v9.8a1.35 1.35 0 0 0 1.35 1.35H8v3.65a1.35 1.35 0 0 0 1.35 1.35h9.8a1.35 1.35 0 0 0 1.35-1.35v-9.8A1.35 1.35 0 0 0 19.15 8H15.5V4.35A1.35 1.35 0 0 0 14.15 3zM14 8V4.5H4.5V14H8V9.35A1.35 1.35 0 0 1 9.35 8zm-4.5 6.75V19H19V9.5H9.5zm4.75-4.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5H15v2.25a.75.75 0 0 1-1.5 0V15h-2.25a.75.75 0 0 1 0-1.5h2.25v-2.25a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const k3 = { render: z3 }, B3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function L3(l, e) {
  return i(), d("svg", B3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.64 8.641a.75.75 0 0 1 1.062 0L12 10.94l2.298-2.298a.75.75 0 0 1 1.06 1.06L13.06 12l2.298 2.298a.75.75 0 1 1-1.06 1.06L12 13.062 9.702 15.36a.75.75 0 0 1-1.061-1.06l2.298-2.3-2.298-2.298a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _3 = { render: L3 }, T3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function S3(l, e) {
  return i(), d("svg", T3, e[0] || (e[0] = [
    a("path", { d: "M21.9 6.975c0-.75-.3-1.425-.825-1.95l-2.1-2.1a2.7 2.7 0 0 0-.9-.6c-.675-.3-1.425-.3-2.1 0-.3.15-.6.375-.9.6L12.3 5.7c-.075 0-.15 0-.15.075l-5.4 2.25c-.15.075-.375.15-.45.3a.51.51 0 0 0-.3.45L2.175 20.1c-.075.225-.075.45 0 .75.075.225.15.45.375.675.15.15.375.3.6.375.15 0 .225.075.375.075s.225 0 .375-.075l11.7-3.45c.225-.075.375-.15.525-.3s.3-.3.375-.525l1.875-5.7v-.15L21.075 9c.525-.6.825-1.275.825-2.025M15 16.95l-9.825 2.925L9.75 15.3c.3.15.6.225.975.225.6 0 1.2-.225 1.575-.675q.675-.675.675-1.575c0-.9-.225-1.2-.675-1.575-.225-.225-.45-.375-.75-.45a2.3 2.3 0 0 0-1.725 0c-.3.15-.525.3-.75.525s-.375.45-.45.75c-.15.3-.15.6-.15.825s.075.6.15.825l.075.075-4.425 4.425L7.425 9.3l5.25-2.175L16.95 11.4zm-5.1-3.6c0-.075 0-.225.075-.3 0-.075.075-.15.15-.225s.15-.15.225-.15c.075-.075.225-.075.3-.075s.225 0 .3.075.15.075.225.15c.15.15.225.3.225.525a.68.68 0 0 1-.225.525c-.3.3-.75.3-1.05 0-.075-.075-.15-.15-.15-.225-.075-.15-.075-.225-.075-.3m10.125-5.475L17.7 10.2l-3.9-3.9 2.325-2.325c.15-.15.225-.225.375-.3.3-.15.675-.15.975 0 .15.075.3.15.375.3l2.1 2.1c.225.225.375.525.375.9s-.075.6-.3.9" }, null, -1)
  ]));
}
const x3 = { render: S3 }, D3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function E3(l, e) {
  return i(), d("svg", D3, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M16.53 6.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0M.97 11.97a.75.75 0 0 1 1.06 0L6 15.94 7.94 14l-1.47-1.47a.75.75 0 1 1 1.06-1.06L12 15.94l9.47-9.47a.75.75 0 0 1 1.06 1.06l-9.575 9.576a1.35 1.35 0 0 1-1.91 0L9 15.061l-2.045 2.045a1.35 1.35 0 0 1-1.91 0L.97 13.03a.75.75 0 0 1 0-1.06",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("path", { d: "M0 0h24v24H0z" })
      ])
    ], -1)
  ]));
}
const R3 = { render: E3 }, O3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function N3(l, e) {
  return i(), d("svg", O3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 20a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m6.22-3.47a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 0 0-1.06-1.06l-2.22 2.22V4a.75.75 0 0 0-1.5 0v10.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const I3 = { render: N3 }, q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function F3(l, e) {
  return i(), d("svg", q3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m3.22-3.47a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V6a.75.75 0 0 0-1.5 0v5.19L9.03 8.97a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const P3 = { render: F3 }, Z3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function U3(l, e) {
  return i(), d("svg", Z3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.258 4.336a1.25 1.25 0 0 0-.884.366l-.95.95 3.182 3.181.95-.95a1.25 1.25 0 0 0 0-1.767l-1.414-1.414a1.25 1.25 0 0 0-.884-.366m.288 5.558-3.183-3.181-9.085 9.084a1.25 1.25 0 0 0-.362.774l-.242 2.74a.25.25 0 0 0 .072.2.25.25 0 0 0 .2.072l2.74-.242c.292-.026.567-.154.775-.361zm-1.341-6.849a2.75 2.75 0 0 1 2.998.597l1.413 1.414a2.75 2.75 0 0 1 0 3.888l-1.48 1.48-9.614 9.616a2.75 2.75 0 0 1-1.705.795l-2.74.242A1.75 1.75 0 0 1 3.18 19.18l.242-2.74a2.75 2.75 0 0 1 .795-1.702l9.616-9.615 1.48-1.48a2.8 2.8 0 0 1 .892-.597Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const j3 = { render: U3 }, G3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function W3(l, e) {
  return i(), d("svg", G3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 21a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M7.934 6.934a.75.75 0 0 1 1.06 0l7.425 7.425a.75.75 0 1 1-1.06 1.06L7.934 7.995a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.384 3.945a1.25 1.25 0 0 0-1.768 0l-9.192 9.192a1.25 1.25 0 0 0 0 1.768l5 5a1.18 1.18 0 0 0 1.667 0l9.243-9.243a1.25 1.25 0 0 0 0-1.768zM9.257 21.75a2.68 2.68 0 0 0 1.895-.785l9.242-9.242a2.75 2.75 0 0 0 0-3.89l-4.95-4.95a2.75 2.75 0 0 0-3.889 0l-9.192 9.193a2.75 2.75 0 0 0 0 3.89l5 5a2.68 2.68 0 0 0 1.894.784",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K3 = { render: W3 }, X3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function J3(l, e) {
  return i(), d("svg", X3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.316 13.308c-3.334-7.41-13.297-7.41-16.632 0a.75.75 0 0 1-1.368-.616c3.865-8.59 15.503-8.59 19.368 0a.75.75 0 1 1-1.368.616",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 11.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5M15.75 14a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y3 = { render: J3 }, Q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function eo(l, e) {
  return i(), d("svg", Q3, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.942 16.606a.75.75 0 0 0 .164-1.048l-2.475-3.396a.75.75 0 0 0-1.212.883l2.475 3.397a.75.75 0 0 0 1.048.164M12 18.25a.75.75 0 0 0 .75-.75V14a.75.75 0 0 0-1.5 0v3.5c0 .414.336.75.75.75m-7.942-1.644a.75.75 0 0 0 1.048-.164l2.47-3.388a.75.75 0 0 0-1.213-.883l-2.47 3.387a.75.75 0 0 0 .165 1.048",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.316 7.692c-3.335 7.41-13.297 7.41-16.632 0a.75.75 0 1 0-1.368.616c3.865 8.59 15.503 8.59 19.368 0a.75.75 0 0 0-1.368-.616",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const lo = { render: eo }, to = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ao(l, e) {
  return i(), d("svg", to, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.928 12.047c.872 1.273 2.018 2.516 3.327 3.468 1.464 1.064 3.09 1.735 4.745 1.735s3.281-.671 4.745-1.735c1.31-.952 2.455-2.195 3.327-3.468C17.829 9.305 15.42 6.75 12 6.75s-5.829 2.556-8.072 5.297m-1.511-.519C4.67 8.741 7.58 5.25 12 5.25s7.329 3.49 9.583 6.278c.202.25.223.6.051.872-.988 1.565-2.37 3.139-4.007 4.328-1.634 1.188-3.564 2.022-5.627 2.022s-3.993-.834-5.627-2.022c-1.636-1.19-3.02-2.763-4.007-4.328a.75.75 0 0 1 .05-.872Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const no = { render: ao }, oo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ro(l, e) {
  return i(), d("svg", oo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-4.034-4.034c-1.35.763-2.854 1.254-4.436 1.254-2.063 0-3.993-.834-5.627-2.022-1.636-1.19-3.02-2.763-4.007-4.328a.75.75 0 0 1 .05-.872c1.128-1.393 2.404-2.934 3.917-4.134L2.47 3.53a.75.75 0 0 1 0-1.06m4.932 5.992c-1.278.983-2.4 2.272-3.474 3.585.872 1.273 2.018 2.516 3.327 3.468 1.464 1.064 3.09 1.735 4.745 1.735 1.137 0 2.26-.316 3.329-.86L13.34 14.4a2.75 2.75 0 0 1-3.742-3.742zm3.36 3.36 1.415 1.416a1.25 1.25 0 0 1-1.415-1.415ZM11.25 6a.75.75 0 0 1 .75-.75c4.42 0 7.329 3.49 9.583 6.278.202.25.223.6.051.872-.334.53-.713 1.059-1.13 1.573a.75.75 0 0 1-1.164-.946q.392-.484.732-.98C17.829 9.305 15.42 6.75 12 6.75a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const so = { render: ro }, io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function uo(l, e) {
  return i(), d("svg", io, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.345 7.603C10 7.895 9.75 8.341 9.75 9a.75.75 0 0 1-1.5 0c0-1.091.437-1.958 1.124-2.54.67-.57 1.538-.835 2.376-.835s1.705.265 2.376.834c.687.583 1.124 1.45 1.124 2.541 0 .766-.196 1.35-.517 1.83-.269.404-.619.716-.894.962l-.087.078c-.308.276-.539.504-.709.804-.162.287-.293.688-.293 1.326a.75.75 0 1 1-1.5 0c0-.862.181-1.524.488-2.065.299-.528.692-.894 1.01-1.18l.072-.065c.3-.27.508-.455.665-.692.149-.223.265-.514.265-.998 0-.659-.25-1.105-.595-1.397-.36-.306-.868-.478-1.405-.478s-1.045.172-1.405.478m2.167 9.838a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const co = { render: uo }, vo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function po(l, e) {
  return i(), d("svg", vo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.513 3.971C4.371 2.606 5.495 1.5 6.825 1.5h10.35c1.328 0 2.456 1.105 2.311 2.472-.32 3.074-1.55 4.624-2.697 5.713a24 24 0 0 1-.572.521l-.2.18a7 7 0 0 0-.582.575C15.14 11.298 15 11.598 15 12c0 .406.141.709.432 1.051.154.182.344.366.577.58l.212.193c.174.158.365.332.552.512 1.137 1.092 2.367 2.638 2.713 5.686.156 1.376-.989 2.478-2.312 2.478H6.825c-1.322 0-2.468-1.102-2.31-2.478m-.002-16.05c.32 3.074 1.553 4.613 2.7 5.697.19.179.383.35.558.507l.213.19c.234.212.425.393.58.573.292.339.436.643.436 1.061 0 .421-.144.73-.434 1.072-.215.255-.458.474-.758.745-.173.156-.364.329-.58.535-1.136 1.086-2.367 2.62-2.714 5.67M6.825 3c-.526 0-.861.42-.82.816.275 2.64 1.288 3.866 2.238 4.762.173.164.338.311.507.46l.238.214c.243.22.493.453.712.708.457.53.8 1.169.8 2.04 0 .867-.337 1.508-.789 2.042-.278.328-.647.663-.997.98-.157.142-.31.281-.45.414-.948.906-1.962 2.135-2.26 4.755-.043.384.288.809.821.809h10.35c.533 0 .864-.425.82-.809-.297-2.621-1.313-3.862-2.26-4.774-.173-.165-.337-.314-.504-.466l-.238-.216a8 8 0 0 1-.703-.712c-.45-.529-.79-1.163-.79-2.023 0-.863.346-1.497.801-2.022a9 9 0 0 1 .71-.705l.225-.201c.172-.154.342-.306.52-.475.95-.902 1.964-2.14 2.239-4.781v-.002c.042-.393-.293-.814-.82-.814H6.824Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M16.092 20.25H7.928c-.731 0-.938-.844-.425-1.367 1.242-1.258 3.747-2.159 3.747-3.602V10.5c0-.93-1.781-1.64-2.883-3.15-.182-.249-.164-.6.298-.6h6.69c.395 0 .48.348.3.598C14.57 8.859 12.75 9.565 12.75 10.5v4.781c0 1.431 2.611 2.203 3.769 3.603.466.565.303 1.366-.427 1.366" }, null, -1)
  ]));
}
const ho = { render: po }, mo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fo(l, e) {
  return i(), d("svg", mo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 10.75a.75.75 0 0 1 .75.75v5a.75.75 0 1 1-1.5 0v-5a.75.75 0 0 1 .75-.75m.512-3.809a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const go = { render: fo }, wo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bo(l, e) {
  return i(), d("svg", wo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.25 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75M5.53 4.47a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l.72-.72v10.052l-.664-.83a.75.75 0 1 0-1.172.936l2 2.5a.75.75 0 0 0 1.172 0l2-2.5a.75.75 0 1 0-1.172-.936l-.664.83V6.81l.72.72a.75.75 0 0 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mo = { render: bo }, yo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vo(l, e) {
  return i(), d("svg", yo, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M5 3.75c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 0 1-1.5 0V5A2.75 2.75 0 0 1 5 2.25h11.172c.729 0 1.428.29 1.944.805l2.829 2.829a2.75 2.75 0 0 1 .805 1.944V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.5a.75.75 0 0 1 1.5 0V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.65-.366-.883l-2.829-2.829a1.25 1.25 0 0 0-.883-.366z"></path><path d="M7.25 3A.75.75 0 0 1 8 2.25h8a.75.75 0 0 1 .75.75v5.4a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 8.4zm1.5.75v4.5h6.5v-4.5zm5.5 9.25a.75.75 0 0 1 .75-.75h2.4c.746 0 1.35.604 1.35 1.35V21a.75.75 0 0 1-1.5 0v-7.25H15a.75.75 0 0 1-.75-.75M6 16.75a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75"></path><path d="M.47 12.53a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72H12a.75.75 0 0 1 0 1.5H2.81l1.72 1.72a.75.75 0 0 1-1.06 1.06z"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Ao = { render: Vo }, $o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Co(l, e) {
  return i(), d("svg", $o, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.648 1.308a.75.75 0 0 1 .404.98l-1.04 2.5a.75.75 0 1 1-1.385-.576l1.04-2.5a.75.75 0 0 1 .981-.404m3.655.006a.75.75 0 0 1 .383.989l-3.435 7.781A6.749 6.749 0 0 1 12 22.75a6.75 6.75 0 0 1-3.67-12.415l-4-8a.75.75 0 0 1 1.34-.67l4 8a6.8 6.8 0 0 1 1.875-.4L8.16 2.33a.75.75 0 1 1 1.348-.658l3.755 7.698q.305.059.6.143l3.45-7.815a.75.75 0 0 1 .989-.383ZM12 10.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ho = { render: Co }, zo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ko(l, e) {
  return i(), d("svg", zo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.5 3.5v11.113l5.955-2.552a.75.75 0 0 1 .605.006L20 16.585V3.5zM2 15.767V3.35C2 2.604 2.605 2 3.35 2h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.35A1.35 1.35 0 0 1 2 20.15zM20 20v-1.767L9.741 13.57l-6.24 2.674V20zM14.5 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M15.75 5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bo = { render: ko }, Lo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _o(l, e) {
  return i(), d("svg", Lo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 5A.75.75 0 0 1 3 4.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const To = { render: _o }, So = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xo(l, e) {
  return i(), d("svg", So, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 5A.75.75 0 0 1 3 4.25h8a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5m0 7a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 7a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Do = { render: xo }, Eo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ro(l, e) {
  return i(), d("svg", Eo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Oo = { render: Ro }, No = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Io(l, e) {
  return i(), d("svg", No, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qo = { render: Io }, Fo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Po(l, e) {
  return i(), d("svg", Fo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H8a.75.75 0 0 1 0-1.5h12.25V3.75H3.75V16a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-7.22 7.22a.75.75 0 1 1-1.06-1.06l7.22-7.22H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zo = { render: Po }, Uo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jo(l, e) {
  return i(), d("svg", Uo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H8a.75.75 0 0 1 0-1.5h12.25V3.75H3.75V16a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-7.22 7.22a.75.75 0 1 1-1.06-1.06l7.22-7.22H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Go = { render: jo }, Wo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ko(l, e) {
  return i(), d("svg", Wo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M21 2.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V4.81l-7.72 7.72a.75.75 0 1 1-1.06-1.06l7.72-7.72H15a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6a.75.75 0 0 1 1.5 0v6A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h6a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xo = { render: Ko }, Jo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yo(l, e) {
  return i(), d("svg", Jo, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1 0-1.5H18A2.75 2.75 0 0 1 20.75 6v14A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.319 2.417c-.32.377-.466.855-.529 1.215-.086.5-.475.982-1.04 1.094V6.25h6.5V4.726c-.565-.112-.954-.594-1.04-1.094-.063-.36-.21-.838-.529-1.215-.293-.346-.781-.667-1.681-.667s-1.388.321-1.681.667m-1.145-.97C9.762.755 10.674.25 12 .25s2.238.505 2.825 1.197c.52.614.743 1.322.841 1.814A1.25 1.25 0 0 1 16.75 4.5v1.9a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 6.4V4.5a1.25 1.25 0 0 1 1.084-1.24c.098-.491.32-1.2.84-1.813",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qo = { render: Yo }, e4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function l4(l, e) {
  return i(), d("svg", e4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t4 = { render: l4 }, a4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n4(l, e) {
  return i(), d("svg", a4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12a9.2 9.2 0 0 0 2.14 5.918L18.06 5.011A9.2 9.2 0 0 0 12 2.75m7.11 3.332L5.94 18.989A9.2 9.2 0 0 0 12 21.25 9.25 9.25 0 0 0 21.25 12a9.2 9.2 0 0 0-2.14-5.918M1.25 12C1.25 6.063 6.063 1.25 12 1.25a10.72 10.72 0 0 1 7.677 3.225A10.72 10.72 0 0 1 22.75 12c0 5.937-4.813 10.75-10.75 10.75a10.72 10.72 0 0 1-7.677-3.225A10.72 10.72 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o4 = { render: n4 }, r4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s4(l, e) {
  return i(), d("svg", r4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.557 5.967c-.532.451-.907 1.135-.907 2.113a.75.75 0 0 1-1.5 0c0-1.41.563-2.515 1.437-3.257.858-.728 1.975-1.073 3.063-1.073s2.205.345 3.063 1.073c.875.742 1.437 1.847 1.437 3.257 0 .993-.253 1.735-.658 2.344-.347.52-.798.922-1.176 1.26l-.119.106c-.42.38-.766.715-1.02 1.165-.248.438-.436 1.032-.436 1.943a.75.75 0 0 1-1.5 0c0-1.135.238-1.99.63-2.682.384-.678.891-1.152 1.323-1.54l.106-.096c.4-.36.708-.636.943-.988.234-.35.407-.801.407-1.512 0-.978-.375-1.662-.907-2.113-.548-.465-1.306-.717-2.093-.717s-1.545.252-2.093.717m2.955 12.474a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i4 = { render: s4 }, d4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u4(l, e) {
  return i(), d("svg", d4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c4 = { render: u4 }, v4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function p4(l, e) {
  return i(), d("svg", v4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M12 18.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5" }, null, -1)
  ]));
}
const h4 = { render: p4 }, m4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f4(l, e) {
  return i(), d("svg", m4, e[0] || (e[0] = [
    a("path", { d: "M15.975 12a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225l3.525-3.525a.68.68 0 0 0 .225-.525.68.68 0 0 0-.225-.525L17.025 3.9c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.25 2.25H9c-2.025 0-5.775 1.125-5.775 5.475 0 4.8 3.75 6.075 5.775 6.075h8.7c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.45 0-4.275-.15-4.275-4.575C4.725 8.85 8.55 8.7 9 8.7h9.225l-2.25 2.25c-.3.3-.3.75 0 1.05" }, null, -1)
  ]));
}
const g4 = { render: f4 }, w4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function b4(l, e) {
  return i(), d("svg", w4, e[0] || (e[0] = [
    a("path", { d: "M18.975 4.275c-.45 0-.75.3-.75.75v6c0 .45.3.75.75.75s.75-.3.75-.75v-6c0-.45-.3-.75-.75-.75M17.7 17.25H9c-.45 0-4.275-.15-4.275-4.575C4.725 8.85 8.55 8.7 9 8.7h5.175l-2.25 2.25c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225L16.5 8.475c.3-.3.3-.75 0-1.05L12.975 3.9c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.25 2.25H9c-2.025 0-5.775 1.125-5.775 5.475 0 4.8 3.75 6.075 5.775 6.075h8.7c.45 0 .75-.3.75-.75s-.3-.75-.75-.75" }, null, -1)
  ]));
}
const M4 = { render: b4 }, y4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V4(l, e) {
  return i(), d("svg", y4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.75 10.625a.75.75 0 0 1-.75.75H9.795l-.058.004a2.5 2.5 0 0 0-.983.282c-.257.138-.5.336-.68.626-.179.288-.324.71-.324 1.338 0 1.435.571 2.03 1.037 2.31a2.3 2.3 0 0 0 1.012.315h.801a.75.75 0 0 1 0 1.5h-.8V17v.75h-.023a2 2 0 0 1-.162-.01 3.8 3.8 0 0 1-1.602-.52c-.934-.562-1.763-1.655-1.763-3.595 0-.871.205-1.575.55-2.13a3.26 3.26 0 0 1 1.246-1.156 4 4 0 0 1 1.733-.464h.02l.001.75v-.75H17a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.75 10.638a.75.75 0 0 1-.23.527l-3.5 3.375a.75.75 0 1 1-1.04-1.08l2.96-2.854-2.98-3.085a.75.75 0 0 1 1.08-1.042l3.5 3.625a.75.75 0 0 1 .21.534",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A4 = { render: V4 }, $4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function C4(l, e) {
  return i(), d("svg", $4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.75 12a9.25 9.25 0 0 1 17.19-4.75H17a.75.75 0 0 0 0 1.5h4.4a1.35 1.35 0 0 0 1.35-1.35V3a.75.75 0 0 0-1.5 0v3.52A10.75 10.75 0 0 0 12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75c5.39 0 9.852-3.966 10.63-9.138a.75.75 0 0 0-1.483-.224A9.25 9.25 0 0 1 2.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const H4 = { render: C4 }, z4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k4(l, e) {
  return i(), d("svg", z4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.745 11.084c.202-1.802 1.956-3.334 4.243-3.334 1.274 0 2.394.482 3.164 1.222h-.658a.75.75 0 0 0 0 1.5H16.4a1.35 1.35 0 0 0 1.35-1.35V7.5a.75.75 0 0 0-1.5 0v.447c-1.064-1.053-2.592-1.697-4.262-1.697-2.912 0-5.432 1.976-5.733 4.666a.75.75 0 0 0 1.49.168m8.508.849c-.223 2.49-2.095 4.317-4.24 4.317-1.353 0-2.59-.719-3.38-1.878h.873a.75.75 0 0 0 0-1.5H7.6a1.35 1.35 0 0 0-1.35 1.35V16.4a.75.75 0 0 0 1.5 0v-.712c1.044 1.255 2.554 2.062 4.262 2.062 3.053 0 5.455-2.557 5.735-5.683a.75.75 0 1 0-1.494-.134",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B4 = { render: k4 }, L4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _4(l, e) {
  return i(), d("svg", L4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.796 11.074A9.251 9.251 0 0 1 19.939 7.25H17a.75.75 0 0 0 0 1.5h4.4a1.35 1.35 0 0 0 1.35-1.35V3a.75.75 0 0 0-1.5 0v3.52A10.75 10.75 0 0 0 12 1.25c-5.575 0-10.158 4.243-10.697 9.676a.75.75 0 1 0 1.493.148m9.253 10.176c4.796 0 8.74-3.65 9.205-8.324a.75.75 0 0 1 1.492.148c-.539 5.433-5.122 9.676-10.697 9.676a10.75 10.75 0 0 1-9.25-5.27V21a.75.75 0 0 1-1.5 0v-4.4c0-.746.605-1.35 1.35-1.35H7.05a.75.75 0 0 1 0 1.5H4.11a9.24 9.24 0 0 0 7.94 4.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T4 = { render: _4 }, S4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x4(l, e) {
  return i(), d("svg", S4, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M20.436 15.665A9.25 9.25 0 1 0 7.07 19.928a.75.75 0 1 1-.785 1.278C1.827 18.47-.08 12.812 2.026 7.851c2.32-5.465 8.631-8.015 14.096-5.695s8.015 8.63 5.695 14.096a10.7 10.7 0 0 1-4.26 4.954.75.75 0 0 1-.785-1.278 9.2 9.2 0 0 0 3.665-4.263Z"></path><path d="M22.75 21a.75.75 0 0 1-.75.75h-4.4a1.35 1.35 0 0 1-1.35-1.35V16a.75.75 0 0 1 1.5 0v4.25H22a.75.75 0 0 1 .75.75"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const D4 = { render: x4 }, E4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function R4(l, e) {
  return i(), d("svg", E4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v2.5a.75.75 0 0 1-1.5 0V5A2.75 2.75 0 0 1 5 2.25h11.172c.729 0 1.428.29 1.944.805l2.829 2.829a2.75 2.75 0 0 1 .805 1.944V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-2.5a.75.75 0 0 1 1.5 0V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V7.828c0-.331-.132-.65-.366-.883l-2.829-2.829a1.25 1.25 0 0 0-.883-.366z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 16.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M14.25 13a.75.75 0 0 1 .75-.75h2.4c.746 0 1.35.604 1.35 1.35V21a.75.75 0 0 1-1.5 0v-7.25H15a.75.75 0 0 1-.75-.75M16 2.25a.75.75 0 0 1 .75.75v5.4a1.35 1.35 0 0 1-1.35 1.35h-1.9a.75.75 0 0 1 0-1.5h1.75V3a.75.75 0 0 1 .75-.75m-3.47 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 1.06l1.72 1.72H1a.75.75 0 0 0 0 1.5h9.19l-1.72 1.72a.75.75 0 0 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O4 = { render: R4 }, N4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I4(l, e) {
  return i(), d("svg", N4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.348 9.348a3.75 3.75 0 1 1 5.304 5.303 3.75 3.75 0 0 1-5.304-5.303M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.256 1.81a.75.75 0 0 1 .725-.56h1.954c.34 0 .639.23.725.56l.528 2.008 1.938.797 1.387-1.185a.75.75 0 0 1 1.017.04l2 2a.75.75 0 0 1 .043 1.014l-1.18 1.396.778 1.88 2.014.513a.75.75 0 0 1 .565.727v1.978a.75.75 0 0 1-.561.726l-2.025.526-.78 1.884 1.188 1.4a.75.75 0 0 1-.042 1.016l-2 2a.75.75 0 0 1-1.03.028l-.056-.05-.152-.135-.491-.431c-.232-.203-.47-.406-.664-.566l-1.898.786-.512 2.022a.75.75 0 0 1-.727.566h-2a.75.75 0 0 1-.727-.566l-.51-2.022-1.844-.758-1.445 1.177a.75.75 0 0 1-1.004-.05l-2-2a.75.75 0 0 1-.03-1.03l1.2-1.346-.788-1.873-2.05-.558A.75.75 0 0 1 1.25 13v-2a.75.75 0 0 1 .58-.73l1.994-.466.767-1.886-1.173-1.445A.75.75 0 0 1 3.47 5.47l2-2a.75.75 0 0 1 1.029-.03l1.35 1.201 1.869-.788.538-2.044Zm1.303.94-.485 1.842a.75.75 0 0 1-.434.5L7.995 6.207a.75.75 0 0 1-.79-.13L6.03 5.03 5.01 6.052l1.026 1.264a.75.75 0 0 1 .113.755l-1.08 2.657a.75.75 0 0 1-.524.448l-1.794.42v.831l1.848.504a.75.75 0 0 1 .494.433l1.115 2.645a.75.75 0 0 1-.131.79L5.03 17.971l1.02 1.02 1.266-1.032a.75.75 0 0 1 .76-.113l2.605 1.072c.22.09.384.28.442.51l.46 1.822h.832l.46-1.821a.75.75 0 0 1 .441-.509l2.651-1.098a.75.75 0 0 1 .723.083c.257.183.723.581 1.095.905l.183.16 1.012-1.012-1.037-1.223a.75.75 0 0 1-.121-.772l1.098-2.652a.75.75 0 0 1 .504-.439l1.825-.474v-.815l-1.813-.461a.75.75 0 0 1-.508-.44l-1.097-2.65a.75.75 0 0 1 .12-.771l1.03-1.218L17.96 5.02l-1.208 1.032a.75.75 0 0 1-.772.124l-2.707-1.113a.75.75 0 0 1-.44-.503l-.476-1.811h-.798Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q4 = { render: I4 }, F4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P4(l, e) {
  return i(), d("svg", F4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 2.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.25 5a3.75 3.75 0 1 1 .974 2.521l-5.681 3.247a3.75 3.75 0 0 1 0 2.464l5.681 3.247a3.75 3.75 0 1 1-.767 1.29L8.776 14.52a3.75 3.75 0 1 1 0-5.043l5.681-3.246A3.8 3.8 0 0 1 14.25 5M18 16.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M3.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z4 = { render: P4 }, U4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j4(l, e) {
  return i(), d("svg", U4, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 12.25a.75.75 0 0 1 .75.75v6c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-6a.75.75 0 0 1 1.5 0v6A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.53 2.47a.75.75 0 0 0-1.06 0l-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22V15a.75.75 0 0 0 1.5 0V4.81l2.22 2.22a.75.75 0 1 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G4 = { render: j4 }, W4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K4(l, e) {
  return i(), d("svg", W4, e[0] || (e[0] = [
    a("path", { d: "M7 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 7.75a4.25 4.25 0 0 0 0 8.5h10a4.25 4.25 0 0 0 0-8.5zm-4.066.184A5.75 5.75 0 0 1 7 6.25h10a5.75 5.75 0 0 1 0 11.5H7a5.75 5.75 0 0 1-4.066-9.816",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X4 = { render: K4 }, J4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Y4(l, e) {
  return i(), d("svg", J4, e[0] || (e[0] = [
    a("path", { d: "M16.75 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 7.75a4.25 4.25 0 0 0 0 8.5h10a4.25 4.25 0 0 0 0-8.5zm-4.066.184A5.75 5.75 0 0 1 7 6.25h10a5.75 5.75 0 0 1 0 11.5H7a5.75 5.75 0 0 1-4.066-9.816",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q4 = { render: Y4 }, er = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lr(l, e) {
  return i(), d("svg", er, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.87 8.261a.75.75 0 0 1 .869.61l1.995 11.345a1.25 1.25 0 0 0 1.23 1.034h8.071a1.25 1.25 0 0 0 1.231-1.034L19.261 8.87a.75.75 0 0 1 1.478.26l-1.995 11.346a2.75 2.75 0 0 1-2.709 2.274h-8.07a2.75 2.75 0 0 1-2.709-2.274L3.261 9.13a.75.75 0 0 1 .609-.869m6.755-5.511c-.69 0-1.25.56-1.25 1.25v1.25h5.25V4c0-.69-.56-1.25-1.25-1.25zm-2.75 2.5V4a2.75 2.75 0 0 1 2.75-2.75h2.75A2.75 2.75 0 0 1 16.125 4v1.25H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tr = { render: lr }, ar = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nr(l, e) {
  return i(), d("svg", ar, e[0] || (e[0] = [
    a("path", { d: "M15 7.275H5.775l2.25-2.25c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0L3.45 7.5a.68.68 0 0 0-.225.525.68.68 0 0 0 .225.525L6.975 12a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05L5.775 8.7H15c.45 0 4.275.15 4.275 3.975 0 4.35-3.825 4.575-4.275 4.575H6.3c-.45 0-.75.3-.75.75s.3.75.75.75H15c2.025 0 5.775-1.275 5.775-6.075 0-4.275-3.75-5.4-5.775-5.4" }, null, -1)
  ]));
}
const or = { render: nr }, rr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sr(l, e) {
  return i(), d("svg", rr, e[0] || (e[0] = [
    a("path", { d: "M5.775 5.025c0-.45-.3-.75-.75-.75s-.75.3-.75.75v6c0 .45.3.75.75.75s.75-.3.75-.75zM15 7.275H9.825l2.25-2.25c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0L7.5 7.5a.68.68 0 0 0-.225.525.68.68 0 0 0 .225.525l3.525 3.525a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05l-2.25-2.25H15c.45 0 4.275.15 4.275 3.975 0 4.35-3.825 4.575-4.275 4.575H6.3c-.45 0-.75.3-.75.75s.3.75.75.75H15c2.025 0 5.775-1.275 5.775-6.075 0-4.35-3.75-5.475-5.775-5.475" }, null, -1)
  ]));
}
const ir = { render: sr }, dr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ur(l, e) {
  return i(), d("svg", dr, e[0] || (e[0] = [
    a("path", { d: "M14.175 9.9h-5.4l2.25-2.325c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0c-.075 0-.15.15-.225.225l-.6.6c-.225.3-.525.525-.75.825L7.575 9l-.675.675c-.15.15-.225.3-.375.375a.85.85 0 0 0-.225.6c0 .3.225.525.375.675.225.15.375.375.6.525.3.225.525.525.825.75.3.3.6.525.825.825l.675.675.375.375c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05l-2.175-2.1h5.325c.375 0 2.025.15 2.025 2.25 0 2.475-1.725 2.625-2.025 2.625h-.825c-.45 0-.75.3-.75.75s.3.75.75.75h.825c1.2 0 3.525-.825 3.525-4.125.075-2.925-2.25-3.675-3.525-3.675" }, null, -1),
    a("path", { d: "M12 1.275C6.075 1.275 1.275 6.075 1.275 12S6.075 22.725 12 22.725 22.725 17.925 22.725 12 17.925 1.275 12 1.275m0 19.95A9.22 9.22 0 0 1 2.775 12C2.775 6.9 6.9 2.775 12 2.775S21.225 6.9 21.225 12 17.1 21.225 12 21.225" }, null, -1)
  ]));
}
const cr = { render: ur }, vr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pr(l, e) {
  return i(), d("svg", vr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 20a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m6.22-16.53a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06l-2.22-2.22V16a.75.75 0 0 1-1.5 0V5.81L9.03 8.03a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hr = { render: pr }, mr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fr(l, e) {
  return i(), d("svg", mr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 10.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gr = { render: fr }, wr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function br(l, e) {
  return i(), d("svg", wr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.616 3.641c1.057-1.838 3.71-1.839 4.768 0l8.043 13.988c1.054 1.833-.27 4.121-2.384 4.121H3.957c-2.115 0-3.438-2.288-2.384-4.12zm3.468.748a1.25 1.25 0 0 0-2.168 0L2.873 18.377a1.25 1.25 0 0 0 1.084 1.873h16.086a1.25 1.25 0 0 0 1.084-1.873z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mr = { render: br }, yr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vr(l, e) {
  return i(), d("svg", yr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 7A.75.75 0 0 1 4 6.25h16a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 7m0 10a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75M4 11.25a.75.75 0 0 0 0 1.5h13.5a1.75 1.75 0 1 1 0 3.5h-1.75v-.75a.75.75 0 0 0-1.136-.643l-2.487 1.492a.75.75 0 0 0 0 1.302l2.487 1.492a.75.75 0 0 0 1.136-.643v-.75h1.75a3.25 3.25 0 0 0 0-6.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ar = { render: Vr }, $r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cr(l, e) {
  return i(), d("svg", $r, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.306 5.75a1.25 1.25 0 0 0-1.238 1.427l1.43 10a1.25 1.25 0 0 0 1.237 1.073h.53a1.25 1.25 0 0 0 1.237-1.073l1.43-10a1.25 1.25 0 0 0-1.238-1.427zm0-1.5a2.75 2.75 0 0 0-2.722 3.14l1.429 10a2.75 2.75 0 0 0 2.722 2.36h.53M7.306 4.25h3.388a2.75 2.75 0 0 1 2.722 3.14l-1.428 10a2.75 2.75 0 0 1-2.723 2.36",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m10 0a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hr = { render: Cr }, zr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kr(l, e) {
  return i(), d("svg", zr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v3.5h5.5v-3.5zM2.645 2.645A1.35 1.35 0 0 1 3.6 2.25h5.8a1.35 1.35 0 0 1 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 8.75H3.6A1.35 1.35 0 0 1 2.25 7.4V3.6c0-.358.142-.701.395-.955M14.75 3.75v8.5h5.5v-8.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.358.142-.701.395-.955M3.75 11.75v8.5h5.5v-8.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-8.8c0-.358.142-.701.395-.955M14.75 16.75v3.5h5.5v-3.5zm-1.105-1.105a1.35 1.35 0 0 1 .955-.395h5.8a1.35 1.35 0 0 1 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.358.142-.701.395-.955",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Br = { render: kr }, Lr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _r(l, e) {
  return i(), d("svg", Lr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75A9.25 9.25 0 0 0 2.75 14v.001a9.2 9.2 0 0 0 1.633 5.25H8.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.6-.3A10.7 10.7 0 0 1 1.25 14H2h-.75C1.25 8.061 6.063 3.25 12 3.25S22.75 8.063 22.75 14c0 2.42-.8 4.655-2.15 6.452a.75.75 0 0 1-.6.299l-4.5-.001a.75.75 0 0 1 0-1.5h4.116A9.2 9.2 0 0 0 21.25 14 9.25 9.25 0 0 0 12 4.75m1.123 5.51a.75.75 0 0 1 .617.863l-1 6a.75.75 0 1 1-1.48-.246l1-6a.75.75 0 0 1 .863-.617",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.348 17.348a3.75 3.75 0 1 1 5.304 5.304 3.75 3.75 0 0 1-5.304-5.304M12 17.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tr = { render: _r }, Sr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xr(l, e) {
  return i(), d("svg", Sr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 0-1.5H4.75V4a.75.75 0 0 0-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.03 17.03a.75.75 0 0 0 0-1.06l-4.5-4.5a.75.75 0 0 0-1.06 0L12 13.94 4.53 6.47a.75.75 0 0 0-1.06 1.06l8 8a.75.75 0 0 0 1.06 0L15 13.06l3.97 3.97a.75.75 0 0 0 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dr = { render: xr }, Er = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rr(l, e) {
  return i(), d("svg", Er, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 0-1.5H4.75V4a.75.75 0 0 0-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.453 17.013a.75.75 0 0 0 1.06.034l7.47-7.003 2.487 2.486a.75.75 0 0 0 1.06 0l4.5-4.5a.75.75 0 0 0-1.06-1.06L15 10.94l-2.47-2.47a.75.75 0 0 0-1.043-.017l-8 7.5a.75.75 0 0 0-.034 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Or = { render: Rr }, Nr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ir(l, e) {
  return i(), d("svg", Nr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17 15.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M19.75 17a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0M7 5.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M9.75 7a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0m9.78-2.53a.75.75 0 0 0-1.06 0l-14 14a.75.75 0 1 0 1.06 1.06l14-14a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qr = { render: Ir }, Fr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pr(l, e) {
  return i(), d("svg", Fr, e[0] || (e[0] = [
    s5('<path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path><path d="M15.5 16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M15.5 15.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M8.5 8.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M7.25 8.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m9.28-1.03a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06" clip-rule="evenodd"></path>', 5)
  ]));
}
const Zr = { render: Pr }, Ur = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jr(l, e) {
  return i(), d("svg", Ur, e[0] || (e[0] = [
    s5('<path fill-rule="evenodd" d="M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z" clip-rule="evenodd"></path><path d="M15.5 16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M15.5 15.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M8.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M8.5 8.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M7.25 8.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m9.28-1.03a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06l8-8a.75.75 0 0 0 0-1.06" clip-rule="evenodd"></path>', 5)
  ]));
}
const Gr = { render: jr }, Wr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kr(l, e) {
  return i(), d("svg", Wr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v3.5h5.5v-3.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 8.75H3.6A1.35 1.35 0 0 1 2.25 7.4zm12.5 13.15v3.5h5.5v-3.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm1.5-12.85v8.5h5.5v-8.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm-9.5 8.15v8.5h5.5v-8.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h5.8c.746 0 1.35.604 1.35 1.35v8.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xr = { render: Kr }, Jr = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yr(l, e) {
  return i(), d("svg", Jr, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.25 3.6c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h4.65V9.6c0-.746.604-1.35 1.35-1.35h4.65zm0 6.15h-4.5v10.5h4.5zm1.5 10.5h4.5V3.75h-4.5zm-7.5 0v-3.5h-4.5v3.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qr = { render: Yr }, e6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function l6(l, e) {
  return i(), d("svg", e6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.53 20.53a.75.75 0 0 1-1.06 0L15 16.06l-2.47 2.47a.75.75 0 0 1-1.06 0l-8-8a.75.75 0 1 1 1.06-1.06L12 16.94l2.47-2.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06m-5.06-8a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v6.19l-1.72-1.72a.75.75 0 1 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t6 = { render: l6 }, a6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n6(l, e) {
  return i(), d("svg", a6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.47 11.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0v-6.19l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm5.06-8a.75.75 0 0 0-1.06 0L15 7.94l-2.47-2.47a.75.75 0 0 0-1.06 0l-8 8a.75.75 0 1 0 1.06 1.06L12 7.06l2.47 2.47a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o6 = { render: n6 }, r6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s6(l, e) {
  return i(), d("svg", r6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 8 7.25m4 3a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m4 2a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i6 = { render: s6 }, d6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u6(l, e) {
  return i(), d("svg", d6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9A.75.75 0 0 1 6 8.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9M15.5 6.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m3.25 1.75a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m-9-2.5a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75m8.874 12.416a.75.75 0 0 1-1.04.208l-4.044-2.696-2.071 1.658a.75.75 0 0 1-.938 0l-5-4a.75.75 0 0 1 .938-1.172L11 16.04l2.031-1.626a.75.75 0 0 1 .885-.038l4.5 3a.75.75 0 0 1 .208 1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c6 = { render: u6 }, v6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function p6(l, e) {
  return i(), d("svg", v6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m-4 3a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m-4 2a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v16.5h16.5V3.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const h6 = { render: p6 }, m6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f6(l, e) {
  return i(), d("svg", m6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.038 12.24c.845-.87 2.144-1.49 3.962-1.49h12.19l-5.72 5.72a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 1 0-1.06 1.06l5.72 5.72H8c-2.182 0-3.883.755-5.038 1.947-1.147 1.182-1.712 2.75-1.712 4.303s.565 3.12 1.712 4.303C4.117 20.995 5.818 21.75 8 21.75a.75.75 0 0 0 0-1.5c-1.818 0-3.117-.62-3.962-1.49-.853-.88-1.288-2.063-1.288-3.26s.435-2.38 1.288-3.26",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const g6 = { render: f6 }, w6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function b6(l, e) {
  return i(), d("svg", w6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75A8.25 8.25 0 0 1 20.25 12c0 2.435-1.284 3.454-2.373 3.635-.577.096-1.12-.03-1.5-.306-.364-.262-.627-.69-.627-1.329V8h-1.5v6c0 1.111.487 1.995 1.248 2.546.744.537 1.702.723 2.625.569 1.91-.319 3.627-2.05 3.627-5.115 0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12s4.365 9.75 9.75 9.75a9.7 9.7 0 0 0 5.959-2.032.75.75 0 1 0-.918-1.187A8.25 8.25 0 1 1 12 3.75m3 3.5a.75.75 0 0 0-.75.75h1.5a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.75c-1.377 0-2.25.906-2.25 1.75V12a.75.75 0 0 1-1.5 0v-1.5c0-1.917 1.813-3.25 3.75-3.25s3.75 1.333 3.75 3.25V12a.75.75 0 0 1-1.5 0v-1.5c0-.844-.873-1.75-2.25-1.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 15.25c-1.377 0-2.25-.906-2.25-1.75V12a.75.75 0 0 0-1.5 0v1.5c0 1.917 1.813 3.25 3.75 3.25s3.75-1.333 3.75-3.25V12a.75.75 0 0 0-1.5 0v1.5c0 .844-.873 1.75-2.25 1.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const M6 = { render: b6 }, y6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V6(l, e) {
  return i(), d("svg", y6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.21 3.362C8.472 2.016 10.194 1.25 12 1.25s3.528.766 4.79 2.112c1.26 1.344 1.96 3.157 1.96 5.038 0 3.63.729 5.91 1.418 7.259a6.7 6.7 0 0 0 .924 1.393 3.4 3.4 0 0 0 .34.335l.01.007A.75.75 0 0 1 21 18.75H3a.75.75 0 0 1-.441-1.356l.008-.007.064-.054c.06-.054.157-.145.277-.281.24-.27.579-.718.924-1.393C4.522 14.31 5.25 12.03 5.25 8.4c0-1.881.7-3.694 1.96-5.038M19.361 17.25a9 9 0 0 1-.529-.909c-.81-1.585-1.582-4.105-1.582-7.941 0-1.514-.564-2.956-1.555-4.013C14.708 3.333 13.377 2.75 12 2.75s-2.707.583-3.695 1.637C7.315 5.444 6.75 6.887 6.75 8.4c0 3.836-.771 6.356-1.582 7.942a9 9 0 0 1-.53.908zm-9.467 3.101a.75.75 0 0 1 1.025.273 1.25 1.25 0 0 0 2.162 0 .75.75 0 1 1 1.298.752 2.752 2.752 0 0 1-4.758 0 .75.75 0 0 1 .273-1.025",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A6 = { render: V6 }, $6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function C6(l, e) {
  return i(), d("svg", $6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.48 5.78a.75.75 0 0 1 .51.93 6 6 0 0 0-.24 1.69c0 3.836-.771 6.356-1.582 7.941a9 9 0 0 1-.53.909H18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.441-1.356l.008-.007.064-.054c.06-.054.157-.145.277-.281.24-.27.579-.718.924-1.393C4.522 14.31 5.25 12.03 5.25 8.4c0-.722.103-1.432.3-2.11a.75.75 0 0 1 .93-.51m.73-2.418C8.472 2.016 10.194 1.25 12 1.25s3.528.766 4.79 2.112c1.26 1.344 1.96 3.157 1.96 5.038 0 3.63.729 5.91 1.418 7.258.345.676.684 1.123.924 1.394a3.4 3.4 0 0 0 .34.335l.01.007a.75.75 0 0 1-.877 1.217L21 18c-.435.611-.435.61-.436.61l-.003-.002-.006-.004-.014-.01a2 2 0 0 1-.168-.14 5 5 0 0 1-.402-.406 8 8 0 0 1-1.139-1.706c-.81-1.586-1.582-4.106-1.582-7.942 0-1.514-.564-2.956-1.555-4.013C14.707 3.333 13.377 2.75 12 2.75s-2.707.583-3.695 1.637A.75.75 0 1 1 7.21 3.362m2.684 16.989a.75.75 0 0 1 1.025.273 1.25 1.25 0 0 0 2.162 0 .75.75 0 1 1 1.298.752 2.75 2.75 0 0 1-4.758 0 .75.75 0 0 1 .273-1.025",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const H6 = { render: C6 }, z6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k6(l, e) {
  return i(), d("svg", z6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 1 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B6 = { render: k6 }, L6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _6(l, e) {
  return i(), d("svg", L6, e[0] || (e[0] = [
    s5('<path d="M17 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M17 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M15.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M7 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M7 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M5.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const T6 = { render: _6 }, S6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x6(l, e) {
  return i(), d("svg", S6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.47 11.47a.75.75 0 0 1 1.06 0L11 13.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D6 = { render: x6 }, E6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function R6(l, e) {
  return i(), d("svg", E6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O6 = { render: R6 }, N6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I6(l, e) {
  return i(), d("svg", N6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.97 8.969a.75.75 0 0 1 1.061.001l1.963 1.97 1.976-1.971a.75.75 0 0 1 1.06 1.062L13.055 12l1.975 1.969a.75.75 0 1 1-1.06 1.062l-1.976-1.97-1.963 1.969a.75.75 0 1 1-1.062-1.06L10.934 12l-1.965-1.97a.75.75 0 0 1 .001-1.061",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q6 = { render: I6 }, F6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P6(l, e) {
  return i(), d("svg", F6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.345 7.603C10 7.895 9.75 8.341 9.75 9a.75.75 0 0 1-1.5 0c0-1.091.437-1.958 1.124-2.54.67-.57 1.538-.835 2.376-.835s1.705.265 2.376.834c.687.583 1.124 1.45 1.124 2.541 0 .766-.196 1.35-.517 1.83-.269.404-.619.716-.894.962l-.087.078c-.308.276-.539.504-.709.804-.162.287-.293.688-.293 1.326a.75.75 0 1 1-1.5 0c0-.862.181-1.524.488-2.065.299-.528.693-.894 1.01-1.18l.072-.065c.3-.27.508-.455.665-.692.149-.222.265-.514.265-.998 0-.659-.25-1.105-.595-1.397-.36-.306-.868-.478-1.405-.478s-1.045.172-1.405.478m2.167 9.838a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z6 = { render: P6 }, U6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j6(l, e) {
  return i(), d("svg", U6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .512.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 1 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v.767H17a.75.75 0 1 1 0 1.5h-1.233c-.6 1.79-1.62 3.468-2.77 4.96l1.684 1.733a.75.75 0 1 1-1.076 1.045l-1.564-1.61a37 37 0 0 1-3.108 3.16.75.75 0 1 1-1.01-1.11 35 35 0 0 0 3.101-3.168 26 26 0 0 1-.791-1.03c-.374-.514-.735-1.053-.912-1.428a.75.75 0 0 1 1.357-.639c.11.232.392.668.767 1.184.173.237.358.48.541.713.901-1.2 1.675-2.484 2.187-3.81H7a.75.75 0 1 1 0-1.5h4.25V7a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G6 = { render: j6 }, W6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K6(l, e) {
  return i(), d("svg", W6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X6 = { render: K6 }, J6 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Y6(l, e) {
  return i(), d("svg", J6, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 10A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q6 = { render: Y6 }, es = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ls(l, e) {
  return i(), d("svg", es, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A9.25 9.25 0 0 0 2.75 12c0 1.686.45 3.265 1.237 4.625a.75.75 0 0 1 .088.512l-.638 3.426 3.426-.638a.75.75 0 0 1 .513.088A9.2 9.2 0 0 0 12 21.25a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75c-1.856 0-3.605-.471-5.13-1.3l-4.233.787a.75.75 0 0 1-.874-.874l.788-4.233A10.7 10.7 0 0 1 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ts = { render: ls }, as = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ns(l, e) {
  return i(), d("svg", as, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 2.75A5.25 5.25 0 0 0 2.75 8v8c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V8c0-2.9-2.35-5.25-5.25-5.25zM1.25 8A6.75 6.75 0 0 1 8 1.25h8A6.75 6.75 0 0 1 22.75 8v8A6.75 6.75 0 0 1 16 22.75H8A6.75 6.75 0 0 1 1.25 16z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 9.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25zM5.25 11A2.75 2.75 0 0 1 8 8.25h3A2.75 2.75 0 0 1 13.75 11v2A2.75 2.75 0 0 1 11 15.75H8A2.75 2.75 0 0 1 5.25 13z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "m17.25 10-2.667 2 2.667 2zm-.66-1.38c.89-.667 2.16-.032 2.16 1.08v4.6c0 1.112-1.27 1.747-2.16 1.08l-3.067-2.3a1.35 1.35 0 0 1 0-2.16z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const os = { render: ns }, rs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ss(l, e) {
  return i(), d("svg", rs, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.357 7.614a.75.75 0 0 1 1.029-.257L12 10.125l4.614-2.768a.75.75 0 0 1 .772 1.286l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 18V6A2.75 2.75 0 0 1 4 3.25h16A2.75 2.75 0 0 1 22.75 6v6.857a.75.75 0 1 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.21 18.4c.294-.299.769-.539 1.49-.539h4.473l-1.85 1.828a.75.75 0 1 0 1.054 1.067l3.15-3.111a.75.75 0 0 0 0-1.067l-3.15-3.112a.75.75 0 1 0-1.054 1.068l1.85 1.827H15.7c-1.079 0-1.954.371-2.56.989a3.14 3.14 0 0 0-.89 2.206c0 .792.292 1.596.89 2.206.606.617 1.481.988 2.56.988a.75.75 0 0 0 0-1.5c-.721 0-1.196-.24-1.49-.54a1.64 1.64 0 0 1-.46-1.154c0-.43.158-.848.46-1.156",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const is = { render: ss }, ds = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function us(l, e) {
  return i(), d("svg", ds, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.795 12.244a.75.75 0 0 1 .961-.449l5.5 2a.75.75 0 0 1 .465.911l-.936 3.277.926 2.78a.75.75 0 0 1-1.423.474l-1-3a.75.75 0 0 1-.01-.443l.809-2.828-4.843-1.761a.75.75 0 0 1-.449-.961m14.968-.455a.75.75 0 0 1 .32-.034l4.5.5a.75.75 0 1 1-.166 1.49l-4.336-.481-2.331.777v2.451l2.029.812a.75.75 0 0 1 .456.549l.5 2.5a.75.75 0 1 1-1.47.294l-.42-2.101-2.123-.85A.75.75 0 0 1 13.25 17v-3.5a.75.75 0 0 1 .513-.711zm2.474-7a.75.75 0 0 1 .475.948l-.5 1.5a.75.75 0 0 1-.606.505l-2.856.408v1.242l1.471-.588a.8.8 0 0 1 .279-.054h2a.75.75 0 0 1 .335.08l2 1a.75.75 0 1 1-.67 1.34l-1.842-.92h-1.679l-2.365.946a.75.75 0 0 1-1.029-.696v-3a.75.75 0 0 1 .644-.742l3.041-.435.354-1.06a.75.75 0 0 1 .948-.474M8.165 2.33a.75.75 0 0 1 1.006.335l1 2a.75.75 0 0 1-.047.751l-2 3a.75.75 0 0 1-.477.32L5.326 9.2l-2.357 1.886a.75.75 0 1 1-.937-1.172l2.5-2a.75.75 0 0 1 .32-.15l2.196-.439 1.587-2.379-.806-1.61a.75.75 0 0 1 .336-1.007Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cs = { render: us }, vs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ps(l, e) {
  return i(), d("svg", vs, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75A7.25 7.25 0 0 0 4.75 11a.75.75 0 0 1-1.5 0 8.75 8.75 0 0 1 17.5 0 .75.75 0 0 1-1.5 0A7.25 7.25 0 0 0 12 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.073 10.459a1.35 1.35 0 0 1 1.677 1.31v5.463a1.35 1.35 0 0 1-1.677 1.31l-1.74-.436a2.75 2.75 0 0 1-2.083-2.668v-1.877a2.75 2.75 0 0 1 2.083-2.667zm.177 1.502-1.553.388a1.25 1.25 0 0 0-.947 1.213v1.876c0 .574.39 1.074.947 1.213l1.553.388zm13.5-.001v5.08l1.553-.389a1.25 1.25 0 0 0 .947-1.213v-1.877a1.25 1.25 0 0 0-.947-1.212zm-1.5-.192a1.35 1.35 0 0 1 1.677-1.31l1.74.436a2.75 2.75 0 0 1 2.083 2.668v1.876a2.75 2.75 0 0 1-2.083 2.668l-1.74.435a1.35 1.35 0 0 1-1.677-1.31z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.25 18.5V18h1.5v.5A2.75 2.75 0 0 1 18 21.25h-3.5v-1.5H18c.69 0 1.25-.56 1.25-1.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.5 19.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm-2.25.75a2.25 2.25 0 0 1 2.25-2.25h3a2.25 2.25 0 0 1 0 4.5h-3a2.25 2.25 0 0 1-2.25-2.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hs = { render: ps }, ms = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fs(l, e) {
  return i(), d("svg", ms, e[0] || (e[0] = [
    a("path", { d: "M12 16.275c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.15-.825-.225-1.8-.225-2.775S8.85 10.125 9 9.225h6c.15.825.225 1.8.225 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-.975-.075-1.875-.225-2.775h4.275c.3.9.45 1.8.45 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-1.275-.225-2.55-.675-3.675 0-.075 0-.075-.075-.15-1.425-3.675-4.8-6.45-8.925-6.825-.375 0-.75-.075-1.125-.075s-.75 0-1.125.075a10.8 10.8 0 0 0-8.925 6.825c0 .075-.075.075-.075.15-.3 1.125-.525 2.4-.525 3.675s.225 2.55.675 3.675c0 .075 0 .075.075.15a10.65 10.65 0 0 0 9 6.825c.3 0 .675.075.975.075.45 0 .75-.3.75-.75s-.3-.75-.75-.75h-.6c-.45-.675-1.5-2.4-2.1-4.95zm-4.575-1.5H3.15c-.3-.9-.45-1.8-.45-2.775s.15-1.875.45-2.775h4.275c-.15.825-.225 1.8-.225 2.775s.15 1.875.225 2.775m12.75-7.05H16.2c-.45-2.025-1.2-3.6-1.725-4.65 2.55.75 4.575 2.475 5.7 4.65M12.6 2.775c.45.675 1.5 2.4 2.1 4.95H9.3c.675-2.55 1.725-4.35 2.1-4.95zm-3.15.3c-.6 1.05-1.275 2.625-1.725 4.65h-3.9c1.125-2.175 3.15-3.9 5.625-4.65m0 17.85c-2.475-.675-4.5-2.4-5.7-4.65h3.975c.45 1.95 1.2 3.525 1.725 4.65" }, null, -1),
    a("path", { d: "m22.275 17.25-5.325-3.3c-.45-.3-.975-.3-1.425 0-.375.3-.6.75-.45 1.275l1.275 6.15c.15.6.6 1.125 1.2 1.2h.15c.45 0 .825-.225 1.05-.675l.975-1.95 2.175-.225c.525-.075.9-.45 1.05-.9.15-.6-.15-1.2-.675-1.575M18.75 18.6l-1.05 2.1-1.05-5.175 4.5 2.775z" }, null, -1)
  ]));
}
const gs = { render: fs }, ws = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bs(l, e) {
  return i(), d("svg", ws, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.386 8.57a.75.75 0 0 1 1.044-.184L12 11.585l4.57-3.2a.75.75 0 1 1 .86 1.23l-5 3.5a.75.75 0 0 1-.86 0l-5-3.5a.75.75 0 0 1-.184-1.045",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25zM1.25 7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ms = { render: bs }, ys = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vs(l, e) {
  return i(), d("svg", ys, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.376 8.584a.75.75 0 0 1 1.04-.208L9.5 11.099l4.084-2.723a.75.75 0 0 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14a.75.75 0 0 1 0 1.5H3A2.75 2.75 0 0 1 .25 17V7A2.75 2.75 0 0 1 3 4.25h13A2.75 2.75 0 0 1 18.75 7v2a.75.75 0 0 1-1.5 0V7c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.53 10.47a.75.75 0 0 1 0 1.06l-1.72 1.72H23a.75.75 0 0 1 0 1.5h-4.19l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const As = { render: Vs }, $s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cs(l, e) {
  return i(), d("svg", $s, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.386 11.57a.75.75 0 0 1 1.044-.184L12 14.585l4.57-3.2a.75.75 0 1 1 .86 1.23l-5 3.5a.75.75 0 0 1-.86 0l-5-3.5a.75.75 0 0 1-.184-1.045",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.585 1.974a2.75 2.75 0 0 1 2.83 0l8 4.8a2.75 2.75 0 0 1 1.335 2.358V20A2.75 2.75 0 0 1 20 22.75H4A2.75 2.75 0 0 1 1.25 20V9.132a2.75 2.75 0 0 1 1.335-2.358zm2.058 1.287a1.25 1.25 0 0 0-1.286 0l-8 4.8a1.25 1.25 0 0 0-.607 1.071V20c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V9.132c0-.439-.23-.846-.607-1.071z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hs = { render: Cs }, zs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ks(l, e) {
  return i(), d("svg", zs, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.376 8.584a.75.75 0 0 1 1.04-.208L9.5 11.099l4.084-2.723a.75.75 0 0 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3 5.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14a.75.75 0 0 1 0 1.5H3A2.75 2.75 0 0 1 .25 17V7A2.75 2.75 0 0 1 3 4.25h13A2.75 2.75 0 0 1 18.75 7v2a.75.75 0 0 1-1.5 0V7c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M23.53 14.53a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H17a.75.75 0 0 0 0 1.5h4.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bs = { render: ks }, Ls = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _s(l, e) {
  return i(), d("svg", Ls, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58A2.75 2.75 0 0 1 7.96 16.25H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ts = { render: _s }, Ss = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xs(l, e) {
  return i(), d("svg", Ss, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58a2.75 2.75 0 0 1 2.147-1.032h11.04c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ds = { render: xs }, Es = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rs(l, e) {
  return i(), d("svg", Es, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 7 7.25h6a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58a2.75 2.75 0 0 1 2.147-1.032h11.04c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Os = { render: Rs }, Ns = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Is(l, e) {
  return i(), d("svg", Ns, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.5 11.75a4.75 4.75 0 0 0-4.115 7.125.75.75 0 0 1 .088.512l-.26 1.4 1.4-.26a.75.75 0 0 1 .513.088A4.75 4.75 0 1 0 7.5 11.75M1.25 16.5a6.25 6.25 0 1 1 3.374 5.55l-2.212.412a.75.75 0 0 1-.874-.874l.412-2.212a6.2 6.2 0 0 1-.7-2.876",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14 2.75a7.25 7.25 0 0 1 6.28 10.874.75.75 0 0 0-.088.513l.47 2.526-2.525-.47a.75.75 0 0 0-.512.087 7.2 7.2 0 0 1-2.462.877.75.75 0 0 0 .239 1.481 8.7 8.7 0 0 0 2.726-.921l3.335.62a.75.75 0 0 0 .874-.874l-.62-3.335A8.75 8.75 0 1 0 5.34 8.742a.75.75 0 1 0 1.485.215A7.25 7.25 0 0 1 14 2.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qs = { render: Is }, Fs = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ps(l, e) {
  return i(), d("svg", Fs, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.064 1.25h3.75a.75.75 0 0 1 .702.486l1.456 3.87a.75.75 0 0 1 .035.401l-.73 3.912c.897 2.108 2.378 3.525 4.834 4.796l3.864-.75a.75.75 0 0 1 .41.036l3.882 1.48a.75.75 0 0 1 .483.7v3.584c0 1.626-1.432 2.945-3.108 2.58-3.053-.664-8.71-2.353-12.672-6.315-3.796-3.795-5.067-9.037-5.495-11.87-.245-1.618 1.052-2.91 2.589-2.91m3.231 1.5H4.064c-.72 0-1.198.572-1.106 1.185.413 2.732 1.62 7.583 5.072 11.035 3.649 3.648 8.953 5.262 11.931 5.91.655.142 1.289-.356 1.289-1.114v-3.068l-3.2-1.219-3.907.757a.75.75 0 0 1-.48-.066c-2.894-1.452-4.773-3.175-5.86-5.892a.75.75 0 0 1-.04-.415l.731-3.925z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zs = { render: Ps }, Us = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function js(l, e) {
  return i(), d("svg", Us, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 7.25a.25.25 0 0 0-.25.25V11c0 .138.112.25.25.25h4.25V7.5A.25.25 0 0 0 9 7.25zm4.213 5.5c-.084.774-.308 1.392-.698 1.94-.523.731-1.4 1.414-2.85 2.14a.75.75 0 1 0 .67 1.34c1.55-.774 2.673-1.591 3.4-2.61.741-1.036 1.015-2.203 1.015-3.56V7.5A1.75 1.75 0 0 0 9 5.75H5A1.75 1.75 0 0 0 3.25 7.5V11c0 .966.784 1.75 1.75 1.75zM15 7.25a.25.25 0 0 0-.25.25V11c0 .138.112.25.25.25h4.25V7.5a.25.25 0 0 0-.25-.25zm4.212 5.5c-.083.774-.307 1.392-.697 1.94-.523.731-1.4 1.414-2.85 2.14a.75.75 0 1 0 .67 1.34c1.55-.774 2.673-1.591 3.4-2.61.741-1.036 1.015-2.203 1.015-3.56V7.5A1.75 1.75 0 0 0 19 5.75h-4a1.75 1.75 0 0 0-1.75 1.75V11c0 .966.784 1.75 1.75 1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gs = { render: js }, Ws = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ks(l, e) {
  return i(), d("svg", Ws, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v14.862l2.064-2.58A2.75 2.75 0 0 1 7.96 16.25H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25zM2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75H7.961c-.38 0-.739.173-.976.47l-2.33 2.913c-.798.996-2.405.433-2.405-.843z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.5 7.75a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1.25V8a.25.25 0 0 0-.25-.25zm.981 3a4 4 0 0 1-.206.3c-.337.449-.796.91-1.305 1.42a.75.75 0 1 0 1.06 1.06l.022-.021c.484-.485 1.016-1.016 1.423-1.559s.775-1.205.775-1.95V8A1.75 1.75 0 0 0 9.5 6.25h-1A1.75 1.75 0 0 0 6.75 8v1c0 .966.784 1.75 1.75 1.75zm5.019-3a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h1.25V8a.25.25 0 0 0-.25-.25zm.981 3a4 4 0 0 1-.206.3c-.337.449-.796.91-1.305 1.42a.75.75 0 1 0 1.06 1.06l.022-.021c.484-.485 1.016-1.016 1.423-1.559s.775-1.205.775-1.95V8a1.75 1.75 0 0 0-1.75-1.75h-1A1.75 1.75 0 0 0 12.75 8v1c0 .966.784 1.75 1.75 1.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xs = { render: Ks }, Js = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ys(l, e) {
  return i(), d("svg", Js, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.53 2.47a.75.75 0 0 1 0 1.06L3.81 9.25H16c2.182 0 3.883.755 5.038 1.947 1.147 1.182 1.712 2.75 1.712 4.303s-.565 3.12-1.712 4.303C19.883 20.995 18.182 21.75 16 21.75a.75.75 0 0 1 0-1.5c1.818 0 3.117-.62 3.962-1.49.853-.88 1.288-2.063 1.288-3.26s-.435-2.38-1.288-3.26c-.845-.87-2.144-1.49-3.962-1.49H3.81l5.72 5.72a.75.75 0 1 1-1.06 1.06l-7-7a.75.75 0 0 1 0-1.06l7-7a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qs = { render: Ys }, ei = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function li(l, e) {
  return i(), d("svg", ei, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.357 7.614a.75.75 0 0 1 1.029-.257L12 10.125l4.614-2.768a.75.75 0 1 1 .772 1.286l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 18V6A2.75 2.75 0 0 1 4 3.25h16A2.75 2.75 0 0 1 22.75 6v6.857a.75.75 0 1 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.684 13.473a.75.75 0 0 1-.007 1.06l-1.85 1.828H19.3c1.079 0 1.954.371 2.56.989.598.609.89 1.413.89 2.206s-.292 1.596-.89 2.206c-.606.617-1.481.988-2.56.988a.75.75 0 0 1 0-1.5c.721 0 1.196-.24 1.49-.54a1.64 1.64 0 0 0 .46-1.154c0-.43-.158-.848-.46-1.156-.294-.299-.769-.539-1.49-.539h-4.473l1.85 1.828a.75.75 0 1 1-1.054 1.067l-3.15-3.111a.75.75 0 0 1 0-1.067l3.15-3.112a.75.75 0 0 1 1.06.007Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ti = { render: li }, ai = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ni(l, e) {
  return i(), d("svg", ai, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.464 3.475a.75.75 0 0 1 .827-.166l19 8a.75.75 0 0 1 0 1.382l-19 8L3 20l.291.691a.75.75 0 0 1-.976-.996L5.742 12 2.315 4.305a.75.75 0 0 1 .15-.83Zm1.993 15.098L20.066 12 4.457 5.427l2.79 6.268a.75.75 0 0 1 0 .61z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 12a.75.75 0 0 1 .75-.75H22a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const oi = { render: ni }, ri = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function si(l, e) {
  return i(), d("svg", ri, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M1.26 7.775a.75.75 0 0 1 .582-.61L21.994 2.82a.75.75 0 0 1 .793 1.132L11.812 21.404l-.635-.4.635.4a.75.75 0 0 1-1.371-.257L8.834 12.88l-7.22-4.34a.75.75 0 0 1-.354-.766ZM11.552 19l9.017-14.338-16.558 3.57 5.882 3.533a.75.75 0 0 1 .35.5z"></path><path d="M8.841 12.874a.75.75 0 0 1 .184-1.045l12.697-8.89a.75.75 0 0 1 .86 1.229l-12.696 8.89a.75.75 0 0 1-1.045-.184"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const ii = { render: si }, di = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ui(l, e) {
  return i(), d("svg", di, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.376 8.584a.75.75 0 0 1 1.04-.208l4.084 2.723 4.084-2.723a.75.75 0 1 1 .832 1.248l-4.5 3a.75.75 0 0 1-.832 0l-4.5-3a.75.75 0 0 1-.208-1.04M5.75 13.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75m0-3a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20 5.75c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25v-.5a.75.75 0 0 0-1.5 0v.5A2.75 2.75 0 0 0 7 19.75h13A2.75 2.75 0 0 0 22.75 17V7A2.75 2.75 0 0 0 20 4.25H7A2.75 2.75 0 0 0 4.25 7v.5a.75.75 0 0 0 1.5 0V7c0-.69.56-1.25 1.25-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ci = { render: ui }, vi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pi(l, e) {
  return i(), d("svg", vi, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.862 4.648 6.863 8.604a1.75 1.75 0 0 1-.963.289H3c-.69 0-1.25.56-1.25 1.25v3.714c0 .69.56 1.25 1.25 1.25h2.9c.343 0 .678.1.963.29l6 3.955a.25.25 0 0 0 .387-.21V4.858a.25.25 0 0 0-.388-.209m-.825-1.252c1.163-.767 2.713.067 2.713 1.461v14.286c0 1.393-1.55 2.228-2.713 1.46l-6-3.955a.25.25 0 0 0-.137-.04H3a2.75 2.75 0 0 1-2.75-2.75v-3.715A2.75 2.75 0 0 1 3 7.393h2.9a.25.25 0 0 0 .138-.041zM16.97 6.97a.75.75 0 0 1 1.06 0h.001l.001.002.003.002.007.007.02.02.062.069c.05.057.12.138.201.241A6.87 6.87 0 0 1 19.75 11.5a6.87 6.87 0 0 1-1.425 4.189 5 5 0 0 1-.264.31l-.02.02-.006.007-.003.002v.001l.01-.01-.012.011a.75.75 0 0 1-1.063-1.058l.003-.002.035-.04c.016-.016-.035.04-.035.04h-.001l-.002.002.005-.005.033-.036c.031-.035.08-.09.139-.167a5.37 5.37 0 0 0 .448-5.843 5 5 0 0 0-.448-.685 3 3 0 0 0-.172-.203l-.005-.005a.75.75 0 0 1 .003-1.058",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M19.97 3.97a.75.75 0 0 1 1.06 0h.001l.002.002.003.003.009.01a2 2 0 0 1 .124.134c.079.089.188.218.316.385.257.333.594.823.929 1.46.67 1.274 1.336 3.143 1.336 5.536s-.666 4.262-1.336 5.537a10 10 0 0 1-.929 1.46 7 7 0 0 1-.44.518l-.01.01-.002.003-.002.001.043-.044-.044.045a.75.75 0 0 1-1.061-1.06l.014-.014.063-.07q.089-.098.25-.304c.212-.276.5-.693.79-1.244.58-1.1 1.164-2.731 1.164-4.838s-.584-3.738-1.164-4.838a8.7 8.7 0 0 0-.79-1.244 6 6 0 0 0-.313-.374l-.014-.014a.75.75 0 0 1 0-1.06" }, null, -1)
  ]));
}
const hi = { render: pi }, mi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fi(l, e) {
  return i(), d("svg", mi, e[0] || (e[0] = [
    a("path", { d: "M12 16.275c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H9c-.15-.825-.225-1.8-.225-2.775S8.85 10.125 9 9.225h6c.15.825.225 1.8.225 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-.975-.075-1.875-.225-2.775h4.275c.3.9.45 1.8.45 2.775 0 .45.3.75.75.75s.75-.3.75-.75c0-1.275-.225-2.55-.675-3.675 0-.075 0-.075-.075-.15-1.425-3.675-4.8-6.45-8.925-6.825-.375 0-.75-.075-1.125-.075s-.75 0-1.125.075a10.8 10.8 0 0 0-8.925 6.825c0 .075-.075.075-.075.15-.3 1.125-.525 2.4-.525 3.675s.225 2.55.675 3.675c0 .075 0 .075.075.15a10.65 10.65 0 0 0 9 6.825c.3 0 .675.075.975.075.45 0 .75-.3.75-.75s-.3-.75-.75-.75h-.6c-.45-.675-1.5-2.4-2.1-4.95zm-4.575-1.5H3.15c-.3-.9-.45-1.8-.45-2.775s.15-1.875.45-2.775h4.275c-.15.825-.225 1.8-.225 2.775s.15 1.875.225 2.775m12.75-7.05H16.2c-.45-2.025-1.2-3.6-1.725-4.65 2.55.75 4.575 2.475 5.7 4.65M12.6 2.775c.45.675 1.5 2.4 2.1 4.95H9.3c.675-2.55 1.725-4.35 2.1-4.95zm-3.15.3c-.6 1.05-1.275 2.625-1.725 4.65h-3.9c1.125-2.175 3.15-3.9 5.625-4.65m0 17.85c-2.475-.675-4.5-2.4-5.7-4.65h3.975c.45 1.95 1.2 3.525 1.725 4.65m11.025-2.7h-.75v-.75c0-.45-.3-.75-.75-.75s-.75.3-.75.75v1.5c0 .45.3.75.75.75h1.5c.45 0 .75-.3.75-.75s-.3-.75-.75-.75" }, null, -1),
    a("path", { d: "M18.975 14.25a4.705 4.705 0 0 0-4.725 4.725c0 2.625 2.1 4.725 4.725 4.725s4.725-2.1 4.725-4.725-2.1-4.725-4.725-4.725m0 8.025a3.2 3.2 0 0 1-3.225-3.225c0-1.8 1.425-3.225 3.225-3.225S22.2 17.25 22.2 19.05s-1.425 3.225-3.225 3.225" }, null, -1)
  ]));
}
const gi = { render: fi }, wi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bi(l, e) {
  return i(), d("svg", wi, e[0] || (e[0] = [
    a("path", { d: "M14.4 11.325 10.875 9.3a.68.68 0 0 0-.75 0 .9.9 0 0 0-.375.675v3.975c0 .3.15.525.375.675.15.075.225.075.375.075s.225 0 .375-.075L14.4 12.6a.79.79 0 0 0 .375-.675c0-.3-.15-.45-.375-.6" }, null, -1),
    a("path", { d: "M21.6 5.475c-1.125-1.125-2.775-1.2-5.7-1.275-1.5-.075-2.85-.075-3.9-.075s-2.4 0-3.975.075C5.1 4.275 3.45 4.35 2.4 5.475 1.275 6.6 1.275 8.25 1.275 11.25v1.425c0 3 0 4.65 1.125 5.775s2.775 1.2 5.7 1.275c1.5.075 2.85.075 3.9.075 1.125 0 2.4 0 3.9-.075 2.925-.075 4.575-.15 5.7-1.275s1.125-2.775 1.125-5.775V11.25c0-2.925 0-4.575-1.125-5.775m-.375 7.2c0 2.7 0 4.05-.675 4.725s-1.875.75-4.65.825c-1.5.075-2.775.075-3.9.075-1.05 0-2.4 0-3.9-.075-2.85-.075-3.975-.15-4.65-.825-.675-.75-.675-2.1-.675-4.725V11.25c0-2.7 0-4.05.675-4.725s1.875-.75 4.65-.825c1.5-.075 2.85-.075 3.9-.075s2.4 0 3.9.075c2.85.075 3.975.15 4.65.825.675.75.675 2.1.675 4.725z" }, null, -1)
  ]));
}
const Mi = { render: bi }, yi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vi(l, e) {
  return i(), d("svg", yi, e[0] || (e[0] = [
    a("path", { d: "M21.075 16.35c-.375-.225-.825-.075-1.05.3-1.2 2.1-3.225 3.6-5.475 4.275.45-.9 1.05-2.1 1.5-3.675.15-.375-.15-.825-.525-.9-.375-.15-.825.15-.9.525-.675 2.25-1.575 3.825-1.95 4.425-.225 0-.375.075-.6.075s-.375 0-.6-.075c-.375-.6-1.35-2.175-1.95-4.425-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9.45 1.575.975 2.775 1.5 3.675-2.25-.675-4.275-2.175-5.475-4.275-.375-.375-.825-.525-1.125-.3-.375.225-.45.675-.3 1.05 1.725 3 4.875 5.025 8.325 5.325.3 0 .675.075.975.075s.675 0 .975-.075c3.45-.3 6.525-2.325 8.325-5.325.225-.375.075-.825-.225-1.05M3 7.65c.375.225.825.075 1.05-.3 1.125-2.1 3.15-3.6 5.4-4.2-.45.9-1.05 2.1-1.5 3.675-.15.375.15.825.525.9H8.7c.3 0 .6-.225.75-.525.675-2.25 1.575-3.825 1.95-4.425.225 0 .375-.075.6-.075s.375 0 .6.075c.375.6 1.35 2.175 1.95 4.425.075.3.375.525.75.525h.225c.375-.15.6-.525.525-.9-.45-1.575-.975-2.775-1.5-3.675 2.25.675 4.275 2.175 5.475 4.275.15.225.375.375.675.375.15 0 .225 0 .375-.075.375-.225.45-.675.3-1.05-1.725-3-4.8-4.95-8.175-5.325h-.075c-.375 0-.675-.075-1.05-.075s-.675 0-1.05.075h-.075C7.5 1.65 4.425 3.675 2.7 6.6c-.225.375-.075.825.3 1.05M15.225 9.3a.666.666 0 0 0-.9.525l-.75 2.625-.825-2.7c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.6-.225.75-.525l.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025c0-.3-.225-.75-.6-.825m-12 5.925.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025a.666.666 0 0 0-.525-.9.666.666 0 0 0-.9.525l-.75 2.625-.75-2.625c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.525-.225.6-.525M23.25 9.3a.666.666 0 0 0-.9.525l-.75 2.625-.75-2.625c-.075-.3-.375-.525-.75-.525s-.6.225-.75.525l-.75 2.625-.75-2.625c-.15-.375-.525-.6-.9-.525-.375.15-.6.525-.525.9l1.5 5.025c.075.3.375.525.75.525s.6-.225.75-.525l.75-2.625.75 2.625c.075.3.375.525.75.525s.6-.225.75-.525l1.5-5.025c-.075-.375-.3-.825-.675-.9" }, null, -1)
  ]));
}
const Ai = { render: Vi }, $i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ci(l, e) {
  return i(), d("svg", $i, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 4A.75.75 0 0 1 3 3.25h18a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V4.75H3.75v11.5H6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.877 14.333a1.35 1.35 0 0 1 2.246 0l2.88 4.318a1.35 1.35 0 0 1-1.124 2.099H9.12a1.35 1.35 0 0 1-1.123-2.099l2.879-4.318ZM12 15.353 9.401 19.25H14.6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hi = { render: Ci }, zi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ki(l, e) {
  return i(), d("svg", zi, e[0] || (e[0] = [
    a("path", { d: "M15.6 6.375c-.375.225-.45.675-.225 1.05.15.225.375.3.6.3.15 0 .3-.075.45-.15.075-.075 1.8-1.275 1.8-3.6S16.5.45 16.425.375C16.05.15 15.6.225 15.375.6s-.15.825.225 1.05c.075 0 1.2.825 1.2 2.4s-1.2 2.325-1.2 2.325M7.575 7.65c.15.075.3.15.45.15.225 0 .45-.15.6-.3.225-.375.15-.825-.225-1.05-.075 0-1.2-.825-1.2-2.4s1.125-2.325 1.2-2.4c.375-.225.45-.675.225-1.05S7.95.15 7.575.375c-.075.075-1.8 1.275-1.8 3.6s1.725 3.6 1.8 3.675m9.075 11.175L15.225 13.8 12.9 5.475c.525-.3.825-.825.825-1.5 0-.975-.75-1.725-1.725-1.725s-1.725.75-1.725 1.725c0 .6.3 1.2.825 1.5L8.775 13.8l-1.35 4.95L6.3 22.725c-.075.375.15.825.525.9s.825-.15.9-.525l.975-3.45h6.675l.975 3.45c.075.3.375.525.75.525h.225c.375-.075.6-.525.525-.9zM12 7.8l1.5 5.475h-3zM9.075 18.225l.975-3.525h3.825l.975 3.525z" }, null, -1)
  ]));
}
const Bi = { render: ki }, Li = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _i(l, e) {
  return i(), d("svg", Li, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.25a.75.75 0 0 1 .723.55l1.046 3.767a.75.75 0 1 1-1.445.401l-.39-1.4a.75.75 0 0 1-1.212-.769l.555-2A.75.75 0 0 1 12 4.25m-1.5 6.148a.75.75 0 0 1 .522.924l-.535 1.928H13.5a.75.75 0 0 1 .735.901.75.75 0 0 1 1.192.384l2.296 8.264a.75.75 0 1 1-1.446.402l-.958-3.451H8.68l-.958 3.45a.75.75 0 0 1-1.446-.4l3.3-11.88a.75.75 0 0 1 .924-.522M9.099 18.25h5.804l-.92-3.313a.75.75 0 0 1-.012-.352.75.75 0 0 1-.47.165h-3.43z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M10.25 4a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ti = { render: _i }, Si = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xi(l, e) {
  return i(), d("svg", Si, e[0] || (e[0] = [
    a("path", { d: "M18 7.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05c0 0 1.275 1.35 1.275 3.45s-1.275 3.45-1.275 3.45c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225A.8.8 0 0 0 18 16.5c.075-.075 1.725-1.725 1.725-4.5S18.075 7.575 18 7.5" }, null, -1),
    a("path", { d: "M21 4.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05c0 0 2.25 2.4 2.25 6.45s-2.25 6.45-2.25 6.45c-.3.3-.3.75 0 1.05a.8.8 0 0 0 .525.225A.8.8 0 0 0 21 19.5c.075-.075 2.7-2.775 2.7-7.5.075-4.725-2.55-7.425-2.7-7.5m-13.95 3c-.3-.3-.75-.3-1.05 0-.075.075-1.725 1.725-1.725 4.5S5.925 16.425 6 16.5c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05 0 0-1.275-1.35-1.275-3.45S7.05 8.55 7.05 8.55c.3-.3.3-.825 0-1.05" }, null, -1),
    a("path", { d: "M1.725 12c0-4.125 2.25-6.45 2.25-6.45.3-.3.3-.75 0-1.05-.225-.3-.675-.3-.975 0C2.85 4.575.225 7.275.225 12S2.85 19.425 3 19.5a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75 0-1.05-.075 0-2.325-2.325-2.325-6.45M12 10.275c-.975 0-1.725.75-1.725 1.725s.75 1.725 1.725 1.725 1.725-.75 1.725-1.725-.75-1.725-1.725-1.725" }, null, -1)
  ]));
}
const Di = { render: xi }, Ei = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ri(l, e) {
  return i(), d("svg", Ei, e[0] || (e[0] = [
    a("path", { d: "M15.975 2.25h-7.95c-3.75 0-6.75 3-6.75 6.75v6c0 3.75 3 6.75 6.75 6.75h8.025c3.75 0 6.75-3 6.75-6.75V9c-.075-3.75-3.075-6.75-6.825-6.75M21.225 15a5.22 5.22 0 0 1-5.25 5.25h-7.95A5.22 5.22 0 0 1 2.775 15V9a5.22 5.22 0 0 1 5.25-5.25h8.025A5.22 5.22 0 0 1 21.3 9v6z" }, null, -1),
    a("path", { d: "M15.525 8.475c-.3-.3-.75-.3-1.05-.075s-.375.75-.075 1.05c0 .075.825.975.825 2.475 0 1.575-.75 2.475-.825 2.475-.3.3-.225.75.075 1.05.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.075-.075 1.2-1.35 1.2-3.525 0-2.025-1.125-3.375-1.2-3.45m-4.05 3c-.3.3-.225.825.075 1.05.15.15.3.15.525.15s.45-.075.6-.225c.3-.3.225-.75-.075-1.05-.375-.225-.9-.225-1.125.075" }, null, -1),
    a("path", { d: "M17.475 6.45c-.3-.3-.75-.225-1.05.075s-.225.75.075 1.05c0 0 1.725 1.575 1.725 4.425s-1.65 4.35-1.725 4.425c-.3.3-.3.75-.075 1.05a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.075-.075 2.25-2.025 2.25-5.55 0-3.45-2.1-5.4-2.25-5.475M8.775 12c0-1.575.75-2.475.825-2.475.3-.3.225-.75-.075-1.05s-.75-.225-1.05.075c-.075.075-1.2 1.35-1.2 3.525 0 2.1 1.125 3.45 1.2 3.525a.8.8 0 0 0 .525.225.8.8 0 0 0 .525-.225c.3-.3.3-.75.075-1.05-.075-.075-.825-.975-.825-2.55" }, null, -1),
    a("path", { d: "M5.775 12c0-2.775 1.65-4.35 1.725-4.425.3-.3.3-.75.075-1.05-.3-.3-.75-.3-1.05-.075-.075.075-2.25 2.025-2.25 5.55s2.175 5.475 2.25 5.55c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.225-.75-.075-1.05-.075-.15-1.725-1.65-1.725-4.5" }, null, -1)
  ]));
}
const Oi = { render: Ri }, Ni = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ii(l, e) {
  return i(), d("svg", Ni, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.463 1.307a.75.75 0 0 1 .817.163l5.5 5.5a.75.75 0 0 1-.058 1.113L12.883 12l4.839 3.917a.75.75 0 0 1 .058 1.113l-5.5 5.5A.75.75 0 0 1 11 22v-8.476l-3.778 3.059a.75.75 0 0 1-.944-1.166L10.5 12 6.28 8.583a.75.75 0 0 1 .943-1.166L11 10.476V2a.75.75 0 0 1 .463-.693M12.5 13.62l3.63 2.939-3.63 3.63v-6.57Zm0-3.24V3.81l3.63 3.631z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qi = { render: Ii }, Fi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pi(l, e) {
  return i(), d("svg", Fi, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.579 5.304a.75.75 0 0 1 .821.179l3.143 3.3a.75.75 0 0 1-.057 1.089L12.982 12l2.504 2.129a.75.75 0 0 1 .057 1.088l-3.143 3.3A.75.75 0 0 1 11.107 18v-4.407l-1.621 1.379a.75.75 0 1 1-.972-1.143L10.666 12l-2.152-1.829a.75.75 0 1 1 .972-1.142l1.621 1.378V6a.75.75 0 0 1 .472-.696m1.028 8.346 1.303 1.107-1.303 1.368zm0-3.3V7.875l1.303 1.368z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zi = { render: Pi }, Ui = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ji(l, e) {
  return i(), d("svg", Ui, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.955 7.308a.75.75 0 0 1 .404.98l-1.234 2.962H14a.75.75 0 0 1 .692 1.039l-1.666 4a.75.75 0 0 1-1.385-.577l1.234-2.962H10a.75.75 0 0 1-.692-1.038l1.666-4a.75.75 0 0 1 .981-.404",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gi = { render: ji }, Wi = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ki(l, e) {
  return i(), d("svg", Wi, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.47 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v14.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xi = { render: Ki }, Ji = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yi(l, e) {
  return i(), d("svg", Ji, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.47 18.47a.75.75 0 0 1 1.06 0L17 20.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06m3-15a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V14a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v14.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qi = { render: Yi }, ed = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ld(l, e) {
  return i(), d("svg", ed, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17 20.75a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-.75.75m0-5a.75.75 0 0 1-.75-.75v-1a.75.75 0 1 1 1.5 0v1a.75.75 0 0 1-.75.75m-9.47 4.78a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V4a.75.75 0 0 1 1.5 0v14.19l1.72-1.72a.75.75 0 1 1 1.06 1.06zm10-17.06a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 1.06 1.06l1.72-1.72V10a.75.75 0 0 0 1.5 0V5.81l1.72 1.72a.75.75 0 1 0 1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const td = { render: ld }, ad = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nd(l, e) {
  return i(), d("svg", ad, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 3.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 7 3.25m0 5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 7 8.25m9.47-4.78a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V20a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zm-10 17.06a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V14a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const od = { render: nd }, rd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sd(l, e) {
  return i(), d("svg", rd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 3.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 7 3.25m0 5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 7 8.25m9.47-4.78a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V12a.75.75 0 0 1-1.5 0V5.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06zM20 15.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057M6.47 20.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V14a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const id = { render: sd }, dd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ud(l, e) {
  return i(), d("svg", dd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.6c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8A1.35 1.35 0 0 1 9.4 7.75H3.6A1.35 1.35 0 0 1 2.25 6.4zm1.5.15v3.5h5.5v-3.5zm4 14.85c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35H9.1a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h5.5v-3.5zm4-15.15c0-.746.604-1.35 1.35-1.35h5.8c.745 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-5.8a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h5.5v-3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 10.5V7h1.5v3.5c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25V7h1.5v3.5a2.75 2.75 0 0 1-2.75 2.75h-7a2.75 2.75 0 0 1-2.75-2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.25 17v-4.5h1.5V17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cd = { render: ud }, vd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pd(l, e) {
  return i(), d("svg", vd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 21.4c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35v-3.8a1.35 1.35 0 0 0-1.35-1.35H3.6a1.35 1.35 0 0 0-1.35 1.35zm1.5-.15v-3.5h5.5v3.5zm4-14.85c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35V2.6a1.35 1.35 0 0 0-1.35-1.35H9.1A1.35 1.35 0 0 0 7.75 2.6zm1.5-.15v-3.5h5.5v3.5zm4 15.15c0 .746.604 1.35 1.35 1.35h5.8a1.35 1.35 0 0 0 1.35-1.35v-3.8a1.35 1.35 0 0 0-1.35-1.35h-5.8a1.35 1.35 0 0 0-1.35 1.35zm1.5-.15v-3.5h5.5v3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 13.5V17h1.5v-3.5c0-.69.56-1.25 1.25-1.25h7c.69 0 1.25.56 1.25 1.25V17h1.5v-3.5a2.75 2.75 0 0 0-2.75-2.75h-7a2.75 2.75 0 0 0-2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.25 7v4.5h1.5V7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hd = { render: pd }, md = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fd(l, e) {
  return i(), d("svg", md, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.6 21.75a1.35 1.35 0 0 1-1.35-1.35v-5.8c0-.745.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5zm14.85-4a1.35 1.35 0 0 1-1.35-1.35V9.1c0-.746.605-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5zm-15.15-4A1.35 1.35 0 0 1 1.25 9.4V3.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v5.8a1.35 1.35 0 0 1-1.35 1.35zm.15-1.5h3.5v-5.5h-3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.5 18.25H7v-1.5h3.5c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H7v-1.5h3.5a2.75 2.75 0 0 1 2.75 2.75v7a2.75 2.75 0 0 1-2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M17 12.75h-4.5v-1.5H17z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gd = { render: fd }, wd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bd(l, e) {
  return i(), d("svg", wd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M21.4 21.75a1.35 1.35 0 0 0 1.35-1.35v-5.8a1.35 1.35 0 0 0-1.35-1.35h-3.8a1.35 1.35 0 0 0-1.35 1.35v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5zm-14.85-4a1.35 1.35 0 0 0 1.35-1.35V9.1A1.35 1.35 0 0 0 6.4 7.75H2.6A1.35 1.35 0 0 0 1.25 9.1v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5zm15.15-4a1.35 1.35 0 0 0 1.35-1.35V3.6a1.35 1.35 0 0 0-1.35-1.35h-3.8a1.35 1.35 0 0 0-1.35 1.35v5.8c0 .746.604 1.35 1.35 1.35zm-.15-1.5h-3.5v-5.5h3.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.5 18.25H17v-1.5h-3.5c-.69 0-1.25-.56-1.25-1.25v-7c0-.69.56-1.25 1.25-1.25H17v-1.5h-3.5a2.75 2.75 0 0 0-2.75 2.75v7a2.75 2.75 0 0 0 2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 12.75h4.5v-1.5H7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Md = { render: bd }, yd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vd(l, e) {
  return i(), d("svg", yd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 9 9.25m6 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ad = { render: Vd }, $d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cd(l, e) {
  return i(), d("svg", $d, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M5.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M16 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M13.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hd = { render: Cd }, zd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kd(l, e) {
  return i(), d("svg", zd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75M13.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-7 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bd = { render: kd }, Ld = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _d(l, e) {
  return i(), d("svg", Ld, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 3.75H10a.75.75 0 0 0 0-1.5H5.6A1.35 1.35 0 0 0 4.25 3.6v16.8c0 .746.604 1.35 1.35 1.35H10a.75.75 0 0 0 0-1.5H5.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.25 7a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.25 3.75H14a.75.75 0 0 1 0-1.5h4.4c.746 0 1.35.604 1.35 1.35v16.8a1.35 1.35 0 0 1-1.35 1.35H14a.75.75 0 0 1 0-1.5h4.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Td = { render: _d }, Sd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xd(l, e) {
  return i(), d("svg", Sd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 17.941a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M21.55 7.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.55 11.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 1 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 0 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274m2.444.095c.383-.557 1.025-.982 1.952-.982s1.57.425 1.952.982c.355.518.465 1.114.465 1.518v1.102c.489.203.833.686.833 1.248v2.3a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.3c0-.563.344-1.045.833-1.248V16.75c0-.404.11-1 .465-1.518m1.035 2.518h1.834v-1a1.3 1.3 0 0 0-.202-.67c-.118-.171-.309-.33-.715-.33s-.597.159-.715.33a1.3 1.3 0 0 0-.202.67zm-.833 1.5v2h3.5v-2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dd = { render: xd }, Ed = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rd(l, e) {
  return i(), d("svg", Ed, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.512 17.442a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0-12.001a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v6.5h18.5v-6.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H2.6A1.35 1.35 0 0 1 1.25 9.4zm1.5 12.15v6.5h18.5v-6.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Od = { render: Rd }, Nd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Id(l, e) {
  return i(), d("svg", Nd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 5A.75.75 0 0 1 6 4.25h12a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75h-5.25v4.5H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h8.25v-4.5H6a.75.75 0 0 1-.75-.75zm1.5.75v6.5h10.5v-6.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.512 8.441a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 0 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056Zm3 0a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qd = { render: Id }, Fd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pd(l, e) {
  return i(), d("svg", Fd, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.5 1.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-.494.705l-5.5 2a.75.75 0 1 1-.512-1.41l5.006-1.82V8.5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 10.75a.75.75 0 0 1 .75.75v2.427l4.947 1.35a.75.75 0 1 1-.394 1.447l-5.5-1.5a.75.75 0 0 1-.553-.724v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.5 17.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M9.25 19.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m6.5-14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75zm1.5.75v1.5h1.5v-1.5zm-5.28-4.78a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06L12.5 3.06l-1.47 1.47a.75.75 0 1 1-1.06-1.06zM7 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M4.25 9a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zd = { render: Pd }, Ud = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jd(l, e) {
  return i(), d("svg", Ud, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 18.942A.75.75 0 0 1 12.568 20l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056ZM21.55 8.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.55 12.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 0 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 1 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gd = { render: jd }, Wd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kd(l, e) {
  return i(), d("svg", Wd, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M12.512 17.941a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M21.55 7.6c-5.733-4.3-13.367-4.3-19.1 0a.75.75 0 1 1-.9-1.2c6.267-4.7 14.633-4.7 20.9 0a.75.75 0 1 1-.9 1.2"></path><path d="M18.55 11.6c-3.733-2.8-9.367-2.8-13.1 0a.75.75 0 1 1-.9-1.2c4.267-3.2 10.633-3.2 14.9 0a.75.75 0 1 1-.9 1.2m-3.446 3.537c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 0 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274m1.487 1.454a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 1 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 1 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Xd = { render: Kd }, Jd = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yd(l, e) {
  return i(), d("svg", Jd, e[0] || (e[0] = [
    a("path", { d: "M22.275 6.975C19.05 4.5 15.6 3.225 12 3.225S4.95 4.5 1.725 6.975c-.225.15-.45.45-.45.825-.075.375.075.675.3.975l9.45 11.175q.338.45.9.45H12c.3 0 .6-.075.825-.3l.15-.15 9.45-11.175c.225-.3.3-.6.3-.975 0-.3-.15-.6-.45-.825M12 18.825l-9.15-10.8C5.7 5.85 8.85 4.8 12 4.8c3.225 0 6.3 1.125 9.15 3.225z" }, null, -1),
    a("path", { d: "M11.25 8.025v2.025c0 .45.3.75.75.75s.75-.3.75-.75V8.025c0-.45-.3-.75-.75-.75s-.75.3-.75.75m.225 5.475c-.3.3-.3.75 0 1.05.15.15.3.225.525.225a.68.68 0 0 0 .525-.225c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0" }, null, -1)
  ]));
}
const Qd = { render: Yd }, e8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function l8(l, e) {
  return i(), d("svg", e8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 18.942A.75.75 0 0 1 12.568 20l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056ZM2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 0 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M21.55 8.6c-3.417-2.563-7.504-3.595-11.458-3.108a.75.75 0 0 1-.184-1.488c4.339-.535 8.815.6 12.542 3.396a.75.75 0 0 1-.9 1.2M6.451 5.576a.75.75 0 0 1-.409.979A16.3 16.3 0 0 0 2.45 8.6a.75.75 0 1 1-.9-1.2 17.8 17.8 0 0 1 3.923-2.233.75.75 0 0 1 .978.409m3.802 4.274a.75.75 0 0 1-.584.885c-1.53.313-2.981.937-4.219 1.865a.75.75 0 1 1-.9-1.2c1.43-1.072 3.09-1.781 4.818-2.135a.75.75 0 0 1 .885.585m3.734.036a.75.75 0 0 1 .896-.567c1.639.37 3.207 1.061 4.567 2.081a.75.75 0 0 1-.9 1.2 10.5 10.5 0 0 0-3.997-1.817.75.75 0 0 1-.566-.897m1.117 6.251c-2.008-1.25-4.2-1.25-6.208 0a.75.75 0 1 1-.792-1.274c2.493-1.55 5.3-1.551 7.793 0a.75.75 0 0 1-.793 1.274",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t8 = { render: l8 }, a8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n8(l, e) {
  return i(), d("svg", a8, e[0] || (e[0] = [
    a("path", { d: "M12 20.475h-.075c-.375 0-.675-.225-.9-.45L1.5 8.775c-.225-.3-.3-.675-.3-.975.075-.375.3-.675.525-.825C4.95 4.5 8.4 3.225 12 3.225S19.05 4.5 22.275 6.9c.3.225.45.6.525.9 0 .375-.075.675-.3.975L12.975 19.95l-.15.15c-.225.225-.525.375-.825.375M2.85 8.025l9.15 10.8 9.15-10.8c-2.85-2.175-5.925-3.3-9.15-3.3s-6.3 1.125-9.15 3.3" }, null, -1)
  ]));
}
const o8 = { render: n8 }, r8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s8(l, e) {
  return i(), d("svg", r8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 3.75A5.25 5.25 0 0 0 2.75 9v6c0 2.9 2.35 5.25 5.25 5.25h8c2.9 0 5.25-2.35 5.25-5.25V9c0-2.9-2.35-5.25-5.25-5.25zM1.25 9A6.75 6.75 0 0 1 8 2.25h8A6.75 6.75 0 0 1 22.75 9v6A6.75 6.75 0 0 1 16 21.75H8A6.75 6.75 0 0 1 1.25 15z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 14.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.06-.057m3.912-2.461c-2.2-2.64-6.648-2.64-8.848 0a.75.75 0 1 1-1.152-.96c2.8-3.36 8.352-3.36 11.152 0a.75.75 0 1 1-1.152.96",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.4 13.7a3 3 0 0 0-4.8 0 .75.75 0 1 1-1.2-.9c1.8-2.4 5.4-2.4 7.2 0a.75.75 0 1 1-1.2.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i8 = { render: s8 }, d8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u8(l, e) {
  return i(), d("svg", d8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 3.75A2.25 2.25 0 0 0 6.75 6v7a.75.75 0 0 1-1.5 0V6A3.75 3.75 0 0 1 9 2.25h5a.75.75 0 0 1 0 1.5zm13 4a.75.75 0 0 1 .75.75V14a.75.75 0 0 1-1.5 0V8.5a.75.75 0 0 1 .75-.75M19.992.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V7a.75.75 0 0 1-1.5 0V4.75h-2.25a.75.75 0 0 1 0-1.5h2.25V1a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 13.75a3.25 3.25 0 0 0 0 6.5h6a.75.75 0 0 1 0 1.5H6a4.75 4.75 0 1 1 0-9.5h12a.75.75 0 0 1 0 1.5A3.25 3.25 0 1 0 21.25 17v-3a.75.75 0 0 1 1.5 0v3a4.75 4.75 0 1 1-8.214-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c8 = { render: u8 }, v8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function p8(l, e) {
  return i(), d("svg", v8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.75 12a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.122.651L12 20.864 8.872 22.65A.75.75 0 0 1 7.75 22zm1.5.75v7.958l2.378-1.36a.75.75 0 0 1 .744 0l2.378 1.36V12.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const h8 = { render: p8 }, m8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f8(l, e) {
  return i(), d("svg", m8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.47 17.47a.75.75 0 0 1 1.06 0L11 19.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const g8 = { render: f8 }, w8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function b8(l, e) {
  return i(), d("svg", w8, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.548-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886m9.557 14.321a.75.75 0 0 1 0 1.06l-1.767 1.768a4.75 4.75 0 0 1-6.718 0l-.353-.353a.75.75 0 1 1 1.06-1.06l.354.353a3.25 3.25 0 0 0 4.596 0l1.768-1.768a.75.75 0 0 1 1.06 0"></path><path d="M16.95 18.957a.75.75 0 0 1 .213.636l-.354 2.475a.75.75 0 0 1-1.273.425l-2.12-2.122a.75.75 0 0 1 .423-1.272l2.475-.354a.75.75 0 0 1 .637.212Zm-9.9-1.525a.75.75 0 0 1 0-1.06l1.768-1.768a4.75 4.75 0 0 1 6.718 0l.353.353a.75.75 0 0 1-1.06 1.06l-.354-.353a3.25 3.25 0 0 0-4.596 0L8.11 17.432a.75.75 0 0 1-1.06 0"></path><path d="M7.05 17.432a.75.75 0 0 1-.212-.636l.354-2.475a.75.75 0 0 1 1.272-.425l2.122 2.122a.75.75 0 0 1-.425 1.273l-2.474.353a.75.75 0 0 1-.637-.212"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const M8 = { render: b8 }, y8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V8(l, e) {
  return i(), d("svg", y8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 22.53a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V13a.75.75 0 0 0-1.5 0v7.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.548 1.397c-.844-.331-1.719-.884-2.384-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.025-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.385 1.76a.75.75 0 1 1-.547-1.397c.65-.255 1.275-.66 1.737-1.27.455-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.016-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A8 = { render: V8 }, $8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function C8(l, e) {
  return i(), d("svg", $8, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M8.47 15.47a.75.75 0 0 1 1.06 0L12 17.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L13.061 19l2.47 2.47a.75.75 0 1 1-1.061 1.06L12 20.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 19l-2.47-2.47a.75.75 0 0 1 0-1.06"></path><path d="M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const H8 = { render: C8 }, z8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k8(l, e) {
  return i(), d("svg", z8, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886M7.05 18.957a.75.75 0 0 0 0 1.06l1.768 1.768a4.75 4.75 0 0 0 6.718 0l.353-.353a.75.75 0 1 0-1.06-1.06l-.354.353a3.25 3.25 0 0 1-4.596 0L8.11 18.957a.75.75 0 0 0-1.06 0"></path><path d="M7.05 18.957a.75.75 0 0 0-.212.636l.354 2.475a.75.75 0 0 0 1.272.425l2.122-2.122a.75.75 0 0 0-.425-1.272l-2.474-.354a.75.75 0 0 0-.637.212m9.778-1.525a.75.75 0 0 0 0-1.06l-1.767-1.768a4.75 4.75 0 0 0-6.718 0l-.353.353a.75.75 0 0 0 1.06 1.06l.354-.353a3.25 3.25 0 0 1 4.596 0l1.768 1.768a.75.75 0 0 0 1.06 0"></path><path d="M16.828 17.432a.75.75 0 0 0 .213-.636l-.354-2.475a.75.75 0 0 0-1.273-.425l-2.121 2.122a.75.75 0 0 0 .424 1.273l2.475.353a.75.75 0 0 0 .636-.212"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const B8 = { render: k8 }, L8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _8(l, e) {
  return i(), d("svg", L8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 12.47a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06l-2.22-2.22V22a.75.75 0 0 1-1.5 0v-7.19l-2.22 2.22a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.393 4.636C6.766 5.682 6.75 6.972 6.75 8a.75.75 0 0 1-.75.75c-.713 0-1.8.22-2.687.859-.848.61-1.563 1.635-1.563 3.391 0 1.195.332 2.038.787 2.64.462.608 1.087 1.014 1.737 1.269a.75.75 0 0 1-.547 1.397c-.845-.331-1.72-.884-2.385-1.76C.672 15.662.25 14.493.25 13c0-2.244.952-3.72 2.187-4.609.914-.658 1.954-.976 2.82-1.09.026-.979.16-2.288.85-3.437C7.029 2.327 8.817 1.25 12 1.25s4.97 1.077 5.893 2.614c.69 1.15.825 2.458.85 3.437.866.114 1.906.432 2.82 1.09 1.235.89 2.187 2.365 2.187 4.609 0 1.493-.422 2.662-1.092 3.546-.665.876-1.54 1.429-2.384 1.76a.75.75 0 1 1-.547-1.397c.649-.255 1.274-.66 1.736-1.27.456-.6.787-1.444.787-2.639 0-1.756-.715-2.78-1.563-3.391C19.8 8.97 18.713 8.75 18 8.75a.75.75 0 0 1-.75-.75c0-1.028-.015-2.318-.643-3.364-.578-.963-1.79-1.886-4.607-1.886s-4.03.923-4.607 1.886",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T8 = { render: _8 }, S8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x8(l, e) {
  return i(), d("svg", S8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319q.861 0 1.572-.059a.75.75 0 0 1 .119 1.496q-.776.061-1.69.063c-3.59 0-5.548-.767-6.614-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25m14 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75m14.99 4.5c-1.378 0-2.617.989-3.077 2.472a.75.75 0 1 1-1.433-.444c.623-2.008 2.372-3.528 4.51-3.528 1.998 0 3.66 1.33 4.374 3.142a.75.75 0 0 1-1.395.55c-.524-1.329-1.689-2.192-2.979-2.192",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M23 14.694a.75.75 0 0 1 .75.75v1.889c0 .598-.485 1.084-1.084 1.084h-1.67a.75.75 0 0 1 0-1.5h1.254v-1.473a.75.75 0 0 1 .75-.75m-3.99 7.556c1.378 0 2.617-.989 3.077-2.472a.75.75 0 1 1 1.433.444c-.622 2.008-2.372 3.528-4.51 3.528-1.998 0-3.66-1.33-4.374-3.142a.75.75 0 1 1 1.396-.55c.523 1.329 1.688 2.192 2.978 2.192",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15 23.305a.75.75 0 0 1-.75-.75v-1.888c0-.599.485-1.084 1.084-1.084h1.67a.75.75 0 1 1 0 1.5H15.75v1.472a.75.75 0 0 1-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D8 = { render: x8 }, E8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function R8(l, e) {
  return i(), d("svg", E8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.47 22.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06zM4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 1 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O8 = { render: R8 }, N8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I8(l, e) {
  return i(), d("svg", N8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 5.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 1 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75m14.47 4.22a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V22a.75.75 0 0 1-1.5 0v-4.19l-1.72 1.72a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q8 = { render: I8 }, F8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P8(l, e) {
  return i(), d("svg", F8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A3.75 3.75 0 0 1 9 2.25h10A3.75 3.75 0 0 1 22.75 6v8a.75.75 0 0 1-1.5 0V6A2.25 2.25 0 0 0 19 3.75H9A2.25 2.25 0 0 0 6.75 6v7a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 13.75a3.25 3.25 0 0 0 0 6.5h6a.75.75 0 0 1 0 1.5H6a4.75 4.75 0 1 1 0-9.5h12a.75.75 0 0 1 0 1.5A3.25 3.25 0 1 0 21.25 17v-3a.75.75 0 0 1 1.5 0v3a4.75 4.75 0 1 1-8.214-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z8 = { render: P8 }, U8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j8(l, e) {
  return i(), d("svg", U8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.25 18v-6h1.5v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V12h1.5v6H19c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 18 4.25 18 5 18z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.25 12V6h1.5v5.981l.004.025c.006.036.02.103.054.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6h1.5v6H19c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 12 4.25 12 5 12z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.387 3.93C6.453 3.018 8.41 2.25 12 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C19.75 6 19.75 6 19 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C17.547 8.983 15.59 9.75 12 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.035C4.25 6 4.25 6 5 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .023-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM5.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C7.047 7.517 8.59 8.25 12 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C16.953 4.483 15.41 3.75 12 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 5.753 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G8 = { render: j8 }, W8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K8(l, e) {
  return i(), d("svg", W8, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.47 18.47a.75.75 0 0 1 1.06 0L17 20.94l4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06M4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025c.007.036.021.103.055.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035l-.004.055a2.5 2.5 0 0 1-.156.649c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.02l.001.01v.005C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035l-.004.055a2.5 2.5 0 0 1-.156.649c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6v.006c.007.036.021.103.055.19.067.173.216.444.555.735C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025c.007.036.021.103.055.19.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 0 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X8 = { render: K8 }, J8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Y8(l, e) {
  return i(), d("svg", J8, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M16.59 16.591a.75.75 0 0 1 1.062 0l1.59 1.591 1.592-1.591a.75.75 0 1 1 1.06 1.06l-1.59 1.592 1.59 1.59a.75.75 0 1 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.59-1.591-1.59-1.591a.75.75 0 0 1 0-1.061ZM4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25"></path><path d="M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.035C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.023.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6a1 1 0 0 0 .056.197c.066.172.215.443.554.734C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 1 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Q8 = { render: Y8 }, eu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lu(l, e) {
  return i(), d("svg", eu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20 15.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m.512 6.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057M4 5.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .058-.216V6a.75.75 0 0 1 1.5 0v6H18c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.024.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328-1.066.914-3.023 1.681-6.613 1.681s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 12 3.25 12 4 12h-.75V6A.75.75 0 0 1 4 5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.387 3.93C5.453 3.018 7.41 2.25 11 2.25s5.547.767 6.613 1.68c.536.46.825.939.977 1.33a2.5 2.5 0 0 1 .156.648l.003.055v.035C18.75 6 18.75 6 18 6c.75 0 .75 0 .75.002v.035a2 2 0 0 1-.023.215 2.5 2.5 0 0 1-.136.489c-.152.39-.441.87-.977 1.328C16.547 8.983 14.59 9.75 11 9.75s-5.547-.767-6.613-1.68c-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 6 3.25 6 4 6c-.75 0-.75 0-.75-.002v-.035a1.4 1.4 0 0 1 .024-.215c.021-.128.061-.295.136-.489.152-.39.441-.87.977-1.328ZM4.753 6a1 1 0 0 0 .056.197c.066.172.215.443.554.734C6.047 7.517 7.59 8.25 11 8.25s4.953-.733 5.637-1.32c.34-.29.488-.561.555-.733a1 1 0 0 0 .055-.203 1 1 0 0 0-.055-.19c-.067-.173-.216-.444-.555-.735C15.953 4.483 14.41 3.75 11 3.75s-4.953.733-5.637 1.32c-.34.29-.488.561-.555.733A1 1 0 0 0 4.753 6M4 11.25a.75.75 0 0 1 .75.75v5.981l.003.025a1 1 0 0 0 .055.19c.067.173.216.444.555.735.684.586 2.227 1.319 5.637 1.319a.75.75 0 1 1 0 1.5c-3.59 0-5.547-.767-6.613-1.68-.536-.46-.825-.939-.977-1.33a2.5 2.5 0 0 1-.156-.648l-.003-.055v-.02l-.001-.01v-.005C3.25 18 3.25 18 4 18h-.75v-6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tu = { render: lu }, au = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nu(l, e) {
  return i(), d("svg", au, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.625 3c-1.19 0-2.156 1.007-2.156 2.25v7c0 .414-.322.75-.719.75s-.719-.336-.719-.75v-7c0-2.071 1.61-3.75 3.594-3.75h4.792c.397 0 .718.336.718.75s-.321.75-.718.75zm12.458 4c.397 0 .72.336.72.75v5.5c0 .414-.323.75-.72.75s-.718-.336-.718-.75v-5.5c0-.414.321-.75.718-.75m-4.552-3.75c0-.414.322-.75.719-.75h3.833c.397 0 .72.336.72.75s-.323.75-.72.75H17.25c-.397 0-.719-.336-.719-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 13c-1.72 0-3.115 1.455-3.115 3.25S4.03 19.5 5.75 19.5h5.75c.397 0 .719.336.719.75s-.322.75-.719.75H5.75c-2.514 0-4.552-2.127-4.552-4.75S3.236 11.5 5.75 11.5h11.5c.397 0 .719.336.719.75s-.322.75-.719.75c-1.72 0-3.115 1.455-3.115 3.25s1.395 3.25 3.115 3.25 3.115-1.455 3.115-3.25v-3c0-.414.321-.75.718-.75s.72.336.72.75v3c0 2.623-2.039 4.75-4.553 4.75s-4.552-2.127-4.552-4.75c0-1.257.468-2.4 1.232-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ou = { render: nu }, ru = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function su(l, e) {
  return i(), d("svg", ru, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20 3.25a.75.75 0 0 1 .75.75v1.25H22a.75.75 0 0 1 0 1.5h-1.25V8a.75.75 0 0 1-1.5 0V6.75H18a.75.75 0 0 1 0-1.5h1.25V4a.75.75 0 0 1 .75-.75M1.25 11a.75.75 0 0 1 .75-.75h19.4c.746 0 1.35.604 1.35 1.35v7.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.75v7.5h18.5v-7.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75V11a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const iu = { render: su }, du = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function uu(l, e) {
  return i(), d("svg", du, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cu = { render: uu }, vu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pu(l, e) {
  return i(), d("svg", vu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H11a.75.75 0 0 1 0-1.5h8.25V5.81l-3.06-3.06H4.75V12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m-11.008 14a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hu = { render: pu }, mu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fu(l, e) {
  return i(), d("svg", mu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 6A.75.75 0 0 1 7 5.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 6m0 3A.75.75 0 0 1 7 8.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 9m2 8a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 2.75v8.5h16.5v-8.5zm18 8.546V2.6a1.35 1.35 0 0 0-1.35-1.35H3.6A1.35 1.35 0 0 0 2.25 2.6v8.696c-.576.154-1 .68-1 1.304v8.8c0 .746.604 1.35 1.35 1.35h18.8a1.35 1.35 0 0 0 1.35-1.35v-8.8a1.35 1.35 0 0 0-1-1.304m-19 1.454v8.5h18.5v-8.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gu = { render: fu }, wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bu(l, e) {
  return i(), d("svg", wu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.778 2.75c-.862 0-1.69.343-2.3.953l-9.19 9.19a5.253 5.253 0 1 0 7.43 7.429l9.19-9.19a.75.75 0 0 1 1.06 1.06l-9.19 9.19a6.754 6.754 0 0 1-9.55-9.55l9.19-9.19a4.752 4.752 0 0 1 6.72 6.72l-9.2 9.19a2.751 2.751 0 0 1-3.89-3.89l8.49-8.48a.75.75 0 0 1 1.06 1.06l-8.49 8.48a1.252 1.252 0 0 0 1.77 1.77l9.2-9.19a3.252 3.252 0 0 0-2.3-5.552",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mu = { render: bu }, yu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vu(l, e) {
  return i(), d("svg", yu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.97 19.97a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.25 18a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M18 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06H4.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35zm12.895.106",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Au = { render: Vu }, $u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cu(l, e) {
  return i(), d("svg", $u, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.47 14.47a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.75 12.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hu = { render: Cu }, zu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ku(l, e) {
  return i(), d("svg", zu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m17.5 16.339-.516 1.094a.75.75 0 0 1-.565.422l-1.223.187.907.924a.75.75 0 0 1 .204.647l-.206 1.261 1.037-.57a.75.75 0 0 1 .724 0l1.037.57-.207-1.261a.75.75 0 0 1 .205-.646l.907-.925-1.223-.187a.75.75 0 0 1-.565-.422L17.5 16.34Zm-.964-1.473a1.062 1.062 0 0 1 1.928 0l.739 1.566 1.638.25c.91.14 1.182 1.24.598 1.835l-1.205 1.229.286 1.743c.133.81-.712 1.598-1.564 1.129l-1.456-.802-1.456.802c-.852.469-1.697-.32-1.564-1.13l.286-1.742-1.205-1.229c-.584-.595-.313-1.695.598-1.834l1.638-.25.74-1.567Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bu = { render: ku }, Lu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _u(l, e) {
  return i(), d("svg", Lu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "m12 9.279-.687 1.456a.75.75 0 0 1-.565.421l-1.604.246 1.183 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L12 15.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tu = { render: _u }, Su = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xu(l, e) {
  return i(), d("svg", Su, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M8.47 11.47a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V9a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 0m-.22 6.343c0-.311.336-.563.75-.563h6c.414 0 .75.252.75.563s-.336.562-.75.562H9c-.414 0-.75-.252-.75-.563Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Du = { render: xu }, Eu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ru(l, e) {
  return i(), d("svg", Eu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H14a.75.75 0 1 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.65c.358 0 .702.142.955.395l3.149 3.149c.253.253.395.596.395.955V13a.75.75 0 1 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 1 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m.472 17.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ou = { render: Ru }, Nu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Iu(l, e) {
  return i(), d("svg", Nu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qu = { render: Iu }, Fu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pu(l, e) {
  return i(), d("svg", Fu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H21.4c.746 0 1.35.604 1.35 1.35v11.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v5.5h18.5v-2.5h-8.528a1.35 1.35 0 0 1-.879-.325L8.723 4.75zm18.5 7H2.75v7.5h18.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zu = { render: Pu }, Uu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ju(l, e) {
  return i(), d("svg", Uu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 2.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M22 6.25a.75.75 0 0 1 .75.75v12.4a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35V11a.75.75 0 0 1 1.5 0v8.25h18.5V7a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75v5.5H14a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gu = { render: ju }, Wu = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ku(l, e) {
  return i(), d("svg", Wu, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H21.4c.746 0 1.35.604 1.35 1.35v2.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v5.5h18.5v-2.5h-8.528a1.35 1.35 0 0 1-.879-.325L8.723 4.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M22 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m-20 0a.75.75 0 0 1 .75.75v9.25H13a.75.75 0 0 1 0 1.5H2.6a1.35 1.35 0 0 1-1.35-1.35V10A.75.75 0 0 1 2 9.25m17 8.5a1.25 1.25 0 1 0-.002 2.498A1.25 1.25 0 0 0 19 17.75m-1.375-1.132a2.75 2.75 0 1 1 2.751 4.763 2.75 2.75 0 0 1-2.752-4.763Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.809 15.255a4 4 0 0 1 .382 0 .75.75 0 0 1-.075 1.498 2 2 0 0 0-.232 0 .75.75 0 0 1-.075-1.498m1.644 1.015a.75.75 0 0 1 1.06-.054q.142.129.27.271a.75.75 0 1 1-1.113 1.006 2 2 0 0 0-.163-.163.75.75 0 0 1-.054-1.06m-2.906 0a.75.75 0 0 1-.054 1.06 2 2 0 0 0-.163.163.75.75 0 0 1-1.114-1.006q.129-.142.271-.27a.75.75 0 0 1 1.06.053m4.411 1.827a.75.75 0 0 1 .787.712 4 4 0 0 1 0 .382.75.75 0 0 1-1.498-.075 2 2 0 0 0 0-.232.75.75 0 0 1 .711-.787m-5.916 0a.75.75 0 0 1 .71.787 2 2 0 0 0 0 .232.75.75 0 0 1-1.497.075 4 4 0 0 1 0-.382.75.75 0 0 1 .787-.712m5.688 2.356a.75.75 0 0 1 .054 1.06 4 4 0 0 1-.271.27.75.75 0 1 1-1.006-1.113q.086-.077.163-.163a.75.75 0 0 1 1.06-.054m-5.46 0a.75.75 0 0 1 1.06.054q.077.086.163.163a.75.75 0 0 1-1.006 1.114 4 4 0 0 1-.27-.271.75.75 0 0 1 .053-1.06m1.827 1.505a.75.75 0 0 1 .787-.71 2 2 0 0 0 .232 0 .75.75 0 0 1 .075 1.497 4 4 0 0 1-.382 0 .75.75 0 0 1-.712-.787",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xu = { render: Ku }, Ju = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yu(l, e) {
  return i(), d("svg", Ju, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 5c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v14c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25zM5 2.25A2.75 2.75 0 0 0 2.25 5v14A2.75 2.75 0 0 0 5 21.75h14A2.75 2.75 0 0 0 21.75 19V5A2.75 2.75 0 0 0 19 2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 1 1 0 1.5H7A.75.75 0 0 1 6.25 7m0 5a.75.75 0 0 1 .75-.75h10a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qu = { render: Yu }, ec = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lc(l, e) {
  return i(), d("svg", ec, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A.75.75 0 0 1 6 5.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6m0 4A.75.75 0 0 1 6 9.25h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m7 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v18.5h18.5V2.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v18.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h1.5v-2.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tc = { render: lc }, ac = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nc(l, e) {
  return i(), d("svg", ac, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 6A.75.75 0 0 1 6 5.25h8a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6m0 4A.75.75 0 0 1 6 9.25h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m7 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.75 2.75v18.5h18.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h15.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h1.5v-2.5zM18 1.25a.75.75 0 0 1 .75.75v3.25H22a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const oc = { render: nc }, rc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sc(l, e) {
  return i(), d("svg", rc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.514 5.444a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 0 1-1.109-1.008l.01-.011a.75.75 0 0 1 1.06-.05ZM8.25 6A.75.75 0 0 1 9 5.25h11a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 6m-2.736 5.444a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.109-1.008l.01-.011a.75.75 0 0 1 1.06-.05ZM8.25 12a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m-1.12 4.07a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-.8-.8a.75.75 0 0 1 1.06-1.06l.27.27 1.47-1.47a.75.75 0 0 1 1.06 0M8.25 18a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ic = { render: sc }, dc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function uc(l, e) {
  return i(), d("svg", dc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 7 9.25h3a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m0-8A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.75a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06zm-2.25.75A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25h-12a2.25 2.25 0 0 1-2.25-2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cc = { render: uc }, vc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pc(l, e) {
  return i(), d("svg", vc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.992 15.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hc = { render: pc }, mc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fc(l, e) {
  return i(), d("svg", mc, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M2.34 16.348a.75.75 0 0 1 1.061 0l1.591 1.591 1.591-1.59a.75.75 0 0 1 1.06 1.06L6.054 19l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.59-1.59L3.4 21.65a.75.75 0 0 1-1.06-1.06L3.93 19l-1.59-1.591a.75.75 0 0 1 0-1.06ZM6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2"></path><path d="M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z"></path><path d="M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const gc = { render: fc }, wc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bc(l, e) {
  return i(), d("svg", wc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.75a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06zm-2.25.75A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25h-12a2.25 2.25 0 0 1-2.25-2.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mc = { render: bc }, yc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vc(l, e) {
  return i(), d("svg", yc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 2A.75.75 0 0 1 7 1.25h9.5a.75.75 0 0 1 .53.22l4.5 4.5c.141.14.22.331.22.53V19a.75.75 0 0 1-1.5 0V6.81l-4.06-4.06H7A.75.75 0 0 1 6.25 2",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h9.752c.357 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V20.5a2.25 2.25 0 0 1-2.25 2.25H11a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 0 .75-.75V8.81l-3.06-3.06H4.5a.75.75 0 0 0-.75.75V13a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.242 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M14 4.25a.75.75 0 0 1 .75.75v3.25H18a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ac = { render: Vc }, $c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cc(l, e) {
  return i(), d("svg", $c, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 10A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 8a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hc = { render: Cc }, zc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kc(l, e) {
  return i(), d("svg", zc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v7h-1.5V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V9.75h1.75a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-1.75v2.65a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35v-2.65h1.5v2.5h14.5v-2.5H4.75v-1.861q.045.032.093.062.612.39 1.452.391.632 0 1.077-.174a1.95 1.95 0 0 0 .729-.479q.282-.304.436-.69a3.4 3.4 0 0 0 .208-.82H7.472q-.058.316-.212.582a1.26 1.26 0 0 1-.403.425 1.1 1.1 0 0 1-.6.158q-.631 0-.994-.5-.357-.503-.358-1.626 0-.745.163-1.198.162-.454.466-.658.303-.204.724-.204a1.2 1.2 0 0 1 .599.142q.249.137.403.383.155.24.212.553h1.273a2.2 2.2 0 0 0-.387-1.06 2.3 2.3 0 0 0-.857-.741 2.6 2.6 0 0 0-1.206-.275q-.844 0-1.456.366l-.089.056V9.75h14.5V5.81l-3.06-3.06zm15.67 8.493-1.17 3.39-.906 2.626h-1.377l-2.06-6.016h1.161l1.59 4.606 1.592-4.58.01-.026zm-8.344 6.1a3.4 3.4 0 0 1-.874-.113 2.8 2.8 0 0 1-.782-.337 2 2 0 0 1-.587-.562 1.7 1.7 0 0 1-.274-.79h1.244a1 1 0 0 0 .237.462q.174.186.44.287.267.1.592.1.333 0 .607-.084a1 1 0 0 0 .441-.25.58.58 0 0 0 .167-.424.52.52 0 0 0-.138-.374 1 1 0 0 0-.362-.237 3 3 0 0 0-.52-.15l-1.04-.212q-.682-.129-1.082-.541-.399-.416-.411-1.107a1.58 1.58 0 0 1 .3-.977q.307-.416.831-.641a3 3 0 0 1 1.182-.225q.777 0 1.306.246.533.24.807.657.28.412.287.92h-1.219a.9.9 0 0 0-.191-.504.9.9 0 0 0-.408-.27 1.8 1.8 0 0 0-.561-.084q-.242 0-.441.055-.196.054-.333.154a.7.7 0 0 0-.212.228.6.6 0 0 0-.075.3q0 .262.174.424.176.162.654.266l1.031.213q.554.108.878.32a1.53 1.53 0 0 1 .707 1.024q.054.274.054.507 0 .486-.307.878-.304.387-.85.616-.544.224-1.272.224Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M3.899 15.853q-.33-.708-.329-1.652 0-.948.329-1.627.304-.631.851-.992V9.75h-1.5v9h1.5v-1.861a2.6 2.6 0 0 1-.851-1.036M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h1.75v-9z" }, null, -1)
  ]));
}
const Bc = { render: kc }, Lc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _c(l, e) {
  return i(), d("svg", Lc, e[0] || (e[0] = [
    s5('<path fill-rule="evenodd" d="M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path d="M4.635 12.226v4.058h.558q.517 0 .937-.2a1.5 1.5 0 0 0 .68-.654q.253-.454.253-1.212 0-.704-.225-1.142a1.4 1.4 0 0 0-.641-.645 2.2 2.2 0 0 0-.987-.205z"></path><path fill-rule="evenodd" d="M.75 10.5a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-21A.75.75 0 0 1 .75 18zm2.914.743H3.41v6.024h1.758q1.08 0 1.779-.371a2.37 2.37 0 0 0 1.045-1.05q.342-.682.342-1.62 0-.9-.325-1.558a2.27 2.27 0 0 0-1.012-1.025q-.692-.367-1.787-.391a22 22 0 0 0-.46-.005h-.02l-.57-.004zm6.767 5.736q.625.372 1.479.371.845 0 1.466-.37a2.46 2.46 0 0 0 .954-1.067q.337-.692.337-1.645 0-.967-.341-1.663a2.5 2.5 0 0 0-.958-1.07q-.621-.375-1.458-.375-.841 0-1.467.38-.624.374-.97 1.07-.342.695-.342 1.658 0 .957.338 1.65.34.686.962 1.061m8.918-5.544a2.6 2.6 0 0 0-1.208-.275q-.846 0-1.458.367a2.4 2.4 0 0 0-.942 1.05q-.33.678-.329 1.628 0 .945.33 1.654.332.708.945 1.1.613.39 1.453.391.634 0 1.08-.175l.03-.012q.425-.173.698-.467.284-.304.438-.691.154-.392.208-.821h-1.275a1.8 1.8 0 0 1-.213.583 1.26 1.26 0 0 1-.403.425 1.1 1.1 0 0 1-.6.158q-.633 0-.995-.5-.36-.504-.359-1.628 0-.745.163-1.2t.466-.658a1.27 1.27 0 0 1 .725-.204q.35 0 .6.141.25.138.404.384.087.135.143.294.044.123.07.26h1.274a2.2 2.2 0 0 0-.387-1.063 2.3 2.3 0 0 0-.858-.741" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4.75 11.248V2.75h11.44l3.06 3.06v5.577l.099.048q.532.27.858.742.329.47.387 1.062h-1.275a2 2 0 0 0-.069-.26v2.473a2 2 0 0 0 .07-.268h1.274q-.055.43-.208.82a2.2 2.2 0 0 1-.438.692 1.9 1.9 0 0 1-.698.467v4.087H4.75v-3.983H3.41v-6.024h.75q.287 0 .57.005zm0 .978h-.115v4.058h.115zM4.6 1.25A1.35 1.35 0 0 0 3.25 2.6v18.8c0 .746.604 1.35 1.35 1.35h14.8a1.35 1.35 0 0 0 1.35-1.35V5.749a1.35 1.35 0 0 0-.395-.955l-3.149-3.149a1.35 1.35 0 0 0-.954-.395z" clip-rule="evenodd"></path><path d="M11.91 16.35q.441 0 .762-.208.324-.213.5-.666.175-.459.175-1.192 0-.754-.18-1.22-.174-.467-.5-.683a1.3 1.3 0 0 0-.757-.221q-.438 0-.763.22-.324.217-.504.688-.18.466-.179 1.216 0 .738.18 1.192.179.453.503.666.325.208.763.208"></path>', 5)
  ]));
}
const Tc = { render: _c }, Sc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xc(l, e) {
  return i(), d("svg", Sc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m13.82 4.055a1.871 1.871 0 1 0-2.646-2.646L14.433 19.4a1.75 1.75 0 0 0-.492.968l-.243 1.556a.75.75 0 0 0 .857.857l1.556-.243a1.75 1.75 0 0 0 .968-.491zm-1.06-1.585a.37.37 0 0 1 0 .525l-.47.47-.525-.526.47-.47a.37.37 0 0 1 .524 0ZM17.953 18l.525.525-2.46 2.461a.25.25 0 0 1-.139.07l-.541.085.084-.542a.25.25 0 0 1 .07-.138L17.954 18ZM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dc = { render: xc }, Ec = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rc(l, e) {
  return i(), d("svg", Ec, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h21a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75zm2.25 1.406v6.188h1.301v-2.208h1.222q.69 0 1.2-.231.512-.231.796-.668.283-.436.283-1.053 0-.654-.323-1.108a1.96 1.96 0 0 0-.872-.684 3.2 3.2 0 0 0-1.252-.236zm1.288 3.013h1.2q.487 0 .796-.3.31-.303.31-.749 0-.462-.328-.731a1.2 1.2 0 0 0-.796-.274H5.038zm4.486-3.013h.797q.306 0 .606.005.305 0 .51.004 1.163.025 1.898.402c.735.377.848.602 1.075 1.053q.346.675.346 1.6 0 .963-.363 1.665a2.48 2.48 0 0 1-1.111 1.078q-.744.38-1.89.38H9.524zm1.302 5.178v-4.168h.61q.606 0 1.05.21.441.21.68.663.24.45.24 1.172 0 .78-.27 1.246t-.722.671q-.447.206-.995.206zm9.424-5.178h-4.355v6.188h1.301v-2.568h2.642v-1.022h-2.642V12.2h3.05z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 11.156V2.75h11.44l3.06 3.06v5.346h1l-.004 1.044h-.996v1.554h.588v1.022h-.588v6.474H4.75v-3.906h-1v-6.188zM4.6 1.25A1.35 1.35 0 0 0 3.25 2.6v18.8c0 .746.604 1.35 1.35 1.35h14.8a1.35 1.35 0 0 0 1.35-1.35V5.749a1.35 1.35 0 0 0-.395-.955l-3.149-3.149a1.35 1.35 0 0 0-.954-.395z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Oc = { render: Rc }, Nc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ic(l, e) {
  return i(), d("svg", Nc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.745.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.396l3.149 3.148c.253.253.395.597.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06H4.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35zm12.895.106",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m12.72 5.97a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.25 18a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M18 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-2-14.5a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qc = { render: Ic }, Fc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pc(l, e) {
  return i(), d("svg", Fc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H11a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m10.25 2.339-.516 1.094a.75.75 0 0 1-.565.422l-1.223.187.907.924a.75.75 0 0 1 .204.647l-.206 1.261 1.037-.57a.75.75 0 0 1 .724 0l1.037.57-.207-1.261a.75.75 0 0 1 .205-.646l.907-.925-1.223-.187a.75.75 0 0 1-.565-.422L17.5 16.34Zm-.964-1.473a1.062 1.062 0 0 1 1.928 0l.739 1.566 1.638.25c.91.14 1.182 1.24.598 1.835l-1.205 1.229.286 1.743c.133.81-.712 1.598-1.564 1.129l-1.456-.802-1.456.802c-.852.469-1.697-.32-1.564-1.13l.286-1.742-1.205-1.229c-.584-.595-.313-1.695.598-1.834l1.638-.25.74-1.567ZM16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zc = { render: Pc }, Uc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jc(l, e) {
  return i(), d("svg", Uc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.5 9.75a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75h21a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75zm6.426 7.507h1.516l-2.12-3.215 1.857-2.807H7.89l-1.192 1.949-1.204-1.95H3.99l.76 1.162L5.93 14.2l-1.18 1.802-.823 1.255h1.308l1.333-2.174zm2.418-6.022h1.224v4.993h2.616v1.029h-3.84zm6.422 5.993q.429.112.874.112.729 0 1.275-.225.18-.076.335-.169.311-.188.514-.447.309-.392.309-.879 0-.233-.055-.508a1.53 1.53 0 0 0-.768-1.062 2.6 2.6 0 0 0-.818-.283l-1.033-.212q-.48-.105-.654-.267a.55.55 0 0 1-.175-.425q0-.165.075-.3a.7.7 0 0 1 .212-.229 1 1 0 0 1 .334-.154q.2-.054.441-.054.316 0 .562.083a.9.9 0 0 1 .408.271.9.9 0 0 1 .192.504h1.22a1.7 1.7 0 0 0-.764-1.395q-.15-.103-.331-.184-.53-.245-1.308-.245-.654 0-1.183.225a2 2 0 0 0-.833.641 1.6 1.6 0 0 0-.3.979q.013.69.413 1.108.399.411 1.083.541l1.04.212q.293.06.521.15a.96.96 0 0 1 .363.238.52.52 0 0 1 .137.375q0 .253-.166.424a1 1 0 0 1-.442.25 2.1 2.1 0 0 1-.608.084q-.324 0-.591-.1a1.14 1.14 0 0 1-.442-.288 1 1 0 0 1-.237-.462H15.12q.046.454.274.791.234.338.588.563t.783.337Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v8.485h-.76l.76 1.161v3.606l-.823 1.255h.823v3.993h14.5v-4.304q.311-.187.514-.447.309-.391.309-.879 0-.233-.055-.508a1.53 1.53 0 0 0-.768-1.062v-1.066h.764a1.7 1.7 0 0 0-.764-1.395V5.81l-3.06-3.06zm-1.5-.15c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gc = { render: jc }, Wc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kc(l, e) {
  return i(), d("svg", Wc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H13a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V12a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 6A.75.75 0 0 1 8 5.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6m0 4A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m2.823 13.148a2.75 2.75 0 0 1 1.354 0l2.555.65c.597.15 1.03.696 1.01 1.332-.09 3.032-1.016 4.87-2.004 5.962-.488.539-.977.88-1.355 1.087a4 4 0 0 1-.615.273l-.047.015-.017.005-.006.001-.003.001c-.002 0-.002 0-.195-.724-.193.725-.194.725-.194.724h-.004l-.006-.002-.017-.005a2 2 0 0 1-.194-.067 4 4 0 0 1-.468-.221 5.3 5.3 0 0 1-1.355-1.087c-.988-1.091-1.914-2.93-2.005-5.962a1.34 1.34 0 0 1 1.01-1.333zM19.5 23l-.193.725a.75.75 0 0 0 .386 0zm0-.804a4 4 0 0 0 .16-.081c.25-.138.603-.379.966-.78.704-.778 1.509-2.225 1.613-4.866l-2.431-.617a1.25 1.25 0 0 0-.616 0l-2.43.617c.103 2.641.908 4.088 1.612 4.866.363.401.715.642.966.78q.09.05.16.081",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xc = { render: Kc }, Jc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yc(l, e) {
  return i(), d("svg", Jc, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.25 6a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m-16 5a.75.75 0 0 1 .75-.75h19.4c.746 0 1.35.604 1.35 1.35v7.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.75v7.5h18.5v-7.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4.6c0-.746.604-1.35 1.35-1.35h6.178c.322 0 .634.115.879.325l3.12 2.675H14a.75.75 0 0 1 0 1.5h-1.278a1.35 1.35 0 0 1-.879-.325L8.723 4.75H2.75V11a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qc = { render: Yc }, e9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function l9(l, e) {
  return i(), d("svg", e9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5h14.5V5.81l-3.06-3.06zm-1.5-.15c0-.746.605-1.35 1.35-1.35h11.652c.358 0 .701.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const t9 = { render: l9 }, a9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n9(l, e) {
  return i(), d("svg", a9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 2.6c0-.746.605-1.35 1.35-1.35h11.652c.358 0 .701.142.954.395l3.149 3.149c.253.253.395.596.395.955V21.4a1.35 1.35 0 0 1-1.35 1.35H11a.75.75 0 0 1 0-1.5h8.25V5.81l-3.06-3.06H4.75V12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75M1.242 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const o9 = { render: n9 }, r9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s9(l, e) {
  return i(), d("svg", r9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v18.5H14a.75.75 0 0 1 0 1.5H4.6a1.35 1.35 0 0 1-1.35-1.35V2.6c0-.746.604-1.35 1.35-1.35h11.652c.358 0 .7.142.954.395l3.149 3.149c.253.253.395.596.395.955V13a.75.75 0 0 1-1.5 0V5.81l-3.06-3.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 1.25a.75.75 0 0 1 .75.75v3.25H20a.75.75 0 0 1 0 1.5h-3.4a1.35 1.35 0 0 1-1.35-1.35V2a.75.75 0 0 1 .75-.75m2.47 21.28a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H16a.75.75 0 0 0 0 1.5h4.19l-1.72 1.72a.75.75 0 0 0 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i9 = { render: s9 }, d9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function u9(l, e) {
  return i(), d("svg", d9, e[0] || (e[0] = [
    a("path", { d: "M20.5 8.2c-1.2 0-2.2 1-2.2 2.2v2.8c-1-.3-2.1-.1-2.8.7l-.9.9c-.5.5-.8 1.2-.8 1.9V20c0 .4.3.8.8.8s.8-.3.8-.8v-3.2c0-.3.1-.6.4-.9l.9-.9c.4-.4 1-.5 1.4-.2l.1.1-.6.6c-.3.3-.3.8 0 1.1s.8.3 1.1 0l.9-.9s0-.1.1-.1q.3-.15.3-.6v-4.5c0-.4.3-.8.8-.8s.8.3.8.8v5.2l-3.8 3.8c-.3.3-.3.8 0 1.1s.8.3 1.1 0l3.8-3.8c.3-.3.4-.6.4-1v-5.3c-.3-1.2-1.4-2.3-2.6-2.3M8.5 14c-.7-.7-1.8-1-2.8-.7v-2.8c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2v5.3c0 .4.1.7.4 1l3.8 3.8c.3.3.8.3 1.1 0s.3-.8 0-1.1l-3.8-3.8v-5.2c0-.4.3-.8.8-.8s.8.3.8.8V15c0 .2.1.5.3.6 0 0 0 .1.1.1l.9.9c.3.3.8.3 1.1 0s.3-.8 0-1.1l-.6-.6-.2-.1c.5-.2 1.1-.1 1.4.2l.9.9c.2.2.4.6.4.9V20c0 .4.3.8.8.8s.8-.3.8-.8v-3.2c0-.7-.3-1.4-.8-1.9zm6.4-5.6c.3-.3.6-.7 1-1q.9-.9.9-2.1c0-1.2-.3-1.6-.9-2.1-.6-.6-1.3-.9-2.2-.9-.4 0-.8.1-1.2.2l-.6.3-.6-.3c-.7-.3-1.6-.3-2.3 0-.4.2-.7.4-1 .7-1 1.1-1 3 .1 4.2l2.9 2.9c.3.3.6.4 1 .4.3 0 .7-.1.9-.4.7-.6 1.4-1.2 2-1.9m-2.9.8L9.2 6.4c-.6-.6-.6-1.6 0-2.2.1-.1.3-.3.5-.3.2-.1.4-.1.6-.1s.4 0 .6.1.4.2.5.3l.1.1c.1.1.3.2.5.2s.4-.1.5-.2l.1-.1c.1-.1.3-.3.5-.3.6-.2 1.2-.1 1.7.3.3.3.4.7.4 1.1s-.2.8-.4 1.1c-.3.3-.6.7-1 1z" }, null, -1)
  ]));
}
const c9 = { render: u9 }, v9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function p9(l, e) {
  return i(), d("svg", v9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M5.25 9a6.75 6.75 0 1 1 7.5 6.709v2.541H14a.75.75 0 0 1 0 1.5h-1.25V21a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1 0-1.5h1.25v-2.541A6.75 6.75 0 0 1 5.25 9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const h9 = { render: p9 }, m9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function f9(l, e) {
  return i(), d("svg", m9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.583 8a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V16a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75v-3.334a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834v-1.583a.75.75 0 0 1 .75-.75h1.583v-1.834h-1.583a.75.75 0 0 1-.75-.75V8.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const g9 = { render: f9 }, w9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function b9(l, e) {
  return i(), d("svg", w9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.25 10.5a2.25 2.25 0 0 1 4.5 0v5.252c0 .357-.142.7-.395.954L18.53 20.53a.75.75 0 1 1-1.06-1.06l3.78-3.78V10.5a.75.75 0 0 0-1.5 0V15a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.45 13.989a2.75 2.75 0 0 1 3.175-.515l.443.221a1.234 1.234 0 0 1 .32 1.977l-.858.858a.75.75 0 0 1-1.06-1.06l.597-.598-.113-.056a1.25 1.25 0 0 0-1.443.234l-.895.895a1.25 1.25 0 0 0-.366.883V20a.75.75 0 0 1-1.5 0v-3.172c0-.729.29-1.428.806-1.944zM3.5 9.75a.75.75 0 0 0-.75.75v5.19l3.78 3.78a.75.75 0 1 1-1.06 1.06l-3.825-3.824a1.35 1.35 0 0 1-.395-.954V10.5a2.25 2.25 0 0 1 4.5 0V15a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.489 15.05a1.25 1.25 0 0 0-1.443-.235l-.113.057.597.598a.75.75 0 0 1-1.06 1.06l-.858-.858a1.234 1.234 0 0 1 .32-1.977l.443-.221a2.75 2.75 0 0 1 3.175.515l.895.895a2.75 2.75 0 0 1 .805 1.944V20a.75.75 0 0 1-1.5 0v-3.172a1.25 1.25 0 0 0-.366-.883zM9.583 4a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V12a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75V6.333a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834V9.667a.75.75 0 0 1 .75-.75h1.583V7.083h-1.583a.75.75 0 0 1-.75-.75V4.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const M9 = { render: b9 }, y9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function V9(l, e) {
  return i(), d("svg", y9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.305 3.75c-1.311 0-2.572.54-3.5 1.502l-.265.275a.75.75 0 0 1-1.08 0l-.265-.275a4.83 4.83 0 0 0-7.001 0c-1.925 1.995-1.925 5.225 0 7.22l7.295 7.562a.71.71 0 0 0 .998.023c1.679-1.616 3.274-3.31 4.881-5.017.806-.855 1.614-1.714 2.438-2.568a5.2 5.2 0 0 0 1.444-3.61 5.2 5.2 0 0 0-1.444-3.61 4.86 4.86 0 0 0-3.5-1.502ZM12 3.942a6.35 6.35 0 0 1 4.305-1.692c1.726 0 3.374.71 4.58 1.96a6.7 6.7 0 0 1 1.865 4.652 6.7 6.7 0 0 1-1.865 4.652c-.796.825-1.591 1.67-2.39 2.518-1.624 1.724-3.265 3.466-4.97 5.108l-.003.004a2.213 2.213 0 0 1-3.113-.069l-7.295-7.561c-2.485-2.577-2.485-6.727 0-9.303A6.33 6.33 0 0 1 12 3.942",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const A9 = { render: V9 }, $9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function C9(l, e) {
  return i(), d("svg", $9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.36 9.891a.75.75 0 0 1 .249-1.031l9-5.5a.75.75 0 0 1 .782 0l9 5.5a.75.75 0 0 1-.782 1.28L12 4.879 3.391 10.14a.75.75 0 0 1-1.031-.249M5 12.25a.75.75 0 0 1 .75.75v6.25h12.5V13a.75.75 0 0 1 1.5 0v6.4a1.35 1.35 0 0 1-1.35 1.35H5.6a1.35 1.35 0 0 1-1.35-1.35V13a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.583 9a.75.75 0 0 1 .75-.75h3.334a.75.75 0 0 1 .75.75v1.583H16a.75.75 0 0 1 .75.75v3.334a.75.75 0 0 1-.75.75h-1.583V17a.75.75 0 0 1-.75.75h-3.334a.75.75 0 0 1-.75-.75v-1.583H8a.75.75 0 0 1-.75-.75v-3.334a.75.75 0 0 1 .75-.75h1.583zm1.5.75v1.583a.75.75 0 0 1-.75.75H8.75v1.834h1.583a.75.75 0 0 1 .75.75v1.583h1.834v-1.583a.75.75 0 0 1 .75-.75h1.583v-1.834h-1.583a.75.75 0 0 1-.75-.75V9.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const H9 = { render: C9 }, z9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function k9(l, e) {
  return i(), d("svg", z9, e[0] || (e[0] = [
    a("path", { d: "M12.7 6a.7.7 0 1 0-1.4 0v1.3H10a.7.7 0 1 0 0 1.4h1.3V10a.7.7 0 1 0 1.4 0V8.7H14a.7.7 0 1 0 0-1.4h-1.3zM10 13.3a.7.7 0 1 0 0 1.4h4a.7.7 0 1 0 0-1.4zM9.3 18a.7.7 0 0 1 .7-.7h4a.7.7 0 1 1 0 1.4h-4a.7.7 0 0 1-.7-.7" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 1.3A2.7 2.7 0 0 0 5.3 4v4.3H4A2.7 2.7 0 0 0 1.3 11v9A2.7 2.7 0 0 0 4 22.7h16a2.7 2.7 0 0 0 2.7-2.7v-6a2.7 2.7 0 0 0-2.7-2.7h-1.3V4A2.7 2.7 0 0 0 16 1.3zM17.3 4A1.3 1.3 0 0 0 16 2.7H8A1.3 1.3 0 0 0 6.7 4v17.3h10.6zm1.4 17.3v-8.6H20a1.3 1.3 0 0 1 1.3 1.3v6a1.3 1.3 0 0 1-1.3 1.3zm-13.4 0V9.7H4A1.3 1.3 0 0 0 2.7 11v9A1.3 1.3 0 0 0 4 21.3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const B9 = { render: k9 }, L9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _9(l, e) {
  return i(), d("svg", L9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 6.25a.75.75 0 0 1 .75.75v4.25h6.5V7a.75.75 0 0 1 1.5 0v10a.75.75 0 0 1-1.5 0v-4.25h-6.5V17a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 8 6.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const T9 = { render: _9 }, S9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function x9(l, e) {
  return i(), d("svg", S9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.25 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.806l-3.985 3.97a6.75 6.75 0 1 1-1.063-1.059l3.983-3.967H16a.75.75 0 0 1-.75-.75M10 8.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D9 = { render: x9 }, E9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function R9(l, e) {
  return i(), d("svg", E9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 20.25a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5M5.25 15a6.75 6.75 0 1 0 7.5-6.709V3a.75.75 0 0 0-1.5 0v5.291a6.75 6.75 0 0 0-6 6.709",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.33 3.665a.75.75 0 0 1 1.005-.336l6 3a.75.75 0 0 1-.67 1.342l-6-3a.75.75 0 0 1-.336-1.006Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.67 3.665a.75.75 0 0 0-1.005-.336l-6 3a.75.75 0 1 0 .67 1.342l6-3a.75.75 0 0 0 .336-1.006Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const O9 = { render: R9 }, N9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function I9(l, e) {
  return i(), d("svg", N9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 20.25A4.25 4.25 0 0 0 20.25 16V8A4.25 4.25 0 0 0 16 3.75H8A4.25 4.25 0 0 0 3.75 8v8A4.25 4.25 0 0 0 8 20.25zM21.75 16A5.75 5.75 0 0 1 16 21.75H8A5.75 5.75 0 0 1 2.25 16V8A5.75 5.75 0 0 1 8 2.25h8A5.75 5.75 0 0 1 21.75 8z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.75 6.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v2.15h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-2.15v2.15a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.15H6.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15zm1.5.15V8.9a1.35 1.35 0 0 1-1.35 1.35H6.75v3.5H8.9c.746 0 1.35.604 1.35 1.35v2.15h3.5V15.1c0-.746.604-1.35 1.35-1.35h2.15v-3.5H15.1a1.35 1.35 0 0 1-1.35-1.35V6.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q9 = { render: I9 }, F9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function P9(l, e) {
  return i(), d("svg", F9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.75 6.6c0-.746.604-1.35 1.35-1.35h3.8c.746 0 1.35.604 1.35 1.35v2.15h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35h-2.15v2.15a1.35 1.35 0 0 1-1.35 1.35h-3.8a1.35 1.35 0 0 1-1.35-1.35v-2.15H6.6a1.35 1.35 0 0 1-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15zm1.5.15V8.9a1.35 1.35 0 0 1-1.35 1.35H6.75v3.5H8.9c.746 0 1.35.604 1.35 1.35v2.15h3.5V15.1c0-.746.604-1.35 1.35-1.35h2.15v-3.5H15.1a1.35 1.35 0 0 1-1.35-1.35V6.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z9 = { render: P9 }, U9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function j9(l, e) {
  return i(), d("svg", U9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.47 2.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06L8 4.06 4.06 8l1.47 1.47a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06zm8 0a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06l-13 13a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 0 1 0-1.06zM13.06 7 17 10.94 19.94 8 16 4.06zm2.88 5L12 8.06 8.06 12 12 15.94zm-5 5L7 13.06 4.06 16 8 19.94zM12 9.75a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m1.5 2a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m-2.5.5a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0V13a.75.75 0 0 1 .75-.75m7.47 1.22a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06L16 19.94 19.94 16l-1.47-1.47a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const G9 = { render: j9 }, W9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function K9(l, e) {
  return i(), d("svg", W9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.5 3.75a7.75 7.75 0 0 0-6.577 11.852.75.75 0 1 1-1.271.796A9.25 9.25 0 0 1 11.5 2.25a.75.75 0 0 1 0 1.5m7.75 5.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-1.75v1.25a9.2 9.2 0 0 1-1.402 4.898.75.75 0 0 1-1.271-.796A7.7 7.7 0 0 0 19.25 11.5zM8 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M10.75 19a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0M15 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M17.75 19a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.5 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.75 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const X9 = { render: K9 }, J9 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Y9(l, e) {
  return i(), d("svg", J9, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 1.25a5.75 5.75 0 0 0-5.716 5.118A6.25 6.25 0 0 0 7.5 18.75h3.75V22a.75.75 0 0 0 1.5 0v-3.25h3.75a6.25 6.25 0 0 0 1.216-12.382A5.75 5.75 0 0 0 12 1.25m4.25 5.76V7a4.25 4.25 0 0 0-8.434-.75H9a.75.75 0 0 1 0 1.5H7.5a4.75 4.75 0 1 0 0 9.5h3.75V10a.75.75 0 0 1 1.5 0v2.787l2.915-1.458a.75.75 0 1 1 .67 1.342l-3.585 1.793v2.786h3.75a4.75 4.75 0 0 0 .433-9.48.75.75 0 0 1-.683-.76",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q9 = { render: Y9 }, ev = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lv(l, e) {
  return i(), d("svg", ev, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V5.75H16.5a.75.75 0 0 1 0-1.5h3.9c.746 0 1.35.604 1.35 1.35v14.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V5.6c0-.746.604-1.35 1.35-1.35h3.9a.75.75 0 0 1 0 1.5H3.75v14.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.306 7.25a1.25 1.25 0 0 0 1.233-1.045l.2-1.205-.2-1.205a1.25 1.25 0 0 0-1.233-1.045H9.694a1.25 1.25 0 0 0-1.233 1.045L8.261 5l.2 1.205A1.25 1.25 0 0 0 9.694 7.25zm2.712-.798a2.75 2.75 0 0 1-2.712 2.298H9.694a2.75 2.75 0 0 1-2.712-2.298l-.205-1.23a1.4 1.4 0 0 1 0-.444l.205-1.23A2.75 2.75 0 0 1 9.694 1.25h4.612a2.75 2.75 0 0 1 2.712 2.298l.205 1.23a1.4 1.4 0 0 1 0 .444z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.278 8.696a.75.75 0 0 1-.974-.417l-1-2.5a.75.75 0 0 1 1.392-.558l1 2.5a.75.75 0 0 1-.418.975",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tv = { render: lv }, av = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nv(l, e) {
  return i(), d("svg", av, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V5.75H16.5a.75.75 0 0 1 0-1.5h3.9c.746 0 1.35.604 1.35 1.35v14.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V5.6c0-.746.604-1.35 1.35-1.35h3.9a.75.75 0 0 1 0 1.5H3.75v14.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.306 7.25a1.25 1.25 0 0 0 1.233-1.045l.2-1.205-.2-1.205a1.25 1.25 0 0 0-1.233-1.045H9.694a1.25 1.25 0 0 0-1.233 1.045L8.261 5l.2 1.205A1.25 1.25 0 0 0 9.694 7.25zm2.712-.798a2.75 2.75 0 0 1-2.712 2.298H9.694a2.75 2.75 0 0 1-2.712-2.298l-.205-1.23a1.4 1.4 0 0 1 0-.444l.205-1.23A2.75 2.75 0 0 1 9.694 1.25h4.612a2.75 2.75 0 0 1 2.712 2.298l.205 1.23a1.4 1.4 0 0 1 0 .444z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.278 8.696a.75.75 0 0 1-.974-.417l-1-2.5a.75.75 0 0 1 1.392-.558l1 2.5a.75.75 0 0 1-.418.975M6.25 17a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ov = { render: nv }, rv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sv(l, e) {
  return i(), d("svg", rv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.452 1.923a1.35 1.35 0 0 1 1.096 0l8.4 3.733c.488.217.802.7.802 1.234v10.22a1.35 1.35 0 0 1-.802 1.234l-8.4 3.733a1.35 1.35 0 0 1-1.096 0l-8.4-3.733a1.35 1.35 0 0 1-.802-1.234V6.89c0-.534.314-1.017.802-1.234L7.184 3.82l.023-.01zM7.5 5.321 4.847 6.5 12 9.678 14.653 8.5zm9 2.359-.05-.024L9.346 4.5 12 3.32l7.153 3.18zm-.749 1.974V12.5a.75.75 0 1 0 1.5 0V8.987l3-1.333v9.359l-7.5 3.333v-9.358zm-12 7.359V7.654l7.5 3.334v9.358z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const iv = { render: sv }, dv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function uv(l, e) {
  return i(), d("svg", dv, e[0] || (e[0] = [
    a("path", { d: "M22.5 19.5H21V9a1.5 1.5 0 0 0-1.5-1.5h-6V3a1.5 1.5 0 0 0-2.332-1.249l-7.5 4.999A1.5 1.5 0 0 0 3 8v11.5H1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5M19.5 9v10.5h-6V9zm-15-1L12 3v16.5H4.5zm6 2.5V12A.75.75 0 1 1 9 12v-1.5a.75.75 0 1 1 1.5 0m-3 0V12A.75.75 0 1 1 6 12v-1.5a.75.75 0 1 1 1.5 0m0 5.25v1.5a.75.75 0 1 1-1.5 0v-1.5a.75.75 0 1 1 1.5 0m3 0v1.5a.75.75 0 1 1-1.5 0v-1.5a.75.75 0 1 1 1.5 0" }, null, -1)
  ]));
}
const cv = { render: uv }, vv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pv(l, e) {
  return i(), d("svg", vv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m.512 7.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hv = { render: pv }, mv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fv(l, e) {
  return i(), d("svg", mv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gv = { render: fv }, wv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bv(l, e) {
  return i(), d("svg", wv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 13.75c-.69 0-1.25.56-1.25 1.25v3a.75.75 0 0 1-1.5 0v-3a2.75 2.75 0 1 1 5.5 0v3a.75.75 0 0 1-1.5 0v-3c0-.69-.56-1.25-1.25-1.25M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 0 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mv = { render: bv }, yv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vv(l, e) {
  return i(), d("svg", yv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 0 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Av = { render: Vv }, $v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cv(l, e) {
  return i(), d("svg", $v, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.75 16a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hv = { render: Cv }, zv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kv(l, e) {
  return i(), d("svg", zv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.31 8.404a2.75 2.75 0 0 1 1.38 0l2.049.531c.59.153 1.024.695 1.003 1.333-.088 2.643-.888 4.258-1.748 5.224a4.6 4.6 0 0 1-1.183.964 3.5 3.5 0 0 1-.544.246l-.043.014-.016.005-.006.001-.003.001h-.001L12 16.76l-.198-.037h-.004l-.006-.002-.016-.005a2 2 0 0 1-.174-.061 4 4 0 0 1-.413-.199 4.6 4.6 0 0 1-1.183-.964c-.86-.966-1.66-2.58-1.748-5.224a1.334 1.334 0 0 1 1.003-1.333l2.049-.53ZM12 16.76l-.197-.036a.75.75 0 0 0 .394 0zm0-1.57a3.1 3.1 0 0 0 .874-.696c.583-.654 1.263-1.881 1.364-4.14l-1.924-.498a1.25 1.25 0 0 0-.628 0l-1.923.499c.1 2.258.78 3.485 1.363 4.138a3.1 3.1 0 0 0 .874.696Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.33 8.335a.75.75 0 0 1 .335-1.006l9.731-4.866c.38-.19.828-.19 1.208 0l9.731 4.866a.75.75 0 1 1-.67 1.342L12 3.838 2.335 8.671a.75.75 0 0 1-1.006-.336ZM4 10.25a.75.75 0 0 1 .75.75v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-8a.75.75 0 0 1 1.5 0v8A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19v-8a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bv = { render: kv }, Lv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _v(l, e) {
  return i(), d("svg", Lv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.538 3.615a4.75 4.75 0 0 1 4.924 0l5 3.03a4.75 4.75 0 0 1 2.288 4.063V17A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17v-6.292a4.75 4.75 0 0 1 2.288-4.063zm4.146 1.283a3.25 3.25 0 0 0-3.368 0l-5 3.03a3.25 3.25 0 0 0-1.566 2.78V17A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17v-6.292a3.25 3.25 0 0 0-1.566-2.78z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.75 17a.75.75 0 0 1-.75.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tv = { render: _v }, Sv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xv(l, e) {
  return i(), d("svg", Sv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.538 3.615a4.75 4.75 0 0 1 4.924 0l5 3.03a4.75 4.75 0 0 1 2.288 4.063V17A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17v-6.292a4.75 4.75 0 0 1 2.288-4.063zm4.146 1.283a3.25 3.25 0 0 0-3.368 0l-5 3.03a3.25 3.25 0 0 0-1.566 2.78V17A3.25 3.25 0 0 0 7 20.25h1.25V17a3.75 3.75 0 1 1 7.5 0v3.25H17A3.25 3.25 0 0 0 20.25 17v-6.292a3.25 3.25 0 0 0-1.566-2.78zm.566 15.352V17a2.25 2.25 0 1 0-4.5 0v3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dv = { render: xv }, Ev = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rv(l, e) {
  return i(), d("svg", Ev, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.624 3.35a.75.75 0 0 1 .752 0l9.5 5.5a.75.75 0 1 1-.752 1.3L12 4.866l-9.124 5.282a.75.75 0 0 1-.752-1.298zM12 15.75A4.25 4.25 0 0 0 7.75 20v.25a.75.75 0 0 1-1.5 0V20a5.75 5.75 0 0 1 11.5 0v.25a.75.75 0 0 1-1.5 0V20A4.25 4.25 0 0 0 12 15.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 12a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ov = { render: Rv }, Nv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Iv(l, e) {
  return i(), d("svg", Nv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m1 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M7.972 4.924c-.808.698-1.243 1.72-1.222 3.064.02 1.28.408 2.11 1.28 2.982l.043.042c.466.466.918.918 1.223 1.528.323.646.454 1.403.454 2.46a.75.75 0 1 1-1.5 0c0-.943-.119-1.436-.296-1.79-.185-.371-.465-.66-.984-1.18-1.129-1.128-1.693-2.324-1.72-4.018-.027-1.705.538-3.184 1.742-4.223C8.178 2.764 9.888 2.25 12 2.25s3.822.514 5.008 1.539c1.204 1.039 1.769 2.518 1.742 4.223-.027 1.695-.592 2.89-1.72 4.018-.518.52-.798.809-.984 1.18-.177.354-.296.847-.296 1.79a.75.75 0 0 1-1.5 0c0-1.057.131-1.814.454-2.46.305-.61.757-1.062 1.223-1.528l.043-.042c.871-.872 1.26-1.703 1.28-2.982.021-1.345-.414-2.366-1.222-3.064-.826-.713-2.14-1.174-4.028-1.174-1.889 0-3.202.46-4.028 1.174",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qv = { render: Iv }, Fv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pv(l, e) {
  return i(), d("svg", Fv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l2.934 2.935a6.5 6.5 0 0 0-.154 1.547c.027 1.694.591 2.89 1.72 4.018.518.52.798.809.984 1.18.177.354.296.847.296 1.79a.75.75 0 0 0 1.5 0c0-1.057-.13-1.814-.454-2.46-.305-.61-.757-1.062-1.223-1.528l-.043-.042c-.872-.872-1.26-1.703-1.28-2.982V7.81l13.72 13.72a.75.75 0 1 0 1.06-1.06zm5.733 1.71c.73-.273 1.638-.43 2.737-.43 1.888 0 3.202.46 4.028 1.174.808.698 1.243 1.72 1.222 3.064-.02 1.28-.409 2.11-1.28 2.982a.75.75 0 1 0 1.06 1.06c1.128-1.128 1.693-2.323 1.72-4.018.027-1.705-.538-3.184-1.742-4.223C15.822 2.764 14.112 2.25 12 2.25c-1.236 0-2.33.176-3.263.525a.75.75 0 0 0 .526 1.405M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M10 21.75a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zv = { render: Pv }, Uv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jv(l, e) {
  return i(), d("svg", Uv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M21.53 1.47a.75.75 0 0 0-1.06 0l-1 1a.75.75 0 0 0 1.06 1.06l1-1a.75.75 0 0 0 0-1.06m-19.06 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m19.06 15.06a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l1 1a.75.75 0 0 1 0 1.06m-19.06 0a.75.75 0 0 0 1.06 0l1-1a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 0 0 0 1.06M8.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m1 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M7.972 4.924c-.809.698-1.243 1.72-1.222 3.064.02 1.28.408 2.11 1.28 2.982l.042.042c.467.466.919.918 1.224 1.528.241.482.375 1.026.428 1.71h4.552c.053-.684.187-1.228.428-1.71.305-.61.757-1.062 1.223-1.528l.043-.042c.871-.872 1.26-1.703 1.28-2.982.021-1.345-.414-2.366-1.222-3.064-.826-.713-2.14-1.174-4.028-1.174-1.889 0-3.202.46-4.028 1.174m-.98-1.135C8.178 2.764 9.888 2.25 12 2.25s3.822.514 5.008 1.539c1.204 1.039 1.769 2.518 1.742 4.223-.027 1.695-.592 2.89-1.72 4.018-.518.52-.799.809-.984 1.18-.177.354-.296.847-.296 1.79a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75c0-.943-.12-1.436-.296-1.79-.186-.371-.466-.66-.984-1.18-1.129-1.128-1.693-2.324-1.72-4.018-.027-1.705.538-3.184 1.742-4.223",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gv = { render: jv }, Wv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kv(l, e) {
  return i(), d("svg", Wv, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.155 3.22c.17-.555.676-.97 1.296-.97h4.872v.01h5.355l-.001-.01h4.862a1.35 1.35 0 0 1 1.301.988l1.532 5.379h.006l.158.538a1.32 1.32 0 0 1-.8 1.614v8.233a2.754 2.754 0 0 1-2.747 2.748H5.001a2.754 2.754 0 0 1-2.748-2.748v-8.236a1.323 1.323 0 0 1-.79-1.608l1.576-5.49-.016-.018zm.597 7.72v8.062c0 .685.563 1.249 1.249 1.249h3.077v-5.247a2.754 2.754 0 0 1 2.748-2.749h1.998a2.754 2.754 0 0 1 2.748 2.749v5.247h3.417c.685 0 1.25-.564 1.25-1.25v-8.063c-.79.033-1.71.002-2.457-.225l-.008-.002c-.617-.196-1.343-.593-1.764-.837-.415.246-1.162.659-1.799.85-.79.243-1.493.377-2.216.377s-1.426-.134-2.216-.378c-.634-.19-1.375-.598-1.792-.845-.434.257-1.158.648-1.766.834-.617.193-1.33.244-1.962.241q-.259 0-.507-.013m5.444-7.18-.408 4.85c.4.235.987.548 1.423.678l.007.002c.697.215 1.247.311 1.777.311s1.08-.096 1.777-.311l.007-.002c.437-.13 1.027-.445 1.427-.68l-.403-4.849zm-4.62-.01h3.108l-.4 4.802c-.393.236-1.04.586-1.503.727l-.005.002c-.402.126-.937.175-1.51.173a13 13 0 0 1-1.306-.078zm14.851 0 1.604 5.627c-.852.088-2.03.138-2.809-.097-.475-.151-1.108-.498-1.51-.733l-.405-4.798zm-5.354 16.5H9.577v-5.247c0-.686.564-1.25 1.249-1.25h1.998c.685 0 1.25.564 1.25 1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xv = { render: Kv }, Jv = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yv(l, e) {
  return i(), d("svg", Jv, e[0] || (e[0] = [
    a("path", { d: "m13.28 12.53-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H2.25a.75.75 0 1 1 0-1.5h8.69L8.47 8.78a.75.75 0 0 1 1.06-1.06l3.75 3.75a.747.747 0 0 1 0 1.06M18 3h-5.25a.75.75 0 1 0 0 1.5H18v15h-5.25a.75.75 0 1 0 0 1.5H18a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 18 3" }, null, -1)
  ]));
}
const Qv = { render: Yv }, ep = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lp(l, e) {
  return i(), d("svg", ep, e[0] || (e[0] = [
    a("path", { d: "M10.5 20.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h5.25a.75.75 0 1 1 0 1.5H4.5v15h5.25a.75.75 0 0 1 .75.75m10.28-8.78-3.75-3.75a.75.75 0 1 0-1.06 1.06l2.47 2.47H9.75a.75.75 0 1 0 0 1.5h8.69l-2.47 2.47a.75.75 0 1 0 1.06 1.06l3.75-3.75a.747.747 0 0 0 0-1.06" }, null, -1)
  ]));
}
const tp = { render: lp }, ap = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function np(l, e) {
  return i(), d("svg", ap, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0M19 15.25a.75.75 0 0 1 .75.75v2.25H22a.75.75 0 0 1 0 1.5h-2.25V22a.75.75 0 0 1-1.5 0v-2.25H16a.75.75 0 0 1 0-1.5h2.25V16a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const op = { render: np }, rp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sp(l, e) {
  return i(), d("svg", rp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.973 2.552a1.35 1.35 0 0 1 1.777 1.28v14.735a1.35 1.35 0 0 1-.923 1.281l-5.59 1.864a.75.75 0 0 1-.474 0L9 19.79l-4.973 1.657a1.35 1.35 0 0 1-1.777-1.28V5.431c0-.58.372-1.097.923-1.28l5.59-1.864a.75.75 0 0 1 .474 0L15 4.21zM14.25 5.54l-4.5-1.5v14.418l4.5 1.5V5.541Zm1.5 14.418V5.541l4.5-1.5v14.418l-4.5 1.5Zm-7.5-1.5V4.041l-4.5 1.5v14.418l4.5-1.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ip = { render: sp }, dp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function up(l, e) {
  return i(), d("svg", dp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m14.25 5.54-4.5-1.5v14.42l4.5 1.5zm-6 12.92V4.04l-4.5 1.5v14.42zM9 19.79l-4.973 1.658a1.35 1.35 0 0 1-1.777-1.28V5.431c0-.58.372-1.097.923-1.28l5.59-1.864a.75.75 0 0 1 .474 0l5.59 1.864c.551.183.923.7.923 1.28v14.736a1.35 1.35 0 0 1-1.777 1.28L9 19.791Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.25 4.04V15a.75.75 0 0 0 1.5 0V3.832a1.35 1.35 0 0 0-1.777-1.28l-5.21 1.737a.75.75 0 0 0 .474 1.423zm-3.659 13.551a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const cp = { render: up }, vp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pp(l, e) {
  return i(), d("svg", vp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 5.53 4.68 18.542l6.867-2.67a1.25 1.25 0 0 1 .906 0l6.866 2.67zm-1.09-1.123a1.25 1.25 0 0 1 2.18 0l7.879 14.008c.575 1.023-.449 2.203-1.543 1.778L12 17.305l-7.426 2.888c-1.094.425-2.118-.755-1.543-1.778z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hp = { render: pp }, mp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fp(l, e) {
  return i(), d("svg", mp, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M19.282 5.425 4.906 9.451l6.743 2.967c.286.126.515.354.64.64l2.968 6.744zm.024-1.564a1.25 1.25 0 0 1 1.54 1.54l-4.333 15.477c-.316 1.13-1.875 1.241-2.348.167l-3.209-7.294-7.293-3.209c-1.075-.472-.964-2.031.166-2.347L19.306 3.86Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("path", { d: "M0 0h24v24H0z" })
      ])
    ], -1)
  ]));
}
const gp = { render: fp }, wp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bp(l, e) {
  return i(), d("svg", wp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m12 5.53 5.846 10.393a.75.75 0 0 0 1.308-.735l-6.065-10.78a1.25 1.25 0 0 0-2.178 0L3.03 18.414c-.575 1.023.449 2.203 1.543 1.778L12 17.305l1.728.672a.75.75 0 1 0 .544-1.398l-1.819-.708a1.25 1.25 0 0 0-.906 0l-6.866 2.67zm4.591 12.061a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mp = { render: bp }, yp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vp(l, e) {
  return i(), d("svg", yp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51zm6.25-1a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ap = { render: Vp }, $p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cp(l, e) {
  return i(), d("svg", $p, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75A7.25 7.25 0 0 0 4.75 10c0 .907.422 2.07 1.154 3.371.72 1.28 1.69 2.605 2.677 3.811A51 51 0 0 0 12 20.95a51 51 0 0 0 3.42-3.768c.985-1.206 1.956-2.531 2.676-3.811.732-1.3 1.154-2.464 1.154-3.371A7.25 7.25 0 0 0 12 2.75M12 22l-.516.544-.007-.006-.018-.018-.07-.067-.26-.254a53 53 0 0 1-3.71-4.068c-1.014-1.24-2.043-2.64-2.823-4.024C3.828 12.743 3.25 11.302 3.25 10a8.75 8.75 0 0 1 17.5 0c0 1.302-.578 2.743-1.346 4.107-.78 1.384-1.81 2.783-2.823 4.024a53 53 0 0 1-3.97 4.322l-.07.067-.018.018-.005.004-.001.002zm0 0 .517.544-.517.49-.516-.49z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M12 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 9.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-1.75.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hp = { render: Cp }, zp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kp(l, e) {
  return i(), d("svg", zp, e[0] || (e[0] = [
    s5('<g clip-path="url(#a)"><path fill-rule="evenodd" d="M9 2.75c-3.432 0-6.25 2.868-6.25 6.45 0 .802.363 1.839 1.002 3.005.628 1.147 1.474 2.336 2.335 3.42A46 46 0 0 0 9 18.933a46 46 0 0 0 2.913-3.309c.86-1.083 1.707-2.272 2.335-3.419.639-1.166 1.002-2.203 1.002-3.005 0-3.582-2.818-6.45-6.25-6.45M9 20l-.524.537-.006-.006-.016-.016-.061-.06-.228-.23a47 47 0 0 1-3.252-3.668c-.89-1.118-1.793-2.381-2.477-3.632C1.762 11.694 1.25 10.386 1.25 9.2 1.25 4.83 4.7 1.25 9 1.25s7.75 3.58 7.75 7.95c0 1.186-.512 2.494-1.186 3.725-.684 1.25-1.588 2.514-2.477 3.633a47 47 0 0 1-3.48 3.896l-.06.06-.017.017-.006.005zm0 0 .524.536-.524.511-.524-.51z" clip-rule="evenodd"></path><path d="M9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2"></path><path fill-rule="evenodd" d="M9 8.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M7.25 9a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m9.098 7.348a.75.75 0 0 1 1.061 0L19 17.94l1.591-1.59a.75.75 0 0 1 1.06 1.06L20.062 19l1.59 1.591a.75.75 0 0 1-1.06 1.06L19 20.062l-1.591 1.59a.75.75 0 0 1-1.06-1.06L17.938 19l-1.59-1.591a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Bp = { render: kp }, Lp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _p(l, e) {
  return i(), d("svg", Lp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.53 5.47a.75.75 0 0 1 0 1.06L7.81 18.25h10.67a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75V6.52a.75.75 0 0 1 1.5 0v10.67L18.47 5.47a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tp = { render: _p }, Sp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xp(l, e) {
  return i(), d("svg", Sp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.359 8.641a.75.75 0 0 0-1.061 0L9.92 13.018v-3.14a.75.75 0 0 0-1.5 0v4.95a.747.747 0 0 0 .75.75h4.95a.75.75 0 1 0 0-1.5h-3.139l4.377-4.376a.75.75 0 0 0 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dp = { render: xp }, Ep = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rp(l, e) {
  return i(), d("svg", Ep, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.77 19c0 .414.336.75.75.75H19a.75.75 0 0 0 .75-.75V6.52a.75.75 0 1 0-1.5 0v10.67L6.53 5.47a.75.75 0 0 0-1.06 1.06l11.72 11.72H6.52a.75.75 0 0 0-.75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Op = { render: Rp }, Np = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ip(l, e) {
  return i(), d("svg", Np, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.641 8.641a.75.75 0 0 1 1.06 0l4.377 4.377v-3.14a.75.75 0 0 1 1.5 0v4.95a.747.747 0 0 1-.75.75h-4.95a.75.75 0 0 1 0-1.5h3.14L8.64 9.703a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qp = { render: Ip }, Fp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pp(l, e) {
  return i(), d("svg", Fp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.72 11.47a.75.75 0 0 1 1.06 0l4.72 4.72V5.5a.75.75 0 0 1 1.5 0v10.69l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zp = { render: Pp }, Up = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jp(l, e) {
  return i(), d("svg", Up, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 16.53a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22V8a.75.75 0 0 0-1.5 0v6.19l-2.22-2.22a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gp = { render: jp }, Wp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kp(l, e) {
  return i(), d("svg", Wp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.53 5.47a.75.75 0 0 1 0 1.06l-4.72 4.72H18.5a.75.75 0 0 1 0 1.5H7.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xp = { render: Kp }, Jp = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yp(l, e) {
  return i(), d("svg", Jp, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.47 11.47a.75.75 0 0 0 0 1.06l3.5 3.5a.75.75 0 1 0 1.06-1.06l-2.22-2.22H16a.75.75 0 0 0 0-1.5H9.81l2.22-2.22a.75.75 0 0 0-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qp = { render: Yp }, eh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lh(l, e) {
  return i(), d("svg", eh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.97 5.47a.75.75 0 0 0 0 1.06l4.72 4.72H6a.75.75 0 0 0 0 1.5h10.69l-4.72 4.72a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const th = { render: lh }, ah = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nh(l, e) {
  return i(), d("svg", ah, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.53 12.53a.75.75 0 0 0 0-1.06l-3.5-3.5a.75.75 0 1 0-1.06 1.06l2.22 2.22H8a.75.75 0 0 0 0 1.5h6.19l-2.22 2.22a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const oh = { render: nh }, rh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sh(l, e) {
  return i(), d("svg", rh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.47 12.53a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 1.06L4.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06zm19.06 0a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 1 0-1.06 1.06L19.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ih = { render: sh }, dh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function uh(l, e) {
  return i(), d("svg", dh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1-1.06 1.06L12 4.06 7.53 8.53a.75.75 0 0 1-1.06-1.06zm0 19.06a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06L12 19.94l-4.47-4.47a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ch = { render: uh }, vh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ph(l, e) {
  return i(), d("svg", vh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.53 19.53a.75.75 0 0 0 0-1.06L7.81 6.75h10.67a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0-.75.75v12.48a.75.75 0 0 0 1.5 0V7.81l11.72 11.72a.75.75 0 0 0 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const hh = { render: ph }, mh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fh(l, e) {
  return i(), d("svg", mh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.172 8.422h4.95a.75.75 0 0 1 0 1.5h-3.14l4.377 4.376a.75.75 0 1 1-1.061 1.06l-4.376-4.376v3.14a.75.75 0 0 1-1.5 0v-4.95a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const gh = { render: fh }, wh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bh(l, e) {
  return i(), d("svg", wh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.77 6a.75.75 0 0 1 .75-.75H19a.75.75 0 0 1 .75.75v12.48a.75.75 0 0 1-1.5 0V7.81L6.53 19.53a.75.75 0 0 1-1.06-1.06L17.19 6.75H6.52A.75.75 0 0 1 5.77 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mh = { render: bh }, yh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vh(l, e) {
  return i(), d("svg", yh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.828 8.422h-4.95a.75.75 0 0 0 0 1.5h3.14L8.64 14.298a.75.75 0 1 0 1.06 1.06l4.377-4.376v3.14a.75.75 0 0 0 1.5 0v-4.95a.75.75 0 0 0-.75-.75Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ah = { render: Vh }, $h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ch(l, e) {
  return i(), d("svg", $h, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.47 12.53a.75.75 0 0 1 0-1.06l5-5a.75.75 0 1 1 1.06 1.06L16.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06zm-4.94 0a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 1.06L7.94 12l-4.47 4.47a.75.75 0 1 0 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hh = { render: Ch }, zh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function kh(l, e) {
  return i(), d("svg", zh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 9.53a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0-1.06-1.06L12 7.94 7.53 3.47a.75.75 0 0 0-1.06 1.06zm0 4.94a.75.75 0 0 1 1.06 0l5 5a.75.75 0 1 1-1.06 1.06L12 16.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bh = { render: kh }, Lh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _h(l, e) {
  return i(), d("svg", Lh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.78 12.53a.75.75 0 0 1-1.06 0L13 7.81V18.5a.75.75 0 0 1-1.5 0V7.81l-4.72 4.72a.75.75 0 0 1-1.06-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Th = { render: _h }, Sh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xh(l, e) {
  return i(), d("svg", Sh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 7.47a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06l-2.22-2.22V16a.75.75 0 0 1-1.5 0V9.81l-2.22 2.22a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dh = { render: xh }, Eh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rh(l, e) {
  return i(), d("svg", Eh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 3.25h4a.75.75 0 0 1 0 1.5H5.81l6.72 6.72a.75.75 0 1 1-1.06 1.06L4.75 5.81V8a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .218-.529l.002-.001.001-.002A.75.75 0 0 1 4 3.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 4.75a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.81l-6.72 6.72a.75.75 0 1 1-1.06-1.06l6.72-6.72z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.53 11.47a.75.75 0 0 1 0 1.06l-6.72 6.72H8a.75.75 0 0 1 0 1.5H4a.747.747 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v2.19l6.72-6.72a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 11.47a.75.75 0 0 1 1.06 0l6.72 6.72V16a.75.75 0 0 1 1.5 0v4a.747.747 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h2.19l-6.72-6.72a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Oh = { render: Rh }, Nh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ih(l, e) {
  return i(), d("svg", Nh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.47 12.47a.75.75 0 0 1 1.06 0L12 17.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06m0-8a.75.75 0 0 1 1.06 0L12 9.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qh = { render: Ih }, Fh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ph(l, e) {
  return i(), d("svg", Fh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.53 5.47a.75.75 0 0 1 0 1.06L6.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0m8 0a.75.75 0 0 1 0 1.06L14.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zh = { render: Ph }, Uh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jh(l, e) {
  return i(), d("svg", Uh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.47 5.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06L17.94 12l-5.47-5.47a.75.75 0 0 1 0-1.06m-8 0a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06-1.06L9.94 12 4.47 6.53a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Gh = { render: jh }, Wh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Kh(l, e) {
  return i(), d("svg", Wh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 4.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 6.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06zm0 8a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 14.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xh = { render: Kh }, Jh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Yh(l, e) {
  return i(), d("svg", Jh, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 6A.75.75 0 0 1 3 5.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 6m4 6a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m4 6a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Qh = { render: Yh }, em = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lm(l, e) {
  return i(), d("svg", em, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9A.75.75 0 0 1 6 8.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 9m2 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m2 4a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 1 0 18.5 9.25 9.25 0 0 1 0-18.5M22.75 12c0-5.937-4.813-10.75-10.75-10.75S1.25 6.063 1.25 12 6.063 22.75 12 22.75 22.75 17.937 22.75 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tm = { render: lm }, am = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nm(l, e) {
  return i(), d("svg", am, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.72 11.72a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06l2.97-2.97-2.97-2.97a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.75 4a.75.75 0 0 1 .75.75v7A3.25 3.25 0 0 0 10.75 15h6a.75.75 0 0 1 0 1.5h-6A4.75 4.75 0 0 1 6 11.75v-7A.75.75 0 0 1 6.75 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const om = { render: nm }, rm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sm(l, e) {
  return i(), d("svg", rm, e[0] || (e[0] = [
    s5('<path d="M18 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M18 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M16.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M6 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M6 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M4.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path>', 6)
  ]));
}
const im = { render: sm }, dm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function um(l, e) {
  return i(), d("svg", dm, e[0] || (e[0] = [
    s5('<path d="M7 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M7 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M5.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M17 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M17 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M15.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const cm = { render: um }, vm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function pm(l, e) {
  return i(), d("svg", vm, e[0] || (e[0] = [
    s5('<path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 18.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 18.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 18a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 6.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path>', 6)
  ]));
}
const hm = { render: pm }, mm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fm(l, e) {
  return i(), d("svg", mm, e[0] || (e[0] = [
    s5('<path d="M12 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 7.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 7a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 17.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 17.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 17a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path d="M12 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path><path fill-rule="evenodd" d="M12 12.25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5M10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12" clip-rule="evenodd"></path>', 7)
  ]));
}
const gm = { render: fm }, wm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function bm(l, e) {
  return i(), d("svg", wm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.47 8.47a.75.75 0 0 1 1.06 0L12 13.94l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Mm = { render: bm }, ym = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Vm(l, e) {
  return i(), d("svg", ym, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.53 5.47a.75.75 0 0 1 0 1.06L10.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Am = { render: Vm }, $m = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Cm(l, e) {
  return i(), d("svg", $m, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.47 5.47a.75.75 0 0 0 0 1.06L13.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hm = { render: Cm }, zm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function km(l, e) {
  return i(), d("svg", zm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.47 15.53a.75.75 0 0 0 1.06 0L12 10.06l5.47 5.47a.75.75 0 1 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 0 0 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bm = { render: km }, Lm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function _m(l, e) {
  return i(), d("svg", Lm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.97 10.47a.75.75 0 0 1 1.06 0L12 13.44l2.97-2.97a.75.75 0 1 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Tm = { render: _m }, Sm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function xm(l, e) {
  return i(), d("svg", Sm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.53 7.97a.75.75 0 0 1 0 1.06L10.56 12l2.97 2.97a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.5a.75.75 0 0 1 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Dm = { render: xm }, Em = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Rm(l, e) {
  return i(), d("svg", Em, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.47 7.97a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06L13.44 12l-2.97-2.97a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Om = { render: Rm }, Nm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Im(l, e) {
  return i(), d("svg", Nm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.47 8.97a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 1 1-1.06 1.06L12 10.56l-2.97 2.97a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const qm = { render: Im }, Fm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Pm(l, e) {
  return i(), d("svg", Fm, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m17.47 2.47-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22V16.5a.75.75 0 0 0 1.5 0V4.81l2.22 2.22a.75.75 0 1 0 1.06-1.06l-3.5-3.5a.75.75 0 0 0-1.06 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 6.75a.75.75 0 0 1 .75.75v9a2.75 2.75 0 1 0 5.5 0 .75.75 0 0 1 1.5 0 4.25 4.25 0 0 1-8.5 0v-9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 7.5a4.25 4.25 0 0 1 8.5 0 .75.75 0 0 1-1.5 0 2.75 2.75 0 1 0-5.5 0v12a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Zm = { render: Pm }, Um = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function jm(l, e) {
  return i(), d("svg", Um, e[0] || (e[0] = [
    a("path", { d: "M21 13.3H3c-.4 0-.8.3-.8.8s.3.8.8.8h7.2L8 17c-.3.3-.3.8 0 1.1s.8.3 1.1 0l2.2-2.2V22c0 .4.3.8.8.8s.8-.3.8-.8v-6.2L15 18c.3.3.8.3 1.1 0s.3-.8 0-1.1l-2.2-2.2H21c.4 0 .8-.3.8-.8s-.4-.6-.8-.6M3 10.7h18c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-7.2L16 7c.3-.3.3-.8 0-1.1s-.7-.2-1 .1l-2.2 2.2V2c0-.4-.3-.8-.8-.8s-.8.4-.8.8v6.2L9 6c-.3-.3-.7-.3-1 0s-.3.7 0 1l2.2 2.2H3c-.4 0-.8.3-.8.8s.4.7.8.7" }, null, -1)
  ]));
}
const Gm = { render: jm }, Wm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Km(l, e) {
  return i(), d("svg", Wm, e[0] || (e[0] = [
    a("path", { d: "M21 13.3H3c-.4 0-.8.3-.8.8s.3.8.8.8h8.2v5.4L9 18c-.3-.3-.8-.3-1.1 0s-.2.7.1 1l3.5 3.5c.1.1.2.1.2.2.1 0 .2.1.3.1s.2 0 .3-.1c.1 0 .2-.1.2-.2L16 19c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.2 2.2v-5.4H21c.4 0 .8-.3.8-.8s-.4-.6-.8-.6M3 10.7h18c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-8.2V3.8L15 6c.3.3.8.3 1.1 0s.3-.8 0-1.1l-3.5-3.5c-.1-.1-.2-.1-.2-.2q-.3-.15-.6 0c-.1 0-.2.1-.2.2L8 5c-.3.3-.3.7 0 1s.7.3 1 0l2.2-2.2v5.4H3c-.4 0-.8.3-.8.8s.4.7.8.7" }, null, -1)
  ]));
}
const Xm = { render: Km }, Jm = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ym(l, e) {
  return i(), d("svg", Jm, e[0] || (e[0] = [
    a("path", { d: "M22.2 13.9q0-.15 0 0l-1.5-5.1c-.2-.8-1-2.2-2.6-2.5-.2-1-1-2.1-2.7-2.1-1.6 0-2.4 1-2.6 2h-1.7c-.3-1-1.1-2-2.6-2-1.6 0-2.4 1.1-2.7 2.1-1.6.3-2.3 1.7-2.5 2.5l-1.5 5v.1c-.3.6-.5 1.4-.5 2.1 0 2.6 2.1 4.8 4.8 4.8 2.5 0 4.5-1.9 4.7-4.3.4.2.8.3 1.3.3s.9-.1 1.3-.3c.2 2.4 2.2 4.3 4.7 4.3 2.6 0 4.8-2.1 4.8-4.8-.1-.8-.3-1.5-.7-2.1M4.7 9.2c0-.1.4-1.4 1.8-1.4.4 0 .7-.3.8-.7 0-.3.1-1.3 1.2-1.3s1.2 1 1.2 1.2c0 .4.3.8.8.8h3c.4 0 .7-.3.8-.7 0-.3.1-1.3 1.2-1.3s1.2 1 1.2 1.2c0 .4.3.8.8.8 1.4 0 1.7 1.3 1.8 1.5l.8 2.5c-.6-.3-1.3-.5-2-.5-1.4 0-2.6.6-3.5 1.6-.4-.9-1.4-1.6-2.5-1.6s-2 .7-2.5 1.6c-.9-1-2.1-1.6-3.5-1.6-.7 0-1.4.2-2 .5zM6 19.3c-1.8 0-3.2-1.5-3.2-3.2s1.5-3.3 3.2-3.3 3.2 1.5 3.2 3.3-1.4 3.2-3.2 3.2m6-4c-.7 0-1.2-.6-1.2-1.2s.6-1.3 1.2-1.3 1.2.6 1.2 1.3-.5 1.2-1.2 1.2m6 4c-1.8 0-3.2-1.5-3.2-3.2s1.5-3.3 3.2-3.3 3.2 1.5 3.2 3.3-1.4 3.2-3.2 3.2" }, null, -1)
  ]));
}
const Qm = { render: Ym }, ef = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function lf(l, e) {
  return i(), d("svg", ef, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.489 1.431 12 2l-.489-.569a.75.75 0 0 1 .978 0m.261 7.222a2.44 2.44 0 0 0 1.32-.89c.475-.623.68-1.461.68-2.388 0-1.095-.64-2.11-1.16-2.772a9.4 9.4 0 0 0-1.07-1.144l-.021-.02-.007-.005-.002-.002L12 2l-.489-.569-.001.001-.002.002-.007.006-.021.019a9 9 0 0 0-.322.305 9 9 0 0 0-.748.839c-.52.661-1.16 1.677-1.16 2.772 0 .927.205 1.764.68 2.388.342.45.795.748 1.32.89v1.597H5A2.75 2.75 0 0 0 2.25 13v1a3.75 3.75 0 0 0 1 2.55V20A2.75 2.75 0 0 0 6 22.75h12A2.75 2.75 0 0 0 20.75 20v-3.45a3.75 3.75 0 0 0 1-2.55v-1A2.75 2.75 0 0 0 19 10.25h-6.25zM5 11.75A1.25 1.25 0 0 0 3.75 13v1a2.25 2.25 0 0 0 4.5 0 .75.75 0 0 1 1.5 0 2.25 2.25 0 0 0 4.5 0 .75.75 0 0 1 1.5 0 2.25 2.25 0 0 0 4.5 0v-1A1.25 1.25 0 0 0 19 11.75zm10 4.5a3.75 3.75 0 0 1-6 0 3.75 3.75 0 0 1-3 1.5c-.43 0-.852-.074-1.25-.215V20A1.25 1.25 0 0 0 6 21.25h12A1.25 1.25 0 0 0 19.25 20v-2.465A3.75 3.75 0 0 1 15 16.25m-3-13.2c-.128.138-.27.3-.41.48-.48.611-.84 1.283-.84 1.845 0 .73.164 1.205.373 1.48.189.246.46.395.877.395.418 0 .688-.149.877-.396.209-.274.373-.749.373-1.479 0-.562-.36-1.234-.84-1.846A8 8 0 0 0 12 3.05",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tf = { render: lf }, af = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function nf(l, e) {
  return i(), d("svg", af, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 8.75c-.69 0-1.25.56-1.25 1.25v4.599l.725-.483a2.75 2.75 0 0 1 3.05 0l.725.483V10c0-.69-.56-1.25-1.25-1.25zM8.25 10A2.75 2.75 0 0 1 11 7.25h2A2.75 2.75 0 0 1 15.75 10v6a.75.75 0 0 1-1.166.624l-1.89-1.26a1.25 1.25 0 0 0-1.387 0l-1.891 1.26A.75.75 0 0 1 8.25 16z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const of = { render: nf }, rf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function sf(l, e) {
  return i(), d("svg", rf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7 3.75c-.69 0-1.25.56-1.25 1.25v14.626l4.763-3.062a2.75 2.75 0 0 1 2.974 0l4.763 3.062V5c0-.69-.56-1.25-1.25-1.25zM4.25 5A2.75 2.75 0 0 1 7 2.25h10A2.75 2.75 0 0 1 19.75 5v16a.75.75 0 0 1-1.156.63l-5.918-3.804a1.25 1.25 0 0 0-1.352 0l-5.918 3.805A.75.75 0 0 1 4.25 21z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const df = { render: sf }, uf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cf(l, e) {
  return i(), d("svg", uf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.565 1.5h12.87a1.51 1.51 0 0 1 1.284.717l3.303 5.331a1.53 1.53 0 0 1-.087 1.731l-.001.001-9.738 12.63a1.508 1.508 0 0 1-2.392 0L1.066 9.28a1.52 1.52 0 0 1-.088-1.73L4.28 2.217v-.001A1.51 1.51 0 0 1 5.565 1.5M5.566 3a.01.01 0 0 0-.008.005l-.001.001L2.773 7.5h18.454l-2.785-4.495A.01.01 0 0 0 18.434 3zm15.69 6H2.744l9.25 11.997L12 21h.004l.002-.003.002-.002L21.255 9Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .6.3l3.722 4.962 1.739-4.057a.75.75 0 0 1 1.378.59L17.2 8.523 12.707 21.25a.75.75 0 0 1-1.414 0L6.8 8.523 4.56 3.295a.75.75 0 0 1 1.378-.59l1.74 4.057L11.4 1.8a.75.75 0 0 1 .6-.3M8.34 8.379 12 18.747l3.66-10.368L12 3.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vf = { render: cf }, pf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hf(l, e) {
  return i(), d("svg", pf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M21.75 4A1.75 1.75 0 0 0 20 2.25H4A1.75 1.75 0 0 0 2.25 4v1.586c0 .464.184.909.513 1.237l6.414 6.414a.25.25 0 0 1 .073.177v5.805a1.75 1.75 0 0 0 1.326 1.698l2 .5a1.75 1.75 0 0 0 2.174-1.698v-6.305a.25.25 0 0 1 .073-.177l6.415-6.414a1.75 1.75 0 0 0 .512-1.237zM20 3.75a.25.25 0 0 1 .25.25v1.586a.25.25 0 0 1-.073.177l-6.414 6.414a1.75 1.75 0 0 0-.513 1.237v6.305a.25.25 0 0 1-.31.243l-2-.5a.25.25 0 0 1-.19-.243v-5.805c0-.464-.184-.909-.513-1.237L3.823 5.763a.25.25 0 0 1-.073-.177V4A.25.25 0 0 1 4 3.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mf = { render: hf }, ff = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gf(l, e) {
  return i(), d("svg", ff, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M21.75 4A1.75 1.75 0 0 0 20 2.25H4A1.75 1.75 0 0 0 2.25 4v3a.75.75 0 0 0 .262.57l6.65 5.7a.25.25 0 0 1 .088.19v6.26a1.75 1.75 0 0 0 2.174 1.697l2-.5a1.75 1.75 0 0 0 1.326-1.698V13.46a.25.25 0 0 1 .087-.19l6.651-5.7A.75.75 0 0 0 21.75 7zM20 3.75a.25.25 0 0 1 .25.25v2.25H3.75V4A.25.25 0 0 1 4 3.75zm-14.973 4h13.946l-5.112 4.381a1.75 1.75 0 0 0-.611 1.329v5.76a.25.25 0 0 1-.19.242l-2 .5a.25.25 0 0 1-.31-.243v-6.26c0-.51-.223-.995-.611-1.328z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wf = { render: gf }, bf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Mf(l, e) {
  return i(), d("svg", bf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2 5.25a.75.75 0 0 1 .75.75v4.536a4.75 4.75 0 0 1 7.94 2.714h2.62a4.75 4.75 0 0 1 7.94-2.714V6a.75.75 0 0 1 1.5 0v8a4.75 4.75 0 0 1-9.44.75h-2.62A4.75 4.75 0 0 1 1.25 14V6A.75.75 0 0 1 2 5.25M21.25 14a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m-18.5 0a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yf = { render: Mf }, Vf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Af(l, e) {
  return i(), d("svg", Vf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 1.3a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4M3.7 5a2.3 2.3 0 1 1 4.6 0 2.3 2.3 0 0 1-4.6 0m8.7 4c0 .458.086.897.242 1.3H10c-.728 0-1.45.24-1.922.831l-5.07 4.888-.513-.514a.7.7 0 1 0-.99.99l6 6a.7.7 0 1 0 .99-.99l-.47-.47 1.036-.908a.7.7 0 0 0 .099-.107c.13-.173.388-.32.84-.32h4c1.262 0 2.456-.459 3.305-1.415l4.576-4.376.002-.002a2.701 2.701 0 0 0-2.294-4.628A3.6 3.6 0 1 0 12.4 9M16 6.8a2.2 2.2 0 1 0 1.386 3.909l.215-.2A2.2 2.2 0 0 0 16 6.8m-1.074 8.103 3.383-3.14a4 4 0 0 0 .274-.255l.543-.505.005-.004a1.302 1.302 0 1 1 1.788 1.892l-4.603 4.403-.043.045c-.549.628-1.346.961-2.273.961h-4c-.722 0-1.439.236-1.91.817l-1.058.925-3.033-3.033 5.087-4.905a1 1 0 0 0 .074-.084c.13-.173.388-.32.84-.32h3a1.3 1.3 0 1 1 0 2.6h-2a.7.7 0 1 0 0 1.4h2a2.7 2.7 0 0 0 1.858-.741z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $f = { render: Af }, Cf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hf(l, e) {
  return i(), d("svg", Cf, e[0] || (e[0] = [
    a("path", { d: "M23.84 10.117 21.449 5.33a1.5 1.5 0 0 0-2.013-.67l-2.331 1.165-4.912-1.3a.76.76 0 0 0-.384 0l-4.912 1.3L4.565 4.66a1.5 1.5 0 0 0-2.013.67L.159 10.116a1.5 1.5 0 0 0 .67 2.013l2.532 1.266 5.202 3.715a.8.8 0 0 0 .254.118l6 1.5a.75.75 0 0 0 .713-.197l5.163-5.164 2.476-1.238a1.5 1.5 0 0 0 .67-2.012zm-5.145 3.128-3.226-2.584a.75.75 0 0 0-1.001.058c-1.67 1.681-3.531 1.469-4.718.719L13.804 7.5h2.982l2.55 5.101zM3.893 6l1.92.958-2.398 4.786-1.915-.957zm10.875 11.17-5.447-1.362-4.613-3.294 2.625-5.25L12 6.026l.919.243L8.7 10.364l-.008.009a1.5 1.5 0 0 0 .255 2.326c1.928 1.23 4.254 1.03 6.086-.47l2.592 2.083zm5.813-5.426-2.393-4.781L20.107 6l2.393 4.787zm-8.227 8.688a.75.75 0 0 1-.909.546L7.538 20a.7.7 0 0 1-.254-.117l-2.47-1.765a.75.75 0 0 1 .872-1.218l2.354 1.68 3.773.942a.75.75 0 0 1 .545.909z" }, null, -1)
  ]));
}
const zf = { render: Hf }, kf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Bf(l, e) {
  return i(), d("svg", kf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 6.75v10.5h12.849l3.5-5.25-3.5-5.25zm-1.5-.15c0-.746.604-1.35 1.35-1.35h13.079c.451 0 .873.226 1.123.601l3.6 5.4a1.35 1.35 0 0 1 0 1.498l-3.6 5.4a1.35 1.35 0 0 1-1.123.601H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lf = { render: Bf }, _f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Tf(l, e) {
  return i(), d("svg", _f, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.75 9A6.245 6.245 0 0 1 12 2.75 6.245 6.245 0 0 1 18.25 9a6.2 6.2 0 0 1-1.043 3.472 6.24 6.24 0 0 1-4.265 2.696l-.008.001-.014.002a5.3 5.3 0 0 1-.92.079q-.476 0-.92-.079l-.012-.002-.01-.001a6.24 6.24 0 0 1-4.265-2.696A6.2 6.2 0 0 1 5.75 9M12 1.25A7.745 7.745 0 0 0 4.25 9c0 1.38.354 2.666.976 3.783L1.74 16.27c-.968.967-.491 2.625.837 2.94l1.65.39.01.002c.07.016.148.081.174.184v.001l.35 1.467c.332 1.4 2.113 1.816 3.039.724l4.2-4.835 4.2 4.825c.926 1.092 2.707.676 3.04-.725l.35-1.47.003-.014c.015-.07.072-.142.183-.17h.001l1.646-.39c1.319-.312 1.813-1.967.835-2.931l-3.484-3.485A7.7 7.7 0 0 0 19.75 9 7.745 7.745 0 0 0 12 1.25m5.344 19.747-3.827-4.396a7.72 7.72 0 0 0 4.389-2.565L21.2 17.33l.005.005c.118.117.072.358-.128.405l-1.65.39-.004.001a1.73 1.73 0 0 0-1.294 1.302l-.349 1.464a.25.25 0 0 1-.436.1m-11.25-6.96a7.72 7.72 0 0 0 4.39 2.564l-3.82 4.397-.008.01a.25.25 0 0 1-.436-.102l-.35-1.47-.001-.003a1.75 1.75 0 0 0-1.3-1.294l-1.646-.389a.253.253 0 0 1-.123-.42l3.294-3.294Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sf = { render: Tf }, xf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Df(l, e) {
  return i(), d("svg", xf, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M2.47 21.53a.75.75 0 0 0 1.06 0l6.5-6.5a.75.75 0 1 0-1.06-1.06l-6.5 6.5a.75.75 0 0 0 0 1.06"></path><path d="M15.126 1.922a.75.75 0 0 1 .561.22l5.85 5.849a.75.75 0 0 1-.045 1.102l-5.208 4.418.352 3.392a.75.75 0 0 1-.216.608l-1.697 1.697a.75.75 0 0 1-1.06 0L4.47 10.016a.75.75 0 0 1 0-1.06l1.697-1.698a.75.75 0 0 1 .607-.216l3.393.352 4.418-5.208a.75.75 0 0 1 .541-.264m.076 1.855-4.147 4.889a.75.75 0 0 1-.649.26l-3.431-.355-.914.914 8.131 8.132.915-.914-.356-3.431a.75.75 0 0 1 .261-.65l4.889-4.146z"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Ef = { render: Df }, Rf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Of(l, e) {
  return i(), d("svg", Rf, e[0] || (e[0] = [
    a("path", { d: "M8 7.3a.7.7 0 1 0 0 1.4h6a.7.7 0 1 0 0-1.4zM7.3 12a.7.7 0 0 1 .7-.7h8a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7m.7 3.3a.7.7 0 1 0 0 1.4h5a.7.7 0 1 0 0-1.4z" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.313 1.374A.7.7 0 0 0 3.3 2v20a.7.7 0 0 0 1.013.626L6 21.783l1.687.843a.7.7 0 0 0 .626 0L10 21.783l1.687.843a.7.7 0 0 0 .626 0L14 21.783l1.687.843a.7.7 0 0 0 .626 0L18 21.783l1.687.843A.7.7 0 0 0 20.7 22V2a.7.7 0 0 0-1.013-.626L18 2.218l-1.687-.844a.7.7 0 0 0-.626 0L14 2.218l-1.687-.844a.7.7 0 0 0-.626 0L10 2.218l-1.687-.844a.7.7 0 0 0-.626 0L6 2.218zM4.7 20.868V3.133l.987.493a.7.7 0 0 0 .626 0L8 2.783l1.687.843a.7.7 0 0 0 .626 0L12 2.783l1.687.843a.7.7 0 0 0 .626 0L16 2.783l1.687.843a.7.7 0 0 0 .626 0l.987-.493v17.735l-.987-.494a.7.7 0 0 0-.626 0L16 21.218l-1.687-.844a.7.7 0 0 0-.626 0L12 21.218l-1.687-.844a.7.7 0 0 0-.626 0L8 21.218l-1.687-.844a.7.7 0 0 0-.626 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nf = { render: Of }, If = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qf(l, e) {
  return i(), d("svg", If, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M2.47 21.53a.75.75 0 0 0 1.06 0l6.5-6.5a.75.75 0 1 0-1.06-1.06l-6.5 6.5a.75.75 0 0 0 0 1.06"></path><path d="M15.126 1.922a.75.75 0 0 1 .561.22l5.85 5.849a.75.75 0 0 1-.045 1.102l-4.308 3.654a.75.75 0 1 1-.97-1.144L19.9 8.476l-4.699-4.699-3.145 3.708a.75.75 0 1 1-1.144-.97l3.672-4.329a.75.75 0 0 1 .541-.264Zm.585 13.332a.75.75 0 0 1 .823.669l.102.98a.75.75 0 0 1-.216.608l-1.697 1.697a.75.75 0 0 1-1.06 0L4.47 10.016a.75.75 0 0 1 0-1.06l1.697-1.698a.75.75 0 0 1 .607-.216l.98.102a.75.75 0 1 1-.155 1.492l-.624-.065-.914.914 8.131 8.132.915-.914-.065-.626a.75.75 0 0 1 .669-.823"></path><path d="M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Ff = { render: qf }, Pf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zf(l, e) {
  return i(), d("svg", Pf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.813 4.813a8.75 8.75 0 0 1 12.882 11.821l3.835 3.836a.75.75 0 0 1-1.06 1.06l-3.836-3.835A8.75 8.75 0 0 1 4.813 4.813M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Uf = { render: Zf }, jf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gf(l, e) {
  return i(), d("svg", jf, e[0] || (e[0] = [
    a("path", { d: "M21.975 14.325 21 12l.975-2.325c.15-.3.15-.6.075-.975-.075-.3-.3-.6-.6-.75l-2.175-1.275-.525-2.4c-.075-.3-.225-.6-.525-.825q-.45-.337-.9-.225l-2.475.225-1.875-1.65a1.37 1.37 0 0 0-1.8 0L9.3 3.45l-2.625-.225c-.3 0-.675.075-.9.225-.225.225-.45.45-.525.825l-.525 2.4L2.55 7.95c-.3.15-.45.45-.6.75-.075.3-.075.675.075.975L3 12l-.975 2.325c-.15.3-.15.6-.075.975.075.3.3.6.6.75l2.175 1.275.525 2.4c.075.3.225.6.525.825q.45.338.9.225l2.475-.225 1.875 1.65c.225.225.525.3.9.3s.675-.15.9-.3l1.875-1.65 2.475.225c.3 0 .675-.075.9-.225.3-.225.45-.45.525-.825l.6-2.475 2.175-1.275c.3-.15.45-.45.6-.75q.225-.45 0-.9m-2.4-1.8.975 2.25-2.1 1.275a.9.9 0 0 0-.375.375c-.075.15-.15.3-.225.525l-.525 2.4-2.4-.225c-.15 0-.375 0-.525.075s-.3.15-.45.3L12 21l-1.875-1.575c-.15-.15-.3-.225-.45-.3s-.3-.075-.45-.075h-.15l-2.475.225-.525-2.4c-.075-.15-.15-.375-.225-.525a.9.9 0 0 0-.375-.375l-2.1-1.275.975-2.25c.075-.075.15-.3.15-.45s0-.375-.075-.525l-.975-2.25 2.1-1.275c.15-.075.3-.225.375-.375s.15-.3.225-.525l.525-2.4 2.475.225c.15 0 .375 0 .525-.075s.3-.15.45-.3L12 3l1.875 1.575c.15.15.3.225.45.3s.375.075.525.075l2.475-.225.525 2.4c.075.15.15.375.225.525s.225.3.375.375l2.1 1.275-.975 2.25c-.075.075-.075.3-.075.45s0 .375.075.525" }, null, -1),
    a("path", { d: "m15.45 9.45-4.5 4.5-1.5-1.5c-.3-.3-.75-.3-1.05 0s-.3.75 0 1.05l2.025 2.025c.15.15.3.225.525.225a.68.68 0 0 0 .525-.225L16.5 10.5c.3-.3.3-.75 0-1.05s-.75-.3-1.05 0" }, null, -1)
  ]));
}
const Wf = { render: Gf }, Kf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xf(l, e) {
  return i(), d("svg", Kf, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.914 3.272a.15.15 0 0 0-.057.065L9.259 8.57a.75.75 0 0 1-.564.41l-5.809.843a.153.153 0 0 0-.089.261L7 14.153a.75.75 0 0 1 .217.666l-.991 5.75a.14.14 0 0 0 .061.148.15.15 0 0 0 .17.012l5.195-2.716a.75.75 0 0 1 .696 0l5.194 2.716a.15.15 0 0 0 .17-.012.14.14 0 0 0 .062-.149l-.991-5.749a.75.75 0 0 1 .217-.666l4.203-4.07a.153.153 0 0 0-.09-.26l-5.808-.845a.75.75 0 0 1-.564-.409l-2.598-5.232a.15.15 0 0 0-.057-.065A.2.2 0 0 0 12 3.25a.2.2 0 0 0-.086.022m-1.4-.602c.608-1.227 2.364-1.227 2.973 0l2.422 4.88 5.42.788c1.356.197 1.908 1.863.917 2.823l-3.918 3.794.925 5.359c.234 1.36-1.197 2.377-2.406 1.745L12 19.524 7.153 22.06c-1.209.632-2.64-.385-2.406-1.745l.925-5.36-3.918-3.793c-.991-.96-.439-2.626.917-2.823l5.42-.788z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jf = { render: Xf }, Yf = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qf(l, e) {
  return i(), d("svg", Yf, e[0] || (e[0] = [
    a("path", { d: "m14.5 4.7-1-2c-.3-.6-.9-.9-1.5-.9s-1.2.4-1.5.9l-.5 1c-.2.4 0 .8.3 1 .4.2.8 0 1-.3l.5-1c0-.1.1-.1.1-.1.1 0 .1 0 .1.1l1 2c.1.3.4.4.7.4.1 0 .2 0 .3-.1.5-.2.7-.7.5-1m2.3 4.5h.1c.4 0 .7-.3.7-.6.1-.4-.2-.8-.6-.9l-1.1-.2-.2-.5c-.2-.4-.6-.5-1-.3s-.5.6-.3 1l.4.8c.1.2.3.4.6.4zm5.9.3c-.2-.6-.7-1-1.3-1.1l-1.5-.2c-.4-.1-.8.2-.8.6-.1.4.2.8.6.9l1.5.2c.1 0 .1 0 .1.1v.2l-1.1 1c-.3.3-.3.8 0 1.1.1.2.3.2.5.2s.4-.1.5-.2l1.1-1c.4-.6.6-1.2.4-1.8m-4.6 3.6-1.1 1c-.2.2-.3.4-.2.7l.2 1.4c.1.4.4.6.7.6h.1c.4-.1.7-.5.6-.9l-.2-1 .8-.7c.3-.3.3-.8 0-1.1-.2-.2-.7-.3-.9 0m.9 5.8c-.1-.4-.4-.7-.9-.6-.4.1-.7.5-.6.9l.2 1.4c0 .1 0 .1-.1.1 0 0-.1.1-.2 0l-1.3-.7c-.4-.2-.8 0-1 .3s0 .8.3 1l1.3.7c.2.1.5.2.8.2s.7-.1 1-.3c.5-.4.8-1 .7-1.6zm-5.4-.2-1.3-.7c-.2-.1-.5-.1-.7 0l-1.6.8c-.4.2-.5.6-.3 1 .1.3.4.4.7.4.1 0 .2 0 .3-.1l1.2-.6 1 .5c.4.2.8 0 1-.3.3-.4.1-.8-.3-1m-6.3 1.6-.8.4h-.2c-.1 0-.1-.1-.1-.1l.2-1.1c.1-.4-.2-.8-.6-.9s-.8.2-.9.6l-.2 1.1c-.1.6.1 1.2.7 1.6.3.2.6.3 1 .3.3 0 .5-.1.8-.2l.8-.4c.4-.2.5-.6.3-1s-.6-.5-1-.3M5.7 15l-.2.9c-.1.4.2.8.6.9h.1c.4 0 .7-.3.7-.6l.2-1.3c0-.2 0-.5-.2-.7l-.7-.7c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1zM3.8 8.2l-1.1.1c-.7.1-1.2.6-1.4 1.2s0 1.3.4 1.7l1.4 1.4c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1l-1.4-1.4s-.1-.1 0-.2c0-.1.1-.1.1-.1L4 9.7c.4-.1.7-.4.6-.8s-.4-.8-.8-.7m5.9-2.3c-.4-.2-.8 0-1 .3l-.6 1.4-1.2.1c-.4.1-.7.5-.6.9 0 .3.3.6.7.6h.1L8.7 9c.2 0 .5-.2.6-.4l.8-1.6c.1-.4 0-.9-.4-1.1" }, null, -1)
  ]));
}
const eg = { render: Qf }, lg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tg(l, e) {
  return i(), d("svg", lg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 3.25a.2.2 0 0 0-.086.022.15.15 0 0 0-.057.065l-.672-.333.672.333-.496.998a.75.75 0 1 1-1.343-.667l.495-.998c.61-1.227 2.365-1.227 2.974 0a.75.75 0 0 1-1.344.667.15.15 0 0 0-.057-.065A.2.2 0 0 0 12 3.25m.665 15.08a.75.75 0 0 1-.317 1.013l-1.573.822a.75.75 0 1 1-.695-1.33l1.572-.822a.75.75 0 0 1 1.013.317m-6.866.3a.75.75 0 0 1 .612.866l-.185 1.073a.14.14 0 0 0 .061.148.15.15 0 0 0 .17.012l.848-.443A.75.75 0 1 1 8 21.616l-.847.443c-1.209.631-2.64-.385-2.406-1.745l.185-1.073a.75.75 0 0 1 .867-.611m-.554-5.133a.75.75 0 0 1 1.06-.017l.695.673a.75.75 0 0 1 .217.666l-.225 1.309a.75.75 0 1 1-1.478-.255l.158-.918-.41-.397a.75.75 0 0 1-.017-1.061M4.631 8.81a.75.75 0 0 1-.634.851l-1.11.161a.152.152 0 0 0-.09.261l1.423 1.378a.75.75 0 1 1-1.043 1.078L1.754 11.16c-.991-.96-.439-2.626.917-2.823l1.11-.161a.75.75 0 0 1 .85.634m5.093-2.864a.75.75 0 0 1 .338 1.005L9.26 8.57a.75.75 0 0 1-.564.409l-1.587.23a.75.75 0 1 1-.216-1.484L8.09 7.55l.629-1.266a.75.75 0 0 1 1.005-.338",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.25 2.5a.75.75 0 0 1 .75-.75 1.65 1.65 0 0 1 1.487.92l2.423 4.88 5.42.788c1.355.197 1.907 1.863.916 2.823l-3.918 3.794.925 5.359c.234 1.36-1.197 2.377-2.406 1.745l-5.195-2.716a.75.75 0 0 1-.402-.665zm1.5 2.06v13.664l4.792 2.506a.15.15 0 0 0 .17-.013.14.14 0 0 0 .062-.149l-.991-5.749a.75.75 0 0 1 .217-.666l4.203-4.07a.153.153 0 0 0-.09-.26l-5.808-.845a.75.75 0 0 1-.564-.409z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ag = { render: tg }, ng = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function og(l, e) {
  return i(), d("svg", ng, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m6 13.279-.687 1.456a.75.75 0 0 1-.565.421l-1.605.246 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.183-1.206-1.604-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916L9.01 17.387l.336 2.046c.139.849-.745 1.666-1.63 1.18L6 19.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM18 13.279l-.687 1.456a.75.75 0 0 1-.565.421l-1.605.246 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L18 19.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295zM12 4.279l-.687 1.456a.75.75 0 0 1-.565.422l-1.604.245 1.183 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422L12 4.28Zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916L15.01 8.387l.335 2.046c.14.849-.744 1.666-1.629 1.18L12 10.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rg = { render: og }, sg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ig(l, e) {
  return i(), d("svg", sg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 7.25a.75.75 0 0 1 .75.75v2.25H14a.75.75 0 0 1 0 1.5h-2.25V14a.75.75 0 0 1-1.5 0v-2.25H8a.75.75 0 0 1 0-1.5h2.25V8a.75.75 0 0 1 .75-.75m5.47 9.22a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M2.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dg = { render: ig }, ug = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cg(l, e) {
  return i(), d("svg", ug, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.47 16.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M2.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vg = { render: cg }, pg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hg(l, e) {
  return i(), d("svg", pg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12a.75.75 0 0 1 .75-.75h2.46l2.828-8.487a.75.75 0 0 1 1.424 0L15 18.628l2.288-6.865A.75.75 0 0 1 18 11.25h3a.75.75 0 0 1 0 1.5h-2.46l-2.829 8.487a.75.75 0 0 1-1.422 0L9 5.372l-2.288 6.865A.75.75 0 0 1 6 12.75H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mg = { render: hg }, fg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gg(l, e) {
  return i(), d("svg", fg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-3.25V16a.75.75 0 0 1-1.5 0v-3.25H8a.75.75 0 0 1 0-1.5h3.25V8a.75.75 0 0 1 .75-.75M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wg = { render: gg }, bg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Mg(l, e) {
  return i(), d("svg", bg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.25 13c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5h-4.25V8a.75.75 0 0 0-1.5 0zM4.4 3.95a.75.75 0 0 0 1.05.15l2-1.5a.75.75 0 1 0-.9-1.2l-2 1.5a.75.75 0 0 0-.15 1.05m15.2 0a.75.75 0 0 1-1.05.15l-2-1.5a.75.75 0 1 1 .9-1.2l2 1.5a.75.75 0 0 1 .15 1.05",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 13c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 18.385 2.25 13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yg = { render: Mg }, Vg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ag(l, e) {
  return i(), d("svg", Vg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.25 13a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M8 10.25a.75.75 0 0 1 .75.75v1.25H10a.75.75 0 0 1 0 1.5H8.75V15a.75.75 0 0 1-1.5 0v-1.25H6a.75.75 0 0 1 0-1.5h1.25V11a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.25 5A.75.75 0 0 1 6 4.25h2a.75.75 0 0 1 .75.75v1.25h6.5V5a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 .75.75v1.25h2.65c.746 0 1.35.604 1.35 1.35v10.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35V7.6c0-.746.604-1.35 1.35-1.35h2.65zm1.5 1.25h.5v-.5h-.5zm10.5 0v-.5h-.5v.5zm-14.5 1.5v10.5h18.5V7.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $g = { render: Ag }, Cg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hg(l, e) {
  return i(), d("svg", Cg, e[0] || (e[0] = [
    a("g", { "clip-path": "url(#a)" }, [
      a("path", {
        "fill-rule": "evenodd",
        d: "M12 .25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 12 .25M3.47 3.47a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m17.06 0a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0M5.553 7.898a.75.75 0 0 1 .782-.069l3.677 1.838 1.419-1.655a.75.75 0 0 1 1.138 0l1.42 1.655 3.676-1.838a.75.75 0 0 1 1.074.798l-1.2 7a.75.75 0 0 1-.739.623H7.2a.75.75 0 0 1-.74-.623l-1.2-7a.75.75 0 0 1 .293-.73Zm1.436 1.935.843 4.917h8.336l.843-4.917-2.876 1.438a.75.75 0 0 1-.904-.183L12 9.652l-1.23 1.436a.75.75 0 0 1-.905.183zM.25 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 12m21 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M5.53 18.47a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0m12.94 0a.75.75 0 0 1 1.06 0l1 1a.75.75 0 1 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06M12 21.25a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75",
        "clip-rule": "evenodd"
      })
    ], -1),
    a("defs", null, [
      a("clipPath", { id: "a" }, [
        a("path", { d: "M0 0h24v24H0z" })
      ])
    ], -1)
  ]));
}
const zg = { render: Hg }, kg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Bg(l, e) {
  return i(), d("svg", kg, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M3 1.75A1.25 1.25 0 0 0 1.75 3v18A1.25 1.25 0 0 0 3 22.25h18A1.25 1.25 0 0 0 22.25 21V3A1.25 1.25 0 0 0 21 1.75zm-1.945-.695A2.75 2.75 0 0 1 3 .25h18A2.75 2.75 0 0 1 23.75 3v18A2.75 2.75 0 0 1 21 23.75H3A2.75 2.75 0 0 1 .25 21V3c0-.73.29-1.429.805-1.945"></path><path d="M7 4.25a.75.75 0 0 1 .75.75v1.25H9a.75.75 0 1 1 0 1.5H7.75V9a.75.75 0 0 1-1.5 0V7.75H5a.75.75 0 0 1 0-1.5h1.25V5A.75.75 0 0 1 7 4.25M14.25 7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m0 8.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m-9.194-.444a.75.75 0 0 1 1.06 0L7 15.94l.885-.884a.75.75 0 0 1 1.06 1.06L8.061 17l.884.884a.75.75 0 1 1-1.06 1.06L7 18.062l-.884.883a.75.75 0 0 1-1.06-1.06L5.939 17l-.883-.884a.75.75 0 0 1 0-1.06M14.25 18.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Lg = { render: Bg }, _g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Tg(l, e) {
  return i(), d("svg", _g, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sg = { render: Tg }, xg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dg(l, e) {
  return i(), d("svg", xg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.8 9.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341c1.029-.515 2.398-.812 3.87-.812s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812a4.6 4.6 0 0 1-1.018-.68c-.9.315-1.973.492-3.112.492-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 1.5 0c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.851 0 1.636-.115 2.298-.307a2 2 0 0 1-.048-.443c0-1.127.895-1.946 1.88-2.438M3 12.25a.75.75 0 0 1 .75.75c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.831 0 1.6-.11 2.251-.293a.75.75 0 0 1 1.499.043c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097a.75.75 0 0 1 1.5 0c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.526-.262-1.027-.618-1.378-1.065A9.8 9.8 0 0 1 8 16.25c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3 4.75a.75.75 0 0 1 .75.75v11c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653.83 0 1.598-.11 2.25-.293V10.5a.75.75 0 0 1 1.5 0v8c0 .253.225.684 1.05 1.097.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097v-8a.75.75 0 0 1 1.5 0v8c0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.684-.341-1.323-.84-1.651-1.49A10 10 0 0 1 8 19.75c-1.472 0-2.841-.297-3.87-.812-.985-.492-1.88-1.31-1.88-2.438v-11A.75.75 0 0 1 3 4.75m10 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.8 4.403c-.825.413-1.05.844-1.05 1.097s.225.684 1.05 1.097c.78.39 1.91.653 3.2.653s2.42-.263 3.2-.653c.825-.413 1.05-.844 1.05-1.097s-.225-.684-1.05-1.097c-.78-.39-1.91-.653-3.2-.653s-2.42.263-3.2.653m-.67-1.341C5.158 2.547 6.527 2.25 8 2.25s2.841.297 3.87.812c.985.492 1.88 1.31 1.88 2.438 0 1.127-.895 1.946-1.88 2.438-1.029.515-2.398.812-3.87.812s-2.841-.297-3.87-.812c-.985-.492-1.88-1.31-1.88-2.438 0-1.127.895-1.946 1.88-2.438",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Eg = { render: Dg }, Rg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Og(l, e) {
  return i(), d("svg", Rg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.75 12a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75m-7.28 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V22a.75.75 0 0 1-1.5 0v-4.19l-1.72 1.72a.75.75 0 0 1-1.06-1.06zm0-6.94a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.72 1.72V2a.75.75 0 0 0-1.5 0v4.19L9.53 4.47a.75.75 0 0 0-1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ng = { render: Og }, Ig = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qg(l, e) {
  return i(), d("svg", Ig, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 5.75A1.25 1.25 0 0 0 2.75 7v10A1.25 1.25 0 0 0 4 18.25h16A1.25 1.25 0 0 0 21.25 17V9.75H6a.75.75 0 0 1 0-1.5h15.25V7A1.25 1.25 0 0 0 20 5.75zm-1.944-.695A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7c0-.73.29-1.429.806-1.945",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fg = { render: qg }, Pg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zg(l, e) {
  return i(), d("svg", Pg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.325 21.746a.75.75 0 0 1-.671-.82l.6-6 .95-10.448A1.35 1.35 0 0 1 6.548 3.25h13.795a1.35 1.35 0 0 1 1.345 1.472l-.891 9.8a1.35 1.35 0 0 1-1.345 1.228H5.68l-.533 5.325a.75.75 0 0 1-.82.671Zm1.496-7.496h13.494l.864-9.5H6.685z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.349 7.128a.75.75 0 0 1 1.023-.28l7 4a.75.75 0 0 1-.744 1.303l-7-4a.75.75 0 0 1-.28-1.023Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ug = { render: Zg }, jg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gg(l, e) {
  return i(), d("svg", jg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18.75 12a.75.75 0 0 1-.75.75H6a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75m-7.28 10.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V16a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06zm0-21.06a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.72V8a.75.75 0 0 1-1.5 0V3.81L9.53 5.53a.75.75 0 0 1-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wg = { render: Gg }, Kg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xg(l, e) {
  return i(), d("svg", Kg, e[0] || (e[0] = [
    s5('<path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M5.5 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M5.5 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M5.5 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M12 20a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M12 19.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 9.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path><path d="M18.5 15a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"></path><path fill-rule="evenodd" d="M18.5 14.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m1.25-.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"></path>', 20)
  ]));
}
const Jg = { render: Xg }, Yg = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qg(l, e) {
  return i(), d("svg", Yg, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 20c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75zm1.5-.75v-2.5h14.5v2.5zM1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m2-8A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm7 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m10.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ew = { render: Qg }, lw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tw(l, e) {
  return i(), d("svg", lw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75m2-8A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm7 0a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m10.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zm-10.5 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m-7 0c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const aw = { render: tw }, nw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ow(l, e) {
  return i(), d("svg", nw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.343 1.515a10.5 10.5 0 0 1 5.15 1.04.9.9 0 0 1-.786 1.62A8.7 8.7 0 0 0 7.856 8.7H17.1a.9.9 0 1 1 0 1.8H7.336a8.7 8.7 0 0 0 0 3H17.1a.9.9 0 1 1 0 1.8H7.856a8.7 8.7 0 0 0 7.584 5.387 8.7 8.7 0 0 0 4.267-.861.9.9 0 1 1 .786 1.619A10.5 10.5 0 0 1 5.938 15.3H3.9a.9.9 0 1 1 0-1.8h1.613a10.5 10.5 0 0 1 0-3H3.9a.9.9 0 1 1 0-1.8h2.038a10.5 10.5 0 0 1 9.405-7.185",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rw = { render: ow }, sw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iw(l, e) {
  return i(), d("svg", sw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75m.512 8.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057M3.25 3A.75.75 0 0 1 4 2.25h5a.75.75 0 0 1 0 1.5H4.75V6a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 3a.75.75 0 0 0-.75-.75h-5a.75.75 0 0 0 0 1.5h4.25V6a.75.75 0 0 0 1.5 0zM3.25 21c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5H4.75V18a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h4.25V18a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dw = { render: iw }, uw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cw(l, e) {
  return i(), d("svg", uw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M13.232 2.287A.75.75 0 0 1 13.75 3v6.25H19a.75.75 0 0 1 .607 1.191l-8 11a.75.75 0 0 1-1.357-.44v-6.25H5a.75.75 0 0 1-.607-1.192l8-11a.75.75 0 0 1 .839-.272M6.472 13.25H11a.75.75 0 0 1 .75.75v4.694l5.777-7.944H13a.75.75 0 0 1-.75-.75V5.307z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vw = { render: cw }, pw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hw(l, e) {
  return i(), d("svg", pw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 5.75A2.25 2.25 0 0 0 9.75 8v13.25h4.5V8A2.25 2.25 0 0 0 12 5.75m0-1.5A3.75 3.75 0 0 1 15.75 8v13.4a1.35 1.35 0 0 1-1.35 1.35H9.6a1.35 1.35 0 0 1-1.35-1.35V8A3.75 3.75 0 0 1 12 4.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 11a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m2-9a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-.25V5a.75.75 0 0 1-1.5 0V2.75H11a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mw = { render: hw }, fw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gw(l, e) {
  return i(), d("svg", fw, e[0] || (e[0] = [
    s5('<path fill-rule="evenodd" d="M4 11.25a.75.75 0 0 1 .75.75v9.25h14.5V12a.75.75 0 0 1 1.5 0v9.4a1.35 1.35 0 0 1-1.35 1.35H4.6a1.35 1.35 0 0 1-1.35-1.35V12a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M1.25 7.6c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35zm1.5.15v3.5h18.5v-3.5z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 6.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M7.5 2.75a1.75 1.75 0 1 0 0 3.5h3.51a9 9 0 0 0-.605-1.389C9.762 3.691 8.833 2.75 7.5 2.75M12 7l.735-.148V6.85l-.001-.005-.003-.014a6 6 0 0 0-.053-.228c-.038-.15-.094-.36-.174-.61-.158-.5-.41-1.174-.784-1.854-.732-1.33-2.053-2.889-4.22-2.889a3.25 3.25 0 0 0 0 6.5H12a.75.75 0 0 0 .735-.897z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12.28 4.139c.732-1.33 2.053-2.889 4.22-2.889a3.25 3.25 0 1 1 0 6.5H12a.75.75 0 0 1-.735-.897L12 7l-.735-.148V6.85l.001-.005.003-.014a6 6 0 0 1 .053-.228c.038-.15.094-.36.174-.61.158-.5.41-1.174.784-1.854m.71 2.111h3.51a1.75 1.75 0 1 0 0-3.5c-1.333 0-2.262.941-2.905 2.111a9 9 0 0 0-.605 1.389" clip-rule="evenodd"></path>', 5)
  ]));
}
const ww = { render: gw }, bw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Mw(l, e) {
  return i(), d("svg", bw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.67 2.362A.75.75 0 0 1 9.023 3c0 4.14 1.026 7.095 2.953 9.023 1.928 1.927 4.884 2.953 9.023 2.953a.75.75 0 0 1 .672 1.084 10.24 10.24 0 0 1-9.179 5.69c-5.657 0-10.243-4.586-10.243-10.243 0-4.023 2.32-7.503 5.69-9.179a.75.75 0 0 1 .73.034ZM7.556 4.29A8.743 8.743 0 1 0 19.71 16.444c-3.753-.197-6.717-1.283-8.794-3.36S7.754 8.043 7.556 4.29",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yw = { render: Mw }, Vw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Aw(l, e) {
  return i(), d("svg", Vw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.164 10.526a.75.75 0 0 1 0 1.06L3.21 19.54l1.06 1.06 7.956-7.954a.75.75 0 0 1 1.06 1.06L4.8 22.191a.75.75 0 0 1-1.06 0l-2.122-2.12a.75.75 0 0 1 0-1.062l8.486-8.484a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.396 1.334a.75.75 0 0 1 .946-.094l8.486 5.656a.75.75 0 0 1 .114 1.154l-.53.53.354.354.53-.53a.75.75 0 0 1 1.06 0l2.475 2.475a.75.75 0 0 1 0 1.06l-4.95 4.95a.75.75 0 0 1-1.06 0l-2.475-2.475a.75.75 0 0 1 0-1.06l.53-.53-.353-.354-1.238 1.237a.75.75 0 0 1-1.06 0l-2.121-2.12a.75.75 0 0 1 0-1.061l1.203-1.205a4 4 0 0 0-.008-.186 6.3 6.3 0 0 0-.237-1.32c-.32-1.12-1.051-2.686-2.726-4.36a.75.75 0 0 1 0-1.061zm2.652 8.307.745.082V9.72l.001-.006.002-.014a2 2 0 0 0 .01-.18 5 5 0 0 0-.01-.478 7.8 7.8 0 0 0-.292-1.64c-.35-1.223-1.083-2.802-2.59-4.465l.108-.108 7.213 4.808-.413.413a.75.75 0 0 0 0 1.06l1.412 1.415a.75.75 0 0 0 1.061 0l.53-.53 1.415 1.414-3.889 3.89-1.414-1.415.53-.53a.75.75 0 0 0 0-1.06l-1.413-1.415a.75.75 0 0 0-1.061 0l-1.238 1.237-1.06-1.06.883-.885a.75.75 0 0 0 .215-.447z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $w = { render: Aw }, Cw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hw(l, e) {
  return i(), d("svg", Cw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4 12.25a.75.75 0 0 0-.75.75v6A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19v-6a.75.75 0 0 0-1.5 0v6c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25v-6a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.53 15.53a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06l2.22 2.22V3a.75.75 0 0 1 1.5 0v10.19l2.22-2.22a.75.75 0 1 1 1.06 1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zw = { render: Hw }, kw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Bw(l, e) {
  return i(), d("svg", kw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.546 1.452a.75.75 0 0 1 1.051.144L13 2.049l.598-.453.001.002.003.004.01.012a6 6 0 0 1 .136.193c.09.13.214.32.362.565.297.489.688 1.2 1.079 2.105A19 19 0 0 1 16.75 12c0 3.125-.781 5.715-1.561 7.523-.39.904-.782 1.616-1.079 2.105a12 12 0 0 1-.499.758l-.009.012-.003.004v.001h-.001L13 21.952l.597.453a.75.75 0 0 1-1.195-.906v-.001l.004-.005.02-.027q.028-.038.084-.12c.075-.109.184-.275.317-.494.266-.439.625-1.09.984-1.923A17.5 17.5 0 0 0 15.25 12c0-2.875-.719-5.26-1.439-6.928a16 16 0 0 0-.984-1.923 11 11 0 0 0-.401-.614l-.02-.028-.003-.004a.75.75 0 0 1 .143-1.05ZM11 2.05l-.598-.454-.001.002-.003.004-.01.012-.03.042a12 12 0 0 0-.469.716 17 17 0 0 0-1.078 2.105A19 19 0 0 0 7.25 12c0 3.125.781 5.715 1.561 7.523.39.904.782 1.616 1.079 2.105a12 12 0 0 0 .499.758l.009.012.003.004v.001h.001l.598-.452-.597.453a.75.75 0 0 0 1.195-.907l-.004-.005-.02-.027a11 11 0 0 1-.401-.615 16 16 0 0 1-.984-1.922A17.5 17.5 0 0 1 8.75 12c0-2.875.719-5.26 1.439-6.928.36-.833.718-1.484.984-1.923a11 11 0 0 1 .401-.615l.02-.027.004-.005z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.88 15.5a.75.75 0 0 1 .75-.75h18.74a.75.75 0 0 1 0 1.5H2.63a.75.75 0 0 1-.75-.75m0-7a.75.75 0 0 1 .75-.75h18.74a.75.75 0 0 1 0 1.5H2.63a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lw = { render: Bw }, _w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Tw(l, e) {
  return i(), d("svg", _w, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 12a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.773 14.368a.75.75 0 0 1-.016 1.06l-4.235 4.11a.75.75 0 1 1-1.044-1.076l4.235-4.11a.75.75 0 0 1 1.06.016m4.454 0a.75.75 0 0 1 1.06-.016l4.235 4.11a.75.75 0 1 1-1.044 1.076l-4.235-4.11a.75.75 0 0 1-.016-1.06m5.311-9.89a.75.75 0 0 1-.016 1.06l-4.235 4.11a.75.75 0 0 1-1.044-1.077l4.235-4.11a.75.75 0 0 1 1.06.017m-15.076 0a.75.75 0 0 1 1.06-.016l4.235 4.11a.75.75 0 1 1-1.044 1.076l-4.235-4.11a.75.75 0 0 1-.016-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sw = { render: Tw }, xw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dw(l, e) {
  return i(), d("svg", xw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.857 7.75H7.143c-2.447 0-4.393 1.922-4.393 4.248 0 2.005 1.443 3.707 3.412 4.141q.473.105.98.106a.75.75 0 0 1 0 1.5 6 6 0 0 1-1.304-.141c-2.612-.576-4.588-2.854-4.588-5.606 0-3.195 2.659-5.748 5.893-5.748h1.714c3.244 0 5.893 2.846 5.893 5.748a.75.75 0 0 1-1.5 0c0-2.082-1.985-4.248-4.393-4.248",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.143 16.245h1.714c2.447 0 4.393-1.922 4.393-4.248 0-2.004-1.444-3.707-3.412-4.14a4.6 4.6 0 0 0-.98-.107.75.75 0 0 1 0-1.5q.672.002 1.303.141c2.613.576 4.589 2.855 4.589 5.607 0 3.194-2.659 5.747-5.893 5.747h-1.714c-3.244 0-5.893-2.846-5.893-5.748a.75.75 0 0 1 1.5 0c0 2.082 1.985 4.248 4.393 4.248",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ew = { render: Dw }, Rw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ow(l, e) {
  return i(), d("svg", Rw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm17.5 0a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nw = { render: Ow }, Iw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qw(l, e) {
  return i(), d("svg", Iw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.857 7.75H7.143c-2.447 0-4.393 1.922-4.393 4.248 0 2.005 1.443 3.707 3.412 4.141q.473.105.98.106a.75.75 0 0 1 0 1.5 6 6 0 0 1-1.304-.141c-2.612-.576-4.588-2.854-4.588-5.606 0-3.195 2.659-5.748 5.893-5.748h1.714c3.244 0 5.893 2.846 5.893 5.748a.75.75 0 0 1-1.5 0c0-2.082-1.985-4.248-4.393-4.248m10.954 8.405a.75.75 0 0 1 .051-1.06 4.17 4.17 0 0 0 1.388-3.097c0-2.005-1.444-3.708-3.412-4.142a4.6 4.6 0 0 0-.98-.106.75.75 0 0 1 0-1.5q.672.001 1.303.142c2.613.576 4.589 2.854 4.589 5.606a5.67 5.67 0 0 1-1.88 4.208.75.75 0 0 1-1.059-.05Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.893 16.995a.75.75 0 0 1-.75.75c-3.244 0-5.893-2.846-5.893-5.748a.75.75 0 0 1 1.5 0c0 2.082 1.986 4.248 4.393 4.248a.75.75 0 0 1 .75.75m1.577.475a.75.75 0 0 1 1.06 0l1.591 1.59 1.591-1.59a.75.75 0 0 1 1.061 1.06l-1.591 1.591 1.591 1.591a.75.75 0 0 1-1.06 1.061l-1.592-1.591-1.59 1.591a.75.75 0 1 1-1.061-1.06l1.59-1.592-1.59-1.59a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fw = { render: qw }, Pw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zw(l, e) {
  return i(), d("svg", Pw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0-4A.75.75 0 0 1 8 9.25h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m0 8a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10 .25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V3.75H6c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3.5a.75.75 0 0 1 0-1.5H18A2.75 2.75 0 0 1 20.75 5v15A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V5A2.75 2.75 0 0 1 6 2.25h3.25V1A.75.75 0 0 1 10 .25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Uw = { render: Zw }, jw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gw(l, e) {
  return i(), d("svg", jw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.25 11a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0-4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M17 20.25A3.25 3.25 0 0 0 20.25 17V3.75H8.75V15a.75.75 0 0 1-1.5 0V3.6c0-.746.604-1.35 1.35-1.35h11.8c.746 0 1.35.604 1.35 1.35V17A4.75 4.75 0 0 1 17 21.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.75 21a.75.75 0 0 1-.75.75H8v-1.5h5.85a5.6 5.6 0 0 1-.668-1.05c-.614-1.24-.82-2.642-.892-3.45H5c-.69 0-1.25.56-1.25 1.25v1A2.25 2.25 0 0 0 6 20.25h2v1.5H6A3.75 3.75 0 0 1 2.25 18v-1A2.75 2.75 0 0 1 5 14.25h7.4c.748 0 1.321.593 1.377 1.287.06.727.238 1.965.749 2.998.5 1.009 1.25 1.715 2.474 1.715a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ww = { render: Gw }, Kw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xw(l, e) {
  return i(), d("svg", Kw, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15 11.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m-3-9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m6 9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75M11.25 18a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75m6 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-12-9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m1.262-6.557a.75.75 0 0 1 .055 1.059l-.01.01A.75.75 0 1 1 5.443 5.51l.01-.01a.75.75 0 0 1 1.059-.056Zm6 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-9 0a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m9-3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m3 6a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-3 0a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m9-9a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m0 3a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 1 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055m-3-9a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 3.75v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8A1.35 1.35 0 0 1 8.4 9.75H3.6A1.35 1.35 0 0 1 2.25 8.4zm13.5.15v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8a1.35 1.35 0 0 1-1.35 1.35h-4.8a1.35 1.35 0 0 1-1.35-1.35zM6.512 17.443a.75.75 0 0 1 .055 1.059l-.01.011a.75.75 0 0 1-1.114-1.004l.01-.011a.75.75 0 0 1 1.059-.055",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.75 15.75v4.5h4.5v-4.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h4.8c.746 0 1.35.604 1.35 1.35v4.8a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jw = { render: Xw }, Yw = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qw(l, e) {
  return i(), d("svg", Yw, e[0] || (e[0] = [
    a("path", { d: "M10.7 8.2c.8.4 1.5 1.1 2 1.8.1.2.4.4.6.4.1 0 .3 0 .4-.1.4-.2.5-.7.3-1-.6-1-1.6-1.9-2.6-2.4-.4-.2-.8 0-1 .3-.3.3-.1.8.3 1" }, null, -1),
    a("path", { d: "M18.6 17.5c2.4-.7 4.2-2.9 4.2-5.5 0-2.7-1.9-5-4.6-5.6-.4-.1-.9-.1-1.3-.1s-.8.3-.8.8.3.8.8.8c.3 0 .7 0 1 .1 2 .4 3.4 2.1 3.4 4.1 0 2.2-1.8 4-4 4.2L11 10 7.5 6.5l-4-4c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l3 3C3 7.2 1.2 9.4 1.2 12c0 2.7 1.9 5 4.6 5.6.4.1.9.1 1.3.1s.8-.3.8-.8-.3-.8-.8-.8c-.3 0-.7 0-1-.1-2-.4-3.4-2.1-3.4-4.1 0-2.2 1.7-4 4-4.2l2.8 2.8c-.3.6-.3 1.3-.3 1.4 0 3 2.8 5.7 5.9 5.7h1.5l3.8 3.8c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1zm-3.5-1.3c-2.5 0-4.4-2.2-4.4-4.2v-.2z" }, null, -1)
  ]));
}
const eb = { render: Qw }, lb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tb(l, e) {
  return i(), d("svg", lb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zm4 8a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ab = { render: tb }, nb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ob(l, e) {
  return i(), d("svg", nb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 2.25a.75.75 0 0 1 .75.75v4.292a6.75 6.75 0 1 1-1.5 0V3A.75.75 0 0 1 8 2.25m0 6.5a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 2.25a.75.75 0 0 1 .75.75v4.292a6.75 6.75 0 1 1-1.5 0V3a.75.75 0 0 1 .75-.75m0 6.5a5.25 5.25 0 1 0 0 10.501A5.25 5.25 0 0 0 16 8.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rb = { render: ob }, sb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ib(l, e) {
  return i(), d("svg", sb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 8.25v-1.5h-1.5v1.5zm1.5.15A1.35 1.35 0 0 1 8.4 9.75H6.6A1.35 1.35 0 0 1 5.25 8.4V6.6c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zM5.25 12a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m9.75-.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75M11.25 18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m1.262-6.557a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m6 0a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m-6 3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m6 0a.75.75 0 0 1 .055 1.059l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0 2.999a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.056Zm-6-8.999a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056m0-3a.75.75 0 0 1 .056 1.059l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.056M8.25 17.25v-1.5h-1.5v1.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35H6.6a1.35 1.35 0 0 1-1.35-1.35v-1.8c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zm7.5-9.15v-1.5h-1.5v1.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35h-1.8a1.35 1.35 0 0 1-1.35-1.35V6.6c0-.746.604-1.35 1.35-1.35h1.8c.746 0 1.35.604 1.35 1.35zM17.25 3a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3.75H18a.75.75 0 0 1-.75-.75m0 18c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-1.5 0v2.25H18a.75.75 0 0 0-.75.75M6.75 3A.75.75 0 0 0 6 2.25H3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0V3.75H6A.75.75 0 0 0 6.75 3m0 18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v2.25H6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const db = { render: ib }, ub = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cb(l, e) {
  return i(), d("svg", ub, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.25 4A.75.75 0 0 1 4 3.25h3a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0zM4 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M10.25 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75m0 16a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M20 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75M20.75 4a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0 0 1.5h2.25V7a.75.75 0 0 0 1.5 0zM3.25 20c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H4.75V17a.75.75 0 0 0-1.5 0zm17.5 0a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V17a.75.75 0 0 1 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vb = { render: cb }, pb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hb(l, e) {
  return i(), d("svg", pb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.25 2a.75.75 0 0 1 .75-.75c.892 0 2.058.291 3.02 1.03.991.763 1.73 1.98 1.73 3.72 0 1.698-.582 2.812-1.55 3.537a5 5 0 0 1-.96.551c.384.24.75.54 1.08.924.907 1.059 1.43 2.634 1.43 4.988a.75.75 0 0 1-1.5 0c0-2.146-.477-3.32-1.07-4.012-.596-.695-1.408-1.022-2.362-1.26a.75.75 0 0 1 0-1.456c1.038-.259 1.876-.48 2.482-.934.532-.4.95-1.036.95-2.338 0-1.26-.511-2.043-1.145-2.53A3.6 3.6 0 0 0 18 2.75a.75.75 0 0 1-.75-.75M13.5 6.75a1.75 1.75 0 0 0-1.75 1.75V11A2.25 2.25 0 0 0 14 13.25h1c2.2 0 3.75 1.15 3.75 2.75a.75.75 0 0 1-1.5 0c0-.4-.45-1.25-2.25-1.25h-1A3.75 3.75 0 0 1 10.25 11V8.5a3.25 3.25 0 0 1 3.25-3.25h.5a.75.75 0 0 1 0 1.5zm4.5 11.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m4 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75m-19.25 1.5v1.5h10.5v-1.5zm-1.5-.15c0-.746.604-1.35 1.35-1.35h10.8c.746 0 1.35.604 1.35 1.35v1.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mb = { render: hb }, fb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gb(l, e) {
  return i(), d("svg", fb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 11A4.75 4.75 0 0 1 11 6.25h2A4.75 4.75 0 0 1 17.75 11v9.4a1.35 1.35 0 0 1-1.35 1.35H7.6a1.35 1.35 0 0 1-1.35-1.35zM11 7.75A3.25 3.25 0 0 0 7.75 11v9.25h8.5V11A3.25 3.25 0 0 0 13 7.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 13a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75m2-10A.75.75 0 0 1 9 2.25h4a.75.75 0 0 1 0 1.5h-.25V7a.75.75 0 0 1-1.5 0V3.75H9A.75.75 0 0 1 8.25 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wb = { render: gb }, bb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Mb(l, e) {
  return i(), d("svg", bb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.75 3.75v2.5h6.5v-2.5zm8 2.5V3.6a1.35 1.35 0 0 0-1.35-1.35H8.6A1.35 1.35 0 0 0 7.25 3.6v2.65H4A2.75 2.75 0 0 0 1.25 9v10A2.75 2.75 0 0 0 4 21.75h16A2.75 2.75 0 0 0 22.75 19V9A2.75 2.75 0 0 0 20 6.25zM4 7.75A1.25 1.25 0 0 0 2.75 9v10A1.25 1.25 0 0 0 4 20.25h16A1.25 1.25 0 0 0 21.25 19V9A1.25 1.25 0 0 0 20 7.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yb = { render: Mb }, Vb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ab(l, e) {
  return i(), d("svg", Vb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.72 4.441a.63.63 0 0 1 .56 0l10 5a.63.63 0 0 1 .345.559v6a.625.625 0 1 1-1.25 0v-4.989L12.28 15.56a.63.63 0 0 1-.56 0l-10-5a.625.625 0 0 1 0-1.118l10-5M20.603 10 12 14.301 3.398 10 12 5.699z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.625 12c.345 0 .625.28.625.625v4.733c1.356 1.242 3.343 1.892 5.375 1.892s4.02-.65 5.375-1.892v-4.733a.625.625 0 1 1 1.25 0v5a.62.62 0 0 1-.183.442c-1.644 1.644-4.068 2.433-6.442 2.433s-4.798-.79-6.442-2.433A.63.63 0 0 1 5 17.625v-5c0-.345.28-.625.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $b = { render: Ab }, Cb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hb(l, e) {
  return i(), d("svg", Cb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 2A.75.75 0 0 1 9 1.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 2M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5M3.25 14a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zb = { render: Hb }, kb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Bb(l, e) {
  return i(), d("svg", kb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 2A.75.75 0 0 1 9 1.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 2M4.479 6.46a.75.75 0 0 1 1.06.02l14 14.5a.75.75 0 0 1-1.079 1.04l-14-14.5a.75.75 0 0 1 .02-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75c-.89 0-1.742.16-2.529.453a.75.75 0 0 1-.523-1.406 8.75 8.75 0 0 1 11.165 11.484.75.75 0 1 1-1.39-.562A7.25 7.25 0 0 0 12 6.75M6.706 7.955a.75.75 0 0 1 .029 1.06A7.25 7.25 0 0 0 16.75 19.478a.75.75 0 0 1 .983 1.133A8.75 8.75 0 0 1 5.646 7.984a.75.75 0 0 1 1.06-.029",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Lb = { render: Bb }, _b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Tb(l, e) {
  return i(), d("svg", _b, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.23 2.25c5.279.123 9.52 4.442 9.52 9.75 0 5.39-4.357 9.76-9.751 9.75-5.4-.01-9.809-4.447-9.749-9.852A9.74 9.74 0 0 1 4.734 5.5a.75.75 0 0 1 1.117 1 8.24 8.24 0 0 0-2.101 5.414c-.05 4.566 3.68 8.327 8.252 8.336 4.56.009 8.248-3.686 8.248-8.25a8.254 8.254 0 0 0-7.5-8.219v3.344a.75.75 0 0 1-1.5 0v-3.92",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M21.75 12c0-5.308-4.241-9.627-9.52-9.75-.744.022-.968.221-.98.956v3.919a.75.75 0 0 0 1.5 0V3.781A8.254 8.254 0 0 1 20.25 12c0 4.564-3.687 8.259-8.248 8.25-4.571-.009-8.303-3.77-8.252-8.336A8.24 8.24 0 0 1 5.851 6.5a.75.75 0 1 0-1.117-1 9.74 9.74 0 0 0-2.484 6.398C2.19 17.303 6.6 21.74 12 21.75c5.394.01 9.751-4.36 9.751-9.75Z" }, null, -1),
    a("path", { d: "M10.94 13.06 7.237 7.765a.381.381 0 0 1 .53-.53l5.297 3.702a1.523 1.523 0 0 1-1.746 2.497 1.6 1.6 0 0 1-.378-.372Z" }, null, -1)
  ]));
}
const Sb = { render: Tb }, xb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Db(l, e) {
  return i(), d("svg", xb, e[0] || (e[0] = [
    a("path", { d: "M21.6 17.1 18.5 14c.6-.3 1.1-.7 1.6-1.1 1.9-1.9 2.5-5.5 1.2-7.6-.1-.2-.3-.3-.6-.4-.2 0-.5.1-.6.2L17.3 8l-1.9.2.2-1.9 2.8-2.8c.2-.2.2-.4.2-.6s-.2-.4-.4-.6C16 1 12.5 1.6 10.6 3.5 9.6 4.4 9 5.7 8.9 7L7.6 5.7 8.2 4c.1-.3 0-.7-.3-.9L4.3 1c-.3-.2-.7-.1-.9.1L2 2.5c-.3.3-.3.7-.2 1L4 7q.3.45.9.3l1.7-.6L9 9.1c0 .5.1.9.2 1.3l-6.7 6.7q-.45.45-.6.9c-.1.3-.2.7-.2 1.1s.1.7.2 1.1.3.6.6.9c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l5.7-5.7 5.7 5.7c1 1 2.9 1 3.9 0 .5-.5.8-1.2.8-1.9s-.3-1.5-.8-2.1M6.1 5.3l-1.2.4-1.5-2.5.6-.6 2.5 1.5zM5.3 20c-.5.5-1.3.5-1.8 0-.1-.1-.2-.3-.3-.4-.1-.2-.1-.3-.1-.5s0-.3.1-.5.2-.3.3-.4l7.1-7.1s0-.1.1-.1c0 0 .1-.1.1-.2v-.6c-.7-1.7-.7-4.3.9-5.9C13 3 15.1 2.7 16.5 3l-2.2 2.2c-.1.1-.2.3-.2.5l-.3 3.1c0 .2.1.4.2.6.2.2.4.2.6.2l3.1-.3c.2 0 .3-.1.5-.2L20.4 7c.3 1.5-.1 3.6-1.3 4.8-1.6 1.6-4.2 1.6-5.9.9h-.6c-.1 0-.1.1-.1.1s-.1 0-.1.1zm15.2 0c-.5.5-1.3.5-1.8 0L13 14.3c.8.2 1.6.4 2.4.4.5 0 .9 0 1.4-.1l3.7 3.7c.2.2.4.5.4.9s-.1.5-.4.8" }, null, -1)
  ]));
}
const Eb = { render: Db }, Rb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ob(l, e) {
  return i(), d("svg", Rb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 2.25a.75.75 0 0 1 .75.75v1.25H16a.75.75 0 0 1 0 1.5h-1.953c-.84 2.454-2.335 4.754-4.022 6.792l2.497 2.42a.75.75 0 1 1-1.044 1.077l-2.436-2.36c-1.51 1.675-3.12 3.161-4.554 4.39a.75.75 0 1 1-.976-1.138c1.429-1.225 3.017-2.695 4.49-4.34a33 33 0 0 1-1.332-1.712c-.574-.784-1.11-1.58-1.34-2.044a.75.75 0 0 1 1.34-.67c.17.337.634 1.04 1.21 1.829a33 33 0 0 0 1.113 1.441c1.45-1.772 2.693-3.692 3.458-5.685H2a.75.75 0 0 1 0-1.5h6.25V3A.75.75 0 0 1 9 2.25m8.5 7.5a.75.75 0 0 1 .7.483l4 10.5a.75.75 0 1 1-1.4.534l-.96-2.517h-4.68l-.96 2.517a.75.75 0 1 1-1.4-.534l4-10.5a.75.75 0 0 1 .7-.483m-1.769 7.5h3.538L17.5 12.607z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Nb = { render: Ob }, Ib = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qb(l, e) {
  return i(), d("svg", Ib, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 3.577a1.35 1.35 0 0 1 2.06-1.148l8.79 5.442a1.35 1.35 0 0 1 .04 2.27l-9.39 6.26V21a.75.75 0 0 1-1.5 0zm1.5 11.021 8.363-5.575L8.75 3.846z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fb = { render: qb }, Pb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zb(l, e) {
  return i(), d("svg", Pb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 0 0-3.75 17.708V6.997a1.35 1.35 0 0 1 1.982-1.194l6.67 3.531a1.35 1.35 0 0 1 .052 2.357L9.75 15.93v5.045A9.25 9.25 0 1 0 12 2.75M9.75 14.189l6.212-3.655L9.75 7.246zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ub = { render: Zb }, jb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gb(l, e) {
  return i(), d("svg", jb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M7.25 3.577a1.35 1.35 0 0 1 2.06-1.148l8.79 5.442a1.35 1.35 0 0 1 .04 2.27l-9.39 6.26V21a.75.75 0 0 1-1.5 0zm1.5 11.021 8.363-5.575L8.75 3.846z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.118 6.099a.75.75 0 0 1-.193 1.043l-6.5 4.476a.75.75 0 0 1-.85-1.236l6.5-4.476a.75.75 0 0 1 1.043.193",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wb = { render: Gb }, Kb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xb(l, e) {
  return i(), d("svg", Kb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a.75.75 0 0 1 .75.75v.026c5.45.385 9.75 4.927 9.75 10.474a.75.75 0 0 1-1.28.53 2.434 2.434 0 0 0-3.44 0 .75.75 0 0 1-1.06 0 2.92 2.92 0 0 0-3.816-.27l-.154.115v7.125a2.25 2.25 0 0 1-4.5 0 .75.75 0 0 1 1.5 0 .75.75 0 1 0 1.5 0v-7.125l-.154-.116a2.92 2.92 0 0 0-3.816.271.75.75 0 0 1-1.06 0 2.43 2.43 0 0 0-3.44 0 .75.75 0 0 1-1.28-.53c0-5.547 4.3-10.09 9.75-10.474V2.25A.75.75 0 0 1 12 1.5m0 10.312.004-.003a4.42 4.42 0 0 1 5.252-.038 3.93 3.93 0 0 1 3.631-.45 9.002 9.002 0 0 0-17.774 0 3.93 3.93 0 0 1 3.631.45 4.42 4.42 0 0 1 5.252.038z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jb = { render: Xb }, Yb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qb(l, e) {
  return i(), d("svg", Yb, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M3.52 9.52a7.75 7.75 0 1 1 10.96 10.96A7.75 7.75 0 0 1 3.52 9.52M9 8.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9.52 3.52a7.75 7.75 0 1 1 10.96 10.96A7.75 7.75 0 0 1 9.52 3.52M15 2.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const eM = { render: Qb }, lM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tM(l, e) {
  return i(), d("svg", lM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5 7.75A1.25 1.25 0 0 0 3.75 9v9A1.25 1.25 0 0 0 5 19.25h14A1.25 1.25 0 0 0 20.25 18V9A1.25 1.25 0 0 0 19 7.75zm-1.945-.695A2.75 2.75 0 0 1 5 6.25h14A2.75 2.75 0 0 1 21.75 9v9A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18V9c0-.73.29-1.429.805-1.945",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M16.5 14a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1" }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M16.5 13.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5m-.884-1.134a1.25 1.25 0 1 1 1.768 1.768 1.25 1.25 0 0 1-1.768-1.768m-.324-9.67a2.75 2.75 0 0 1 3.458 2.657V7h-1.5V5.603a1.252 1.252 0 0 0-1.572-1.207l-11 2.933a1.25 1.25 0 0 0-.928 1.208V9h-1.5v-.463A2.75 2.75 0 0 1 4.292 5.88z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const aM = { render: tM }, nM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oM(l, e) {
  return i(), d("svg", nM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.325 21.746a.75.75 0 0 1-.671-.82l.6-6 .95-10.448A1.35 1.35 0 0 1 6.548 3.25h13.795a1.35 1.35 0 0 1 1.345 1.472l-.891 9.8a1.35 1.35 0 0 1-1.345 1.228H5.68l-.533 5.325a.75.75 0 0 1-.82.671Zm1.496-7.496h13.494l.864-9.5H6.685z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rM = { render: oM }, sM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iM(l, e) {
  return i(), d("svg", sM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M4.75 2.75v12.778a3.25 3.25 0 0 0 1.797 2.907L12 21.162l5.453-2.727a3.25 3.25 0 0 0 1.797-2.907V2.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h14.8c.746 0 1.35.604 1.35 1.35v12.928a4.75 4.75 0 0 1-2.626 4.248l-5.52 2.76c-.38.19-.828.19-1.208 0l-5.52-2.76a4.75 4.75 0 0 1-2.626-4.248z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dM = { render: iM }, uM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cM(l, e) {
  return i(), d("svg", uM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 8.75a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m4.691 2.5a4.751 4.751 0 1 0 0 1.5H21.25V15a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 11.25a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vM = { render: cM }, pM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hM(l, e) {
  return i(), d("svg", pM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-4.691 2.5a4.751 4.751 0 1 1 0 1.5H2.75V15a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6 11.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mM = { render: hM }, fM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gM(l, e) {
  return i(), d("svg", fM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.242 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75M12.943 5.217a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wM = { render: gM }, bM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function MM(l, e) {
  return i(), d("svg", bM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M17.992 14.25a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25V21a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V15a.75.75 0 0 1 .75-.75m-5.049-9.033a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yM = { render: MM }, VM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function AM(l, e) {
  return i(), d("svg", VM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.34 15.348a.75.75 0 0 1 1.061 0l1.591 1.591 1.591-1.59a.75.75 0 0 1 1.06 1.06L19.054 18l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.59-1.59-1.592 1.59a.75.75 0 0 1-1.06-1.06L16.93 18l-1.59-1.591a.75.75 0 0 1 0-1.06ZM12.943 5.217a3.25 3.25 0 1 0 4.596 4.596 3.25 3.25 0 0 0-4.596-4.596m-1.55 5.085A4.751 4.751 0 0 1 18.6 4.156a4.75 4.75 0 0 1-6.145 7.206l-7.466 7.466 1.59 1.591a.75.75 0 0 1-1.06 1.061l-2.122-2.12a.75.75 0 0 1 0-1.06l7.996-7.997Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.225 15.47a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1-1.06 1.06l-2.122-2.12a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $M = { render: AM }, CM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function HM(l, e) {
  return i(), d("svg", CM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.191 5.062C8.931 4.035 10.156 3.25 12 3.25s3.07.785 3.809 1.812c.711.988.941 2.151.941 2.938v3.25h.65c.746 0 1.35.604 1.35 1.35v6.8a1.35 1.35 0 0 1-1.35 1.35H6.6a1.35 1.35 0 0 1-1.35-1.35v-6.8c0-.746.604-1.35 1.35-1.35h.65V8c0-.787.23-1.95.941-2.938m.559 6.188h6.5V8c0-.547-.17-1.383-.659-2.062-.46-.64-1.235-1.188-2.591-1.188s-2.13.548-2.591 1.188C8.92 6.617 8.75 7.453 8.75 8zm-2 1.5v6.5h10.5v-6.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zM = { render: HM }, kM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function BM(l, e) {
  return i(), d("svg", kM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.75 12.75h4.75a.75.75 0 0 0 0-1.5H6.6a1.35 1.35 0 0 0-1.35 1.35v6.8c0 .746.604 1.35 1.35 1.35h10.8a1.35 1.35 0 0 0 1.35-1.35v-.9a.75.75 0 0 0-1.5 0v.75H6.75zm3.06-9.043c.616-.292 1.344-.457 2.19-.457 1.845 0 3.07.785 3.809 1.812.711.988.941 2.151.941 2.938v4a.75.75 0 0 1-1.5 0V8c0-.547-.17-1.383-.659-2.062-.46-.64-1.235-1.188-2.591-1.188-.647 0-1.152.125-1.547.313a.75.75 0 1 1-.643-1.356",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M15.25 12a.75.75 0 0 1 .75-.75h1.4c.746 0 1.35.604 1.35 1.35v.4a.75.75 0 0 1-1.5 0v-.25H16a.75.75 0 0 1-.75-.75M8 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 8 7.25",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const LM = { render: BM }, _M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function TM(l, e) {
  return i(), d("svg", _M, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.562 13.018c.424-.297.963-.275 1.392-.01l5.318 3.27c.488.3.73.823.71 1.313-.021.506-.357 1.092-1.064 1.172l-2.161.245-.97 1.948c-.317.637-.982.752-1.465.598a1.48 1.48 0 0 1-.99-1.116l-1.256-6.116c-.101-.494.063-1.007.486-1.304m1.1 1.57 1.057 5.148 1.058-2.126 2.361-.268zm1.14 5.55s0 .001 0 0m-4.29-9.697a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const SM = { render: TM }, xM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function DM(l, e) {
  return i(), d("svg", xM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.591 15.591a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.591a.75.75 0 0 1 1.061 1.06l-1.59 1.592 1.59 1.59a.75.75 0 0 1-1.06 1.061l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06l1.591-1.591-1.591-1.591a.75.75 0 0 1 0-1.061",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 .75.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 10.441a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const EM = { render: DM }, RM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function OM(l, e) {
  return i(), d("svg", RM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.75 16a.75.75 0 0 1-.75.75H5A2.75 2.75 0 0 1 2.25 14V8A2.75 2.75 0 0 1 5 5.25h14A2.75 2.75 0 0 1 21.75 8v5a.75.75 0 0 1-1.5 0V8c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 .75.75m1.22 1.97a.75.75 0 0 1 1.06 0l1.47 1.47 3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12.512 10.441a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057m4 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057m-8 0a.75.75 0 0 1 .055 1.06l-.01.01a.75.75 0 1 1-1.114-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const NM = { render: OM }, IM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qM(l, e) {
  return i(), d("svg", IM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.47 9.97a.75.75 0 0 1 1.06 0L11 11.44l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const FM = { render: qM }, PM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ZM(l, e) {
  return i(), d("svg", PM, e[0] || (e[0] = [
    a("path", { d: "M17 21.3H7c-.4 0-.8.3-.8.8s.3.8.8.8h10c.4 0 .8-.3.8-.8s-.4-.8-.8-.8m3-20.1H4C2.5 1.2 1.2 2.5 1.2 4v13c0 1.5 1.2 2.8 2.8 2.8h16c1.5 0 2.8-1.2 2.8-2.8V4c0-1.5-1.3-2.8-2.8-2.8M21.2 17c0 .7-.6 1.2-1.2 1.2H4c-.7 0-1.2-.6-1.2-1.2V4c0-.7.6-1.2 1.2-1.2h16c.7 0 1.2.6 1.2 1.2z" }, null, -1),
    a("path", { d: "m15.7 6.2-3.1-.8c-.4-.1-.9-.1-1.3 0l-3 .8c-.6.2-1 .7-1 1.3.2 7 4.4 8.2 4.6 8.2h.4c.2 0 4.4-1.2 4.6-8.2-.1-.6-.6-1.2-1.2-1.3m-3.7 8c-.7-.3-3.1-1.7-3.2-6.6l2.9-.7h.6l2.9.7c-.1 4.9-2.5 6.3-3.2 6.6" }, null, -1)
  ]));
}
const UM = { render: ZM }, jM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function GM(l, e) {
  return i(), d("svg", jM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 7.25a3.25 3.25 0 0 0-2.784 4.928l4.518-4.428A3.23 3.23 0 0 0 12 7.25m2.784 1.572-4.518 4.428a3.25 3.25 0 0 0 4.518-4.428M7.25 10.5a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const WM = { render: GM }, KM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function XM(l, e) {
  return i(), d("svg", KM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.25 22a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M4 2.75c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zM1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v13A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 7.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const JM = { render: XM }, YM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function QM(l, e) {
  return i(), d("svg", YM, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.47 10.47a.75.75 0 0 1 1.06 0L12 12.94l7.47-7.47a.75.75 0 1 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75A7.25 7.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0 8.75 8.75 0 1 1-5.798-8.24.75.75 0 0 1-.506 1.413A7.2 7.2 0 0 0 12 4.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ey = { render: QM }, ly = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function ty(l, e) {
  return i(), d("svg", ly, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ay = { render: ty }, ny = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oy(l, e) {
  return i(), d("svg", ny, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ry = { render: oy }, sy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iy(l, e) {
  return i(), d("svg", sy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m.512 9.191a.75.75 0 0 1 .056 1.06l-.01.01a.75.75 0 1 1-1.115-1.003l.01-.01a.75.75 0 0 1 1.059-.057",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.403 1.364a2.75 2.75 0 0 1 1.194 0l7.662 1.703a1.746 1.746 0 0 1 1.353 1.952l-1.87 13.087c-.045.32-.21 1.408-1.337 2.394-1.113.975-3.05 1.75-6.405 1.75s-5.292-.775-6.405-1.75c-1.126-.986-1.292-2.074-1.337-2.394L2.388 5.02A1.746 1.746 0 0 1 3.74 3.067zm.868 1.465a1.25 1.25 0 0 0-.542 0L4.067 4.53a.246.246 0 0 0-.194.276l1.87 13.095c.027.186.12.839.84 1.47.744.65 2.273 1.378 5.417 1.378s4.673-.727 5.417-1.379c.72-.63.813-1.283.84-1.47l1.87-13.095a.246.246 0 0 0-.194-.275z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dy = { render: iy }, uy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cy(l, e) {
  return i(), d("svg", uy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M20 6.25a.75.75 0 0 1 .75.75v2.25H23a.75.75 0 0 1 0 1.5h-2.25V13a.75.75 0 0 1-1.5 0v-2.25H17a.75.75 0 0 1 0-1.5h2.25V7a.75.75 0 0 1 .75-.75m-12 6.5A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vy = { render: cy }, py = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hy(l, e) {
  return i(), d("svg", py, e[0] || (e[0] = [
    a("path", { d: "M7.8 16.35a.75.75 0 0 0 1.05-.15 4.874 4.874 0 0 1 7.8 0 .75.75 0 1 0 1.2-.9 6.36 6.36 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0A6.36 6.36 0 0 0 7.65 15.3a.75.75 0 0 0 .15 1.05m2.7-5.85a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9-8.25H6a1.5 1.5 0 0 0-1.5 1.5V6H3a.75.75 0 0 0 0 1.5h1.5v3.75H3a.75.75 0 1 0 0 1.5h1.5v3.75H3A.75.75 0 1 0 3 18h1.5v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5m0 18H6V3.75h13.5z" }, null, -1)
  ]));
}
const my = { render: hy }, fy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gy(l, e) {
  return i(), d("svg", fy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m6 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75m-4.893 3.614a.75.75 0 0 1 1.029-.257c.369.222.932.393 1.614.393s1.245-.171 1.614-.393a.75.75 0 0 1 .772 1.286c-.631.379-1.468.607-2.386.607s-1.755-.228-2.386-.607a.75.75 0 0 1-.257-1.029",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.998 2.25H12c1.131 0 2.166.31 2.938.866.776.56 1.312 1.393 1.312 2.384 0 1.655-1.092 3.25-2.75 3.25-.514 0-1.036-.127-1.453-.392-.421-.269-.797-.729-.797-1.358a.75.75 0 0 1 1.5-.001l.003.006a.3.3 0 0 0 .1.087c.133.085.361.158.647.158.543 0 1.25-.605 1.25-1.75 0-.409-.214-.825-.688-1.166-.478-.344-1.193-.584-2.061-.584a8.25 8.25 0 0 0-8.066 6.6.75.75 0 0 1-.408.525 1.25 1.25 0 0 0 0 2.25.75.75 0 0 1 .406.518 8.25 8.25 0 0 0 16.134 0 .75.75 0 0 1 .406-.518 1.25 1.25 0 0 0 0-2.25.75.75 0 0 1-.41-.532 8.25 8.25 0 0 0-1.65-3.575.75.75 0 0 1 1.173-.936 9.75 9.75 0 0 1 1.879 3.887 2.75 2.75 0 0 1-.008 4.567 9.75 9.75 0 0 1-18.914 0 2.75 2.75 0 0 1-.004-4.57A9.75 9.75 0 0 1 12 2.25Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wy = { render: gy }, by = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function My(l, e) {
  return i(), d("svg", by, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75m-8 2A2.25 2.25 0 0 0 1.75 17v1a.75.75 0 0 1-1.5 0v-1A3.75 3.75 0 0 1 4 13.25zm16 0A2.25 2.25 0 0 1 22.25 17v1a.75.75 0 0 0 1.5 0v-1A3.75 3.75 0 0 0 20 13.25z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M4 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M1.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M20 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M17.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yy = { render: My }, Vy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ay(l, e) {
  return i(), d("svg", Vy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M16 3.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5M14.25 4a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m5.274 7.463a.75.75 0 0 1 .218.643l-1 7a.75.75 0 0 1-1.485-.212l.856-5.986-4.99.832a.75.75 0 1 1-.246-1.48l6-1a.75.75 0 0 1 .647.204ZM7.47 4.47a.75.75 0 0 1 .89-.128l5.5 3a.75.75 0 0 1 .262 1.077l-2.36 3.5a.75.75 0 1 1-1.244-.838l1.9-2.817-4.284-2.337L5.53 8.53a.75.75 0 0 1-1.06-1.06zm-3.01 9.313a.75.75 0 0 1 .497.936 4.25 4.25 0 0 0 5.848 5.1.75.75 0 1 1 .63 1.362 5.75 5.75 0 0 1-7.912-6.9.75.75 0 0 1 .936-.498Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.565 10.82a5.75 5.75 0 0 1 7.912 6.9.75.75 0 1 1-1.434-.44 4.25 4.25 0 0 0-5.848-5.1.75.75 0 1 1-.63-1.36",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $y = { render: Ay }, Cy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Hy(l, e) {
  return i(), d("svg", Cy, e[0] || (e[0] = [
    a("path", { d: "M3.277 11.861a.69.69 0 0 0 .97-.139 4.5 4.5 0 0 1 7.2 0 .692.692 0 0 0 1.107 0 4.5 4.5 0 0 1 7.2 0 .693.693 0 1 0 1.108-.831 5.9 5.9 0 0 0-2.37-1.876 3.462 3.462 0 1 0-4.669 0 5.8 5.8 0 0 0-1.817 1.238 5.8 5.8 0 0 0-1.818-1.238 3.462 3.462 0 1 0-4.668 0 5.9 5.9 0 0 0-2.382 1.877.693.693 0 0 0 .139.969m12.878-7.477a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.154m-8.309 0a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.154m10.645 13.631a3.462 3.462 0 1 0-4.668 0 5.8 5.8 0 0 0-1.817 1.239 5.8 5.8 0 0 0-1.818-1.239 3.462 3.462 0 1 0-4.668 0 5.9 5.9 0 0 0-2.382 1.877.693.693 0 0 0 1.108.831 4.5 4.5 0 0 1 7.2 0 .693.693 0 0 0 1.107 0 4.5 4.5 0 0 1 7.201 0 .693.693 0 0 0 1.108-.832 5.9 5.9 0 0 0-2.37-1.876Zm-10.645-4.63a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.155Zm8.309 0a2.077 2.077 0 1 1 0 4.154 2.077 2.077 0 0 1 0-4.155Z" }, null, -1)
  ]));
}
const zy = { render: Hy }, ky = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function By(l, e) {
  return i(), d("svg", ky, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.996 7.75a4.76 4.76 0 0 0-2.4.635.75.75 0 0 1-.748-1.3 6.26 6.26 0 0 1 3.154-.835c2.554 0 4.797 1.494 5.515 3.665a.75.75 0 0 1-1.424.47C15.607 8.917 14.005 7.75 12 7.75zM7.568 9.214a.75.75 0 0 1 .412.977c-.15.366-.23.76-.23 1.17v4.64a.75.75 0 0 1-1.5 0v-4.64c0-.61.12-1.194.34-1.736a.75.75 0 0 1 .978-.411m1.682 2.64c0-1.49 1.286-2.604 2.75-2.604s2.75 1.113 2.75 2.603V17a.75.75 0 0 1-1.5 0v-5.147c0-.556-.505-1.103-1.25-1.103s-1.25.547-1.25 1.103v.794a.75.75 0 0 1-1.5 0zm7.75.211a.75.75 0 0 1 .75.75V16a.75.75 0 0 1-1.5 0v-3.185a.75.75 0 0 1 .75-.75m-7 2.008a.75.75 0 0 1 .75.75V17a.75.75 0 0 1-1.5 0v-2.177a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12M12 2.75A9.25 9.25 0 0 0 2.75 12 9.25 9.25 0 0 0 12 21.25 9.25 9.25 0 0 0 21.25 12 9.25 9.25 0 0 0 12 2.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ly = { render: By }, _y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Ty(l, e) {
  return i(), d("svg", _y, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "m11.5 4.839-8.323 4.16 8.323 4.162 8.323-4.16L11.5 4.838Zm-.603-1.376a1.35 1.35 0 0 1 1.206 0l8.66 4.33a1.351 1.351 0 0 1 0 2.415l-8.66 4.329a1.35 1.35 0 0 1-1.206 0l-8.66-4.33a1.352 1.352 0 0 1 0-2.415z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M19.83 8.165a.75.75 0 0 1 1.005-.336l2 1a.75.75 0 0 1 .415.67V13a.75.75 0 0 1-1.5 0V9.964l-1.585-.792a.75.75 0 0 1-.336-1.006ZM4.5 9.75a.75.75 0 0 1 .75.75v5.412a1.25 1.25 0 0 0 .714 1.13l5 2.373a1.25 1.25 0 0 0 1.072 0l5-2.374a1.25 1.25 0 0 0 .714-1.129V10.5a.75.75 0 0 1 1.5 0v5.412a2.75 2.75 0 0 1-1.57 2.484l-5 2.374a2.75 2.75 0 0 1-2.36 0l-5-2.374a2.75 2.75 0 0 1-1.57-2.484V10.5a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Sy = { render: Ty }, xy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Dy(l, e) {
  return i(), d("svg", xy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M8 12.75A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 9.75A4.25 4.25 0 0 0 13.75 14h-1.5a5.75 5.75 0 0 1 11.5 0v.5a.75.75 0 0 1-1.5 0V14A4.25 4.25 0 0 0 18 9.75m-10-5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M18 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M14.25 6a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ey = { render: Dy }, Ry = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Oy(l, e) {
  return i(), d("svg", Ry, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5zm-3 1.5a3 3 0 0 1 3-3h10.5a3 3 0 0 1 3 3v16.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 3.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 9 3.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", { d: "M15.632 13.336a1.86 1.86 0 0 0-1.382-.586c-.544 0-1.036.207-1.385.583s-.525.896-.484 1.453c.08 1.1.918 1.995 1.869 1.995.95 0 1.788-.895 1.869-1.994a1.9 1.9 0 0 0-.487-1.45ZM17.423 21h-6.346a.565.565 0 0 1-.56-.437.6.6 0 0 1-.006-.27c.153-.823.627-1.515 1.374-2 .662-.43 1.502-.668 2.365-.668s1.703.237 2.365.668c.747.485 1.221 1.177 1.374 2a.61.61 0 0 1-.13.512.56.56 0 0 1-.436.195" }, null, -1)
  ]));
}
const Ny = { render: Oy }, Iy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function qy(l, e) {
  return i(), d("svg", Iy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M6.744 16.724c.403.693.731 1.455.82 2.344q.004.037.004.075V22a.75.75 0 0 1-1.5 0v-2.817c-.065-.587-.286-1.13-.62-1.705-.248-.425-.533-.83-.847-1.277a48 48 0 0 1-.423-.608C3.228 14.203 2.25 12.51 2.25 10c0-2.43.727-4.646 2.252-6.252C6.035 2.135 8.295 1.22 11.19 1.251c2.094.022 4.176.63 5.752 1.894 1.549 1.243 2.564 3.086 2.623 5.49l2.068 3.248a.75.75 0 0 1 .117.403c0 .696-.168 1.268-.458 1.724-.289.453-.67.75-1.035.94a3.3 3.3 0 0 1-.672.26q-.001.135-.01.29a8.2 8.2 0 0 1-.386 2.166c-.268.801-.723 1.65-1.5 2.302-.64.536-1.46.905-2.485 1.025V22a.75.75 0 1 1-1.5 0v-1.714a.75.75 0 0 1 .75-.75c1.071 0 1.782-.307 2.272-.718.501-.42.83-1 1.04-1.627.21-.628.288-1.269.312-1.762a7 7 0 0 0-.006-.78v-.006a.75.75 0 0 1 .74-.821h.005l.039-.003a1.9 1.9 0 0 0 .705-.198c.181-.094.345-.227.465-.416.1-.156.19-.382.216-.713L18.186 9.26a.75.75 0 0 1-.118-.402c0-2.06-.824-3.548-2.064-4.543-1.26-1.01-2.997-1.545-4.83-1.564-2.56-.027-4.39.773-5.585 2.03-1.202 1.266-1.839 3.08-1.839 5.22 0 2.061.781 3.45 1.666 4.745q.181.264.373.536c.331.471.673.958.955 1.442m12.073-2.902",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11 8.75a1.25 1.25 0 1 0-.001 2.498A1.25 1.25 0 0 0 11 8.75M9.624 7.618a2.75 2.75 0 1 1 2.751 4.763 2.75 2.75 0 0 1-2.75-4.763Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M10.809 6.255a4 4 0 0 1 .382 0 .75.75 0 0 1-.075 1.498 2 2 0 0 0-.232 0 .75.75 0 0 1-.075-1.498m1.644 1.015a.75.75 0 0 1 1.06-.054q.143.129.27.271a.75.75 0 1 1-1.112 1.006 2 2 0 0 0-.164-.164.75.75 0 0 1-.054-1.059m-2.906 0a.75.75 0 0 1-.054 1.06 2 2 0 0 0-.164.163.75.75 0 1 1-1.113-1.006 4 4 0 0 1 .271-.27.75.75 0 0 1 1.06.053m4.411 1.827a.75.75 0 0 1 .787.712 4 4 0 0 1 0 .382.75.75 0 0 1-1.498-.075 2 2 0 0 0 0-.232.75.75 0 0 1 .711-.787m-5.916 0a.75.75 0 0 1 .71.787 2 2 0 0 0 0 .232.75.75 0 0 1-1.497.075 4 4 0 0 1 0-.382.75.75 0 0 1 .787-.712m5.688 2.356a.75.75 0 0 1 .054 1.06 4 4 0 0 1-.271.27.75.75 0 1 1-1.006-1.112q.086-.078.164-.164a.75.75 0 0 1 1.059-.054m-5.46 0a.75.75 0 0 1 1.06.054q.077.086.163.164a.75.75 0 0 1-1.006 1.113 4 4 0 0 1-.27-.271.75.75 0 0 1 .053-1.06m1.827 1.505a.75.75 0 0 1 .787-.71 2 2 0 0 0 .232 0 .75.75 0 0 1 .075 1.497 4 4 0 0 1-.382 0 .75.75 0 0 1-.712-.787",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Fy = { render: qy }, Py = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Zy(l, e) {
  return i(), d("svg", Py, e[0] || (e[0] = [
    a("path", { d: "M16 2.2H8C4.8 2.2 2.2 4.8 2.2 8v8c0 3.2 2.6 5.8 5.8 5.8h8c3.2 0 5.8-2.6 5.8-5.8V8c0-3.2-2.6-5.8-5.8-5.8M20.2 16c0 2.3-1.9 4.2-4.2 4.2H8c-2.3 0-4.2-1.9-4.2-4.2V8c0-2.3 1.9-4.2 4.2-4.2h8c2.3 0 4.2 1.9 4.2 4.2z" }, null, -1),
    a("path", { d: "M15.9 14c-.1.1-1.3 1.7-3.9 1.7S8.2 14.1 8.1 14c-.2-.3-.7-.4-1.1-.1-.3.2-.4.7-.1 1 .1.1 1.8 2.4 5.1 2.4s5-2.2 5.1-2.3c.2-.3.2-.8-.1-1-.4-.3-.8-.3-1.1 0m-7.4-3.3a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m7 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4" }, null, -1)
  ]));
}
const Uy = { render: Zy }, jy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Gy(l, e) {
  return i(), d("svg", jy, e[0] || (e[0] = [
    a("path", { d: "M20.4 18.7c1.5-1.8 2.4-4.2 2.4-6.7C22.8 6.1 18 1.2 12 1.2S1.2 6.1 1.2 12 6 22.8 12 22.8c3.4 0 6.4-1.6 8.4-4.1M12 2.7c5.1 0 9.2 4.1 9.2 9.2 0 1.9-.6 3.7-1.6 5.2-1.1-.9-3.5-2.5-7.6-2.5s-6.6 1.5-7.6 2.5c-1-1.5-1.6-3.3-1.6-5.2 0-5 4.1-9.2 9.2-9.2m0 18.6c-2.6 0-5-1.1-6.7-2.9.8-.7 2.9-2.1 6.7-2.1s5.9 1.4 6.7 2.1c-1.7 1.7-4.1 2.9-6.7 2.9" }, null, -1),
    a("path", { d: "M12 12.7c2.1 0 3.8-1.7 3.8-3.8S14.1 5.2 12 5.2 8.2 6.9 8.2 9s1.7 3.7 3.8 3.7m0-6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2" }, null, -1)
  ]));
}
const Wy = { render: Gy }, Ky = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Xy(l, e) {
  return i(), d("svg", Ky, e[0] || (e[0] = [
    s5('<g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M18.091 7.348a.75.75 0 0 1 1.06 0l1.592 1.591 1.59-1.59a.75.75 0 0 1 1.061 1.06L21.804 10l1.59 1.591a.75.75 0 0 1-1.06 1.06l-1.591-1.59-1.591 1.59a.75.75 0 0 1-1.061-1.06L19.682 10l-1.591-1.591a.75.75 0 0 1 0-1.06ZM8 12.75A6.25 6.25 0 0 0 1.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 8 12.75"></path><path d="M8 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M3.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs>', 2)
  ]));
}
const Jy = { render: Xy }, Yy = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function Qy(l, e) {
  return i(), d("svg", Yy, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 15.5 0v1a.75.75 0 0 1-1.5 0v-1A6.25 6.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const eV = { render: Qy }, lV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function tV(l, e) {
  return i(), d("svg", lV, e[0] || (e[0] = [
    a("path", { d: "M19.7 21.8h-3.4c-.4 0-.8-.1-1.1-.2-.4-.2-.7-.4-.9-.7-.3-.3-.5-.7-.6-1-.1-.4-.1-.8-.1-1.2l.3-2c.1-.7.4-1.2.9-1.7s1.1-.7 1.8-.7h2.8c.7 0 1.3.2 1.8.7s.8 1 .9 1.7l.3 2c.1.4 0 .8-.1 1.2s-.3.7-.6 1-.6.5-.9.7c-.3.1-.7.2-1.1.2m-3.1-6c-.3 0-.6.1-.8.3s-.4.5-.4.8l-.3 2v.5c.1.2.1.3.3.5.1.1.3.2.4.3.2.1.3.1.5.1h3.4c.2 0 .4 0 .5-.1.2-.1.3-.2.4-.3s.2-.3.3-.5c0-.2.1-.4 0-.5l-.3-2c0-.3-.2-.6-.4-.8s-.5-.3-.8-.3zM2 18.8c-.4 0-.8-.3-.8-.8 0-1.5.4-2.9 1.2-4.1s1.9-2.2 3.2-2.9c.2-.1.3-.2.5-.2-.2-.1-.3-.3-.5-.4-.9-.9-1.4-2.1-1.4-3.4s.5-2.5 1.4-3.4S7.7 2.2 9 2.2s2.5.5 3.4 1.4 1.4 2.1 1.4 3.4-.5 2.5-1.4 3.4c-.2.2-.3.3-.5.4.7.3 1.3.6 1.9 1.1.3.3.4.7.1 1.1-.3.3-.7.4-1.1.1-.9-.7-2-1.2-3.2-1.3h-.7c-.9 0-1.9.2-2.7.6-1.1.5-1.9 1.3-2.6 2.3-.6 1-1 2.1-1 3.3.2.4-.2.8-.6.8m7-8.6c.9 0 1.7-.3 2.3-1 .6-.6 1-1.4 1-2.3s-.3-1.7-1-2.3c-1.2-1.2-3.4-1.2-4.6 0-.6.6-1 1.4-1 2.3s.3 1.7 1 2.3c.6.7 1.4 1 2.3 1m10 3.6h-2c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h2c.4 0 .8.3.8.8s-.4.8-.8.8" }, null, -1)
  ]));
}
const aV = { render: tV }, nV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function oV(l, e) {
  return i(), d("svg", nV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M5.641 3.641a4.75 4.75 0 1 1 6.215 7.155 7.7 7.7 0 0 1 1.938 1.115.75.75 0 1 1-.928 1.178A6.25 6.25 0 0 0 2.75 18a.75.75 0 0 1-1.5 0 7.75 7.75 0 0 1 4.894-7.204 4.75 4.75 0 0 1-.503-7.154ZM9 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m13.237 8.039a.75.75 0 0 1 .475.948l-.834 2.5-1.166 3.5a.75.75 0 0 1-.712.513h-4.5a.75.75 0 0 1-.721-.544l-1-3.5a.75.75 0 0 1 .721-.956h6.126l.662-1.987a.75.75 0 0 1 .95-.474Zm-2.11 3.961h-4.633l.572 2h3.393zm-3.112 4.194a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.012a.75.75 0 0 1 1.06-.05m3 0a.75.75 0 0 1 .05 1.06l-.01.01a.75.75 0 1 1-1.11-1.008l.01-.012a.75.75 0 0 1 1.06-.05",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const rV = { render: oV }, sV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function iV(l, e) {
  return i(), d("svg", sV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const dV = { render: iV }, uV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function cV(l, e) {
  return i(), d("svg", uV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 11.072-7.004.75.75 0 1 1-.644 1.355A6.2 6.2 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M11.558 15.394a.75.75 0 0 0-.298.73l1 6a.75.75 0 0 0 .74.626h8a.75.75 0 0 0 .74-.627l1-6a.75.75 0 0 0-1.083-.79l-2.965 1.525-1.116-1.338a.75.75 0 0 0-1.152 0l-1.115 1.338-2.966-1.525a.75.75 0 0 0-.785.061m1.427 1.956 2.172 1.117a.75.75 0 0 0 .92-.187L17 17.172l.924 1.108a.75.75 0 0 0 .919.187l2.172-1.117-.65 3.9h-6.73z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vV = { render: cV }, pV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function hV(l, e) {
  return i(), d("svg", pV, e[0] || (e[0] = [
    a("path", { d: "M21.9 15.1c-1-1-2.7-1.2-3.9-.4-1.2-.8-2.9-.7-3.9.4-1.2 1.2-1.2 3.1 0 4.3l2.9 2.9c.3.3.6.4 1 .4.3 0 .7-.1.9-.4.7-.7 1.4-1.3 2-2 .3-.3.6-.6.9-1q.9-.9.9-2.1c0-1.2-.3-1.5-.8-2.1m-1.1 3.3c-.3.3-.6.7-1 1-.6.6-1.2 1.3-1.8 1.9l-2.8-2.8c-.6-.6-.6-1.6 0-2.2.3-.3.7-.5 1.1-.5s.8.2 1.1.5l.1.1c.1.1.4.2.5.2.2 0 .4-.1.5-.2l.1-.1c.6-.6 1.6-.6 2.2 0 .3.3.4.7.4 1.1s-.1.7-.4 1M15.7 13c.2-.4 0-.8-.4-1-.2-.1-.3-.1-.5-.2 1.2-.9 1.9-2.2 1.9-3.8 0-2.6-2.1-4.8-4.8-4.8S7.2 5.4 7.2 8c0 1.6.8 2.9 1.9 3.8-2.9 1.1-4.9 3.9-4.9 7.2v1c0 .4.3.8.8.8s.8-.3.8-.8v-1c0-3.4 2.8-6.3 6.2-6.3q1.35 0 2.7.6c.4.2.8.1 1-.3M8.8 8c0-1.8 1.5-3.2 3.2-3.2s3.2 1.5 3.2 3.2-1.5 3.2-3.2 3.2S8.8 9.8 8.8 8" }, null, -1)
  ]));
}
const mV = { render: hV }, fV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function gV(l, e) {
  return i(), d("svg", fV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M2.25 3A.75.75 0 0 1 3 2.25h3a.75.75 0 0 1 0 1.5H3.75V6a.75.75 0 0 1-1.5 0zm15 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3.75H18a.75.75 0 0 1-.75-.75M9.348 6.348a3.75 3.75 0 1 1 5.132 5.465A5.75 5.75 0 0 1 17.75 17v1a.75.75 0 0 1-1.5 0v-1a4.25 4.25 0 0 0-8.5 0v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 3.27-5.188 3.75 3.75 0 0 1-.171-5.464ZM12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-9 10.5a.75.75 0 0 1 .75.75v2.25H6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75m18 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V18a.75.75 0 0 1 .75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wV = { render: gV }, bV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function MV(l, e) {
  return i(), d("svg", bV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A4.25 4.25 0 0 0 7.75 17v1a.75.75 0 0 1-1.5 0v-1a5.75 5.75 0 0 1 11.5 0v1a.75.75 0 0 1-1.5 0v-1A4.25 4.25 0 0 0 12 12.75",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M8.25 9a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M20.25 20.25V3.75H3.75v16.5zm1.5.15a1.35 1.35 0 0 1-1.35 1.35H3.6a1.35 1.35 0 0 1-1.35-1.35V3.6c0-.746.604-1.35 1.35-1.35h16.8c.746 0 1.35.604 1.35 1.35z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yV = { render: MV }, VV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function AV(l, e) {
  return i(), d("svg", VV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M12 12.75A6.25 6.25 0 0 0 5.75 19v1a.75.75 0 0 1-1.5 0v-1a7.75 7.75 0 0 1 11.072-7.004.75.75 0 1 1-.644 1.355A6.2 6.2 0 0 0 12 12.75m6 2.529-.687 1.456a.75.75 0 0 1-.565.422l-1.605.245 1.184 1.206a.75.75 0 0 1 .204.647l-.271 1.659 1.378-.76a.75.75 0 0 1 .724 0l1.378.76-.271-1.66a.75.75 0 0 1 .204-.646l1.184-1.206-1.605-.245a.75.75 0 0 1-.565-.422zm-1.004-1.387a1.107 1.107 0 0 1 2.008 0l.87 1.842 1.928.295c.948.145 1.234 1.293.623 1.916l-1.415 1.442.335 2.046c.14.849-.744 1.666-1.629 1.18L18 21.668l-1.716.945c-.885.486-1.769-.331-1.63-1.18l.336-2.046-1.415-1.442c-.611-.623-.325-1.77.623-1.916l1.929-.295z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $V = { render: AV }, CV = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function HV(l, e) {
  return i(), d("svg", CV, e[0] || (e[0] = [
    a("path", {
      "fill-rule": "evenodd",
      d: "M9 12.75A6.25 6.25 0 0 0 2.75 19v1a.75.75 0 0 1-1.5 0v-1A7.75 7.75 0 0 1 9 11.25zm6.25-.941a2.37 2.37 0 0 1 3.5 0 .87.87 0 0 0 .683.282 2.37 2.37 0 0 1 2.476 2.476.87.87 0 0 0 .283.682 2.37 2.37 0 0 1 0 3.502.87.87 0 0 0-.283.682 2.37 2.37 0 0 1-2.476 2.476.87.87 0 0 0-.682.282 2.37 2.37 0 0 1-3.502 0 .87.87 0 0 0-.682-.282 2.37 2.37 0 0 1-2.476-2.476.87.87 0 0 0-.282-.682 2.37 2.37 0 0 1 0-3.502.87.87 0 0 0 .282-.682 2.37 2.37 0 0 1 2.476-2.476.87.87 0 0 0 .682-.282Zm2.392 1.01a.87.87 0 0 0-1.284 0 2.37 2.37 0 0 1-1.86.77.87.87 0 0 0-.909.908 2.37 2.37 0 0 1-.77 1.861.87.87 0 0 0 0 1.284 2.37 2.37 0 0 1 .77 1.86.87.87 0 0 0 .908.909 2.37 2.37 0 0 1 1.861.77.87.87 0 0 0 1.284 0 2.37 2.37 0 0 1 1.861-.77.87.87 0 0 0 .908-.908 2.37 2.37 0 0 1 .77-1.861.87.87 0 0 0 0-1.284 2.37 2.37 0 0 1-.77-1.861.87.87 0 0 0-.908-.908 2.37 2.37 0 0 1-1.861-.77",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      "fill-rule": "evenodd",
      d: "M14.833 16.47a.75.75 0 0 1 1.061 0l.56.56 1.652-1.651a.75.75 0 0 1 1.06 1.06l-2.181 2.182a.75.75 0 0 1-1.06 0l-1.092-1.09a.75.75 0 0 1 0-1.061M9 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M4.25 8a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const zV = { render: HV }, kV = {
  audition: aa,
  dentaire: ra,
  "frais-de-sante": da,
  hospitalisation: va,
  maternite: ma,
  "medecine-douce": wa,
  medicaments: ya,
  optique: $a,
  "soins-courants": za,
  surcomplementaire: La
}, BV = {
  "age1-circle": Ea,
  age1: Sa,
  "age2-circle": Fa,
  age2: Na,
  "collectif-circle": Wa,
  collectif: Ua,
  "emprunteur-circle": en,
  emprunteur: Ja,
  "epargne-retraite-circle": rn,
  "epargne-retraite": an,
  "financements-circle": pn,
  financements: un,
  "frontaliers-expatries-circle": bn,
  "frontaliers-expatries": fn,
  "independants-circle": Cn,
  independants: Vn,
  "particuliers-circle": _n,
  particuliers: kn,
  "prevoyance-circle": Rn,
  prevoyance: xn,
  "salaries-circle": Pn,
  salaries: In,
  "sante-circle": Kn,
  sante: jn
}, LV = {
  ...kV,
  ...BV
}, _V = {
  "add-circle": Yn,
  "add-media-image": l3,
  brightness: n3,
  calendar: s3,
  cancel: u3,
  "check-circle": f3,
  check: p3,
  "clipboard-check": b3,
  combine: V3,
  "copy-plus": k3,
  copy: C3,
  "delete-circle": _3,
  "design-nib": x3,
  "double-check": R3,
  "download-circle": P3,
  download: I3,
  "edit-pencil": j3,
  erase: K3,
  "eye-alt": Y3,
  "eye-close": lo,
  "eye-empty": no,
  "eye-off": so,
  "help-circle": co,
  "hourglass-outline": ho,
  "info-empty": go,
  "line-space": Mo,
  "load-action-floppy": Ao,
  medal: Ho,
  "media-image": Bo,
  "menu-scale": Do,
  menu: To,
  "minus-circle": qo,
  minus: Oo,
  "open-in-browser": Zo,
  "open-in-window": Go,
  "open-new-window": Xo,
  "paste-clipboard": Qo,
  plus: t4,
  prohibition: o4,
  "question-mark": i4,
  "radio-button-off": c4,
  "radio-button-on": h4,
  "redo-action": M4,
  "redo-circle": A4,
  redo: g4,
  "refresh-circular": B4,
  "refresh-double": T4,
  refresh: H4,
  restart: D4,
  "save-action-floppy": O4,
  settings: q4,
  "share-android": Z4,
  "share-ios": G4,
  "switch-off": X4,
  "switch-on": Q4,
  trash: tr,
  "undo-action": ir,
  "undo-circle": cr,
  undo: or,
  upload: hr,
  "warning-circle": gr,
  "warning-triangle": Mr,
  "wrap-text": Ar
}, TV = {
  "control-slider": Hr,
  "dashboard-speed": Tr,
  dashboard: Br,
  "graph-down": Dr,
  "graph-up": Or,
  "percentage-circle": Zr,
  "percentage-square": Gr,
  percentage: qr,
  "report-columns": Xr,
  reports: Qr,
  "stat-down": t6,
  "stat-up": o6,
  "stats-down-square": i6,
  "stats-report": c6,
  "stats-up-square": h6
}, SV = {
  "arrow-email-forward": g6,
  "at-sign": M6,
  "bell-off": H6,
  bell: A6,
  "chat-add": B6,
  "chat-bubble-check": D6,
  "chat-bubble-empty": O6,
  "chat-bubble-error": q6,
  "chat-bubble-question": Z6,
  "chat-bubble-translate": G6,
  "chat-bubble-warning": X6,
  "chat-bubble": T6,
  "chat-lines": Q6,
  "chat-remove": ts,
  facetime: os,
  "forward-message": is,
  globe: cs,
  "headset-help": hs,
  internet: gs,
  "mail-in": As,
  "mail-opened": Hs,
  "mail-out": Bs,
  mail: Ms,
  "message-alert": Ds,
  "message-text": Os,
  message: Ts,
  "multi-bubble": qs,
  phone: Zs,
  "quote-message": Xs,
  quote: Gs,
  "reply-to-message": ti,
  reply: Qs,
  "send-diagonal": ii,
  "send-mail": ci,
  send: oi,
  "sound-high": hi,
  "time-zone": gi,
  video: Mi,
  www: Ai
}, xV = {
  airplay: Hi,
  "antenna-off": Ti,
  "antenna-signal-tag": Oi,
  "antenna-signal": Di,
  antenna: Bi,
  "bluetooth-tag": Zi,
  bluetooth: qi,
  "cable-tag": Gi,
  "data-transfer-both": Xi,
  "data-transfer-check": Qi,
  "data-transfer-down": td,
  "data-transfer-up": od,
  "data-transfer-warning": id,
  "network-alt": hd,
  "network-left": gd,
  "network-right": Md,
  network: cd,
  "plug-type-a": Ad,
  "plug-type-c": Hd,
  "plug-type-g": Bd,
  "plug-type-l": Td,
  "private-wifi": Dd,
  "server-connection": qd,
  server: Od,
  usb: Zd,
  "wifi-error": Xd,
  wifi: Gd,
  "wifi-issue": Qd,
  "wifi-off": t8,
  "wifi-signal-none": o8,
  "wifi-tag": i8
}, DV = {
  "add-database-script": c8,
  "cloud-book-alt": h8,
  "cloud-check": g8,
  "cloud-desync": M8,
  "cloud-download": A8,
  "cloud-error": H8,
  "cloud-sync": B8,
  "cloud-upload": T8,
  "database-backup": D8,
  "database-export": O8,
  "database-restore": q8,
  "database-script": Z8,
  "db-check": X8,
  "db-error": Q8,
  "db-warning": tu,
  db: G8,
  "remove-database-script": ou
}, EV = {
  "add-folder": iu,
  "add-page-alt": hu,
  "add-page": cu,
  archive: gu,
  attachment: Mu,
  "doc-magnifying-glass-in": Hu,
  "doc-magnifying-glass": Au,
  "doc-star-alt": Tu,
  "doc-star": Bu,
  "download-page-alt": Ou,
  "download-page": Du,
  "empty-page": qu,
  "folder-alert": Gu,
  "folder-settings": Xu,
  folder: Zu,
  "google-docs": Qu,
  "journal-page": oc,
  journal: tc,
  "list-select": ic,
  "multiple-pages-add": hc,
  "multiple-pages-delete": gc,
  "multiple-pages-empty": Mc,
  "multiple-pages-remove": Ac,
  "multiple-pages": cc,
  "page-csv": Bc,
  "page-doc": Tc,
  "page-edit": Dc,
  "page-pdf": Oc,
  "page-search": qc,
  "page-star": Zc,
  "page-xls": Gc,
  page: Hc,
  "privacy-policy": Xc,
  "remove-folder": Qc,
  "remove-page-alt": o9,
  "remove-page": t9,
  "submit-document": i9
}, RV = {
  donate: c9,
  female: h9,
  "health-shield": g9,
  healthcare: M9,
  heart: A9,
  "home-hospital": H9,
  "hospital-sign": T9,
  hospital: B9,
  male: D9,
  "non-binary": O9,
  "pharmacie-cross-square": q9,
  "pharmacy-cross-circle": Z9,
  "plaster-2": G9,
  stroller: X9,
  tree: Q9,
  "weight-alt": ov,
  weight: tv
}, OV = {
  "box-iso": iv,
  buildings: cv,
  "domotic-issue": hv,
  "home-alt-slim-horiz": Hv,
  "home-alt-slim": Av,
  "home-alt": Mv,
  "home-shield": Bv,
  "home-simple-door": Dv,
  "home-simple": Tv,
  "home-user": Ov,
  home: gv,
  "light-bulb-off": Zv,
  "light-bulb-on": Gv,
  "light-bulb": qv,
  shop: Xv,
  "sign-in": Qv,
  "sign-out": tp
}, NV = {
  "add-pin-alt": op,
  "map-issue": cp,
  map: ip,
  "maps-arrow-diagonal": gp,
  "maps-arrow-issue": Mp,
  "maps-arrow": hp,
  "minus-pin-alt": Ap,
  "pin-alt": Hp,
  "remove-pin-alt": Bp
}, IV = {
  "arrow-bl-circle": Dp,
  "arrow-bl": Tp,
  "arrow-br-circle": qp,
  "arrow-br": Op,
  "arrow-down-circle": Gp,
  "arrow-down": Zp,
  "arrow-left-circle": Qp,
  "arrow-left": Xp,
  "arrow-right-circle": oh,
  "arrow-right": th,
  "arrow-separate-vertical": ch,
  "arrow-separate": ih,
  "arrow-tl-circle": gh,
  "arrow-tl": hh,
  "arrow-tr-circle": Ah,
  "arrow-tr": Mh,
  "arrow-union-vertical": Bh,
  "arrow-union": Hh,
  "arrow-up-circle": Dh,
  "arrow-up": Th,
  drag: Oh,
  "fast-arrow-down": qh,
  "fast-arrow-left": Zh,
  "fast-arrow-right": Gh,
  "fast-arrow-up": Xh,
  "filter-list-circle": tm,
  "filter-list": Qh,
  "long-arrow-down-right": om,
  "more-horiz-circle": cm,
  "more-horiz": im,
  "more-vert-circle": gm,
  "more-vert": hm,
  "nav-arrow-down": Mm,
  "nav-arrow-left": Am,
  "nav-arrow-right": Hm,
  "nav-arrow-up": Bm,
  "page-down": Tm,
  "page-left": Dm,
  "page-right": Om,
  "page-up": qm,
  "path-arrow": Zm,
  "vertical-merge": Gm,
  "vertical-split": Xm
}, qV = {
  binocular: Qm,
  "birthday-cake": tf,
  "bookmark-circle": of,
  "bookmark-empty": df,
  diamond: vf,
  "filter-alt": wf,
  filter: mf,
  glasses: yf,
  "hand-coins": $f,
  handshake: zf,
  label: Lf,
  "medal-star": Sf,
  pin: Ef,
  "receipt-text": Nf,
  "remove-pin": Ff,
  search: Uf,
  "settings-profiles": Wf,
  "star-dashed": eg,
  star: Jf,
  "star-half-dashed": ag,
  "three-stars": rg,
  "zoom-in": dg,
  "zoom-out": vg
}, FV = {
  activity: mg,
  "add-selection": wg,
  alarm: yg,
  "battery-indicator": $g,
  "bright-crown": zg,
  calculator: Lg,
  clock: Sg,
  coins: Eg,
  compress: Ng,
  "credit-card": Fg,
  "dash-flag": Ug,
  "de-compress": Wg,
  dialpad: Jg,
  "divide-selection-1": ew,
  "divide-selection-2": aw,
  euro: rw,
  "file-not-found": dw,
  flash: vw,
  gas: mw,
  gift: ww,
  "half-moon": yw,
  hammer: $w,
  import: zw,
  language: Lw,
  lifebelt: Sw,
  link: Ew,
  maximize: Nw,
  "no-link": Fw,
  notes: Uw,
  "page-flip": Ww,
  "qr-code": Jw,
  "remove-link": eb,
  "remove-selection": ab,
  rings: rb,
  "scan-qr-code": db,
  selection: vb,
  smoking: mb,
  soap: wb,
  "suite-case": yb,
  teach: $b,
  "timer-off": Lb,
  "timer-outline": Sb,
  timer: zb,
  tools: Eb,
  translate: Nb,
  "triangle-flag-circle": Ub,
  "triangle-flag-two-stripes": Wb,
  "triangle-flag": Fb,
  "umbrella-outline": Jb,
  "union-alt": eM,
  walet: aM,
  "white-flag": rM
}, PV = {
  "historic-shield": dM,
  "key-alt-back": mM,
  "key-alt-minus": wM,
  "key-alt-plus": yM,
  "key-alt-remove": $M,
  "key-alt": vM,
  lock: zM,
  "no-lock": LM,
  "password-cursor": SM,
  "password-error": EM,
  "password-pass": NM,
  "pc-check": FM,
  "pc-firewall": UM,
  "pc-no-entry": WM,
  "pc-warning": JM,
  "security-pass": ey,
  "shield-add": ry,
  "shield-alert": dy,
  shield: ay
}, ZV = {
  "add-user": vy,
  "address-book": my,
  baby: wy,
  community: yy,
  disability: $y,
  family: zy,
  "fingerprint-circle": Ly,
  "graduation-cap": Sy,
  group: Ey,
  "id-card": Ny,
  learning: Fy,
  "people-tag": Uy,
  "profile-circle": Wy,
  "remove-user": Jy,
  "user-bag": aV,
  "user-cart": rV,
  "user-circle": dV,
  "user-crown": vV,
  "user-love": mV,
  "user-scan": wV,
  "user-square": yV,
  "user-star": $V,
  user: eV,
  "verified-user": zV
}, UV = {
  ..._V,
  ...TV,
  ...SV,
  ...xV,
  ...DV,
  ...EV,
  ...RV,
  ...OV,
  ...NV,
  ...IV,
  ...qV,
  ...FV,
  ...PV,
  ...ZV
}, jV = {
  ...LV,
  ...UV
}, l2 = 9, GV = /* @__PURE__ */ R({
  __name: "TotemBadge",
  props: {
    value: { default: void 0 }
  },
  setup(l) {
    const e = l, t = $(() => {
      if (!(!e.value || e.value < 0))
        return e.value <= l2 ? e.value : `+${l2}`;
    });
    return (n, o) => (f(), M("span", {
      class: J(["totem-badge", {
        "totem-badge--no-value": !t.value
      }]),
      "data-test": "value"
    }, [
      t.value ? (f(), M(o5, { key: 0 }, [
        P(O(t.value), 1)
      ], 64)) : C("", !0)
    ], 2));
  }
}), WV = {
  key: 0,
  class: "totem-icon totem-icon--with-badge"
}, a5 = /* @__PURE__ */ R({
  __name: "TotemIcon",
  props: {
    name: {},
    badge: { type: Boolean },
    badgeValue: { default: void 0 },
    rotation: { default: void 0 }
  },
  setup(l) {
    const e = l, t = $(() => jV[e.name]), n = $(() => [
      "totem-icon__icon",
      {
        "totem-icon__icon--with-rotation": e.rotation !== void 0
      }
    ]), o = $(() => {
      const r = {};
      return e.rotation && (r["--totem-icon--rotation-degree"] = `${e.rotation}deg`), r;
    });
    return (r, s) => r.badge ? (f(), M("span", WV, [
      W(V(t), {
        class: J(n.value),
        style: m5(o.value)
      }, null, 8, ["class", "style"]),
      r.badge ? (f(), L(GV, {
        key: 0,
        value: r.badgeValue,
        "data-test": "badge",
        class: "totem-icon__badge"
      }, null, 8, ["value"])) : C("", !0)
    ])) : (f(), L(V(t), {
      key: 1,
      class: J(["totem-icon", n.value]),
      style: m5(o.value)
    }, null, 8, ["class", "style"]));
  }
}), v5 = [];
for (let l = 0; l < 256; ++l)
  v5.push((l + 256).toString(16).slice(1));
function KV(l, e = 0) {
  return (v5[l[e + 0]] + v5[l[e + 1]] + v5[l[e + 2]] + v5[l[e + 3]] + "-" + v5[l[e + 4]] + v5[l[e + 5]] + "-" + v5[l[e + 6]] + v5[l[e + 7]] + "-" + v5[l[e + 8]] + v5[l[e + 9]] + "-" + v5[l[e + 10]] + v5[l[e + 11]] + v5[l[e + 12]] + v5[l[e + 13]] + v5[l[e + 14]] + v5[l[e + 15]]).toLowerCase();
}
let c0;
const XV = new Uint8Array(16);
function JV() {
  if (!c0) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    c0 = crypto.getRandomValues.bind(crypto);
  }
  return c0(XV);
}
const YV = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), t2 = { randomUUID: YV };
function P5(l, e, t) {
  var o;
  if (t2.randomUUID && !l)
    return t2.randomUUID();
  l = l || {};
  const n = l.random ?? ((o = l.rng) == null ? void 0 : o.call(l)) ?? JV();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, KV(n);
}
const v0 = 1e3;
function a2(l, e) {
  return `${l.toLocaleString("fr-FR")} ${e}`;
}
function QV(l, e = 1) {
  if (Math.abs(l) < v0)
    return a2(l, "o");
  const t = ["ko", "Mo", "Go", "To", "Po", "Eo", "Zo", "Yo"];
  let n = l, o = -1;
  const r = 10 ** e;
  do
    n /= v0, o += 1;
  while (Math.round(Math.abs(n) * r) / r >= v0 && o < t.length - 1);
  return a2(parseFloat(n.toFixed(e)), t[o]);
}
function eA(l) {
  if (!(!l || !l.length))
    return Array.from(l);
}
function lA(l, e, t, n) {
  const o = $(() => e5(e) === "file");
  return {
    isTypeFile: o,
    onStartUploadingFiles: () => {
      if (o.value) {
        const v = e5(l);
        v && v.click();
      }
    },
    onUpdateUploadedFiles: (v) => {
      o.value && v.target && (t.value = eA(v.target.files));
    },
    onRemoveFile: (v) => {
      o.value && t.value && (t.value = t.value.filter((h) => h !== v), n.value = "");
    },
    onRemoveAllFiles: () => {
      o.value && t.value && (t.value = [], n.value = "");
    }
  };
}
const $1 = (l) => {
  const e = q(!1), t = (v = !0) => {
    e.value = v;
  }, n = () => {
    t(!0);
  }, o = () => {
    t(!1);
  }, r = q(), s = (v) => {
    v.addEventListener("focus", n), v.addEventListener("blur", o), r.value = !0;
  }, c = (v) => {
    v.removeEventListener("focus", n), v.removeEventListener("blur", o), r.value = !1;
  }, u = () => {
    var v;
    (v = l.value) == null || v.focus();
  };
  return h5(
    l,
    (v, h) => {
      h && c(h), v && !r.value && s(v);
    },
    { immediate: !0 }
  ), P1(() => {
    l.value && c(l.value);
  }), { isFocused: e, triggerFocus: u };
}, C1 = /* @__PURE__ */ R({
  __name: "TotemClickableElement",
  props: {
    disabled: { type: Boolean },
    href: { default: void 0 },
    label: { default: void 0 },
    target: { default: "_self" },
    to: { default: void 0 },
    type: { default: "button" }
  },
  setup(l) {
    const e = l, t = $(() => e.to ? e.disabled ? "a" : "RouterLink" : e.href ? "a" : "button"), n = $(() => {
      const o = {};
      return t.value === "a" ? e.disabled || (o.href = e.href) : t.value === "RouterLink" ? o.to = e.to : t.value === "button" && (o.type = e.type, e.disabled && (o.disabled = e.disabled)), (t.value === "a" || t.value === "RouterLink") && e.target !== "_self" && (o.target = e.target), o;
    });
    return (o, r) => (f(), L(V5(t.value), Q(n.value, { class: "totem-clickable-element" }), {
      default: w(() => [
        p(o.$slots, "default", {}, () => [
          P(O(o.label), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), tA = {}, aA = { class: "totem-loader" };
function nA(l, e) {
  return f(), M("span", aA);
}
const xe = /* @__PURE__ */ A1(tA, [["render", nA]]), oA = ["hidden"], rA = ["hidden"], N5 = /* @__PURE__ */ R({
  __name: "TotemButtonIcon",
  props: {
    color: { default: "primary" },
    size: { default: "m" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    target: { default: "_self" },
    to: { default: void 0 },
    type: { default: "button" },
    loading: { type: Boolean },
    iconName: { default: void 0 },
    iconRotation: { default: void 0 }
  },
  setup(l) {
    return (e, t) => (f(), L(C1, {
      disabled: e.disabled,
      href: e.href,
      target: e.target,
      to: e.to,
      type: e.type,
      class: J(["totem-button-icon", {
        [`totem-button-icon--color-${e.color}`]: e.color,
        [`totem-button-icon--size-${e.size}`]: e.size,
        "totem-button-icon--disabled": e.disabled,
        "totem-button-icon--loading": e.loading
      }])
    }, {
      default: w(() => [
        A("span", {
          hidden: e.loading,
          class: "totem-button-icon__layer totem-button-icon__layer--body",
          "data-test": "body"
        }, [
          p(e.$slots, "default", {}, () => [
            e.iconName ? (f(), L(a5, {
              key: 0,
              name: e.iconName,
              rotation: e.iconRotation,
              class: "totem-button-icon__icon"
            }, null, 8, ["name", "rotation"])) : C("", !0)
          ])
        ], 8, oA),
        W(J5, { name: "totem-button-icon__layer-" }, {
          default: w(() => [
            e.$slots.loading || e.loading ? (f(), M("span", {
              key: 0,
              hidden: !e.loading,
              class: "totem-button-icon__layer totem-button-icon__layer--loader",
              "data-test": "loading"
            }, [
              p(e.$slots, "loading", {}, () => [
                W(xe)
              ])
            ], 8, rA)) : C("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled", "href", "target", "to", "type", "class"]));
  }
}), G1 = /* @__PURE__ */ R({
  __name: "TotemDivider",
  props: {
    vertical: { type: Boolean }
  },
  setup(l) {
    const e = l, t = $(() => e.vertical ? "div" : "hr");
    return (n, o) => (f(), L(V5(t.value), {
      class: J(["totem-divider", {
        "totem-divider--vertical": n.vertical
      }])
    }, null, 8, ["class"]));
  }
}), sA = {
  key: 0,
  class: "totem-chip__icon",
  "data-test": "icon"
}, iA = {
  class: "totem-chip__label",
  "data-test": "label"
}, dA = {
  key: 1,
  class: "totem-chip__detail",
  "data-test": "detail"
}, uA = {
  key: 2,
  class: "totem-chip__close",
  "data-test": "close"
}, n2 = /* @__PURE__ */ R({
  __name: "TotemChip",
  props: {
    label: {},
    detail: {},
    color: { default: "default" },
    iconName: {},
    disabled: { type: Boolean },
    closable: { type: Boolean }
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const t = e, n = () => {
      t("close");
    };
    return (o, r) => (f(), M("div", {
      class: J(["totem-chip", {
        [`totem-chip--color-${o.color}`]: o.color,
        "totem-chip--disabled": o.disabled
      }])
    }, [
      o.iconName || o.$slots.icon ? (f(), M("span", sA, [
        p(o.$slots, "icon", {}, () => [
          o.iconName ? (f(), L(a5, {
            key: 0,
            name: o.iconName
          }, null, 8, ["name"])) : C("", !0)
        ])
      ])) : C("", !0),
      A("span", iA, [
        p(o.$slots, "label", {}, () => [
          p(o.$slots, "default", {}, () => [
            P(O(o.label), 1)
          ])
        ])
      ]),
      o.detail || o.$slots.detail ? (f(), M("span", dA, [
        p(o.$slots, "detail", {}, () => [
          P(O(o.detail), 1)
        ])
      ])) : C("", !0),
      o.closable && !o.disabled ? (f(), M("span", uA, [
        W(a5, {
          name: "cancel",
          onClick: K5(n, ["stop"])
        })
      ])) : C("", !0)
    ], 2));
  }
}), De = Object.freeze(
  (() => {
    const l = "totem-teleport-target";
    return {
      destination: `#${l}`,
      destinationId: l
    };
  })()
), W7 = q(), cA = $(
  () => W7.value !== void 0
), K7 = /* @__PURE__ */ R({
  __name: "TotemTeleport",
  setup(l) {
    return (e, t) => V(cA) ? (f(), L(ql, {
      key: 0,
      to: V(De).destination
    }, [
      p(e.$slots, "default")
    ], 8, ["to"])) : C("", !0);
  }
}), o2 = 40, X7 = /* @__PURE__ */ R({
  __name: "TotemChipList",
  props: {
    items: {},
    closable: { type: Boolean },
    disabled: { type: Boolean },
    oneLine: { type: Boolean },
    mapLabel: {},
    mapDetail: {},
    mapColor: {},
    mapIconName: {},
    mapDisabled: {},
    mapClosable: {}
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = (B) => {
      n("close", B);
    }, r = (B) => {
      var k, S, Z, j, t5, u5;
      return {
        key: P5(),
        label: ((k = t.mapLabel) == null ? void 0 : k.call(t, B)) ?? void 0,
        detail: ((S = t.mapDetail) == null ? void 0 : S.call(t, B)) ?? void 0,
        color: ((Z = t.mapColor) == null ? void 0 : Z.call(t, B)) ?? void 0,
        iconName: ((j = t.mapIconName) == null ? void 0 : j.call(t, B)) ?? void 0,
        disabled: ((t5 = t.mapDisabled) == null ? void 0 : t5.call(t, B)) ?? t.disabled ?? void 0,
        closable: ((u5 = t.mapClosable) == null ? void 0 : u5.call(t, B)) ?? t.closable,
        item: B
      };
    }, s = $(() => {
      var B;
      return ((B = t.items) == null ? void 0 : B.map(r)) ?? [];
    }), c = (B) => `label-${B.key}`, u = (B) => `detail-${B.key}`, v = (B) => `icon-${B.key}`, h = q(), m = q(), b = q(), g = q(), y = q(), z = q([]), _ = () => {
      m.value && (y.value = {
        width: m.value.getBoundingClientRect().width
      }), y.value = void 0;
    }, H = () => g.value && h.value ? g.value.scrollWidth + o2 > h.value.clientWidth : !1, E = () => z.value.reduce((B, k, S) => (h.value && k.$el.offsetLeft + k.$el.offsetWidth + o2 > h.value.clientWidth && B.push(S), B), []), x = (B) => ({
      key: "plus-n",
      label: `+${B}`,
      item: void 0
    }), D = () => {
      const B = E(), k = s.value.reduce((S, Z, j) => (B.includes(j) || S.push(Z), S), []);
      return k.push(x(B.length)), k;
    }, F = () => {
      _5(() => {
        t.oneLine && H() ? b.value = D() : b.value = s.value;
      });
    };
    return h5(
      [s, () => t.oneLine],
      () => {
        _(), F();
      },
      { immediate: !0 }
    ), V1(h, () => {
      _(), F();
    }), (B, k) => (f(), M("div", {
      ref_key: "chipList",
      ref: h,
      class: J(["totem-chip-list", {
        "totem-chip-list--one-line": B.oneLine
      }])
    }, [
      b.value && b.value.length ? (f(), M("div", {
        key: 0,
        ref_key: "visibleWrapper",
        ref: m,
        class: "totem-chip-list__wrapper"
      }, [
        p(B.$slots, "default", {}, () => [
          (f(!0), M(o5, null, c5(b.value, (S) => (f(), L(n2, {
            key: S.key,
            label: S.label,
            detail: S.detail,
            color: S.color,
            "icon-name": S.iconName,
            disabled: S.disabled,
            closable: S.closable,
            class: "totem-chip-list__chip",
            onClose: (Z) => o(S)
          }, r5({ _: 2 }, [
            B.$slots.label || B.$slots[c(S)] ? {
              name: "label",
              fn: w(() => [
                p(B.$slots, "label", {
                  item: S.item,
                  metadataItem: S
                }, () => [
                  p(B.$slots, c(S), {
                    item: S.item,
                    metadataItem: S
                  })
                ])
              ]),
              key: "0"
            } : void 0,
            B.$slots.detail || B.$slots[u(S)] ? {
              name: "detail",
              fn: w(() => [
                p(B.$slots, "detail", {
                  item: S.item,
                  metadataItem: S
                }, () => [
                  p(B.$slots, u(S), {
                    item: S.item,
                    metadataItem: S
                  })
                ])
              ]),
              key: "1"
            } : void 0,
            B.$slots.icon || B.$slots[v(S)] ? {
              name: "icon",
              fn: w(() => [
                p(B.$slots, "icon", {
                  item: S.item,
                  metadataItem: S
                }, () => [
                  p(B.$slots, v(S), {
                    item: S.item,
                    metadataItem: S
                  })
                ])
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["label", "detail", "color", "icon-name", "disabled", "closable", "onClose"]))), 128))
        ])
      ], 512)) : C("", !0),
      B.oneLine && s.value && s.value.length ? (f(), L(K7, { key: 1 }, {
        default: w(() => [
          A("div", {
            ref_key: "hiddenWrapper",
            ref: g,
            style: m5(y.value),
            class: "totem-chip-list__wrapper totem-chip-list__wrapper--hidden"
          }, [
            (f(!0), M(o5, null, c5(s.value, (S) => (f(), L(n2, {
              ref_for: !0,
              ref_key: "hiddenChips",
              ref: z,
              key: S.key,
              label: S.label,
              detail: S.detail,
              "icon-name": S.iconName,
              disabled: S.disabled,
              closable: S.closable,
              class: "totem-chip-list__chip"
            }, r5({ _: 2 }, [
              B.$slots.label || B.$slots[c(S)] ? {
                name: "label",
                fn: w(() => [
                  p(B.$slots, "label", {
                    item: S.item,
                    metadataItem: S
                  }, () => [
                    p(B.$slots, c(S), {
                      item: S.item,
                      metadataItem: S
                    })
                  ])
                ]),
                key: "0"
              } : void 0,
              B.$slots.detail || B.$slots[u(S)] ? {
                name: "detail",
                fn: w(() => [
                  p(B.$slots, "detail", {
                    item: S.item,
                    metadataItem: S
                  }, () => [
                    p(B.$slots, u(S), {
                      item: S.item,
                      metadataItem: S
                    })
                  ])
                ]),
                key: "1"
              } : void 0,
              B.$slots.icon || B.$slots[v(S)] ? {
                name: "icon",
                fn: w(() => [
                  p(B.$slots, "icon", {
                    item: S.item,
                    metadataItem: S
                  }, () => [
                    p(B.$slots, v(S), {
                      item: S.item,
                      metadataItem: S
                    })
                  ])
                ]),
                key: "2"
              } : void 0
            ]), 1032, ["label", "detail", "icon-name", "disabled", "closable"]))), 128))
          ], 4)
        ]),
        _: 3
      })) : C("", !0)
    ], 2));
  }
}), vA = { class: "totem-input__upload" }, pA = ["for"], hA = /* @__PURE__ */ R({
  __name: "TotemInputUploadChipList",
  props: {
    inputId: {},
    files: {},
    multiple: { type: Boolean }
  },
  emits: ["remove:file"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = (s) => {
      s && n("remove:file", s);
    }, r = $(() => t.multiple ? "Sélectionner des fichiers" : "Sélectionner un fichier");
    return (s, c) => (f(), M("div", vA, [
      s.files && s.files.length ? (f(), L(X7, {
        key: 0,
        items: s.files,
        "map-label": (u) => u.name,
        "map-detail": (u) => V(QV)(u.size),
        "map-closable": () => s.multiple ?? !1,
        onClose: c[0] || (c[0] = ({ item: u }) => o(u))
      }, null, 8, ["items", "map-label", "map-detail", "map-closable"])) : C("", !0),
      A("label", {
        for: s.inputId,
        class: "totem-input__upload-label"
      }, O(r.value), 9, pA)
    ]));
  }
}), mA = ["id", "type", "name", "disabled", "readonly", "placeholder", "minlength", "maxlength", "accept", "multiple"], H1 = /* @__PURE__ */ R({
  __name: "TotemInput",
  props: /* @__PURE__ */ l5({
    color: {},
    inline: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    noDivider: { type: Boolean },
    prefixIconName: {},
    affixIconName: {},
    suffixIconName: {},
    type: {},
    id: {},
    name: {},
    placeholder: {},
    minlength: {},
    maxlength: {},
    accept: {},
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {},
    files: {},
    filesModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["blur", "focus", "change"], ["update:modelValue", "update:files"]),
  setup(l, { emit: e }) {
    const t = l, n = e, o = d5(l, "modelValue"), r = d5(l, "files"), s = x1("input"), c = $(() => t.id ?? P5()), u = $(() => t.inline ? "span" : "div"), v = Fl(), { isFocused: h, triggerFocus: m } = $1(s), { isTypeFile: b, onStartUploadingFiles: g, onUpdateUploadedFiles: y, onRemoveFile: z, onRemoveAllFiles: _ } = lA(
      s,
      () => t.type,
      r,
      o
    ), H = $(() => !!v.prefix || !!t.prefixIconName), E = $(() => {
      var k;
      return !!v.affix || !!t.affixIconName || !!((k = r.value) != null && k.length);
    }), x = $(() => !!v.suffix || !!t.suffixIconName || b.value), D = (k) => {
      y(k), n("change", k);
    }, F = (k) => {
      n("focus", k);
    }, B = (k) => {
      n("blur", k);
    };
    return (k, S) => (f(), L(V5(u.value), {
      "data-test": "root",
      class: J(["totem-input", [
        {
          "totem-input--inline": k.inline,
          "totem-input--focused": V(h),
          "totem-input--disabled": k.disabled,
          "totem-input--readonly": k.readonly,
          [`totem-input--color-${k.color}`]: k.color
        }
      ]]),
      tabindex: "-1"
    }, {
      default: w(() => [
        H.value ? (f(), L(V5(u.value), {
          key: 0,
          class: "totem-input__prefix",
          "data-test": "prefix",
          onClick: V(m)
        }, {
          default: w(() => [
            p(k.$slots, "prefix", {}, () => [
              k.prefixIconName ? (f(), L(a5, {
                key: 0,
                name: k.prefixIconName
              }, null, 8, ["name"])) : C("", !0)
            ])
          ]),
          _: 3
        }, 8, ["onClick"])) : C("", !0),
        p(k.$slots, "upload", {}, () => [
          V(b) ? (f(), L(hA, {
            key: 0,
            "input-id": c.value,
            multiple: k.multiple,
            files: l.files,
            "onRemove:file": V(z)
          }, null, 8, ["input-id", "multiple", "files", "onRemove:file"])) : C("", !0)
        ]),
        p(k.$slots, "default", {}, () => [
          Y5(A("input", {
            id: c.value,
            ref: "input",
            "onUpdate:modelValue": S[0] || (S[0] = (Z) => o.value = Z),
            tabindex: "0",
            type: k.type,
            name: k.name,
            disabled: k.disabled,
            readonly: k.readonly,
            placeholder: k.placeholder,
            minlength: k.minlength,
            maxlength: k.maxlength,
            accept: k.accept,
            multiple: k.multiple,
            class: "totem-input__input",
            "data-test": "input",
            onFocus: F,
            onBlur: B,
            onChange: D
          }, null, 40, mA), [
            [$7, o.value]
          ])
        ]),
        E.value ? (f(), L(V5(u.value), {
          key: 1,
          class: "totem-input__affix",
          "data-test": "affix",
          onClick: V(m)
        }, {
          default: w(() => [
            p(k.$slots, "affix", {}, () => {
              var Z;
              return [
                k.affixIconName ? (f(), L(a5, {
                  key: 0,
                  name: k.affixIconName
                }, null, 8, ["name"])) : C("", !0),
                (Z = l.files) != null && Z.length ? (f(), L(N5, {
                  key: 1,
                  size: "s",
                  color: "text",
                  "icon-name": "cancel",
                  onClick: V(_)
                }, null, 8, ["onClick"])) : C("", !0)
              ];
            })
          ]),
          _: 3
        }, 8, ["onClick"])) : C("", !0),
        x.value && !k.noDivider ? (f(), L(G1, {
          key: 2,
          vertical: "",
          class: "totem-input__suffix-divider"
        })) : C("", !0),
        x.value ? (f(), L(V5(u.value), {
          key: 3,
          class: "totem-input__suffix",
          "data-test": "suffix",
          onClick: V(m)
        }, {
          default: w(() => [
            p(k.$slots, "suffix", {}, () => [
              k.suffixIconName ? (f(), L(a5, {
                key: 0,
                name: k.suffixIconName
              }, null, 8, ["name"])) : C("", !0),
              V(b) ? (f(), L(N5, {
                key: 1,
                size: "s",
                color: "text",
                "icon-name": "upload",
                onClick: V(g)
              }, null, 8, ["onClick"])) : C("", !0)
            ])
          ]),
          _: 3
        }, 8, ["onClick"])) : C("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), fA = (l, e, t) => {
  const n = (v) => l.value ? l.value.findIndex(({ id: h }) => v.id === h) !== -1 : !1, o = (v, h) => {
    var m;
    v.disabled || (h ? l.value = [...l.value ?? [], v] : l.value = (m = l.value) == null ? void 0 : m.filter(({ id: b }) => v.id !== b));
  }, r = $(() => e5(e).filter(({ disabled: v }) => !v)), s = $(() => e5(t) && r.value.every(n)), c = $(() => {
    var v;
    return e5(t) && !!((v = l.value) != null && v.length) && !s.value;
  });
  return {
    mapItemChecked: n,
    onItemChecked: o,
    isAllChecked: s,
    isIndeterminate: c,
    onAllChecked: (v) => {
      e5(t) && (v ? l.value = [...r.value] : l.value = []);
    }
  };
}, J7 = () => {
  const l = (t) => "items" in t && Array.isArray(t.items);
  return { isCategory: l, isCategories: (t) => t.every(l) };
}, gA = (l) => {
  const e = (n) => n.flatMap((o) => {
    const { items: r, ...s } = o;
    return r ? e(r) : s;
  });
  return { flatItems: $(() => e(e5(l))) };
}, wA = (l, e, t, n) => {
  const o = $(() => {
    const c = e5(l), u = e5(e);
    return (u == null ? void 0 : u(c)) ?? c.label;
  }), r = $(() => {
    const c = e5(l), u = e5(t);
    return (u == null ? void 0 : u(c)) ?? c.detail;
  }), s = $(() => {
    const c = e5(l), u = e5(n);
    return (u == null ? void 0 : u(c)) ?? c.disabled;
  });
  return { label: o, detail: r, disabled: s };
}, bA = (l, e) => ({ label: $(() => {
  const n = e5(l), o = e5(e);
  return (o == null ? void 0 : o(n)) ?? n.label;
}) }), MA = (l, e) => ({ label: $(() => {
  const n = e5(l), o = e5(e);
  return (o == null ? void 0 : o(n)) ?? n.label;
}) }), yA = { class: "totem-checkbox__input-wrapper" }, VA = ["id", "disabled", "readonly"], AA = ["for"], Ee = /* @__PURE__ */ R({
  __name: "TotemCheckbox",
  props: {
    modelValue: { type: Boolean },
    label: { default: void 0 },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    indeterminate: { type: Boolean },
    id: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = q(), { isFocused: r } = $1(o), s = $({
      get: () => t.modelValue,
      set: (h) => {
        !t.disabled && !t.readonly && n("update:modelValue", h);
      }
    });
    h5(
      () => [t.indeterminate, o.value],
      () => {
        o.value && (o.value.indeterminate = t.indeterminate);
      },
      { immediate: !0 }
    );
    const c = $(() => t.modelValue && t.indeterminate), u = $(() => c.value ? "minus" : "check"), v = $(() => t.id ?? P5());
    return (h, m) => (f(), M("span", {
      class: J(["totem-checkbox", {
        "totem-checkbox--checked": h.modelValue,
        "totem-checkbox--indeterminate": h.indeterminate,
        "totem-checkbox--focused": V(r),
        "totem-checkbox--readonly": h.readonly,
        "totem-checkbox--disabled": h.disabled,
        "totem-checkbox--error": h.error
      }])
    }, [
      A("span", yA, [
        Y5(A("input", {
          id: v.value,
          ref_key: "input",
          ref: o,
          "onUpdate:modelValue": m[0] || (m[0] = (b) => s.value = b),
          type: "checkbox",
          class: "totem-checkbox__input",
          disabled: h.disabled,
          readonly: h.readonly
        }, null, 8, VA), [
          [C7, s.value]
        ]),
        u.value ? (f(), L(a5, {
          key: 0,
          class: "totem-checkbox__input-checkmark",
          name: u.value
        }, null, 8, ["name"])) : C("", !0)
      ]),
      h.label || h.$slots.default || h.$slots.label ? (f(), M("label", {
        key: 0,
        class: "totem-checkbox__label",
        for: v.value,
        "data-test": "label"
      }, [
        p(h.$slots, "default", {}, () => [
          p(h.$slots, "label", {}, () => [
            P(O(h.label), 1)
          ])
        ])
      ], 8, AA)) : C("", !0)
    ], 2));
  }
}), $A = { class: "totem-list-item__description" }, CA = {
  key: 0,
  class: "totem-list-item__label"
}, HA = {
  key: 1,
  class: "totem-list-item__detail"
}, Re = /* @__PURE__ */ R({
  __name: "TotemListItem",
  props: /* @__PURE__ */ l5({
    item: {},
    checkbox: { type: Boolean },
    mapItemDisabled: {},
    mapItemLabel: {},
    mapItemDetail: {}
  }, {
    checked: { type: Boolean },
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["click:item"], ["update:checked"]),
  setup(l, { emit: e }) {
    const t = l, n = e, o = d5(l, "checked"), { label: r, detail: s, disabled: c } = wA(
      () => t.item,
      () => t.mapItemLabel ?? void 0,
      () => t.mapItemDetail ?? void 0,
      () => t.mapItemDisabled ?? void 0
    ), u = () => {
      c.value || (t.checkbox && (o.value = !o.value), n("click:item", t.item));
    }, v = Z1(
      $(() => ({
        item: t.item,
        checked: o.value,
        label: r.value,
        detail: s.value,
        disabled: c.value
      }))
    );
    return (h, m) => (f(), M("div", {
      class: J(["totem-list-item", {
        "totem-list-item--disabled": V(c),
        "totem-list-item--with-checkbox": h.checkbox,
        "totem-list-item--checked": o.value
      }]),
      onClick: u
    }, [
      p(h.$slots, "default", C5(H5(V(v))), () => [
        p(h.$slots, "checkbox", C5(H5(V(v))), () => [
          h.checkbox ? (f(), L(Ee, {
            key: 0,
            modelValue: o.value,
            "onUpdate:modelValue": m[0] || (m[0] = (b) => o.value = b),
            disabled: V(c),
            class: "totem-list-item__checkbox"
          }, null, 8, ["modelValue", "disabled"])) : C("", !0)
        ]),
        A("span", $A, [
          p(h.$slots, "description", C5(H5(V(v))), () => [
            V(r) || h.$slots.label ? (f(), M("span", CA, [
              p(h.$slots, "label", C5(H5(V(v))), () => [
                P(O(V(r)), 1)
              ])
            ])) : C("", !0),
            V(s) || h.$slots.detail ? (f(), M("span", HA, [
              p(h.$slots, "detail", C5(H5(V(v))), () => [
                P(O(V(s)), 1)
              ])
            ])) : C("", !0)
          ])
        ])
      ])
    ], 2));
  }
}), zA = { class: "totem-list-sub-category" }, kA = { class: "totem-list-sub-category__header" }, BA = { class: "totem-list-sub-category__description" }, LA = { class: "totem-list-sub-category__label" }, _A = /* @__PURE__ */ R({
  __name: "TotemListSubCategory",
  props: {
    subCategory: {},
    checkboxes: { type: Boolean },
    mapItemChecked: {},
    mapItemDisabled: {},
    mapItemLabel: {},
    mapItemDetail: {},
    mapSubCategoryLabel: {}
  },
  emits: ["click:item", "checked:item"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = (v) => {
      n("click:item", v);
    }, r = (v, h) => {
      n("checked:item", v, h);
    }, { label: s } = bA(
      () => t.subCategory,
      () => t.mapSubCategoryLabel ?? void 0
    ), c = $(() => t.subCategory.items), u = Z1(
      $(() => ({
        subCategory: t.subCategory,
        label: s.value
      }))
    );
    return (v, h) => (f(), M("div", zA, [
      A("div", kA, [
        A("div", BA, [
          A("span", LA, [
            p(v.$slots, "label", C5(H5(V(u))), () => [
              P(O(V(s)), 1)
            ])
          ])
        ])
      ]),
      p(v.$slots, "default", C5(H5(V(u))), () => [
        (f(!0), M(o5, null, c5(c.value, (m) => (f(), L(Re, {
          key: `item-${m.id}`,
          item: m,
          checkbox: v.checkboxes,
          checked: v.mapItemChecked(m),
          "map-item-disabled": v.mapItemDisabled,
          "map-item-label": v.mapItemLabel,
          "map-item-detail": v.mapItemDetail,
          "onUpdate:checked": (b) => r(m, b),
          onClick: (b) => o(m)
        }, r5({ _: 2 }, [
          v.$slots.item ? {
            name: "default",
            fn: w((b) => [
              p(v.$slots, "item", Q({ ref_for: !0 }, b))
            ]),
            key: "0"
          } : void 0,
          v.$slots.itemCheckbox ? {
            name: "checkbox",
            fn: w((b) => [
              p(v.$slots, "itemCheckbox", Q({ ref_for: !0 }, b))
            ]),
            key: "1"
          } : void 0,
          v.$slots.itemDescription ? {
            name: "description",
            fn: w((b) => [
              p(v.$slots, "itemDescription", Q({ ref_for: !0 }, b))
            ]),
            key: "2"
          } : void 0,
          v.$slots.itemLabel ? {
            name: "label",
            fn: w((b) => [
              p(v.$slots, "itemLabel", Q({ ref_for: !0 }, b))
            ]),
            key: "3"
          } : void 0,
          v.$slots.itemDetail ? {
            name: "detail",
            fn: w((b) => [
              p(v.$slots, "itemDetail", Q({ ref_for: !0 }, b))
            ]),
            key: "4"
          } : void 0
        ]), 1032, ["item", "checkbox", "checked", "map-item-disabled", "map-item-label", "map-item-detail", "onUpdate:checked", "onClick"]))), 128))
      ])
    ]));
  }
}), TA = { class: "totem-list-category" }, SA = { class: "totem-list-category__header" }, xA = { class: "totem-list-category__description" }, DA = { class: "totem-list-category__label" }, EA = /* @__PURE__ */ R({
  __name: "TotemListCategory",
  props: {
    category: {},
    checkboxes: { type: Boolean },
    mapItemChecked: {},
    mapItemDisabled: {},
    mapItemLabel: {},
    mapItemDetail: {},
    mapSubCategoryLabel: {},
    mapCategoryLabel: {}
  },
  emits: ["click:item", "checked:item"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = (h) => {
      n("click:item", h);
    }, r = (h, m) => {
      n("checked:item", h, m);
    }, { isCategory: s } = J7(), { label: c } = MA(
      () => t.category,
      () => t.mapCategoryLabel ?? void 0
    ), u = $(() => t.category.items), v = Z1(
      $(() => ({
        category: t.category,
        label: c.value
      }))
    );
    return (h, m) => (f(), M("div", TA, [
      A("div", SA, [
        A("div", xA, [
          A("span", DA, [
            p(h.$slots, "label", C5(H5(V(v))), () => [
              P(O(V(c)), 1)
            ])
          ])
        ])
      ]),
      p(h.$slots, "default", C5(H5(V(v))), () => [
        (f(!0), M(o5, null, c5(u.value, (b) => (f(), M(o5, null, [
          V(s)(b) ? (f(), L(_A, {
            key: `sub-category-${b.id}`,
            "sub-category": b,
            checkboxes: h.checkboxes,
            "map-item-checked": h.mapItemChecked,
            "map-item-disabled": h.mapItemDisabled,
            "map-item-label": h.mapItemLabel,
            "map-item-detail": h.mapItemDetail,
            "map-sub-category-label": h.mapSubCategoryLabel,
            "onChecked:item": r,
            "onClick:item": o
          }, r5({ _: 2 }, [
            h.$slots.subCategory ? {
              name: "default",
              fn: w((g) => [
                p(h.$slots, "subCategory", Q({ ref_for: !0 }, g))
              ]),
              key: "0"
            } : void 0,
            h.$slots.subCategoryLabel ? {
              name: "label",
              fn: w((g) => [
                p(h.$slots, "subCategoryLabel", Q({ ref_for: !0 }, g))
              ]),
              key: "1"
            } : void 0,
            h.$slots.item ? {
              name: "item",
              fn: w((g) => [
                p(h.$slots, "item", Q({ ref_for: !0 }, g))
              ]),
              key: "2"
            } : void 0,
            h.$slots.itemCheckbox ? {
              name: "itemCheckbox",
              fn: w((g) => [
                p(h.$slots, "itemCheckbox", Q({ ref_for: !0 }, g))
              ]),
              key: "3"
            } : void 0,
            h.$slots.itemDescription ? {
              name: "itemDescription",
              fn: w((g) => [
                p(h.$slots, "itemDescription", Q({ ref_for: !0 }, g))
              ]),
              key: "4"
            } : void 0,
            h.$slots.itemLabel ? {
              name: "itemLabel",
              fn: w((g) => [
                p(h.$slots, "itemLabel", Q({ ref_for: !0 }, g))
              ]),
              key: "5"
            } : void 0,
            h.$slots.itemDetail ? {
              name: "itemDetail",
              fn: w((g) => [
                p(h.$slots, "itemDetail", Q({ ref_for: !0 }, g))
              ]),
              key: "6"
            } : void 0
          ]), 1032, ["sub-category", "checkboxes", "map-item-checked", "map-item-disabled", "map-item-label", "map-item-detail", "map-sub-category-label"])) : (f(), L(Re, {
            key: `item-${b.id}`,
            item: b,
            checkbox: h.checkboxes,
            checked: h.mapItemChecked(b),
            "map-item-disabled": h.mapItemDisabled,
            "map-item-label": h.mapItemLabel,
            "map-item-detail": h.mapItemDetail,
            "onUpdate:checked": (g) => r(b, g),
            onClick: (g) => o(b)
          }, r5({ _: 2 }, [
            h.$slots.item ? {
              name: "default",
              fn: w((g) => [
                p(h.$slots, "item", Q({ ref_for: !0 }, g))
              ]),
              key: "0"
            } : void 0,
            h.$slots.itemCheckbox ? {
              name: "checkbox",
              fn: w((g) => [
                p(h.$slots, "itemCheckbox", Q({ ref_for: !0 }, g))
              ]),
              key: "1"
            } : void 0,
            h.$slots.itemDescription ? {
              name: "description",
              fn: w((g) => [
                p(h.$slots, "itemDescription", Q({ ref_for: !0 }, g))
              ]),
              key: "2"
            } : void 0,
            h.$slots.itemLabel ? {
              name: "label",
              fn: w((g) => [
                p(h.$slots, "itemLabel", Q({ ref_for: !0 }, g))
              ]),
              key: "3"
            } : void 0,
            h.$slots.itemDetail ? {
              name: "detail",
              fn: w((g) => [
                p(h.$slots, "itemDetail", Q({ ref_for: !0 }, g))
              ]),
              key: "4"
            } : void 0
          ]), 1032, ["item", "checkbox", "checked", "map-item-disabled", "map-item-label", "map-item-detail", "onUpdate:checked", "onClick"]))
        ], 64))), 256))
      ])
    ]));
  }
}), RA = { class: "totem-list-header__label" }, OA = /* @__PURE__ */ R({
  __name: "TotemListHeader",
  props: /* @__PURE__ */ l5({
    indeterminate: { type: Boolean },
    offLabel: {},
    onLabel: {}
  }, {
    checked: { type: Boolean },
    checkedModifiers: {}
  }),
  emits: ["update:checked"],
  setup(l) {
    const e = l, t = d5(l, "checked"), n = $(() => t.value ? e.onLabel ?? "Tout sélectionner" : e.offLabel ?? "Tout désélectionner"), o = () => {
      t.value = !t.value;
    }, r = (s) => {
      var c;
      ((c = s.target) == null ? void 0 : c.tagName) !== "INPUT" && o();
    };
    return (s, c) => (f(), M("div", {
      class: "totem-list-header",
      onClick: r
    }, [
      p(s.$slots, "checkbox", {}, () => [
        W(Ee, {
          modelValue: t.value,
          "onUpdate:modelValue": c[0] || (c[0] = (u) => t.value = u),
          indeterminate: s.indeterminate,
          class: "totem-list-header__checkbox"
        }, null, 8, ["modelValue", "indeterminate"])
      ]),
      A("span", RA, [
        p(s.$slots, "default", {}, () => [
          P(O(n.value), 1)
        ])
      ])
    ]));
  }
}), NA = { class: "totem-list" }, IA = /* @__PURE__ */ R({
  __name: "TotemList",
  props: /* @__PURE__ */ l5({
    items: {},
    checkboxes: { type: Boolean },
    checkAll: { type: Boolean },
    checkAllOffLabel: {},
    checkAllOnLabel: {},
    mapItemDisabled: {},
    mapItemLabel: {},
    mapItemDetail: {},
    mapSubCategoryLabel: {},
    mapCategoryLabel: {}
  }, {
    checked: {},
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["click:item"], ["update:checked"]),
  setup(l, { emit: e }) {
    const t = l, n = e, o = d5(l, "checked"), { flatItems: r } = gA(() => t.items ?? []), { mapItemChecked: s, onItemChecked: c, isAllChecked: u, isIndeterminate: v, onAllChecked: h } = fA(
      o,
      r,
      () => t.checkAll
    ), { isCategory: m } = J7(), b = (g) => {
      n("click:item", g);
    };
    return (g, y) => (f(), M("div", NA, [
      g.checkboxes && g.checkAll ? (f(), L(OA, {
        key: 0,
        checked: V(u),
        indeterminate: V(v),
        "off-label": g.checkAllOffLabel,
        "on-label": g.checkAllOnLabel,
        "onUpdate:checked": V(h)
      }, null, 8, ["checked", "indeterminate", "off-label", "on-label", "onUpdate:checked"])) : C("", !0),
      p(g.$slots, "default", {}, () => [
        (f(!0), M(o5, null, c5(g.items, (z) => (f(), M(o5, null, [
          V(m)(z) ? (f(), L(EA, {
            key: `category-${z.id}`,
            category: z,
            checkboxes: g.checkboxes,
            "map-item-checked": V(s),
            "map-item-disabled": g.mapItemDisabled,
            "map-item-label": g.mapItemLabel,
            "map-item-detail": g.mapItemDetail,
            "map-sub-category-label": g.mapSubCategoryLabel,
            "map-category-label": g.mapCategoryLabel,
            "onChecked:item": V(c),
            "onClick:item": b
          }, r5({ _: 2 }, [
            g.$slots.category ? {
              name: "default",
              fn: w((_) => [
                p(g.$slots, "category", Q({ ref_for: !0 }, _))
              ]),
              key: "0"
            } : void 0,
            g.$slots.categoryLabel ? {
              name: "label",
              fn: w((_) => [
                p(g.$slots, "categoryLabel", Q({ ref_for: !0 }, _))
              ]),
              key: "1"
            } : void 0,
            g.$slots.subCategory ? {
              name: "subCategory",
              fn: w((_) => [
                p(g.$slots, "subCategory", Q({ ref_for: !0 }, _))
              ]),
              key: "2"
            } : void 0,
            g.$slots.subCategoryLabel ? {
              name: "subCategoryLabel",
              fn: w((_) => [
                p(g.$slots, "subCategoryLabel", Q({ ref_for: !0 }, _))
              ]),
              key: "3"
            } : void 0,
            g.$slots.item ? {
              name: "item",
              fn: w((_) => [
                p(g.$slots, "item", Q({ ref_for: !0 }, _))
              ]),
              key: "4"
            } : void 0,
            g.$slots.itemCheckbox ? {
              name: "itemCheckbox",
              fn: w((_) => [
                p(g.$slots, "itemCheckbox", Q({ ref_for: !0 }, _))
              ]),
              key: "5"
            } : void 0,
            g.$slots.itemDescription ? {
              name: "itemDescription",
              fn: w((_) => [
                p(g.$slots, "itemDescription", Q({ ref_for: !0 }, _))
              ]),
              key: "6"
            } : void 0,
            g.$slots.itemLabel ? {
              name: "itemLabel",
              fn: w((_) => [
                p(g.$slots, "itemLabel", Q({ ref_for: !0 }, _))
              ]),
              key: "7"
            } : void 0,
            g.$slots.itemDetail ? {
              name: "itemDetail",
              fn: w((_) => [
                p(g.$slots, "itemDetail", Q({ ref_for: !0 }, _))
              ]),
              key: "8"
            } : void 0
          ]), 1032, ["category", "checkboxes", "map-item-checked", "map-item-disabled", "map-item-label", "map-item-detail", "map-sub-category-label", "map-category-label", "onChecked:item"])) : (f(), L(Re, {
            key: `item-${z.id}`,
            item: z,
            checkbox: g.checkboxes,
            checked: V(s)(z),
            "map-item-disabled": g.mapItemDisabled,
            "map-item-label": g.mapItemLabel,
            "map-item-detail": g.mapItemDetail,
            "onUpdate:checked": (_) => V(c)(z, _),
            "onClick:item": (_) => b(z)
          }, r5({ _: 2 }, [
            g.$slots.item ? {
              name: "default",
              fn: w((_) => [
                p(g.$slots, "item", Q({ ref_for: !0 }, _))
              ]),
              key: "0"
            } : void 0,
            g.$slots.itemCheckbox ? {
              name: "checkbox",
              fn: w((_) => [
                p(g.$slots, "itemCheckbox", Q({ ref_for: !0 }, _))
              ]),
              key: "1"
            } : void 0,
            g.$slots.itemDescription ? {
              name: "description",
              fn: w((_) => [
                p(g.$slots, "itemDescription", Q({ ref_for: !0 }, _))
              ]),
              key: "2"
            } : void 0,
            g.$slots.itemLabel ? {
              name: "label",
              fn: w((_) => [
                p(g.$slots, "itemLabel", Q({ ref_for: !0 }, _))
              ]),
              key: "3"
            } : void 0,
            g.$slots.itemDetail ? {
              name: "detail",
              fn: w((_) => [
                p(g.$slots, "itemDetail", Q({ ref_for: !0 }, _))
              ]),
              key: "4"
            } : void 0
          ]), 1032, ["item", "checkbox", "checked", "map-item-disabled", "map-item-label", "map-item-detail", "onUpdate:checked", "onClick:item"]))
        ], 64))), 256))
      ])
    ]));
  }
}), qA = /* @__PURE__ */ R({
  __name: "TotemAutoComplete",
  props: /* @__PURE__ */ l5({
    id: {},
    name: {},
    placeholder: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    color: {},
    suggestions: {},
    defaultSortEnabled: { type: Boolean },
    defaultFilterEnabled: { type: Boolean },
    selectedFirstDisabled: { type: Boolean },
    mapValue: {},
    mapLabel: {},
    mapDetail: {},
    mapDisabled: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["click:item"], ["update:modelValue"]),
  setup(l, { expose: e, emit: t }) {
    const n = l, o = t, r = d5(l, "modelValue");
    function s() {
      return {
        mappedSuggestions: $(() => n.suggestions ? n.suggestions.map((j) => {
          var t5, u5, f5, N;
          return {
            id: j.id,
            value: ((t5 = n.mapValue) == null ? void 0 : t5.call(n, j)) ?? j.value,
            label: ((u5 = n.mapLabel) == null ? void 0 : u5.call(n, j)) ?? j.label,
            detail: ((f5 = n.mapDetail) == null ? void 0 : f5.call(n, j)) ?? j.detail,
            disabled: ((N = n.mapDisabled) == null ? void 0 : N.call(n, j)) ?? j.disabled ?? n.disabled
          };
        }) : [])
      };
    }
    const { mappedSuggestions: c } = s();
    function u() {
      const Z = q(), j = q(), t5 = q(!1);
      function u5() {
        n.disabled || n.readonly || (j.value = r.value, _5(() => {
          var G;
          ((G = Z.value) == null ? void 0 : G.$refs.input).focus();
        }), r.value && K.value.length > 0 && B());
      }
      function f5() {
        n.disabled || n.readonly || (F.value = !1, _5(() => {
          var G;
          ((G = Z.value) == null ? void 0 : G.$refs.input).blur();
        }));
      }
      function N() {
        r.value = j.value, j.value = void 0, _5(() => {
          f5();
        });
      }
      function Y(G) {
        t5.value = !0, r.value = G.value, o("click:item", G), f5();
      }
      const K = $(() => {
        const G = (T) => [...T].sort((I, U) => !I.label || !U.label ? 0 : I.label.localeCompare(U.label)), i5 = (T) => T.reduce((I, U) => (U.value === r.value ? I.unshift(U) : I.push(U), I), []), A5 = n.defaultFilterEnabled ? He(c.value, r.value) : c.value, M5 = n.defaultSortEnabled ? G(A5) : A5;
        return n.selectedFirstDisabled ? M5 : i5(M5);
      }), n5 = $(() => !n.disabled && !n.readonly && !!r.value);
      return h5(K, () => {
        if (t5.value) {
          t5.value = !1;
          return;
        }
        if (K.value.length === 0) {
          F.value = !1;
          return;
        }
        F.value || B();
      }), {
        inputRef: Z,
        onSuggestionSelection: Y,
        putFocusOnInput: u5,
        blurInput: f5,
        escapeInput: N,
        internalSuggestions: K,
        isAffixVisible: n5
      };
    }
    const {
      onSuggestionSelection: v,
      inputRef: h,
      putFocusOnInput: m,
      blurInput: b,
      escapeInput: g,
      internalSuggestions: y,
      isAffixVisible: z
    } = u();
    function _() {
      const Z = {
        danger: "warning-triangle",
        warning: "warning-triangle",
        default: void 0
      };
      return {
        colorIconName: $(() => {
          if (!n.disabled && !n.readonly && !F.value && n.color)
            return Z[n.color];
        })
      };
    }
    const { colorIconName: H } = _(), { dropdownContentStyle: E, updateDropdownContentStyle: x } = ze("totem-autocomplete");
    function D() {
      const Z = q(!1), j = q(-1), t5 = q(null);
      function u5(G) {
        switch (G.key) {
          case "Tab":
            b();
            break;
          case "Enter":
            Z.value ? K(j.value) : b();
            break;
          case "Escape":
            g();
            break;
          case "ArrowDown":
            N();
            break;
          case "ArrowUp":
            Y();
            break;
        }
      }
      function f5() {
        n.disabled || n.readonly || (Z.value = !0);
      }
      function N() {
        let G = j.value;
        const i5 = j.value;
        do
          G = (G + 1) % y.value.length;
        while (y.value[G].disabled && G !== j.value);
        y.value[G].disabled || (j.value = G, n5(i5));
      }
      function Y() {
        let G = j.value;
        const i5 = j.value;
        do
          G = (G - 1 + y.value.length) % y.value.length;
        while (y.value[G].disabled && G !== j.value);
        y.value[G].disabled || (j.value = G, n5(i5));
      }
      function K(G) {
        G >= 0 && G < y.value.length && !y.value[G].disabled && v(y.value[G]);
      }
      function n5(G) {
        _5(() => {
          var A5;
          const i5 = t5.value;
          if (i5) {
            const T = i5.querySelectorAll(".totem-autocomplete__dropdown-content > *")[0].querySelectorAll(".totem-list-item"), I = T[j.value];
            I && ((A5 = T[G]) == null || A5.classList.remove("totem-list-item--highlighted"), I.classList.add("totem-list-item--highlighted"), I.scrollIntoView({ block: "nearest" }));
          }
        });
      }
      return h5(y, () => {
        j.value = -1;
      }), {
        isDropdownExpanded: Z,
        openDropdown: f5,
        focusNextSuggestion: N,
        focusPreviousSuggestion: Y,
        selectSuggestion: K,
        dropdownContentRef: t5,
        handleKeydown: u5
      };
    }
    const { isDropdownExpanded: F, openDropdown: B, dropdownContentRef: k, handleKeydown: S } = D();
    return e({
      putFocusOnInput: m
    }), (Z, j) => (f(), M("div", {
      class: J(["totem-autocomplete", {
        [`totem-autocomplete--color-${Z.color}`]: Z.color
      }]),
      tabindex: "-1"
    }, [
      p(Z.$slots, "default", {}, () => [
        W(ke, {
          modelValue: V(F),
          "onUpdate:modelValue": j[1] || (j[1] = (t5) => D1(F) ? F.value = t5 : null),
          class: "totem-autocomplete__dropdown",
          onRequestTargetRender: V(x)
        }, {
          trigger: w(() => [
            p(Z.$slots, "trigger", {}, () => [
              W(H1, {
                id: Z.id,
                ref_key: "inputRef",
                ref: h,
                modelValue: r.value,
                "onUpdate:modelValue": j[0] || (j[0] = (t5) => r.value = t5),
                class: "totem-autocomplete__input",
                placeholder: Z.placeholder,
                color: Z.color,
                disabled: Z.disabled,
                readonly: Z.readonly,
                name: Z.name,
                onClick: V(m),
                onFocus: V(m),
                onKeydown: V(S)
              }, r5({ _: 2 }, [
                V(z) ? {
                  name: "affix",
                  fn: w(() => [
                    V(H) ? (f(), L(a5, {
                      key: 0,
                      tabindex: "-1",
                      class: "totem-autocomplete__color-icon",
                      size: "s",
                      color: "text",
                      name: V(H)
                    }, null, 8, ["name"])) : C("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["id", "modelValue", "placeholder", "color", "disabled", "readonly", "name", "onClick", "onFocus", "onKeydown"])
            ])
          ]),
          target: w(() => [
            p(Z.$slots, "target", {}, () => [
              A("div", {
                ref_key: "dropdownContentRef",
                ref: k,
                class: "totem-autocomplete__dropdown-content",
                style: m5(V(E)),
                tabindex: "-1"
              }, [
                W(IA, {
                  items: V(y),
                  "map-item-disabled": Z.mapDisabled,
                  "map-item-label": Z.mapLabel,
                  "map-item-detail": Z.mapDetail,
                  "onClick:item": V(v)
                }, {
                  itemLabel: w(({ label: t5 }) => [
                    W(Ye, {
                      content: t5,
                      search: r.value
                    }, null, 8, ["content", "search"])
                  ]),
                  itemDetail: w(({ detail: t5 }) => [
                    W(Ye, {
                      content: t5,
                      search: r.value
                    }, null, 8, ["content", "search"])
                  ]),
                  _: 1
                }, 8, ["items", "map-item-disabled", "map-item-label", "map-item-detail", "onClick:item"])
              ], 4)
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "onRequestTargetRender"])
      ])
    ], 2));
  }
}), FA = ["hidden"], PA = {
  key: 0,
  class: "totem-button__prepend",
  "data-test": "prepend"
}, ZA = {
  class: "totem-button__label",
  "data-test": "label"
}, UA = {
  key: 1,
  class: "totem-button__append",
  "data-test": "append"
}, jA = ["hidden"], GA = { key: 0 }, r2 = /* @__PURE__ */ R({
  __name: "TotemButton",
  props: {
    color: { default: "primary" },
    size: { default: "m" },
    loading: { type: Boolean },
    loadingMessage: { default: void 0 },
    prependIconName: { default: void 0 },
    appendIconName: { default: void 0 },
    disabled: { type: Boolean },
    href: { default: void 0 },
    label: { default: void 0 },
    target: { default: "_self" },
    to: { default: void 0 },
    type: { default: "button" }
  },
  setup(l) {
    return (e, t) => (f(), L(C1, {
      disabled: e.disabled,
      href: e.href,
      target: e.target,
      to: e.to,
      type: e.type,
      class: J(["totem-button", {
        [`totem-button--color-${e.color}`]: e.color,
        [`totem-button--size-${e.size}`]: e.size,
        "totem-button--disabled": e.disabled,
        "totem-button--loading": e.loading,
        "totem-button--with-prepend": e.prependIconName || e.$slots.prepend,
        "totem-button--with-append": e.appendIconName || e.$slots.append
      }])
    }, {
      default: w(() => [
        A("span", {
          hidden: e.loading,
          class: "totem-button__layer totem-button__layer--body",
          "data-test": "body"
        }, [
          e.prependIconName || e.$slots.prepend ? (f(), M("span", PA, [
            p(e.$slots, "prepend", {}, () => [
              e.prependIconName ? (f(), L(a5, {
                key: 0,
                name: e.prependIconName
              }, null, 8, ["name"])) : C("", !0)
            ])
          ])) : C("", !0),
          A("span", ZA, [
            p(e.$slots, "default", {}, () => [
              P(O(e.label), 1)
            ])
          ]),
          e.appendIconName || e.$slots.append ? (f(), M("span", UA, [
            p(e.$slots, "append", {}, () => [
              e.appendIconName ? (f(), L(a5, {
                key: 0,
                name: e.appendIconName
              }, null, 8, ["name"])) : C("", !0)
            ])
          ])) : C("", !0)
        ], 8, FA),
        W(J5, { name: "totem-button__layer-" }, {
          default: w(() => [
            e.loadingMessage || e.$slots.loading || e.$slots.loadingMessage || e.loading ? (f(), M("span", {
              key: 0,
              hidden: !e.loading,
              class: "totem-button__layer totem-button__layer--loader",
              "data-test": "loading"
            }, [
              p(e.$slots, "loading", {}, () => [
                W(xe),
                e.loadingMessage || e.$slots.loadingMessage ? (f(), M("span", GA, [
                  p(e.$slots, "loadingMessage", {}, () => [
                    P(O(e.loadingMessage), 1)
                  ])
                ])) : C("", !0)
              ])
            ], 8, jA)) : C("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled", "href", "target", "to", "type", "class"]));
  }
}), WA = {
  key: 0,
  class: "totem-tag__label",
  "data-test": "label"
}, KA = {
  key: 1,
  class: "totem-tag__detail",
  "data-test": "detail"
}, XA = /* @__PURE__ */ R({
  __name: "TotemTag",
  props: {
    color: { default: "default" },
    label: { default: () => {
    } },
    detail: { default: () => {
    } }
  },
  setup(l) {
    return (e, t) => (f(), M("div", {
      class: J(["totem-tag", {
        [`totem-tag--color-${e.color}`]: e.color
      }])
    }, [
      e.label || e.$slots.label || e.$slots.default ? (f(), M("span", WA, [
        p(e.$slots, "label", {}, () => [
          p(e.$slots, "default", {}, () => [
            P(O(e.label), 1)
          ])
        ])
      ])) : C("", !0),
      e.detail || e.$slots.detail ? (f(), M("span", KA, [
        p(e.$slots, "detail", {}, () => [
          P(O(e.detail), 1)
        ])
      ])) : C("", !0)
    ], 2));
  }
}), JA = {
  key: 0,
  class: "totem-card__header",
  "data-test": "header"
}, YA = {
  key: 0,
  class: "totem-card__loader"
}, QA = ["src", "alt"], e$ = {
  key: 0,
  class: "totem-card__tags",
  "data-test": "tags"
}, l$ = { class: "totem-card__tags-wrapper" }, t$ = { class: "totem-card__content-wrapper" }, a$ = {
  key: 0,
  class: "totem-card__date",
  "data-test": "date"
}, n$ = {
  key: 1,
  class: "totem-card__title",
  "data-test": "title"
}, o$ = {
  key: 2,
  class: "totem-card__description",
  "data-test": "description"
}, r$ = {
  key: 1,
  class: "totem-card__actions",
  "data-test": "actions"
}, oB = /* @__PURE__ */ R({
  __name: "TotemCard",
  props: {
    title: { default: void 0 },
    description: { default: void 0 },
    imageSrc: { default: void 0 },
    imageSrcLoading: { type: Boolean },
    date: { default: void 0 },
    tags: { default: () => [] },
    href: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 }
  },
  emits: ["click"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = () => {
      n("click");
    }, r = $(() => t.date === void 0 || t.date === null ? "" : new Intl.DateTimeFormat("fr-FR", {}).format(t.date));
    return (s, c) => (f(), L(C1, {
      class: "totem-card",
      "data-test": "totem-card",
      href: s.href,
      target: s.target,
      to: s.to,
      onClick: o
    }, {
      default: w(() => [
        s.$slots.header || s.$slots.image || s.imageSrc || s.imageSrcLoading ? (f(), M("div", JA, [
          p(s.$slots, "header", {}, () => [
            p(s.$slots, "image", {}, () => [
              W(J5, { name: "totem-card__transition-" }, {
                default: w(() => [
                  s.imageSrcLoading ? (f(), M("div", YA, [
                    W(xe)
                  ])) : s.imageSrc ? (f(), M("img", {
                    key: 1,
                    src: s.imageSrc,
                    alt: s.title,
                    class: "totem-card__image",
                    "data-test": "image"
                  }, null, 8, QA)) : C("", !0)
                ]),
                _: 1
              })
            ]),
            s.$slots.tags || s.tags ? (f(), M("div", e$, [
              p(s.$slots, "tags", {}, () => [
                A("div", l$, [
                  (f(!0), M(o5, null, c5(s.tags, (u) => (f(), L(XA, {
                    key: u,
                    label: u,
                    color: "tertiary"
                  }, null, 8, ["label"]))), 128))
                ])
              ])
            ])) : C("", !0)
          ])
        ])) : C("", !0),
        A("div", t$, [
          s.$slots.date || s.date ? (f(), M("div", a$, [
            p(s.$slots, "date", {}, () => [
              P("Le " + O(r.value), 1)
            ])
          ])) : C("", !0),
          s.$slots.title || s.title ? (f(), M("div", n$, [
            p(s.$slots, "title", {}, () => [
              P(O(s.title), 1)
            ])
          ])) : C("", !0),
          s.$slots.description || s.description ? (f(), M("div", o$, [
            p(s.$slots, "description", {}, () => [
              P(O(s.description), 1)
            ])
          ])) : C("", !0)
        ]),
        s.$slots.actions ? (f(), M("div", r$, [
          p(s.$slots, "actions")
        ])) : C("", !0)
      ]),
      _: 3
    }, 8, ["href", "target", "to"]));
  }
});
function Me(l, e, t) {
  typeof l === "function" && (!t || t !== "titleTemplate" && !(t[0] === "o" && t[1] === "n")) && (l = l());
  let o;
  if (e && (o = e(t, l)), Array.isArray(o))
    return o.map((r) => Me(r, e));
  if ((o == null ? void 0 : o.constructor) === Object) {
    const r = {};
    for (const s of Object.keys(o))
      r[s] = Me(o[s], e, s);
    return r;
  }
  return o;
}
const s$ = (l, e) => D1(e) ? e5(e) : e, i$ = "usehead";
function d$() {
  if (Pl()) {
    const l = H7(i$);
    if (!l)
      throw new Error("useHead() was called without provide context, ensure you call it through the setup() function.");
    return l;
  }
  throw new Error("useHead() was called without provide context, ensure you call it through the setup() function.");
}
function u$(l, e = {}) {
  const t = e.head || d$();
  return t.ssr ? t.push(l || {}, e) : c$(t, l, e);
}
function c$(l, e, t = {}) {
  const n = q(!1);
  let o;
  return Zl(() => {
    const s = n.value ? {} : Me(e, s$);
    o ? o.patch(s) : o = l.push(s, t);
  }), F1() && (P1(() => {
    o.dispose();
  }), Ul(() => {
    n.value = !0;
  }), jl(() => {
    n.value = !1;
  })), o;
}
const v$ = {}, p$ = { class: "totem-layout-header" }, h$ = { class: "totem-layout-header__bar" }, m$ = {
  key: 0,
  class: "totem-layout-header__left",
  "data-test": "left"
}, f$ = {
  key: 1,
  class: "totem-layout-header__right",
  "data-test": "right"
}, g$ = {
  key: 0,
  class: "totem-layout-header__breadcrumb",
  "data-test": "breadcrumb"
};
function w$(l, e) {
  return f(), M("div", p$, [
    A("div", h$, [
      l.$slots.left ? (f(), M("div", m$, [
        p(l.$slots, "left")
      ])) : C("", !0),
      l.$slots.right ? (f(), M("div", f$, [
        p(l.$slots, "right")
      ])) : C("", !0)
    ]),
    l.$slots.breadcrumb ? (f(), M("div", g$, [
      p(l.$slots, "breadcrumb")
    ])) : C("", !0)
  ]);
}
const b$ = /* @__PURE__ */ A1(v$, [["render", w$]]), M$ = { class: "totem-layout-error-page" }, y$ = {
  class: "totem-layout-error-page__header",
  "data-test": "header"
}, V$ = {
  class: "totem-layout-error-page__header-title",
  "data-test": "header-title"
}, A$ = {
  class: "totem-layout-error-page__body",
  "data-test": "body"
}, $$ = { class: "totem-layout-error-page__body-info" }, C$ = { class: "totem-layout-error-page__body-info-prepend" }, H$ = { class: "totem-layout-error-page__body-info-append" }, z$ = {
  class: "totem-layout-error-page__title",
  "data-test": "body-title"
}, k$ = {
  class: "totem-layout-error-page__message",
  "data-test": "body-message"
}, B$ = {
  class: "totem-layout-error-page__actions",
  "data-test": "body-actions"
}, L$ = {
  class: "totem-layout-error-page__footer",
  "data-test": "footer"
}, Oe = /* @__PURE__ */ R({
  __name: "TotemLayoutErrorPage",
  props: {
    code: {},
    title: {},
    headTitle: {},
    message: {},
    iconName: {},
    homeUrl: {},
    homeTo: {}
  },
  setup(l) {
    try {
      u$({ title: $(() => l.headTitle ?? l.title) });
    } catch (n) {
      console.warn(n);
    }
    const e = q(!1);
    y1(async () => {
      e.value = !!document.referrer && document.referrer !== window.location.href;
    });
    const t = () => {
      if (!e.value)
        throw new Error("Aucune page précédente.");
      history.back();
    };
    return (n, o) => (f(), M("div", M$, [
      A("header", y$, [
        p(n.$slots, "header", {}, () => [
          W(b$, null, {
            left: w(() => [
              p(n.$slots, "headerLeft", {}, () => [
                e.value ? (f(), L(N5, {
                  key: 0,
                  "icon-name": "arrow-left",
                  color: "text",
                  size: "s",
                  onClick: t
                })) : C("", !0),
                A("div", V$, [
                  p(n.$slots, "headerTitle", {}, () => [
                    P(" Erreur " + O(n.code), 1)
                  ])
                ])
              ])
            ]),
            _: 3
          })
        ])
      ]),
      A("div", A$, [
        p(n.$slots, "body", {}, () => [
          A("div", $$, [
            A("div", C$, [
              W(a5, {
                name: n.iconName,
                class: "totem-layout-error-page__icon"
              }, null, 8, ["name"])
            ]),
            A("div", H$, [
              A("h1", z$, [
                p(n.$slots, "bodyTitle", {}, () => [
                  P(O(n.title), 1)
                ])
              ]),
              A("div", k$, [
                p(n.$slots, "default", {}, () => [
                  P(O(n.message), 1)
                ])
              ]),
              A("div", B$, [
                p(n.$slots, "bodyActions", {}, () => [
                  e.value ? (f(), L(r2, {
                    key: 0,
                    color: "secondary",
                    size: "s",
                    "prepend-icon-name": "nav-arrow-left",
                    onClick: t
                  }, {
                    default: w(() => o[0] || (o[0] = [
                      P(" Précédent ")
                    ])),
                    _: 1
                  })) : C("", !0),
                  n.homeUrl || n.homeTo ? (f(), L(r2, {
                    key: 1,
                    size: "s",
                    "prepend-icon-name": "home-simple-door",
                    href: n.homeUrl,
                    to: n.homeTo,
                    "data-test": "action-home-button"
                  }, {
                    default: w(() => o[1] || (o[1] = [
                      P(" Retour à l'accueil ")
                    ])),
                    _: 1
                  }, 8, ["href", "to"])) : C("", !0)
                ])
              ])
            ])
          ])
        ])
      ]),
      A("footer", L$, [
        p(n.$slots, "footer")
      ])
    ]));
  }
}), rB = /* @__PURE__ */ R({
  __name: "TotemErrorPageAccessDenied",
  props: {
    code: { default: "403" },
    title: { default: "Accès refusé" },
    headTitle: {},
    message: {},
    iconName: { default: "lock" },
    homeUrl: {},
    homeTo: {}
  },
  setup(l) {
    return (e, t) => (f(), L(Oe, {
      code: e.code,
      title: e.title,
      "head-title": e.headTitle,
      "icon-name": e.iconName,
      "home-url": e.homeUrl,
      "home-to": e.homeTo,
      class: "totem-error-page-access-denied"
    }, {
      default: w(() => [
        p(e.$slots, "default", {}, () => [
          t[0] || (t[0] = A("p", null, [
            P(" Il semble que l'accès à cette page soit refusé. "),
            A("br"),
            P(" Si c'est une erreur, merci de nous contacter pour obtenir l'accès. ")
          ], -1))
        ])
      ]),
      header: w(() => [
        p(e.$slots, "header")
      ]),
      headerLeft: w(() => [
        p(e.$slots, "headerLeft")
      ]),
      headerTitle: w(() => [
        p(e.$slots, "headerTitle")
      ]),
      body: w(() => [
        p(e.$slots, "body")
      ]),
      bodyTitle: w(() => [
        p(e.$slots, "bodyTitle")
      ]),
      bodyActions: w(() => [
        p(e.$slots, "bodyActions")
      ]),
      footer: w(() => [
        p(e.$slots, "footer")
      ]),
      _: 3
    }, 8, ["code", "title", "head-title", "icon-name", "home-url", "home-to"]));
  }
}), sB = /* @__PURE__ */ R({
  __name: "TotemErrorPageDefault",
  props: {
    code: { default: "500" },
    title: { default: "Nous ne pouvons pas afficher la page" },
    headTitle: {},
    message: {},
    iconName: { default: "db-warning" },
    homeUrl: {},
    homeTo: {}
  },
  setup(l) {
    return (e, t) => (f(), L(Oe, {
      code: e.code,
      title: e.title,
      "head-title": e.headTitle,
      "icon-name": e.iconName,
      "home-url": e.homeUrl,
      "home-to": e.homeTo,
      class: "totem-error-page-default"
    }, {
      default: w(() => [
        p(e.$slots, "default", {}, () => [
          t[0] || (t[0] = A("p", null, "Vous pouvez retourner à la page précédente ou revenir à l'accueil.", -1))
        ])
      ]),
      header: w(() => [
        p(e.$slots, "header")
      ]),
      headerLeft: w(() => [
        p(e.$slots, "headerLeft")
      ]),
      headerTitle: w(() => [
        p(e.$slots, "headerTitle")
      ]),
      body: w(() => [
        p(e.$slots, "body")
      ]),
      bodyTitle: w(() => [
        p(e.$slots, "bodyTitle")
      ]),
      bodyActions: w(() => [
        p(e.$slots, "bodyActions")
      ]),
      footer: w(() => [
        p(e.$slots, "footer")
      ]),
      _: 3
    }, 8, ["code", "title", "head-title", "icon-name", "home-url", "home-to"]));
  }
}), iB = /* @__PURE__ */ R({
  __name: "TotemErrorPageNotFound",
  props: {
    code: { default: "404" },
    title: { default: "La page est introuvable" },
    headTitle: { default: "Page introuvable" },
    message: {},
    iconName: { default: "search" },
    homeUrl: {},
    homeTo: {}
  },
  setup(l) {
    return (e, t) => (f(), L(Oe, {
      code: e.code,
      title: e.title,
      "head-title": e.headTitle,
      "icon-name": e.iconName,
      "home-url": e.homeUrl,
      "home-to": e.homeTo,
      class: "totem-error-page-not-found"
    }, {
      default: w(() => [
        p(e.$slots, "default", {}, () => [
          t[0] || (t[0] = A("div", { class: "totem-error-page-not-found__content" }, [
            A("p", null, "Nous ne trouvons pas la page que vous recherchez."),
            A("p", null, "Vous pouvez retourner à la page précédente ou revenir à l'accueil.")
          ], -1))
        ])
      ]),
      header: w(() => [
        p(e.$slots, "header")
      ]),
      headerLeft: w(() => [
        p(e.$slots, "headerLeft")
      ]),
      headerTitle: w(() => [
        p(e.$slots, "headerTitle")
      ]),
      body: w(() => [
        p(e.$slots, "body")
      ]),
      bodyTitle: w(() => [
        p(e.$slots, "bodyTitle")
      ]),
      bodyActions: w(() => [
        p(e.$slots, "bodyActions")
      ]),
      footer: w(() => [
        p(e.$slots, "footer")
      ]),
      _: 3
    }, 8, ["code", "title", "head-title", "icon-name", "home-url", "home-to"]));
  }
}), c1 = Math.min, W5 = Math.max, I1 = Math.round, B1 = Math.floor, T5 = (l) => ({
  x: l,
  y: l
});
function ye(l, e, t) {
  return W5(l, c1(e, t));
}
function W1(l, e) {
  return typeof l == "function" ? l(e) : l;
}
function K1(l) {
  return l.split("-")[0];
}
function Ne(l) {
  return l.split("-")[1];
}
function Y7(l) {
  return l === "x" ? "y" : "x";
}
function Q7(l) {
  return l === "y" ? "height" : "width";
}
function X1(l) {
  return ["top", "bottom"].includes(K1(l)) ? "y" : "x";
}
function el(l) {
  return Y7(X1(l));
}
function _$(l) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...l
  };
}
function ll(l) {
  return typeof l != "number" ? _$(l) : {
    top: l,
    right: l,
    bottom: l,
    left: l
  };
}
function q1(l) {
  const {
    x: e,
    y: t,
    width: n,
    height: o
  } = l;
  return {
    width: n,
    height: o,
    top: t,
    left: e,
    right: e + n,
    bottom: t + o,
    x: e,
    y: t
  };
}
function s2(l, e, t) {
  let {
    reference: n,
    floating: o
  } = l;
  const r = X1(e), s = el(e), c = Q7(s), u = K1(e), v = r === "y", h = n.x + n.width / 2 - o.width / 2, m = n.y + n.height / 2 - o.height / 2, b = n[c] / 2 - o[c] / 2;
  let g;
  switch (u) {
    case "top":
      g = {
        x: h,
        y: n.y - o.height
      };
      break;
    case "bottom":
      g = {
        x: h,
        y: n.y + n.height
      };
      break;
    case "right":
      g = {
        x: n.x + n.width,
        y: m
      };
      break;
    case "left":
      g = {
        x: n.x - o.width,
        y: m
      };
      break;
    default:
      g = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ne(e)) {
    case "start":
      g[s] -= b * (t && v ? -1 : 1);
      break;
    case "end":
      g[s] += b * (t && v ? -1 : 1);
      break;
  }
  return g;
}
const T$ = async (l, e, t) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: r = [],
    platform: s
  } = t, c = r.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let v = await s.getElementRects({
    reference: l,
    floating: e,
    strategy: o
  }), {
    x: h,
    y: m
  } = s2(v, n, u), b = n, g = {}, y = 0;
  for (let z = 0; z < c.length; z++) {
    const {
      name: _,
      fn: H
    } = c[z], {
      x: E,
      y: x,
      data: D,
      reset: F
    } = await H({
      x: h,
      y: m,
      initialPlacement: n,
      placement: b,
      strategy: o,
      middlewareData: g,
      rects: v,
      platform: s,
      elements: {
        reference: l,
        floating: e
      }
    });
    h = E ?? h, m = x ?? m, g = {
      ...g,
      [_]: {
        ...g[_],
        ...D
      }
    }, F && y <= 50 && (y++, typeof F == "object" && (F.placement && (b = F.placement), F.rects && (v = F.rects === !0 ? await s.getElementRects({
      reference: l,
      floating: e,
      strategy: o
    }) : F.rects), {
      x: h,
      y: m
    } = s2(v, b, u)), z = -1);
  }
  return {
    x: h,
    y: m,
    placement: b,
    strategy: o,
    middlewareData: g
  };
};
async function S$(l, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: n,
    y: o,
    platform: r,
    rects: s,
    elements: c,
    strategy: u
  } = l, {
    boundary: v = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: m = "floating",
    altBoundary: b = !1,
    padding: g = 0
  } = W1(e, l), y = ll(g), _ = c[b ? m === "floating" ? "reference" : "floating" : m], H = q1(await r.getClippingRect({
    element: (t = await (r.isElement == null ? void 0 : r.isElement(_))) == null || t ? _ : _.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(c.floating)),
    boundary: v,
    rootBoundary: h,
    strategy: u
  })), E = m === "floating" ? {
    x: n,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c.floating)), D = await (r.isElement == null ? void 0 : r.isElement(x)) ? await (r.getScale == null ? void 0 : r.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = q1(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: E,
    offsetParent: x,
    strategy: u
  }) : E);
  return {
    top: (H.top - F.top + y.top) / D.y,
    bottom: (F.bottom - H.bottom + y.bottom) / D.y,
    left: (H.left - F.left + y.left) / D.x,
    right: (F.right - H.right + y.right) / D.x
  };
}
const x$ = (l) => ({
  name: "arrow",
  options: l,
  async fn(e) {
    const {
      x: t,
      y: n,
      placement: o,
      rects: r,
      platform: s,
      elements: c,
      middlewareData: u
    } = e, {
      element: v,
      padding: h = 0
    } = W1(l, e) || {};
    if (v == null)
      return {};
    const m = ll(h), b = {
      x: t,
      y: n
    }, g = el(o), y = Q7(g), z = await s.getDimensions(v), _ = g === "y", H = _ ? "top" : "left", E = _ ? "bottom" : "right", x = _ ? "clientHeight" : "clientWidth", D = r.reference[y] + r.reference[g] - b[g] - r.floating[y], F = b[g] - r.reference[g], B = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(v));
    let k = B ? B[x] : 0;
    (!k || !await (s.isElement == null ? void 0 : s.isElement(B))) && (k = c.floating[x] || r.floating[y]);
    const S = D / 2 - F / 2, Z = k / 2 - z[y] / 2 - 1, j = c1(m[H], Z), t5 = c1(m[E], Z), u5 = j, f5 = k - z[y] - t5, N = k / 2 - z[y] / 2 + S, Y = ye(u5, N, f5), K = !u.arrow && Ne(o) != null && N !== Y && r.reference[y] / 2 - (N < u5 ? j : t5) - z[y] / 2 < 0, n5 = K ? N < u5 ? N - u5 : N - f5 : 0;
    return {
      [g]: b[g] + n5,
      data: {
        [g]: Y,
        centerOffset: N - Y - n5,
        ...K && {
          alignmentOffset: n5
        }
      },
      reset: K
    };
  }
});
async function D$(l, e) {
  const {
    placement: t,
    platform: n,
    elements: o
  } = l, r = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), s = K1(t), c = Ne(t), u = X1(t) === "y", v = ["left", "top"].includes(s) ? -1 : 1, h = r && u ? -1 : 1, m = W1(e, l);
  let {
    mainAxis: b,
    crossAxis: g,
    alignmentAxis: y
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return c && typeof y == "number" && (g = c === "end" ? y * -1 : y), u ? {
    x: g * h,
    y: b * v
  } : {
    x: b * v,
    y: g * h
  };
}
const E$ = function(l) {
  return l === void 0 && (l = 0), {
    name: "offset",
    options: l,
    async fn(e) {
      var t, n;
      const {
        x: o,
        y: r,
        placement: s,
        middlewareData: c
      } = e, u = await D$(e, l);
      return s === ((t = c.offset) == null ? void 0 : t.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
        x: o + u.x,
        y: r + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, R$ = function(l) {
  return l === void 0 && (l = {}), {
    name: "shift",
    options: l,
    async fn(e) {
      const {
        x: t,
        y: n,
        placement: o
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (_) => {
            let {
              x: H,
              y: E
            } = _;
            return {
              x: H,
              y: E
            };
          }
        },
        ...u
      } = W1(l, e), v = {
        x: t,
        y: n
      }, h = await S$(e, u), m = X1(K1(o)), b = Y7(m);
      let g = v[b], y = v[m];
      if (r) {
        const _ = b === "y" ? "top" : "left", H = b === "y" ? "bottom" : "right", E = g + h[_], x = g - h[H];
        g = ye(E, g, x);
      }
      if (s) {
        const _ = m === "y" ? "top" : "left", H = m === "y" ? "bottom" : "right", E = y + h[_], x = y - h[H];
        y = ye(E, y, x);
      }
      const z = c.fn({
        ...e,
        [b]: g,
        [m]: y
      });
      return {
        ...z,
        data: {
          x: z.x - t,
          y: z.y - n,
          enabled: {
            [b]: r,
            [m]: s
          }
        }
      };
    }
  };
};
function J1() {
  return typeof window < "u";
}
function e1(l) {
  return Ie(l) ? (l.nodeName || "").toLowerCase() : "#document";
}
function b5(l) {
  var e;
  return (l == null || (e = l.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function E5(l) {
  var e;
  return (e = (Ie(l) ? l.ownerDocument : l.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ie(l) {
  return J1() ? l instanceof Node || l instanceof b5(l).Node : !1;
}
function B5(l) {
  return J1() ? l instanceof Element || l instanceof b5(l).Element : !1;
}
function D5(l) {
  return J1() ? l instanceof HTMLElement || l instanceof b5(l).HTMLElement : !1;
}
function i2(l) {
  return !J1() || typeof ShadowRoot > "u" ? !1 : l instanceof ShadowRoot || l instanceof b5(l).ShadowRoot;
}
function z1(l) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: n,
    display: o
  } = L5(l);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + t) && !["inline", "contents"].includes(o);
}
function O$(l) {
  return ["table", "td", "th"].includes(e1(l));
}
function Y1(l) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return l.matches(e);
    } catch {
      return !1;
    }
  });
}
function qe(l) {
  const e = Fe(), t = B5(l) ? L5(l) : l;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => t[n] ? t[n] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (t.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (t.contain || "").includes(n));
}
function N$(l) {
  let e = F5(l);
  for (; D5(e) && !v1(e); ) {
    if (qe(e))
      return e;
    if (Y1(e))
      return null;
    e = F5(e);
  }
  return null;
}
function Fe() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function v1(l) {
  return ["html", "body", "#document"].includes(e1(l));
}
function L5(l) {
  return b5(l).getComputedStyle(l);
}
function Q1(l) {
  return B5(l) ? {
    scrollLeft: l.scrollLeft,
    scrollTop: l.scrollTop
  } : {
    scrollLeft: l.scrollX,
    scrollTop: l.scrollY
  };
}
function F5(l) {
  if (e1(l) === "html")
    return l;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    l.assignedSlot || // DOM Element detected.
    l.parentNode || // ShadowRoot detected.
    i2(l) && l.host || // Fallback.
    E5(l)
  );
  return i2(e) ? e.host : e;
}
function tl(l) {
  const e = F5(l);
  return v1(e) ? l.ownerDocument ? l.ownerDocument.body : l.body : D5(e) && z1(e) ? e : tl(e);
}
function w1(l, e, t) {
  var n;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const o = tl(l), r = o === ((n = l.ownerDocument) == null ? void 0 : n.body), s = b5(o);
  if (r) {
    const c = Ve(s);
    return e.concat(s, s.visualViewport || [], z1(o) ? o : [], c && t ? w1(c) : []);
  }
  return e.concat(o, w1(o, [], t));
}
function Ve(l) {
  return l.parent && Object.getPrototypeOf(l.parent) ? l.frameElement : null;
}
function al(l) {
  const e = L5(l);
  let t = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const o = D5(l), r = o ? l.offsetWidth : t, s = o ? l.offsetHeight : n, c = I1(t) !== r || I1(n) !== s;
  return c && (t = r, n = s), {
    width: t,
    height: n,
    $: c
  };
}
function Pe(l) {
  return B5(l) ? l : l.contextElement;
}
function d1(l) {
  const e = Pe(l);
  if (!D5(e))
    return T5(1);
  const t = e.getBoundingClientRect(), {
    width: n,
    height: o,
    $: r
  } = al(e);
  let s = (r ? I1(t.width) : t.width) / n, c = (r ? I1(t.height) : t.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const I$ = /* @__PURE__ */ T5(0);
function nl(l) {
  const e = b5(l);
  return !Fe() || !e.visualViewport ? I$ : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function q$(l, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== b5(l) ? !1 : e;
}
function X5(l, e, t, n) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const o = l.getBoundingClientRect(), r = Pe(l);
  let s = T5(1);
  e && (n ? B5(n) && (s = d1(n)) : s = d1(l));
  const c = q$(r, t, n) ? nl(r) : T5(0);
  let u = (o.left + c.x) / s.x, v = (o.top + c.y) / s.y, h = o.width / s.x, m = o.height / s.y;
  if (r) {
    const b = b5(r), g = n && B5(n) ? b5(n) : n;
    let y = b, z = Ve(y);
    for (; z && n && g !== y; ) {
      const _ = d1(z), H = z.getBoundingClientRect(), E = L5(z), x = H.left + (z.clientLeft + parseFloat(E.paddingLeft)) * _.x, D = H.top + (z.clientTop + parseFloat(E.paddingTop)) * _.y;
      u *= _.x, v *= _.y, h *= _.x, m *= _.y, u += x, v += D, y = b5(z), z = Ve(y);
    }
  }
  return q1({
    width: h,
    height: m,
    x: u,
    y: v
  });
}
function Ze(l, e) {
  const t = Q1(l).scrollLeft;
  return e ? e.left + t : X5(E5(l)).left + t;
}
function ol(l, e, t) {
  t === void 0 && (t = !1);
  const n = l.getBoundingClientRect(), o = n.left + e.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    Ze(l, n)
  )), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function F$(l) {
  let {
    elements: e,
    rect: t,
    offsetParent: n,
    strategy: o
  } = l;
  const r = o === "fixed", s = E5(n), c = e ? Y1(e.floating) : !1;
  if (n === s || c && r)
    return t;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, v = T5(1);
  const h = T5(0), m = D5(n);
  if ((m || !m && !r) && ((e1(n) !== "body" || z1(s)) && (u = Q1(n)), D5(n))) {
    const g = X5(n);
    v = d1(n), h.x = g.x + n.clientLeft, h.y = g.y + n.clientTop;
  }
  const b = s && !m && !r ? ol(s, u, !0) : T5(0);
  return {
    width: t.width * v.x,
    height: t.height * v.y,
    x: t.x * v.x - u.scrollLeft * v.x + h.x + b.x,
    y: t.y * v.y - u.scrollTop * v.y + h.y + b.y
  };
}
function P$(l) {
  return Array.from(l.getClientRects());
}
function Z$(l) {
  const e = E5(l), t = Q1(l), n = l.ownerDocument.body, o = W5(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = W5(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -t.scrollLeft + Ze(l);
  const c = -t.scrollTop;
  return L5(n).direction === "rtl" && (s += W5(e.clientWidth, n.clientWidth) - o), {
    width: o,
    height: r,
    x: s,
    y: c
  };
}
function U$(l, e) {
  const t = b5(l), n = E5(l), o = t.visualViewport;
  let r = n.clientWidth, s = n.clientHeight, c = 0, u = 0;
  if (o) {
    r = o.width, s = o.height;
    const v = Fe();
    (!v || v && e === "fixed") && (c = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: c,
    y: u
  };
}
function j$(l, e) {
  const t = X5(l, !0, e === "fixed"), n = t.top + l.clientTop, o = t.left + l.clientLeft, r = D5(l) ? d1(l) : T5(1), s = l.clientWidth * r.x, c = l.clientHeight * r.y, u = o * r.x, v = n * r.y;
  return {
    width: s,
    height: c,
    x: u,
    y: v
  };
}
function d2(l, e, t) {
  let n;
  if (e === "viewport")
    n = U$(l, t);
  else if (e === "document")
    n = Z$(E5(l));
  else if (B5(e))
    n = j$(e, t);
  else {
    const o = nl(l);
    n = {
      x: e.x - o.x,
      y: e.y - o.y,
      width: e.width,
      height: e.height
    };
  }
  return q1(n);
}
function rl(l, e) {
  const t = F5(l);
  return t === e || !B5(t) || v1(t) ? !1 : L5(t).position === "fixed" || rl(t, e);
}
function G$(l, e) {
  const t = e.get(l);
  if (t)
    return t;
  let n = w1(l, [], !1).filter((c) => B5(c) && e1(c) !== "body"), o = null;
  const r = L5(l).position === "fixed";
  let s = r ? F5(l) : l;
  for (; B5(s) && !v1(s); ) {
    const c = L5(s), u = qe(s);
    !u && c.position === "fixed" && (o = null), (r ? !u && !o : !u && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || z1(s) && !u && rl(l, s)) ? n = n.filter((h) => h !== s) : o = c, s = F5(s);
  }
  return e.set(l, n), n;
}
function W$(l) {
  let {
    element: e,
    boundary: t,
    rootBoundary: n,
    strategy: o
  } = l;
  const s = [...t === "clippingAncestors" ? Y1(e) ? [] : G$(e, this._c) : [].concat(t), n], c = s[0], u = s.reduce((v, h) => {
    const m = d2(e, h, o);
    return v.top = W5(m.top, v.top), v.right = c1(m.right, v.right), v.bottom = c1(m.bottom, v.bottom), v.left = W5(m.left, v.left), v;
  }, d2(e, c, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function K$(l) {
  const {
    width: e,
    height: t
  } = al(l);
  return {
    width: e,
    height: t
  };
}
function X$(l, e, t) {
  const n = D5(e), o = E5(e), r = t === "fixed", s = X5(l, !0, r, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = T5(0);
  if (n || !n && !r)
    if ((e1(e) !== "body" || z1(o)) && (c = Q1(e)), n) {
      const b = X5(e, !0, r, e);
      u.x = b.x + e.clientLeft, u.y = b.y + e.clientTop;
    } else o && (u.x = Ze(o));
  const v = o && !n && !r ? ol(o, c) : T5(0), h = s.left + c.scrollLeft - u.x - v.x, m = s.top + c.scrollTop - u.y - v.y;
  return {
    x: h,
    y: m,
    width: s.width,
    height: s.height
  };
}
function p0(l) {
  return L5(l).position === "static";
}
function u2(l, e) {
  if (!D5(l) || L5(l).position === "fixed")
    return null;
  if (e)
    return e(l);
  let t = l.offsetParent;
  return E5(l) === t && (t = t.ownerDocument.body), t;
}
function sl(l, e) {
  const t = b5(l);
  if (Y1(l))
    return t;
  if (!D5(l)) {
    let o = F5(l);
    for (; o && !v1(o); ) {
      if (B5(o) && !p0(o))
        return o;
      o = F5(o);
    }
    return t;
  }
  let n = u2(l, e);
  for (; n && O$(n) && p0(n); )
    n = u2(n, e);
  return n && v1(n) && p0(n) && !qe(n) ? t : n || N$(l) || t;
}
const J$ = async function(l) {
  const e = this.getOffsetParent || sl, t = this.getDimensions, n = await t(l.floating);
  return {
    reference: X$(l.reference, await e(l.floating), l.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Y$(l) {
  return L5(l).direction === "rtl";
}
const Q$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: F$,
  getDocumentElement: E5,
  getClippingRect: W$,
  getOffsetParent: sl,
  getElementRects: J$,
  getClientRects: P$,
  getDimensions: K$,
  getScale: d1,
  isElement: B5,
  isRTL: Y$
};
function il(l, e) {
  return l.x === e.x && l.y === e.y && l.width === e.width && l.height === e.height;
}
function eC(l, e) {
  let t = null, n;
  const o = E5(l);
  function r() {
    var c;
    clearTimeout(n), (c = t) == null || c.disconnect(), t = null;
  }
  function s(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), r();
    const v = l.getBoundingClientRect(), {
      left: h,
      top: m,
      width: b,
      height: g
    } = v;
    if (c || e(), !b || !g)
      return;
    const y = B1(m), z = B1(o.clientWidth - (h + b)), _ = B1(o.clientHeight - (m + g)), H = B1(h), x = {
      rootMargin: -y + "px " + -z + "px " + -_ + "px " + -H + "px",
      threshold: W5(0, c1(1, u)) || 1
    };
    let D = !0;
    function F(B) {
      const k = B[0].intersectionRatio;
      if (k !== u) {
        if (!D)
          return s();
        k ? s(!1, k) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      k === 1 && !il(v, l.getBoundingClientRect()) && s(), D = !1;
    }
    try {
      t = new IntersectionObserver(F, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(F, x);
    }
    t.observe(l);
  }
  return s(!0), r;
}
function lC(l, e, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = n, v = Pe(l), h = o || r ? [...v ? w1(v) : [], ...w1(e)] : [];
  h.forEach((H) => {
    o && H.addEventListener("scroll", t, {
      passive: !0
    }), r && H.addEventListener("resize", t);
  });
  const m = v && c ? eC(v, t) : null;
  let b = -1, g = null;
  s && (g = new ResizeObserver((H) => {
    let [E] = H;
    E && E.target === v && g && (g.unobserve(e), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var x;
      (x = g) == null || x.observe(e);
    })), t();
  }), v && !u && g.observe(v), g.observe(e));
  let y, z = u ? X5(l) : null;
  u && _();
  function _() {
    const H = X5(l);
    z && !il(z, H) && t(), z = H, y = requestAnimationFrame(_);
  }
  return t(), () => {
    var H;
    h.forEach((E) => {
      o && E.removeEventListener("scroll", t), r && E.removeEventListener("resize", t);
    }), m == null || m(), (H = g) == null || H.disconnect(), g = null, u && cancelAnimationFrame(y);
  };
}
const tC = E$, aC = R$, nC = x$, oC = (l, e, t) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: Q$,
    ...t
  }, r = {
    ...o.platform,
    _c: n
  };
  return T$(l, e, {
    ...o,
    platform: r
  });
};
function rC(l) {
  return l != null && typeof l == "object" && "$el" in l;
}
function Ae(l) {
  if (rC(l)) {
    const e = l.$el;
    return Ie(e) && e1(e) === "#comment" ? null : e;
  }
  return l;
}
function s1(l) {
  return typeof l == "function" ? l() : V(l);
}
function sC(l) {
  return {
    name: "arrow",
    options: l,
    fn(e) {
      const t = Ae(s1(l.element));
      return t == null ? {} : nC({
        element: t,
        padding: l.padding
      }).fn(e);
    }
  };
}
function dl(l) {
  return typeof window > "u" ? 1 : (l.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function c2(l, e) {
  const t = dl(l);
  return Math.round(e * t) / t;
}
function iC(l, e, t) {
  t === void 0 && (t = {});
  const n = t.whileElementsMounted, o = $(() => {
    var k;
    return (k = s1(t.open)) != null ? k : !0;
  }), r = $(() => s1(t.middleware)), s = $(() => {
    var k;
    return (k = s1(t.placement)) != null ? k : "bottom";
  }), c = $(() => {
    var k;
    return (k = s1(t.strategy)) != null ? k : "absolute";
  }), u = $(() => {
    var k;
    return (k = s1(t.transform)) != null ? k : !0;
  }), v = $(() => Ae(l.value)), h = $(() => Ae(e.value)), m = q(0), b = q(0), g = q(c.value), y = q(s.value), z = A7({}), _ = q(!1), H = $(() => {
    const k = {
      position: g.value,
      left: "0",
      top: "0"
    };
    if (!h.value)
      return k;
    const S = c2(h.value, m.value), Z = c2(h.value, b.value);
    return u.value ? {
      ...k,
      transform: "translate(" + S + "px, " + Z + "px)",
      ...dl(h.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: g.value,
      left: S + "px",
      top: Z + "px"
    };
  });
  let E;
  function x() {
    if (v.value == null || h.value == null)
      return;
    const k = o.value;
    oC(v.value, h.value, {
      middleware: r.value,
      placement: s.value,
      strategy: c.value
    }).then((S) => {
      m.value = S.x, b.value = S.y, g.value = S.strategy, y.value = S.placement, z.value = S.middlewareData, _.value = k !== !1;
    });
  }
  function D() {
    typeof E == "function" && (E(), E = void 0);
  }
  function F() {
    if (D(), n === void 0) {
      x();
      return;
    }
    if (v.value != null && h.value != null) {
      E = n(v.value, h.value, x);
      return;
    }
  }
  function B() {
    o.value || (_.value = !1);
  }
  return h5([r, s, c, o], x, {
    flush: "sync"
  }), h5([v, h], F, {
    flush: "sync"
  }), h5(o, B, {
    flush: "sync"
  }), y7() && V7(D), {
    x: o1(m),
    y: o1(b),
    strategy: o1(g),
    placement: o1(y),
    middlewareData: o1(z),
    isPositioned: o1(_),
    floatingStyles: H,
    update: x
  };
}
const dB = ["top", "right", "bottom", "left"], uB = ["s", "m", "l"], dC = 4, ul = "top", uC = "s", cC = (l) => {
  const e = $(() => e5(l.side) ?? ul), t = $(() => e5(l.target)), n = $(() => e5(l.floating)), o = $(() => e5(l.isManual)), r = q(!1), s = iC(t, n, {
    open: r,
    placement: e,
    middleware: [sC({ element: l.arrow }), tC(dC), aC()],
    whileElementsMounted: lC
  }), c = $(() => {
    var E, x;
    const { x: y, y: z } = s.middlewareData.value.arrow ?? {}, _ = ((E = s.middlewareData.value.shift) == null ? void 0 : E.x) ?? 0, H = ((x = s.middlewareData.value.shift) == null ? void 0 : x.y) ?? 0;
    return {
      left: y !== void 0 ? he(y - _) : "",
      top: z !== void 0 ? he(z - H) : ""
    };
  }), u = () => {
    r.value || (r.value = !0);
  }, v = () => {
    r.value && (r.value = !1);
  }, h = q(), m = (y) => {
    y.addEventListener("mouseover", u), y.addEventListener("mouseleave", v), h.value = !0;
  }, b = (y) => {
    y.removeEventListener("mouseover", u), y.removeEventListener("mouseleave", v), h.value = !1;
  }, g = (y) => {
    const z = y == null ? void 0 : y.$el;
    return z || y;
  };
  return h5(
    [t, o],
    ([y, z], [_]) => {
      const H = g(y), E = g(_);
      E && b(E), !z && H && !h.value && m(H);
    },
    { immediate: !0 }
  ), P1(() => {
    const y = g(t.value);
    y && b(y);
  }), {
    floatingStyles: s.floatingStyles,
    arrowStyles: c,
    placement: e,
    isOpen: Z1(r),
    open: u,
    close: v
  };
}, vC = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 4"
};
function pC(l, e) {
  return f(), M("svg", vC, e[0] || (e[0] = [
    A("path", { d: "M3.293 3.293a1 1 0 0 0 1.414 0L8 0H0l3.293 3.293Z" }, null, -1)
  ]));
}
const hC = { render: pC }, mC = {
  class: "totem-tooltip__body",
  "data-test": "message"
}, cl = /* @__PURE__ */ R({
  __name: "TotemTooltip",
  props: {
    message: { default: () => {
    } },
    target: { default: () => {
    } },
    side: { default: () => ul },
    maxSize: { default: () => uC }
  },
  setup(l) {
    const e = x1("floating"), t = x1("arrow"), { floatingStyles: n, arrowStyles: o, placement: r, isOpen: s } = cC({
      side: () => l.side,
      target: () => l.target,
      floating: e,
      arrow: t
    });
    return (c, u) => (f(), L(K7, null, {
      default: w(() => [
        W(J5, { name: "totem-tooltip-" }, {
          default: w(() => [
            V(s) ? (f(), M("div", {
              key: 0,
              ref: "floating",
              style: m5(V(n)),
              class: J(["totem-tooltip", {
                [`totem-tooltip--placement-${V(r)}`]: V(r),
                [`totem-tooltip--max-size-${c.maxSize}`]: c.maxSize
              }]),
              "data-test": "tooltip"
            }, [
              A("div", {
                ref: "arrow",
                class: "totem-tooltip__arrow",
                style: m5(V(o))
              }, [
                W(V(hC), { class: "totem-tooltip__arrow-icon" })
              ], 4),
              A("div", mC, [
                p(c.$slots, "default", {}, () => [
                  P(O(c.message), 1)
                ])
              ])
            ], 6)) : C("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), fC = { class: "totem-form-element__header-and-body" }, gC = {
  key: 0,
  class: "totem-form-element__header-wrapper",
  "data-test": "header-wrapper"
}, wC = ["for"], bC = {
  key: 0,
  class: "totem-form-element__optional-flag"
}, MC = {
  key: 1,
  class: "totem-form-element__required-flag"
}, yC = {
  key: 1,
  class: "totem-form-element__header-description",
  "data-test": "header-description"
}, VC = {
  class: "totem-form-element__body",
  "data-test": "body"
}, AC = {
  key: 0,
  class: "totem-form-element__bottom",
  "data-test": "bottom"
}, $C = {
  key: 0,
  class: "totem-form-element__bottom-details",
  "data-test": "bottom-details"
}, CC = {
  key: 0,
  class: "totem-form-element__bottom-details-single"
}, HC = {
  key: 1,
  class: "totem-form-element__bottom-details-list"
}, zC = {
  key: 1,
  class: "totem-form-element__bottom-link",
  "data-test": "bottom-link"
}, l1 = /* @__PURE__ */ R({
  __name: "TotemFormElement",
  props: {
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean }
  },
  setup(l) {
    const e = x1("iconHelp");
    return (t, n) => {
      var o;
      return f(), M("div", {
        class: J(["totem-form-element", {
          [`totem-form-element--color-${t.color}`]: t.color,
          "totem-form-element--slim": t.slim
        }])
      }, [
        A("div", fC, [
          t.$slots.header || t.$slots.headerLabelText || t.label || t.$slots.headerFlags || t.optionalFlag || t.requiredFlag || t.$slots.headerDescription || t.description || t.$slots.headerHelp || t.help ? (f(), M("div", {
            key: 0,
            class: J(["totem-form-element__header", { "totem-form-element--default": !t.$slots.header }]),
            "data-test": "header"
          }, [
            p(t.$slots, "header", {}, () => [
              t.label || t.$slots.headerLabelText || t.$slots.headerFlags || t.optionalFlag || t.requiredFlag || t.help || t.$slots.headerHelp ? (f(), M("div", gC, [
                t.label || t.$slots.headerLabelText ? (f(), M("label", {
                  key: 0,
                  for: t.labelFor,
                  class: "totem-form-element__header-label",
                  "data-test": "header-label"
                }, [
                  p(t.$slots, "headerLabelText", {}, () => [
                    P(O(t.label), 1)
                  ])
                ], 8, wC)) : C("", !0),
                p(t.$slots, "headerFlags", {}, () => [
                  t.optionalFlag && !t.requiredFlag ? (f(), M("span", bC, " (facultatif) ")) : C("", !0),
                  t.requiredFlag && !t.optionalFlag ? (f(), M("span", MC, " * ")) : C("", !0)
                ]),
                p(t.$slots, "headerHelp", {}, () => [
                  t.help ? (f(), M(o5, { key: 0 }, [
                    W(a5, {
                      ref: "iconHelp",
                      name: "help-circle",
                      class: "totem-form-element__header-help"
                    }, null, 512),
                    W(cl, {
                      target: V(e),
                      side: "right"
                    }, {
                      default: w(() => [
                        P(O(t.help), 1)
                      ]),
                      _: 1
                    }, 8, ["target"])
                  ], 64)) : C("", !0)
                ])
              ])) : C("", !0),
              t.$slots.headerDescription || t.description ? (f(), M("div", yC, [
                p(t.$slots, "headerDescription", {}, () => [
                  P(O(t.description), 1)
                ])
              ])) : C("", !0)
            ])
          ], 2)) : C("", !0),
          A("div", VC, [
            p(t.$slots, "default")
          ])
        ]),
        t.$slots.bottom || t.$slots.bottomDetails || t.$slots.bottomLink || (o = t.details) != null && o.length ? (f(), M("div", AC, [
          p(t.$slots, "bottom", {}, () => {
            var r;
            return [
              (r = t.details) != null && r.length || t.$slots.bottomDetails ? (f(), M("div", $C, [
                p(t.$slots, "bottomDetails", {}, () => {
                  var s;
                  return [
                    ((s = t.details) == null ? void 0 : s.length) === 1 ? (f(), M("p", CC, O(t.details[0]), 1)) : (f(), M("ul", HC, [
                      (f(!0), M(o5, null, c5(t.details, (c, u) => (f(), M("li", {
                        key: u,
                        class: "totem-form-element__bottom-details-item"
                      }, O(c), 1))), 128))
                    ]))
                  ];
                })
              ])) : C("", !0),
              t.$slots.bottomLink ? (f(), M("div", zC, [
                p(t.$slots, "bottomLink")
              ])) : C("", !0)
            ];
          })
        ])) : C("", !0)
      ], 2);
    };
  }
}), cB = /* @__PURE__ */ R({
  __name: "TotemFormElementAutoComplete",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    id: {},
    name: {},
    placeholder: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    suggestions: {},
    defaultSortEnabled: { type: Boolean },
    defaultFilterEnabled: { type: Boolean },
    selectedFirstDisabled: { type: Boolean },
    mapValue: {},
    mapLabel: {},
    mapDetail: {},
    mapDisabled: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["click:item"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, n = d5(l, "modelValue"), o = (r) => t("click:item", r);
    return (r, s) => (f(), L(l1, {
      details: r.details,
      description: r.description,
      help: r.help,
      color: r.color,
      label: r.label,
      "label-for": r.id,
      "optional-flag": r.optionalFlag,
      "required-flag": r.requiredFlag,
      class: "totem-form-element-auto-complete"
    }, r5({
      default: w(() => [
        p(r.$slots, "default", {}, () => [
          W(qA, {
            id: r.id,
            modelValue: n.value,
            "onUpdate:modelValue": s[0] || (s[0] = (c) => n.value = c),
            suggestions: r.suggestions,
            "default-sort-enabled": r.defaultSortEnabled,
            "default-filter-enabled": r.defaultFilterEnabled,
            "selected-first-disabled": r.selectedFirstDisabled,
            name: r.name,
            placeholder: r.placeholder,
            color: r.color,
            disabled: r.disabled,
            readonly: r.readonly,
            "map-value": r.mapValue,
            "map-label": r.mapLabel,
            "map-detail": r.mapDetail,
            "map-disabled": r.mapDisabled,
            "onClick:item": o
          }, r5({ _: 2 }, [
            r.$slots.actions ? {
              name: "default",
              fn: w(() => [
                p(r.$slots, "actions")
              ]),
              key: "0"
            } : void 0,
            r.$slots.trigger ? {
              name: "trigger",
              fn: w(() => [
                p(r.$slots, "trigger")
              ]),
              key: "1"
            } : void 0,
            r.$slots.target ? {
              name: "target",
              fn: w(() => [
                p(r.$slots, "target")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["id", "modelValue", "suggestions", "default-sort-enabled", "default-filter-enabled", "selected-first-disabled", "name", "placeholder", "color", "disabled", "readonly", "map-value", "map-label", "map-detail", "map-disabled"])
        ])
      ]),
      _: 2
    }, [
      r.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(r.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      r.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(r.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      r.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(r.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      r.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(r.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      r.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(r.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      r.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(r.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      r.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(r.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      r.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(r.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), vB = /* @__PURE__ */ R({
  __name: "TotemFormElementFile",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    inline: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    noDivider: { type: Boolean },
    prefixIconName: {},
    affixIconName: {},
    suffixIconName: {},
    type: {},
    id: {},
    name: {},
    placeholder: {},
    minlength: {},
    maxlength: {},
    accept: {},
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {},
    files: {},
    filesModifiers: {}
  }),
  emits: ["update:modelValue", "update:files"],
  setup(l) {
    const e = d5(l, "modelValue"), t = d5(l, "files");
    return (n, o) => (f(), L(l1, {
      details: n.details,
      description: n.description,
      help: n.help,
      color: n.color,
      label: n.label,
      "label-for": n.id,
      "optional-flag": n.optionalFlag,
      "required-flag": n.requiredFlag,
      class: "totem-form-element-file"
    }, r5({
      default: w(() => [
        p(n.$slots, "default", {}, () => [
          W(H1, {
            id: n.id,
            modelValue: e.value,
            "onUpdate:modelValue": o[0] || (o[0] = (r) => e.value = r),
            files: t.value,
            "onUpdate:files": o[1] || (o[1] = (r) => t.value = r),
            class: "totem-form-element-file__input",
            color: n.color,
            name: n.name,
            type: "file",
            accept: n.accept,
            placeholder: "Ajouter un fichier",
            readonly: n.readonly,
            disabled: n.disabled,
            multiple: n.multiple,
            inline: n.inline,
            "data-test": "totem-input"
          }, r5({ _: 2 }, [
            n.$slots.prefix ? {
              name: "prefix",
              fn: w(() => [
                p(n.$slots, "prefix")
              ]),
              key: "0"
            } : void 0,
            n.$slots.affix ? {
              name: "affix",
              fn: w(() => [
                p(n.$slots, "affix")
              ]),
              key: "1"
            } : void 0,
            n.$slots.suffix ? {
              name: "suffix",
              fn: w(() => [
                p(n.$slots, "suffix")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["id", "modelValue", "files", "color", "name", "accept", "readonly", "disabled", "multiple", "inline"])
        ])
      ]),
      _: 2
    }, [
      n.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(n.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      n.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(n.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      n.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(n.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      n.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(n.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      n.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(n.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      n.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(n.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      n.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(n.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      n.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(n.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), $e = {
  button: "button",
  radio: "radio"
}, pB = Object.values($e), v2 = (l) => `label-${l}`, p2 = (l) => `icon-${l}`, kC = { class: "totem-radio__input-wrapper" }, BC = ["id", "name", "disabled", "readonly"], LC = ["for"], _C = /* @__PURE__ */ R({
  __name: "TotemRadio",
  props: {
    modelValue: { type: Boolean },
    label: { default: void 0 },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    id: { default: void 0 },
    name: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = q(), { isFocused: r } = $1(o), s = $({
      get: () => t.modelValue,
      set: (v) => {
        !t.disabled && !t.readonly && n("update:modelValue", v);
      }
    }), c = $(() => "check"), u = $(() => t.id ?? P5());
    return (v, h) => (f(), M("span", {
      class: J(["totem-radio", {
        "totem-radio--checked": v.modelValue,
        "totem-radio--focused": V(r),
        "totem-radio--readonly": v.readonly,
        "totem-radio--disabled": v.disabled,
        "totem-radio--error": v.error
      }])
    }, [
      p(v.$slots, "default", {}, () => [
        A("span", kC, [
          Y5(A("input", {
            id: u.value,
            ref_key: "input",
            ref: o,
            "onUpdate:modelValue": h[0] || (h[0] = (m) => s.value = m),
            name: v.name,
            type: "radio",
            class: "totem-radio__input",
            disabled: v.disabled,
            readonly: v.readonly
          }, null, 8, BC), [
            [z7, s.value]
          ]),
          p(v.$slots, "icon", {}, () => [
            c.value ? (f(), L(a5, {
              key: 0,
              class: "totem-radio__input-checkmark",
              name: c.value
            }, null, 8, ["name"])) : C("", !0)
          ])
        ]),
        A("label", {
          class: "totem-radio__label",
          for: u.value,
          "data-test": "label"
        }, [
          p(v.$slots, "label", {}, () => [
            P(O(v.label), 1)
          ])
        ], 8, LC)
      ])
    ], 2));
  }
}), TC = ["id", "name", "disabled", "readonly"], SC = ["for"], xC = {
  class: "totem-radio-button__label-texte",
  "data-test": "label"
}, DC = /* @__PURE__ */ R({
  __name: "TotemRadioButton",
  props: {
    modelValue: { type: Boolean },
    label: { default: void 0 },
    iconName: { default: void 0 },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    id: { default: void 0 },
    name: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = q(), { isFocused: r } = $1(o), s = $({
      get: () => t.modelValue,
      set: (u) => {
        !t.disabled && !t.readonly && n("update:modelValue", u);
      }
    }), c = $(() => t.id ?? P5());
    return (u, v) => (f(), M("span", {
      class: J(["totem-radio-button", {
        "totem-radio-button--checked": u.modelValue,
        "totem-radio-button--focused": V(r),
        "totem-radio-button--readonly": u.readonly,
        "totem-radio-button--disabled": u.disabled,
        "totem-radio-button--error": u.error
      }])
    }, [
      Y5(A("input", {
        id: c.value,
        ref_key: "input",
        ref: o,
        "onUpdate:modelValue": v[0] || (v[0] = (h) => s.value = h),
        name: u.name,
        type: "radio",
        class: "totem-radio-button__input",
        disabled: u.disabled,
        readonly: u.readonly
      }, null, 8, TC), [
        [z7, s.value]
      ]),
      A("label", {
        class: "totem-radio-button__label",
        for: c.value
      }, [
        p(u.$slots, "default", {}, () => [
          p(u.$slots, "icon", {}, () => [
            u.iconName ? (f(), L(a5, {
              key: 0,
              class: "totem-radio-button__label-icon",
              name: u.iconName
            }, null, 8, ["name"])) : C("", !0)
          ]),
          A("span", xC, [
            p(u.$slots, "label", {}, () => [
              P(O(u.label), 1)
            ])
          ])
        ])
      ], 8, SC)
    ], 2));
  }
}), EC = /* @__PURE__ */ R({
  __name: "TotemRadioList",
  props: /* @__PURE__ */ l5({
    name: {},
    options: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean },
    iconName: {},
    type: {},
    cols: {},
    mapLabel: {},
    mapDisabled: {},
    mapReadonly: {},
    mapIconName: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, t = d5(l, "modelValue"), n = $(() => e.options ? e.options.map((v) => {
      var h, m, b, g;
      return {
        value: v.value,
        label: ((h = e.mapLabel) == null ? void 0 : h.call(e, v)) ?? v.label ?? "",
        readonly: ((m = e.mapReadonly) == null ? void 0 : m.call(e, v)) ?? v.readonly ?? e.readonly,
        disabled: ((b = e.mapDisabled) == null ? void 0 : b.call(e, v)) ?? v.disabled ?? e.disabled,
        iconName: ((g = e.mapIconName) == null ? void 0 : g.call(e, v)) ?? v.iconName ?? e.iconName,
        selected: t.value === v.value,
        option: v
      };
    }) : []), o = (v) => {
      t.value = v.value;
    }, r = $(() => e.type === $e.radio), s = $(() => e.type === $e.button), c = $(() => s.value ? DC : _C), u = $(() => e.cols !== void 0 ? { "--totem-radio-list--cols": e.cols } : {});
    return (v, h) => (f(), M("div", {
      class: J(["totem-radio-list", {
        "totem-radio-list--radio": r.value,
        "totem-radio-list--button": s.value
      }]),
      style: m5(u.value)
    }, [
      p(v.$slots, "default", {}, () => [
        (f(!0), M(o5, null, c5(n.value, (m) => (f(), L(V5(c.value), {
          key: m.value,
          error: v.error,
          name: v.name,
          value: m.value.toString(),
          label: m.label,
          readonly: m.readonly,
          disabled: m.disabled,
          "icon-name": m.iconName,
          "data-test": "radio",
          "model-value": m.selected,
          "onUpdate:modelValue": (b) => o(m)
        }, r5({ _: 2 }, [
          v.$slots.label || v.$slots[V(v2)(m.value)] ? {
            name: "label",
            fn: w(() => [
              p(v.$slots, "label", { internalOption: m }, () => [
                p(v.$slots, V(v2)(m.value), { internalOption: m }, void 0, !0)
              ], !0)
            ]),
            key: "0"
          } : void 0,
          v.$slots.icon || v.$slots[V(p2)(m.value)] ? {
            name: "icon",
            fn: w(() => [
              p(v.$slots, "icon", { internalOption: m }, () => [
                p(v.$slots, V(p2)(m.value), { internalOption: m }, void 0, !0)
              ], !0)
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["error", "name", "value", "label", "readonly", "disabled", "icon-name", "model-value", "onUpdate:modelValue"]))), 128))
      ], !0)
    ], 6));
  }
}), RC = /* @__PURE__ */ A1(EC, [["__scopeId", "data-v-c2fc9162"]]), hB = /* @__PURE__ */ R({
  __name: "TotemFormElementRadioList",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    name: {},
    options: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    iconName: {},
    type: {},
    cols: {},
    mapLabel: {},
    mapDisabled: {},
    mapReadonly: {},
    mapIconName: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = d5(l, "modelValue");
    return (t, n) => (f(), L(l1, {
      details: t.details,
      description: t.description,
      help: t.help,
      color: t.color,
      label: t.label,
      "optional-flag": t.optionalFlag,
      "required-flag": t.requiredFlag,
      class: "totem-form-element-radio-list"
    }, r5({
      default: w(() => [
        p(t.$slots, "default", {}, () => [
          W(RC, {
            modelValue: e.value,
            "onUpdate:modelValue": n[0] || (n[0] = (o) => e.value = o),
            options: t.options,
            type: t.type,
            "map-label": t.mapLabel,
            "map-disabled": t.mapDisabled,
            "map-readonly": t.mapReadonly,
            "map-icon-name": t.mapIconName,
            error: t.color === "danger",
            readonly: t.readonly,
            disabled: t.disabled,
            name: t.name,
            "icon-name": t.iconName,
            cols: t.cols
          }, r5({ _: 2 }, [
            t.$slots.icon ? {
              name: "icon",
              fn: w((o) => [
                p(t.$slots, "icon", C5(H5(o)))
              ]),
              key: "0"
            } : void 0,
            t.$slots.label ? {
              name: "label",
              fn: w((o) => [
                p(t.$slots, "label", C5(H5(o)))
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["modelValue", "options", "type", "map-label", "map-disabled", "map-readonly", "map-icon-name", "error", "readonly", "disabled", "name", "icon-name", "cols"])
        ])
      ]),
      _: 2
    }, [
      t.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(t.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      t.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(t.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      t.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(t.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      t.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(t.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      t.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(t.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      t.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(t.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      t.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(t.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      t.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(t.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "optional-flag", "required-flag"]));
  }
}), OC = 180, NC = 0, Ue = (l, e = {}) => {
  const t = e.activeAngle ?? OC, n = e.inactiveAngle ?? NC;
  return $(() => e5(l) ? t : n);
}, IC = (l, e) => {
  if (l == null || l === "")
    return !0;
  const t = Array.isArray(l);
  return e.multiple ? t : !t;
}, vl = "Aucun résultat", pl = "Essayez de modifier votre recherche.", hl = "Sélectionnez une option", qC = { class: "totem-select-option__description" }, FC = { class: "totem-select-option__label" }, PC = { class: "totem-select-option__detail" }, ml = /* @__PURE__ */ R({
  __name: "TotemSelectOption",
  props: {
    label: { default: void 0 },
    detail: { default: void 0 },
    disabled: { type: Boolean },
    selected: { type: Boolean },
    multiple: { type: Boolean },
    highlighted: { type: Boolean }
  },
  setup(l) {
    return (e, t) => (f(), M("div", {
      class: J(["totem-select-option", {
        "totem-select-option--selected": e.selected,
        "totem-select-option--disabled": e.disabled,
        "totem-select-option--multiple": e.multiple,
        "totem-select-option--highlighted": e.highlighted
      }])
    }, [
      e.multiple ? (f(), L(Ee, {
        key: 0,
        "model-value": e.selected,
        class: "totem-select-option__checkbox"
      }, null, 8, ["model-value"])) : C("", !0),
      A("span", qC, [
        A("span", FC, O(e.label), 1),
        A("span", PC, O(e.detail), 1)
      ])
    ], 2));
  }
}), ZC = {
  key: 0,
  class: "totem-select__empty-message"
}, UC = { class: "totem-select__empty-message-title" }, jC = { class: "totem-select__empty-message-text" }, GC = ["id", "name"], WC = ["value", "disabled", "selected"], KC = /* @__PURE__ */ R({
  __name: "TotemSelect",
  props: /* @__PURE__ */ l5({
    options: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    color: { default: "default" },
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: hl },
    emptyTitle: { default: vl },
    emptyMessage: { default: pl },
    preventClear: { type: Boolean },
    disabledFilterOptions: { type: Boolean },
    disabledSortOptions: { type: Boolean },
    disabledSearch: { type: Boolean },
    mapValue: { default: void 0 },
    mapLabel: { default: void 0 },
    mapDetail: { default: void 0 },
    mapDisabled: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["search"], ["update:modelValue"]),
  setup(l, { expose: e, emit: t }) {
    const n = l, o = t, r = d5(l, "modelValue"), s = $(() => n.options.map((N) => {
      var Y, K, n5, G;
      return {
        value: ((Y = n.mapValue) == null ? void 0 : Y.call(n, N)) ?? N.value,
        label: ((K = n.mapLabel) == null ? void 0 : K.call(n, N)) ?? N.label,
        detail: ((n5 = n.mapDetail) == null ? void 0 : n5.call(n, N)) ?? N.detail,
        disabled: ((G = n.mapDisabled) == null ? void 0 : G.call(n, N)) ?? N.disabled ?? n.disabled
      };
    }));
    function c() {
      return {
        isCancelAffixVisible: $(() => !E.value && !n.preventClear)
      };
    }
    const { isCancelAffixVisible: u } = c();
    function v() {
      const N = q(), Y = q(), K = q();
      function n5() {
        n.disabledSearch || n.disabled || n.readonly || (_5(() => {
          var I;
          ((I = N.value) == null ? void 0 : I.$refs.input).focus();
        }), S());
      }
      function G(I) {
        r.value = I.value, K.value = I.label, Z();
      }
      function i5() {
        if (B.value && !n.disabledSearch) {
          M5.value = void 0, n5();
          return;
        }
        r.value = void 0, K.value = "", S();
      }
      const A5 = $(() => {
        const I = (o0) => o0.sort((a1, n1) => !a1.label || !n1.label ? 0 : a1.label.localeCompare(n1.label)), U = (o0) => o0.reduce((a1, n1) => (n1.value === r.value ? a1.unshift(n1) : a1.push(n1), a1), []), X = Y.value && !n.disabledFilterOptions ? He(s.value, Y.value) : s.value, t1 = n.disabledSortOptions ? X : I(X);
        return U(t1);
      }), M5 = $({
        get: () => B.value && !n.disabledSearch ? Y.value : K.value,
        set: (I) => {
          n.disabledSearch || (Y.value = I, o("search", I));
        }
      }), T = $(() => !n.disabled && !n.readonly && !!M5.value);
      return h5(
        [r, s],
        ([I, U]) => {
          const X = U.find((t1) => t1.value === I);
          K.value = (X == null ? void 0 : X.label) || "";
        },
        { immediate: !0 }
      ), {
        inputRef: N,
        onOptionSelection: G,
        clearSelect: i5,
        putFocusOnInput: n5,
        valueOnInput: M5,
        internalOptions: A5,
        isAffixVisible: T
      };
    }
    const { onOptionSelection: h, inputRef: m, clearSelect: b, putFocusOnInput: g, valueOnInput: y, internalOptions: z, isAffixVisible: _ } = v();
    function H() {
      const N = {
        danger: "warning-triangle",
        warning: "warning-triangle",
        default: void 0
      };
      return {
        colorIconName: $(() => {
          if (!n.disabled && !n.readonly && !B.value && n.color)
            return N[n.color];
        })
      };
    }
    const { colorIconName: E } = H(), { dropdownContentStyle: x, updateDropdownContentStyle: D } = ze("totem-select");
    function F() {
      const N = q(!1), Y = q(-1), K = q(null);
      function n5(X) {
        switch (X.key) {
          case "Tab":
            i5();
            break;
          case "Enter":
          case " ":
            N.value ? I(Y.value) : G();
            break;
          case "Escape":
            i5();
            break;
          case "ArrowDown":
            M5();
            break;
          case "ArrowUp":
            T();
            break;
        }
      }
      function G() {
        n.disabled || n.readonly || (N.value || (y.value = void 0), N.value = !0);
      }
      function i5() {
        N.value = !1;
      }
      function A5() {
        N.value ? i5() : g();
      }
      function M5() {
        let X = Y.value;
        do
          X = (X + 1) % z.value.length;
        while (z.value[X].disabled && X !== Y.value);
        z.value[X].disabled || (Y.value = X, U());
      }
      function T() {
        let X = Y.value;
        do
          X = (X - 1 + z.value.length) % z.value.length;
        while (z.value[X].disabled && X !== Y.value);
        z.value[X].disabled || (Y.value = X, U());
      }
      function I(X) {
        X >= 0 && X < z.value.length && !z.value[X].disabled && (r.value = z.value[X].value), i5();
      }
      function U() {
        _5(() => {
          const X = K.value;
          if (X) {
            const t1 = X.querySelectorAll(".totem-select__dropdown-content > *")[Y.value];
            t1 && t1.scrollIntoView({ block: "nearest" });
          }
        });
      }
      return h5(z, () => {
        Y.value = -1;
      }), {
        isDropdownExpanded: N,
        focusedOptionIndex: Y,
        openDropdown: G,
        closeDropdown: i5,
        focusNextOption: M5,
        focusPreviousOption: T,
        selectOption: I,
        onButtonDropdownClick: A5,
        dropdownContentRef: K,
        handleKeydown: n5
      };
    }
    const {
      isDropdownExpanded: B,
      focusedOptionIndex: k,
      openDropdown: S,
      closeDropdown: Z,
      onButtonDropdownClick: j,
      dropdownContentRef: t5,
      handleKeydown: u5
    } = F(), f5 = Ue(B);
    return e({
      putFocusOnInput: g
    }), (N, Y) => (f(), M("div", {
      class: J(["totem-select", {
        [`totem-select--color-${N.color}`]: N.color
      }]),
      tabindex: "-1"
    }, [
      p(N.$slots, "default", {}, () => [
        W(ke, {
          modelValue: V(B),
          "onUpdate:modelValue": Y[1] || (Y[1] = (K) => D1(B) ? B.value = K : null),
          class: "totem-select__dropdown",
          onRequestTargetRender: V(D)
        }, {
          trigger: w(() => [
            p(N.$slots, "trigger", {
              actions: { handleKeydown: V(u5), clearSelect: V(b), onButtonDropdownClick: V(j) }
            }, () => [
              W(H1, {
                ref_key: "inputRef",
                ref: m,
                modelValue: V(y),
                "onUpdate:modelValue": Y[0] || (Y[0] = (K) => D1(y) ? y.value = K : null),
                class: "totem-select__input",
                placeholder: N.placeholder,
                color: N.color,
                disabled: N.disabled,
                readonly: N.readonly,
                onClick: V(g),
                onFocus: V(g),
                onKeydown: V(u5)
              }, r5({
                suffix: w(() => [
                  W(N5, {
                    tabindex: "-1",
                    "icon-rotation": V(f5),
                    size: "s",
                    color: "text",
                    "icon-name": "nav-arrow-down",
                    disabled: N.disabled || N.readonly,
                    onClick: K5(V(j), ["stop"])
                  }, null, 8, ["icon-rotation", "disabled", "onClick"])
                ]),
                _: 2
              }, [
                V(_) ? {
                  name: "affix",
                  fn: w(() => [
                    V(u) ? (f(), L(N5, {
                      key: 0,
                      class: "totem-select__clean-button",
                      size: "s",
                      color: "text",
                      "icon-name": "cancel",
                      onClick: K5(V(b), ["stop"])
                    }, null, 8, ["onClick"])) : V(E) ? (f(), L(a5, {
                      key: 1,
                      tabindex: "-1",
                      class: "totem-select__color-icon",
                      size: "s",
                      color: "text",
                      name: V(E)
                    }, null, 8, ["name"])) : C("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["modelValue", "placeholder", "color", "disabled", "readonly", "onClick", "onFocus", "onKeydown"])
            ])
          ]),
          target: w(() => [
            p(N.$slots, "target", {
              actions: { onOptionSelection: V(h) },
              options: V(z)
            }, () => [
              A("div", {
                ref_key: "dropdownContentRef",
                ref: t5,
                class: "totem-select__dropdown-content",
                style: m5(V(x)),
                tabindex: "-1"
              }, [
                (f(!0), M(o5, null, c5(V(z), (K, n5) => (f(), L(ml, {
                  key: `option-${n5}-${K.value}`,
                  tabindex: "-1",
                  label: K.label,
                  detail: K.detail,
                  disabled: K.disabled,
                  selected: r.value === K.value,
                  highlighted: V(k) === n5,
                  onClick: (G) => V(h)(K)
                }, null, 8, ["label", "detail", "disabled", "selected", "highlighted", "onClick"]))), 128)),
                V(z).length === 0 ? (f(), M("div", ZC, [
                  A("div", UC, O(N.emptyTitle), 1),
                  A("div", jC, O(N.emptyMessage), 1)
                ])) : C("", !0)
              ], 4)
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "onRequestTargetRender"]),
        A("select", {
          id: N.id,
          name: N.name,
          class: "totem-select__native-select"
        }, [
          (f(!0), M(o5, null, c5(V(z), (K, n5) => (f(), M("option", {
            key: `native-select-${n5}-${K.value}`,
            value: K.value,
            disabled: K.disabled,
            selected: r.value === K.value
          }, O(K.label), 9, WC))), 128))
        ], 8, GC)
      ])
    ], 2));
  }
}), XC = {
  key: 0,
  class: "totem-select-multiple__empty-message"
}, JC = { class: "totem-select-multiple__empty-message-title" }, YC = { class: "totem-select-multiple__empty-message-text" }, QC = ["id", "name", "multiple"], eH = ["value", "disabled", "selected"], lH = /* @__PURE__ */ R({
  __name: "TotemSelectMultiple",
  props: /* @__PURE__ */ l5({
    options: { default: () => [] },
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    color: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: hl },
    emptyTitle: { default: vl },
    emptyMessage: { default: pl },
    mapLabel: { default: void 0 },
    mapDetail: { default: void 0 },
    mapDisabled: { default: void 0 }
  }, {
    modelValue: {
      validator: IC
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = l, t = d5(l, "modelValue"), n = q(), o = q(), r = q(!1), s = q(!1), c = Ue(s), u = (T) => {
      var I, U, X;
      return {
        value: T.value,
        label: ((I = e.mapLabel) == null ? void 0 : I.call(e, T)) ?? T.label,
        detail: ((U = e.mapDetail) == null ? void 0 : U.call(e, T)) ?? T.detail,
        disabled: ((X = e.mapDisabled) == null ? void 0 : X.call(e, T)) ?? T.disabled ?? e.disabled
      };
    }, v = $(() => e.options.reduce((T, I) => (T[I.value] = u(I), T), {})), h = $(() => Object.values(v.value)), m = (T) => t.value === void 0 ? !1 : e.multiple ? Array.isArray(t.value) && t.value.includes(T) : t.value === T, b = $(() => {
      const T = (I) => I.reduce((U, X) => (m(X.value) ? U.unshift(X) : U.push(X), U), []);
      return !e.multiple && n.value && et(h.value, n.value) ? T(h.value) : T(n.value ? He(h.value, n.value) : h.value);
    }), g = $(() => t.value === void 0 ? [] : h.value.filter(({ value: T }) => m(T))), y = $(() => e.multiple && Array.isArray(t.value) ? t.value.map((T) => v.value[T]) : []), z = () => {
      e.disabled || e.readonly || (s.value = !0);
    }, _ = () => s.value = !1, H = () => s.value = !s.value, E = () => {
      if (e.multiple)
        n.value = void 0;
      else if (n.value) {
        const T = g.value.find(
          (I) => n.value && p1(I.label, n.value)
        );
        T ? n.value = T.label : n.value = void 0;
      }
    }, x = () => {
      !e.multiple && !n.value && (t.value = void 0);
    }, D = () => {
      !e.multiple && !n.value && g.value.length === 1 && (n.value = g.value[0].label);
    }, F = (T) => {
      if (e.multiple)
        throw new Error("pick() method is for simple select only.");
      t.value = T;
    }, B = (T) => {
      if (!e.multiple)
        throw new Error("toggle() method is for multiple select only.");
      Array.isArray(t.value) ? m(T) ? t.value = t.value.filter((I) => I !== T) : t.value = [...t.value, T] : t.value = [T];
    }, k = (T) => {
      e.multiple ? B(T) : F(T);
    }, S = (T) => {
      T.disabled || (k(T.value), e.multiple || (_(), n.value = T.label));
    }, Z = () => {
      r.value = !0, _5(() => {
        var T;
        ((T = o.value) == null ? void 0 : T.$refs.input).focus();
      }), z();
    }, j = () => {
      e.disabled || e.readonly || H();
    }, t5 = () => {
      z();
    }, u5 = (T) => {
      T && B(T.value);
    }, f5 = () => {
      n.value = void 0, e.multiple || (t.value = void 0), Z();
    }, N = () => {
      E(), x();
    };
    y1(() => {
      D();
    }), h5(s, (T, I) => {
      T && T !== I ? (r.value = !0, _5(() => {
        var U;
        ((U = o.value) == null ? void 0 : U.$refs.input).focus();
      })) : !T && I !== T && (r.value = !1, N());
    }), h5(
      t,
      (T) => {
        !e.multiple && !Array.isArray(T) && T && (n.value = v.value[T].label);
      },
      { immediate: !0 }
    );
    const Y = $(() => e.multiple ? Array.isArray(t.value) && t.value.length > 0 : !!t.value), K = $(() => e.multiple && !s.value && y.value.length > 0), n5 = $(() => !e.disabled && !e.readonly && (!s.value && !e.multiple && Y.value || s.value && (!!n.value || Y.value))), G = {
      danger: "warning-triangle",
      warning: "warning-triangle",
      default: void 0
    }, i5 = $(() => {
      if (!e.disabled && !e.readonly && !s.value && e.color)
        return G[e.color];
    }), { dropdownContentStyle: A5, updateDropdownContentStyle: M5 } = ze("totem-select");
    return (T, I) => (f(), M("div", {
      "data-test": "default",
      tabindex: "0",
      class: J(["totem-select-multiple", {
        "totem-select-multiple--disabled": T.disabled,
        "totem-select-multiple--readonly": T.readonly,
        "totem-select-multiple--focus": r.value,
        [`totem-select-multiple--color-${T.color}`]: T.color
      }])
    }, [
      p(T.$slots, "default", {}, () => [
        W(ke, {
          modelValue: s.value,
          "onUpdate:modelValue": I[3] || (I[3] = (U) => s.value = U),
          class: "totem-select-multiple__dropdown",
          onRequestTargetRender: V(M5)
        }, {
          trigger: w(() => [
            W(H1, {
              ref_key: "input",
              ref: o,
              modelValue: n.value,
              "onUpdate:modelValue": I[1] || (I[1] = (U) => n.value = U),
              placeholder: T.placeholder,
              color: T.color,
              disabled: T.disabled,
              readonly: T.readonly,
              onFocus: Z,
              onBlur: I[2] || (I[2] = (U) => r.value = !1)
            }, r5({
              suffix: w(() => [
                W(N5, {
                  "icon-rotation": V(c),
                  size: "s",
                  color: "text",
                  "icon-name": "nav-arrow-down",
                  disabled: T.disabled || T.readonly,
                  onClick: K5(j, ["stop"])
                }, null, 8, ["icon-rotation", "disabled"])
              ]),
              _: 2
            }, [
              K.value ? {
                name: "default",
                fn: w(() => [
                  A("div", {
                    class: "totem-select-multiple__chip-list-wrapper",
                    onClick: t5
                  }, [
                    W(X7, {
                      items: y.value,
                      "map-label": (U) => U.label,
                      closable: "",
                      "one-line": "",
                      disabled: T.disabled || T.readonly,
                      class: "totem-select-multiple__chip-list",
                      onClose: I[0] || (I[0] = ({ item: U }) => u5(U))
                    }, null, 8, ["items", "map-label", "disabled"])
                  ])
                ]),
                key: "0"
              } : void 0,
              n5.value || i5.value ? {
                name: "affix",
                fn: w(() => [
                  n5.value && !i5.value ? (f(), L(N5, {
                    key: 0,
                    size: "s",
                    color: "text",
                    "icon-name": "cancel",
                    class: "totem-select-multiple__clean-button",
                    onClick: K5(f5, ["stop"])
                  })) : i5.value ? (f(), L(a5, {
                    key: 1,
                    class: "totem-select-multiple__color-icon",
                    size: "s",
                    color: "text",
                    name: i5.value
                  }, null, 8, ["name"])) : C("", !0)
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["modelValue", "placeholder", "color", "disabled", "readonly"])
          ]),
          target: w(() => [
            A("div", {
              class: "totem-select-multiple__dropdown-content",
              style: m5(V(A5)),
              tabindex: "0"
            }, [
              (f(!0), M(o5, null, c5(b.value, (U) => (f(), L(ml, {
                key: U.value,
                label: U.label,
                detail: U.detail,
                disabled: U.disabled,
                selected: m(U.value),
                multiple: T.multiple,
                onClick: (X) => S(U)
              }, null, 8, ["label", "detail", "disabled", "selected", "multiple", "onClick"]))), 128)),
              b.value.length === 0 ? (f(), M("div", XC, [
                A("div", JC, O(T.emptyTitle), 1),
                A("div", YC, O(T.emptyMessage), 1)
              ])) : C("", !0)
            ], 4)
          ]),
          _: 1
        }, 8, ["modelValue", "onRequestTargetRender"]),
        A("select", {
          id: T.id,
          name: T.name,
          multiple: T.multiple,
          class: "totem-select-multiple__native-select"
        }, [
          (f(!0), M(o5, null, c5(h.value, (U) => (f(), M("option", {
            key: U.value,
            value: U.value,
            disabled: U.disabled,
            selected: m(U.value)
          }, O(U.label), 9, eH))), 128))
        ], 8, QC)
      ])
    ], 2));
  }
}), mB = /* @__PURE__ */ R({
  __name: "TotemFormElementSelect",
  props: {
    label: { default: void 0 },
    description: { default: void 0 },
    help: { default: void 0 },
    details: { default: () => [] },
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    options: { default: () => [] },
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    color: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: void 0 },
    emptyTitle: { default: void 0 },
    emptyMessage: { default: void 0 },
    preventClear: { type: Boolean },
    disabledFilterOptions: { type: Boolean },
    disabledSortOptions: { type: Boolean },
    disabledSearch: { type: Boolean },
    mapLabel: { default: void 0 },
    mapDetail: { default: void 0 },
    mapDisabled: { default: void 0 },
    modelValue: { default: void 0 }
  },
  emits: ["update:modelValue", "blur", "focus", "search"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = $({
      get() {
        return t.modelValue ?? "";
      },
      set(u) {
        n("update:modelValue", u);
      }
    }), r = (u) => {
      n("blur", u);
    }, s = (u) => {
      n("focus", u);
    }, c = (u) => {
      n("search", u);
    };
    return (u, v) => (f(), L(l1, {
      details: u.details,
      description: u.description,
      help: u.help,
      color: u.color,
      label: u.label,
      "label-for": u.id,
      "optional-flag": u.optionalFlag,
      "required-flag": u.requiredFlag,
      class: "totem-form-element-text"
    }, r5({
      default: w(() => [
        p(u.$slots, "default", {}, () => [
          u.multiple ? (f(), L(lH, {
            key: 1,
            id: u.id,
            modelValue: o.value,
            "onUpdate:modelValue": v[1] || (v[1] = (h) => o.value = h),
            name: u.name,
            options: u.options,
            placeholder: u.placeholder,
            color: u.color,
            disabled: u.disabled,
            readonly: u.readonly,
            "empty-title": u.emptyTitle,
            "empty-message": u.emptyMessage,
            "map-label": u.mapLabel,
            "map-detail": u.mapDetail,
            "map-disabled": u.mapDisabled,
            multiple: "",
            "data-test": "select",
            onBlur: r,
            onFocus: s
          }, null, 8, ["id", "modelValue", "name", "options", "placeholder", "color", "disabled", "readonly", "empty-title", "empty-message", "map-label", "map-detail", "map-disabled"])) : (f(), L(KC, {
            key: 0,
            id: u.id,
            modelValue: o.value,
            "onUpdate:modelValue": v[0] || (v[0] = (h) => o.value = h),
            options: u.options,
            name: u.name,
            placeholder: u.placeholder,
            "empty-title": u.emptyTitle,
            "empty-message": u.emptyMessage,
            color: u.color,
            disabled: u.disabled,
            readonly: u.readonly,
            "prevent-clear": u.preventClear,
            "disabled-filter-options": u.disabledFilterOptions,
            "disabled-sort-options": u.disabledSortOptions,
            "disabled-search": u.disabledSearch,
            "map-label": u.mapLabel,
            "map-detail": u.mapDetail,
            "map-disabled": u.mapDisabled,
            onSearch: c
          }, null, 8, ["id", "modelValue", "options", "name", "placeholder", "empty-title", "empty-message", "color", "disabled", "readonly", "prevent-clear", "disabled-filter-options", "disabled-sort-options", "disabled-search", "map-label", "map-detail", "map-disabled"]))
        ])
      ]),
      _: 2
    }, [
      u.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(u.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      u.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(u.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      u.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(u.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      u.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(u.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      u.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(u.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      u.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(u.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      u.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(u.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      u.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(u.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), fB = /* @__PURE__ */ R({
  __name: "TotemFormElementText",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    inline: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    noDivider: { type: Boolean },
    prefixIconName: {},
    affixIconName: {},
    suffixIconName: {},
    type: {},
    id: {},
    name: {},
    placeholder: {},
    minlength: {},
    maxlength: {},
    accept: {},
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["blur", "focus"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, n = d5(l, "modelValue"), o = (s) => {
      t("blur", s);
    }, r = (s) => {
      t("focus", s);
    };
    return (s, c) => (f(), L(l1, {
      details: s.details,
      description: s.description,
      help: s.help,
      color: s.color,
      label: s.label,
      "label-for": s.id,
      "optional-flag": s.optionalFlag,
      "required-flag": s.requiredFlag,
      class: "totem-form-element-text"
    }, r5({
      default: w(() => [
        p(s.$slots, "default", {}, () => [
          W(H1, {
            id: s.id,
            modelValue: n.value,
            "onUpdate:modelValue": c[0] || (c[0] = (u) => n.value = u),
            color: s.color,
            name: s.name,
            type: s.type,
            placeholder: s.placeholder,
            readonly: s.readonly,
            disabled: s.disabled,
            "prefix-icon-name": s.prefixIconName,
            "affix-icon-name": s.affixIconName,
            "suffix-icon-name": s.suffixIconName,
            minlength: s.minlength,
            maxlength: s.maxlength,
            inline: s.inline,
            "no-divider": s.noDivider,
            "data-test": "totem-input",
            onBlur: o,
            onFocus: r
          }, r5({ _: 2 }, [
            s.$slots.prefix ? {
              name: "prefix",
              fn: w(() => [
                p(s.$slots, "prefix")
              ]),
              key: "0"
            } : void 0,
            s.$slots.affix ? {
              name: "affix",
              fn: w(() => [
                p(s.$slots, "affix")
              ]),
              key: "1"
            } : void 0,
            s.$slots.suffix ? {
              name: "suffix",
              fn: w(() => [
                p(s.$slots, "suffix")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["id", "modelValue", "color", "name", "type", "placeholder", "readonly", "disabled", "prefix-icon-name", "affix-icon-name", "suffix-icon-name", "minlength", "maxlength", "inline", "no-divider"])
        ])
      ]),
      _: 2
    }, [
      s.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(s.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      s.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(s.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      s.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(s.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      s.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(s.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      s.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(s.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      s.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(s.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      s.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(s.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      s.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(s.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), tH = ["id", "name", "disabled", "readonly", "placeholder"], aH = /* @__PURE__ */ R({
  __name: "TotemTextarea",
  props: /* @__PURE__ */ l5({
    color: {},
    inline: { type: Boolean },
    modelValue: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    id: {},
    name: {},
    placeholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["blur", "focus"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = l, n = e, o = d5(l, "modelValue"), r = $(() => t.inline ? "span" : "div"), s = q(), { isFocused: c } = $1(s), u = (h) => {
      n("focus", h);
    }, v = (h) => {
      n("blur", h);
    };
    return (h, m) => (f(), L(V5(r.value), {
      "data-test": "root",
      class: J(["totem-textarea", [
        {
          "totem-textarea--inline": h.inline,
          "totem-textarea--focused": V(c),
          "totem-textarea--disabled": h.disabled,
          "totem-textarea--readonly": h.readonly,
          [`totem-textarea--color-${h.color}`]: h.color
        }
      ]])
    }, {
      default: w(() => [
        p(h.$slots, "default", {}, () => [
          Y5(A("textarea", {
            id: h.id,
            ref_key: "textarea",
            ref: s,
            "onUpdate:modelValue": m[0] || (m[0] = (b) => o.value = b),
            name: h.name,
            disabled: h.disabled,
            readonly: h.readonly,
            placeholder: h.placeholder,
            class: "totem-textarea__textarea",
            "data-test": "textarea",
            onFocus: u,
            onBlur: v
          }, null, 40, tH), [
            [$7, o.value]
          ])
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), gB = /* @__PURE__ */ R({
  __name: "TotemFormElementTextarea",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    description: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    inline: { type: Boolean },
    modelValue: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    id: {},
    name: {},
    placeholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ l5(["blur", "focus"], ["update:modelValue"]),
  setup(l, { emit: e }) {
    const t = e, n = d5(l, "modelValue"), o = (s) => {
      t("blur", s);
    }, r = (s) => {
      t("focus", s);
    };
    return (s, c) => (f(), L(l1, {
      details: s.details,
      description: s.description,
      help: s.help,
      color: s.color,
      label: s.label,
      "label-for": s.id,
      "optional-flag": s.optionalFlag,
      "required-flag": s.requiredFlag,
      class: "totem-form-element-textarea"
    }, r5({
      default: w(() => [
        p(s.$slots, "default", {}, () => [
          W(aH, {
            id: s.id,
            modelValue: n.value,
            "onUpdate:modelValue": c[0] || (c[0] = (u) => n.value = u),
            color: s.color,
            name: s.name,
            placeholder: s.placeholder,
            readonly: s.readonly,
            disabled: s.disabled,
            onBlur: o,
            onFocus: r
          }, null, 8, ["id", "modelValue", "color", "name", "placeholder", "readonly", "disabled"])
        ])
      ]),
      _: 2
    }, [
      s.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(s.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      s.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(s.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      s.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(s.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      s.$slots.headerDescription ? {
        name: "headerDescription",
        fn: w(() => [
          p(s.$slots, "headerDescription")
        ]),
        key: "3"
      } : void 0,
      s.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(s.$slots, "headerHelp")
        ]),
        key: "4"
      } : void 0,
      s.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(s.$slots, "bottom")
        ]),
        key: "5"
      } : void 0,
      s.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(s.$slots, "bottomDetails")
        ]),
        key: "6"
      } : void 0,
      s.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(s.$slots, "bottomLink")
        ]),
        key: "7"
      } : void 0
    ]), 1032, ["details", "description", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), nH = { class: "totem-toggle__label-layer" }, oH = { class: "totem-toggle__label-background" }, rH = ["for"], sH = ["hidden"], iH = ["hidden"], dH = { class: "totem-toggle__circle-layer" }, uH = { class: "totem-toggle__circle-wrapper" }, cH = ["id", "disabled", "readonly"], vH = {
  class: "totem-toggle__icon-wrapper",
  "data-test": "icon-wrapper"
}, fl = /* @__PURE__ */ R({
  __name: "TotemToggle",
  props: /* @__PURE__ */ l5({
    id: { default: () => {
    } },
    onLabel: { default: "Oui" },
    onIconName: { default: "check" },
    offLabel: { default: "Non" },
    offIconName: { default: "cancel" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    error: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = d5(l, "modelValue"), t = $(() => l.id ?? P5()), n = () => {
      !l.disabled && !l.readonly && (e.value = !e.value);
    };
    return (o, r) => (f(), M("span", {
      class: J(["totem-toggle", [
        {
          "totem-toggle--disabled": o.disabled,
          "totem-toggle--readonly": o.readonly,
          "totem-toggle--error": o.error,
          "totem-toggle--on": e.value,
          "totem-toggle--off": !e.value
        }
      ]]),
      onClick: K5(n, ["prevent"])
    }, [
      A("span", nH, [
        A("span", oH, [
          A("label", {
            for: t.value,
            class: "totem-toggle__label",
            "data-test": "label"
          }, [
            p(o.$slots, "default", {}, () => [
              A("span", {
                hidden: !e.value,
                class: "totem-toggle__text totem-toggle__text--on",
                "data-test": "on-label"
              }, [
                p(o.$slots, "onLabel", {}, () => [
                  P(O(o.onLabel), 1)
                ])
              ], 8, sH),
              A("span", {
                hidden: e.value,
                class: "totem-toggle__text totem-toggle__text--off",
                "data-test": "off-label"
              }, [
                p(o.$slots, "offLabel", {}, () => [
                  P(O(o.offLabel), 1)
                ])
              ], 8, iH)
            ])
          ], 8, rH)
        ])
      ]),
      A("span", dH, [
        A("span", uH, [
          Y5(A("input", {
            id: t.value,
            "onUpdate:modelValue": r[0] || (r[0] = (s) => e.value = s),
            type: "checkbox",
            class: "totem-toggle__input",
            disabled: o.disabled,
            readonly: o.readonly
          }, null, 8, cH), [
            [C7, e.value]
          ]),
          A("span", vH, [
            o.disabled ? C("", !0) : (f(), L(J5, {
              key: 0,
              name: "totem-toggle__icon-",
              mode: "default"
            }, {
              default: w(() => [
                e.value ? p(o.$slots, "onIcon", { key: 0 }, () => [
                  W(a5, {
                    name: o.onIconName,
                    class: "totem-toggle__icon totem-toggle__icon--on"
                  }, null, 8, ["name"])
                ]) : p(o.$slots, "offIcon", { key: 1 }, () => [
                  W(a5, {
                    name: o.offIconName,
                    class: "totem-toggle__icon totem-toggle__icon--off"
                  }, null, 8, ["name"])
                ])
              ]),
              _: 3
            }))
          ])
        ])
      ])
    ], 2));
  }
}), wB = /* @__PURE__ */ R({
  __name: "TotemFormElementToggle",
  props: /* @__PURE__ */ l5({
    color: {},
    label: {},
    labelFor: {},
    help: {},
    details: {},
    optionalFlag: { type: Boolean },
    requiredFlag: { type: Boolean },
    slim: { type: Boolean },
    id: {},
    onLabel: {},
    onIconName: {},
    offLabel: {},
    offIconName: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const e = d5(l, "modelValue");
    return (t, n) => (f(), L(l1, {
      details: t.details,
      help: t.help,
      color: t.color,
      label: t.label,
      "label-for": t.id,
      "optional-flag": t.optionalFlag,
      "required-flag": t.requiredFlag,
      slim: "",
      class: "totem-form-element-text"
    }, r5({
      default: w(() => [
        p(t.$slots, "default", {}, () => [
          W(fl, {
            id: t.id,
            modelValue: e.value,
            "onUpdate:modelValue": n[0] || (n[0] = (o) => e.value = o),
            "on-label": t.onLabel,
            "on-icon-name": t.onIconName,
            "off-label": t.offLabel,
            "off-icon-name": t.offIconName,
            error: t.color === "danger",
            readonly: t.readonly,
            disabled: t.disabled,
            "data-test": "totem-toggle"
          }, r5({ _: 2 }, [
            t.$slots.onLabel ? {
              name: "onLabel",
              fn: w(() => [
                p(t.$slots, "onLabel")
              ]),
              key: "0"
            } : void 0,
            t.$slots.offLabel ? {
              name: "offLabel",
              fn: w(() => [
                p(t.$slots, "offLabel")
              ]),
              key: "1"
            } : void 0,
            t.$slots.onIcon ? {
              name: "onIcon",
              fn: w(() => [
                p(t.$slots, "onIcon")
              ]),
              key: "2"
            } : void 0,
            t.$slots.offIcon ? {
              name: "offIcon",
              fn: w(() => [
                p(t.$slots, "offIcon")
              ]),
              key: "3"
            } : void 0
          ]), 1032, ["id", "modelValue", "on-label", "on-icon-name", "off-label", "off-icon-name", "error", "readonly", "disabled"])
        ])
      ]),
      _: 2
    }, [
      t.$slots.header ? {
        name: "header",
        fn: w(() => [
          p(t.$slots, "header")
        ]),
        key: "0"
      } : void 0,
      t.$slots.headerLabelText ? {
        name: "headerLabelText",
        fn: w(() => [
          p(t.$slots, "headerLabelText")
        ]),
        key: "1"
      } : void 0,
      t.$slots.headerFlags ? {
        name: "headerFlags",
        fn: w(() => [
          p(t.$slots, "headerFlags")
        ]),
        key: "2"
      } : void 0,
      t.$slots.headerHelp ? {
        name: "headerHelp",
        fn: w(() => [
          p(t.$slots, "headerHelp")
        ]),
        key: "3"
      } : void 0,
      t.$slots.bottom ? {
        name: "bottom",
        fn: w(() => [
          p(t.$slots, "bottom")
        ]),
        key: "4"
      } : void 0,
      t.$slots.bottomDetails ? {
        name: "bottomDetails",
        fn: w(() => [
          p(t.$slots, "bottomDetails")
        ]),
        key: "5"
      } : void 0,
      t.$slots.bottomLink ? {
        name: "bottomLink",
        fn: w(() => [
          p(t.$slots, "bottomLink")
        ]),
        key: "6"
      } : void 0
    ]), 1032, ["details", "help", "color", "label", "label-for", "optional-flag", "required-flag"]));
  }
}), pH = {
  key: 0,
  class: "totem-link__prepend",
  "data-test": "prepend"
}, hH = {
  class: "totem-link__label",
  "data-test": "label"
}, mH = {
  key: 1,
  class: "totem-link__append",
  "data-test": "append"
}, bB = /* @__PURE__ */ R({
  __name: "TotemLink",
  props: {
    size: { default: "s" },
    prependIconName: { default: void 0 },
    appendIconName: { default: void 0 },
    secondary: { type: Boolean },
    disabled: { type: Boolean },
    href: { default: void 0 },
    label: { default: void 0 },
    target: { default: "_self" },
    to: { default: void 0 },
    type: { default: void 0 }
  },
  setup(l) {
    return (e, t) => (f(), L(C1, {
      disabled: e.disabled,
      href: e.href,
      target: e.target,
      to: e.to,
      type: e.type,
      class: J(["totem-link", {
        [`totem-link--size-${e.size}`]: e.size,
        "totem-link--disabled": e.disabled,
        "totem-link--with-prepend": e.prependIconName || e.$slots.prepend,
        "totem-link--with-append": e.appendIconName || e.$slots.append,
        "totem-link--secondary": e.secondary
      }])
    }, {
      default: w(() => [
        e.prependIconName || e.$slots.prepend ? (f(), M("span", pH, [
          p(e.$slots, "prepend", {}, () => [
            e.prependIconName ? (f(), L(a5, {
              key: 0,
              name: e.prependIconName
            }, null, 8, ["name"])) : C("", !0)
          ])
        ])) : C("", !0),
        A("span", hH, [
          p(e.$slots, "label", {}, () => [
            p(e.$slots, "default", {}, () => [
              P(O(e.label), 1)
            ])
          ])
        ]),
        e.appendIconName || e.$slots.append ? (f(), M("span", mH, [
          p(e.$slots, "append", {}, () => [
            e.appendIconName ? (f(), L(a5, {
              key: 0,
              name: e.appendIconName
            }, null, 8, ["name"])) : C("", !0)
          ])
        ])) : C("", !0)
      ]),
      _: 3
    }, 8, ["disabled", "href", "target", "to", "type", "class"]));
  }
}), fH = {
  key: 0,
  class: "totem-message__header",
  "data-test": "header"
}, gH = {
  key: 0,
  class: "totem-message__icon-wrapper",
  "data-test": "icon"
}, wH = {
  key: 1,
  class: "totem-message__title",
  "data-test": "title"
}, bH = {
  key: 1,
  class: "totem-message__content",
  "data-test": "content"
}, MH = {
  key: 2,
  class: "totem-message__actions",
  "data-test": "actions"
}, MB = /* @__PURE__ */ R({
  __name: "TotemMessage",
  props: {
    color: { default: "default" },
    title: { default: void 0 },
    content: { default: void 0 },
    iconName: { default: void 0 }
  },
  setup(l) {
    return (e, t) => (f(), M("div", {
      class: J(["totem-message", {
        [`totem-message--color-${e.color}`]: e.color
      }])
    }, [
      e.$slots.header || e.$slots.title || e.title || e.$slots.icon || e.iconName ? (f(), M("div", fH, [
        p(e.$slots, "header", {}, () => [
          e.$slots.icon || e.iconName ? (f(), M("div", gH, [
            p(e.$slots, "icon", {}, () => [
              e.iconName ? (f(), L(a5, {
                key: 0,
                name: e.iconName,
                class: "totem-message__icon"
              }, null, 8, ["name"])) : C("", !0)
            ])
          ])) : C("", !0),
          e.$slots.title || e.title ? (f(), M("p", wH, [
            p(e.$slots, "title", {}, () => [
              P(O(e.title), 1)
            ])
          ])) : C("", !0)
        ])
      ])) : C("", !0),
      e.$slots.default || e.content ? (f(), M("div", bH, [
        p(e.$slots, "default", {}, () => [
          P(O(e.content), 1)
        ])
      ])) : C("", !0),
      e.$slots.actions ? (f(), M("div", MH, [
        p(e.$slots, "actions")
      ])) : C("", !0)
    ], 2));
  }
}), yH = { class: "totem-modal__close-wrapper" }, VH = {
  class: "totem-modal__main",
  "data-test": "main"
}, AH = {
  class: "totem-modal__header",
  "data-test": "header"
}, $H = {
  key: 0,
  class: "totem-modal__title",
  "data-test": "title"
}, CH = {
  key: 1,
  class: "totem-modal__subtitle",
  "data-test": "subtitle"
}, HH = { class: "totem-modal__content-wrapper" }, zH = {
  key: 0,
  class: "totem-modal__remember-me",
  "data-test": "rememberMe"
}, kH = {
  class: "totem-modal__footer",
  "data-test": "footer"
}, BH = {
  class: "totem-modal__actions",
  "data-test": "actions"
}, yB = /* @__PURE__ */ R({
  __name: "TotemModal",
  props: {
    title: { default: void 0 },
    subtitle: { default: void 0 },
    content: { default: void 0 },
    size: { default: "m" }
  },
  emits: ["close"],
  setup(l) {
    const e = q(), t = q(!1);
    return V1(e, ([{ target: n }]) => {
      const { scrollHeight: o, clientHeight: r } = n;
      t.value = o > r;
    }), (n, o) => (f(), M("div", {
      class: J(["totem-modal", {
        [`totem-modal--size-${n.size}`]: n.size,
        "totem-modal--with-scrollbar": t.value
      }]),
      "data-test": "totem-modal"
    }, [
      A("div", yH, [
        W(N5, {
          color: "text",
          "icon-name": "cancel",
          "data-test": "close-button-icon",
          onClick: o[0] || (o[0] = (r) => n.$emit("close"))
        })
      ]),
      A("div", VH, [
        p(n.$slots, "main", {}, () => [
          A("div", AH, [
            p(n.$slots, "header", {}, () => [
              n.$slots.title || n.title ? (f(), M("span", $H, [
                p(n.$slots, "title", {}, () => [
                  P(O(n.title), 1)
                ])
              ])) : C("", !0),
              n.$slots.subtitle || n.subtitle ? (f(), M("p", CH, [
                p(n.$slots, "subtitle", {}, () => [
                  P(O(n.subtitle), 1)
                ])
              ])) : C("", !0),
              W(G1)
            ])
          ]),
          A("div", HH, [
            A("div", {
              ref_key: "contentElement",
              ref: e,
              class: "totem-modal__content",
              "data-test": "content"
            }, [
              p(n.$slots, "default", {}, () => [
                P(O(n.content), 1)
              ])
            ], 512)
          ]),
          n.$slots.rememberMe ? (f(), M("div", zH, [
            p(n.$slots, "rememberMe")
          ])) : C("", !0),
          A("div", kH, [
            p(n.$slots, "footer", {}, () => [
              A("div", BH, [
                p(n.$slots, "actions")
              ])
            ])
          ])
        ])
      ])
    ], 2));
  }
}), LH = { class: "totem-modal-overlay" }, _H = {
  class: "totem-modal-overlay__slot",
  "data-test": "slot"
}, TH = /* @__PURE__ */ R({
  __name: "TotemModalOverlay",
  emits: ["clickOutside"],
  setup(l, { emit: e }) {
    const t = e, n = (o) => {
      t("clickOutside", o);
    };
    return (o, r) => (f(), M("div", LH, [
      A("div", {
        class: "totem-modal-overlay__frame",
        "data-test": "frame",
        onClick: n
      }),
      A("div", _H, [
        p(o.$slots, "default")
      ])
    ]));
  }
}), SH = { class: "totem-progress-bar" }, xH = { class: "totem-progress-bar__label-wrapper" }, DH = { "data-test": "label" }, EH = { class: "totem-progress-bar__progression-wrapper" }, RH = {
  class: "totem-progress-bar__message",
  "data-test": "message"
}, VB = /* @__PURE__ */ R({
  __name: "TotemProgressBar",
  props: {
    label: { default: void 0 },
    message: { default: void 0 },
    progression: {}
  },
  emits: ["click"],
  setup(l) {
    const e = l, t = $(() => 100 - e.progression);
    return (n, o) => (f(), M("div", SH, [
      A("div", xH, [
        A("p", DH, [
          p(n.$slots, "label", {}, () => [
            P(O(n.label), 1)
          ])
        ]),
        A("div", {
          class: J(["totem-progress-bar__label-action", { "totem-progress-bar__label-action--full": n.progression === 100 }]),
          "data-test": "action"
        }, [
          p(n.$slots, "action", {}, () => [
            W(a5, {
              class: "totem-progress-bar__label-action-icon",
              name: n.progression === 100 ? "check" : "cancel",
              onClick: o[0] || (o[0] = (r) => n.$emit("click"))
            }, null, 8, ["name"])
          ])
        ], 2)
      ]),
      A("div", EH, [
        A("div", {
          class: "totem-progress-bar__progression totem-progress-bar__progression--full",
          style: m5({ width: `${n.progression}%` }),
          "data-test": "progression-full"
        }, null, 4),
        A("div", {
          class: "totem-progress-bar__progression totem-progress-bar__progression--empty",
          style: m5({ width: `${t.value}%` }),
          "data-test": "progression-empty"
        }, null, 4)
      ]),
      A("div", RH, [
        p(n.$slots, "message", {}, () => [
          P(O(n.message), 1)
        ])
      ])
    ]));
  }
}), OH = { class: "totem-section__header-wrapper" }, NH = { class: "totem-section__header" }, IH = {
  key: 0,
  class: "totem-section__header-icon",
  "data-test": "icon"
}, qH = {
  key: 0,
  class: "totem-section__header-title",
  "data-test": "title"
}, FH = {
  key: 1,
  class: "totem-section__header-details",
  "data-test": "details"
}, PH = {
  key: 1,
  class: "totem-section__header-actions",
  "data-test": "actions"
}, ZH = {
  key: 0,
  class: "totem-section__content",
  "data-test": "content"
}, UH = {
  key: 0,
  class: "totem-section__content-footer"
}, AB = /* @__PURE__ */ R({
  __name: "TotemSection",
  props: /* @__PURE__ */ l5({
    type: { default: "primary" },
    title: { default: void 0 },
    details: { default: void 0 },
    iconName: { default: void 0 },
    noDivider: { type: Boolean },
    toggleArrow: { type: Boolean },
    toggle: { type: Boolean },
    alwaysRender: { type: Boolean }
  }, {
    closed: { type: Boolean, default: !1 },
    closedModifiers: {}
  }),
  emits: ["update:closed"],
  setup(l) {
    const e = l, t = d5(l, "closed"), n = $({
      get: () => !t.value,
      set: (h) => t.value = !h
    }), o = $(() => e.alwaysRender ? !0 : !t.value), r = $(() => e.alwaysRender ? !t.value : !0), s = $(() => e.noDivider ? !1 : e.type === "secondary" ? !0 : !t.value), c = () => {
      t.value = !t.value;
    }, u = () => {
      (e.toggle || e.toggleArrow) && c();
    }, v = Ue(t);
    return (h, m) => (f(), M("div", {
      class: J(["totem-section", {
        [`totem-section--type-${h.type}`]: h.type,
        "totem-section--closed": t.value
      }])
    }, [
      A("div", OH, [
        A("div", NH, [
          h.iconName || h.$slots.icon ? (f(), M("div", IH, [
            p(h.$slots, "icon", {}, () => [
              h.iconName ? (f(), L(a5, {
                key: 0,
                name: h.iconName
              }, null, 8, ["name"])) : C("", !0)
            ])
          ])) : C("", !0),
          A("div", {
            class: "totem-section__header-description",
            onClick: u
          }, [
            h.title || h.$slots.title ? (f(), M("div", qH, [
              p(h.$slots, "title", {}, () => [
                P(O(h.title), 1)
              ])
            ])) : C("", !0),
            h.details || h.$slots.details ? (f(), M("div", FH, [
              p(h.$slots, "details", {}, () => [
                P(O(h.details), 1)
              ])
            ])) : C("", !0)
          ]),
          h.toggle || h.toggleArrow || h.$slots.allActions || h.$slots.actions ? (f(), M("div", PH, [
            p(h.$slots, "allActions", {}, () => [
              p(h.$slots, "actions"),
              h.toggleArrow && !h.toggle ? (f(), L(N5, {
                key: 0,
                "icon-rotation": V(v),
                size: "s",
                color: "text",
                "icon-name": "nav-arrow-up",
                onClick: c
              }, null, 8, ["icon-rotation"])) : h.toggle && !h.toggleArrow ? (f(), L(fl, {
                key: 1,
                modelValue: n.value,
                "onUpdate:modelValue": m[0] || (m[0] = (b) => n.value = b)
              }, null, 8, ["modelValue"])) : C("", !0)
            ])
          ])) : C("", !0)
        ]),
        s.value ? (f(), L(G1, {
          key: 0,
          class: "totem-section__header-divider"
        })) : C("", !0)
      ]),
      W(J5, { name: "totem-section__content-" }, {
        default: w(() => [
          o.value ? Y5((f(), M("div", ZH, [
            p(h.$slots, "default"),
            h.$slots.footer ? (f(), M("div", UH, [
              p(h.$slots, "footer")
            ])) : C("", !0)
          ], 512)), [
            [Gl, r.value]
          ]) : C("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), jH = /* @__PURE__ */ R({
  __name: "TotemTab",
  props: {
    label: { default: void 0 },
    iconName: { default: void 0 },
    selected: { type: Boolean },
    disabled: { type: Boolean },
    href: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 }
  },
  emits: ["click"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = () => {
      t.disabled || n("click");
    }, r = q(), s = q(), c = q(), u = () => s.value ? s.value.scrollWidth > s.value.clientWidth : !1;
    return y1(() => {
      c.value = u();
    }), V1(s, () => {
      c.value = u();
    }), (v, h) => (f(), L(C1, {
      ref_key: "tabElement",
      ref: r,
      class: J(["totem-tab", {
        "totem-tab--selected": v.selected,
        "totem-tab--disabled": v.disabled
      }]),
      href: v.href,
      target: v.target,
      to: v.to,
      onClick: o
    }, {
      default: w(() => [
        p(v.$slots, "icon", {}, () => [
          v.iconName ? (f(), L(a5, {
            key: 0,
            class: "totem-tab__icon",
            name: v.iconName
          }, null, 8, ["name"])) : C("", !0)
        ]),
        A("span", {
          ref_key: "labelElement",
          ref: s,
          class: "totem-tab__label",
          "data-test": "label"
        }, [
          p(v.$slots, "default", {}, () => [
            p(v.$slots, "label", {}, () => [
              P(O(v.label), 1)
            ])
          ])
        ], 512),
        c.value ? (f(), L(cl, {
          key: 0,
          target: r.value
        }, {
          default: w(() => [
            P(O(v.label), 1)
          ]),
          _: 1
        }, 8, ["target"])) : C("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "target", "to"]));
  }
});
var L1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function GH(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var h0, h2;
function je() {
  if (h2) return h0;
  h2 = 1;
  var l = Array.isArray;
  return h0 = l, h0;
}
var m0, m2;
function WH() {
  if (m2) return m0;
  m2 = 1;
  var l = typeof L1 == "object" && L1 && L1.Object === Object && L1;
  return m0 = l, m0;
}
var f0, f2;
function Ge() {
  if (f2) return f0;
  f2 = 1;
  var l = WH(), e = typeof self == "object" && self && self.Object === Object && self, t = l || e || Function("return this")();
  return f0 = t, f0;
}
var g0, g2;
function We() {
  if (g2) return g0;
  g2 = 1;
  var l = Ge(), e = l.Symbol;
  return g0 = e, g0;
}
var w0, w2;
function KH() {
  if (w2) return w0;
  w2 = 1;
  var l = We(), e = Object.prototype, t = e.hasOwnProperty, n = e.toString, o = l ? l.toStringTag : void 0;
  function r(s) {
    var c = t.call(s, o), u = s[o];
    try {
      s[o] = void 0;
      var v = !0;
    } catch {
    }
    var h = n.call(s);
    return v && (c ? s[o] = u : delete s[o]), h;
  }
  return w0 = r, w0;
}
var b0, b2;
function XH() {
  if (b2) return b0;
  b2 = 1;
  var l = Object.prototype, e = l.toString;
  function t(n) {
    return e.call(n);
  }
  return b0 = t, b0;
}
var M0, M2;
function gl() {
  if (M2) return M0;
  M2 = 1;
  var l = We(), e = KH(), t = XH(), n = "[object Null]", o = "[object Undefined]", r = l ? l.toStringTag : void 0;
  function s(c) {
    return c == null ? c === void 0 ? o : n : r && r in Object(c) ? e(c) : t(c);
  }
  return M0 = s, M0;
}
var y0, y2;
function JH() {
  if (y2) return y0;
  y2 = 1;
  function l(e) {
    return e != null && typeof e == "object";
  }
  return y0 = l, y0;
}
var V0, V2;
function Ke() {
  if (V2) return V0;
  V2 = 1;
  var l = gl(), e = JH(), t = "[object Symbol]";
  function n(o) {
    return typeof o == "symbol" || e(o) && l(o) == t;
  }
  return V0 = n, V0;
}
var A0, A2;
function YH() {
  if (A2) return A0;
  A2 = 1;
  var l = je(), e = Ke(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function o(r, s) {
    if (l(r))
      return !1;
    var c = typeof r;
    return c == "number" || c == "symbol" || c == "boolean" || r == null || e(r) ? !0 : n.test(r) || !t.test(r) || s != null && r in Object(s);
  }
  return A0 = o, A0;
}
var $0, $2;
function wl() {
  if ($2) return $0;
  $2 = 1;
  function l(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return $0 = l, $0;
}
var C0, C2;
function QH() {
  if (C2) return C0;
  C2 = 1;
  var l = gl(), e = wl(), t = "[object AsyncFunction]", n = "[object Function]", o = "[object GeneratorFunction]", r = "[object Proxy]";
  function s(c) {
    if (!e(c))
      return !1;
    var u = l(c);
    return u == n || u == o || u == t || u == r;
  }
  return C0 = s, C0;
}
var H0, H2;
function ez() {
  if (H2) return H0;
  H2 = 1;
  var l = Ge(), e = l["__core-js_shared__"];
  return H0 = e, H0;
}
var z0, z2;
function lz() {
  if (z2) return z0;
  z2 = 1;
  var l = ez(), e = function() {
    var n = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function t(n) {
    return !!e && e in n;
  }
  return z0 = t, z0;
}
var k0, k2;
function tz() {
  if (k2) return k0;
  k2 = 1;
  var l = Function.prototype, e = l.toString;
  function t(n) {
    if (n != null) {
      try {
        return e.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return k0 = t, k0;
}
var B0, B2;
function az() {
  if (B2) return B0;
  B2 = 1;
  var l = QH(), e = lz(), t = wl(), n = tz(), o = /[\\^$.*+?()[\]{}|]/g, r = /^\[object .+?Constructor\]$/, s = Function.prototype, c = Object.prototype, u = s.toString, v = c.hasOwnProperty, h = RegExp(
    "^" + u.call(v).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(b) {
    if (!t(b) || e(b))
      return !1;
    var g = l(b) ? h : r;
    return g.test(n(b));
  }
  return B0 = m, B0;
}
var L0, L2;
function nz() {
  if (L2) return L0;
  L2 = 1;
  function l(e, t) {
    return e == null ? void 0 : e[t];
  }
  return L0 = l, L0;
}
var _0, _2;
function bl() {
  if (_2) return _0;
  _2 = 1;
  var l = az(), e = nz();
  function t(n, o) {
    var r = e(n, o);
    return l(r) ? r : void 0;
  }
  return _0 = t, _0;
}
var T0, T2;
function e0() {
  if (T2) return T0;
  T2 = 1;
  var l = bl(), e = l(Object, "create");
  return T0 = e, T0;
}
var S0, S2;
function oz() {
  if (S2) return S0;
  S2 = 1;
  var l = e0();
  function e() {
    this.__data__ = l ? l(null) : {}, this.size = 0;
  }
  return S0 = e, S0;
}
var x0, x2;
function rz() {
  if (x2) return x0;
  x2 = 1;
  function l(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return x0 = l, x0;
}
var D0, D2;
function sz() {
  if (D2) return D0;
  D2 = 1;
  var l = e0(), e = "__lodash_hash_undefined__", t = Object.prototype, n = t.hasOwnProperty;
  function o(r) {
    var s = this.__data__;
    if (l) {
      var c = s[r];
      return c === e ? void 0 : c;
    }
    return n.call(s, r) ? s[r] : void 0;
  }
  return D0 = o, D0;
}
var E0, E2;
function iz() {
  if (E2) return E0;
  E2 = 1;
  var l = e0(), e = Object.prototype, t = e.hasOwnProperty;
  function n(o) {
    var r = this.__data__;
    return l ? r[o] !== void 0 : t.call(r, o);
  }
  return E0 = n, E0;
}
var R0, R2;
function dz() {
  if (R2) return R0;
  R2 = 1;
  var l = e0(), e = "__lodash_hash_undefined__";
  function t(n, o) {
    var r = this.__data__;
    return this.size += this.has(n) ? 0 : 1, r[n] = l && o === void 0 ? e : o, this;
  }
  return R0 = t, R0;
}
var O0, O2;
function uz() {
  if (O2) return O0;
  O2 = 1;
  var l = oz(), e = rz(), t = sz(), n = iz(), o = dz();
  function r(s) {
    var c = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++c < u; ) {
      var v = s[c];
      this.set(v[0], v[1]);
    }
  }
  return r.prototype.clear = l, r.prototype.delete = e, r.prototype.get = t, r.prototype.has = n, r.prototype.set = o, O0 = r, O0;
}
var N0, N2;
function cz() {
  if (N2) return N0;
  N2 = 1;
  function l() {
    this.__data__ = [], this.size = 0;
  }
  return N0 = l, N0;
}
var I0, I2;
function vz() {
  if (I2) return I0;
  I2 = 1;
  function l(e, t) {
    return e === t || e !== e && t !== t;
  }
  return I0 = l, I0;
}
var q0, q2;
function l0() {
  if (q2) return q0;
  q2 = 1;
  var l = vz();
  function e(t, n) {
    for (var o = t.length; o--; )
      if (l(t[o][0], n))
        return o;
    return -1;
  }
  return q0 = e, q0;
}
var F0, F2;
function pz() {
  if (F2) return F0;
  F2 = 1;
  var l = l0(), e = Array.prototype, t = e.splice;
  function n(o) {
    var r = this.__data__, s = l(r, o);
    if (s < 0)
      return !1;
    var c = r.length - 1;
    return s == c ? r.pop() : t.call(r, s, 1), --this.size, !0;
  }
  return F0 = n, F0;
}
var P0, P2;
function hz() {
  if (P2) return P0;
  P2 = 1;
  var l = l0();
  function e(t) {
    var n = this.__data__, o = l(n, t);
    return o < 0 ? void 0 : n[o][1];
  }
  return P0 = e, P0;
}
var Z0, Z2;
function mz() {
  if (Z2) return Z0;
  Z2 = 1;
  var l = l0();
  function e(t) {
    return l(this.__data__, t) > -1;
  }
  return Z0 = e, Z0;
}
var U0, U2;
function fz() {
  if (U2) return U0;
  U2 = 1;
  var l = l0();
  function e(t, n) {
    var o = this.__data__, r = l(o, t);
    return r < 0 ? (++this.size, o.push([t, n])) : o[r][1] = n, this;
  }
  return U0 = e, U0;
}
var j0, j2;
function gz() {
  if (j2) return j0;
  j2 = 1;
  var l = cz(), e = pz(), t = hz(), n = mz(), o = fz();
  function r(s) {
    var c = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++c < u; ) {
      var v = s[c];
      this.set(v[0], v[1]);
    }
  }
  return r.prototype.clear = l, r.prototype.delete = e, r.prototype.get = t, r.prototype.has = n, r.prototype.set = o, j0 = r, j0;
}
var G0, G2;
function wz() {
  if (G2) return G0;
  G2 = 1;
  var l = bl(), e = Ge(), t = l(e, "Map");
  return G0 = t, G0;
}
var W0, W2;
function bz() {
  if (W2) return W0;
  W2 = 1;
  var l = uz(), e = gz(), t = wz();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new l(),
      map: new (t || e)(),
      string: new l()
    };
  }
  return W0 = n, W0;
}
var K0, K2;
function Mz() {
  if (K2) return K0;
  K2 = 1;
  function l(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return K0 = l, K0;
}
var X0, X2;
function t0() {
  if (X2) return X0;
  X2 = 1;
  var l = Mz();
  function e(t, n) {
    var o = t.__data__;
    return l(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
  }
  return X0 = e, X0;
}
var J0, J2;
function yz() {
  if (J2) return J0;
  J2 = 1;
  var l = t0();
  function e(t) {
    var n = l(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  return J0 = e, J0;
}
var Y0, Y2;
function Vz() {
  if (Y2) return Y0;
  Y2 = 1;
  var l = t0();
  function e(t) {
    return l(this, t).get(t);
  }
  return Y0 = e, Y0;
}
var Q0, Q2;
function Az() {
  if (Q2) return Q0;
  Q2 = 1;
  var l = t0();
  function e(t) {
    return l(this, t).has(t);
  }
  return Q0 = e, Q0;
}
var ee, e7;
function $z() {
  if (e7) return ee;
  e7 = 1;
  var l = t0();
  function e(t, n) {
    var o = l(this, t), r = o.size;
    return o.set(t, n), this.size += o.size == r ? 0 : 1, this;
  }
  return ee = e, ee;
}
var le, l7;
function Cz() {
  if (l7) return le;
  l7 = 1;
  var l = bz(), e = yz(), t = Vz(), n = Az(), o = $z();
  function r(s) {
    var c = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++c < u; ) {
      var v = s[c];
      this.set(v[0], v[1]);
    }
  }
  return r.prototype.clear = l, r.prototype.delete = e, r.prototype.get = t, r.prototype.has = n, r.prototype.set = o, le = r, le;
}
var te, t7;
function Hz() {
  if (t7) return te;
  t7 = 1;
  var l = Cz(), e = "Expected a function";
  function t(n, o) {
    if (typeof n != "function" || o != null && typeof o != "function")
      throw new TypeError(e);
    var r = function() {
      var s = arguments, c = o ? o.apply(this, s) : s[0], u = r.cache;
      if (u.has(c))
        return u.get(c);
      var v = n.apply(this, s);
      return r.cache = u.set(c, v) || u, v;
    };
    return r.cache = new (t.Cache || l)(), r;
  }
  return t.Cache = l, te = t, te;
}
var ae, a7;
function zz() {
  if (a7) return ae;
  a7 = 1;
  var l = Hz(), e = 500;
  function t(n) {
    var o = l(n, function(s) {
      return r.size === e && r.clear(), s;
    }), r = o.cache;
    return o;
  }
  return ae = t, ae;
}
var ne, n7;
function kz() {
  if (n7) return ne;
  n7 = 1;
  var l = zz(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, n = l(function(o) {
    var r = [];
    return o.charCodeAt(0) === 46 && r.push(""), o.replace(e, function(s, c, u, v) {
      r.push(u ? v.replace(t, "$1") : c || s);
    }), r;
  });
  return ne = n, ne;
}
var oe, o7;
function Bz() {
  if (o7) return oe;
  o7 = 1;
  function l(e, t) {
    for (var n = -1, o = e == null ? 0 : e.length, r = Array(o); ++n < o; )
      r[n] = t(e[n], n, e);
    return r;
  }
  return oe = l, oe;
}
var re, r7;
function Lz() {
  if (r7) return re;
  r7 = 1;
  var l = We(), e = Bz(), t = je(), n = Ke(), o = l ? l.prototype : void 0, r = o ? o.toString : void 0;
  function s(c) {
    if (typeof c == "string")
      return c;
    if (t(c))
      return e(c, s) + "";
    if (n(c))
      return r ? r.call(c) : "";
    var u = c + "";
    return u == "0" && 1 / c == -1 / 0 ? "-0" : u;
  }
  return re = s, re;
}
var se, s7;
function _z() {
  if (s7) return se;
  s7 = 1;
  var l = Lz();
  function e(t) {
    return t == null ? "" : l(t);
  }
  return se = e, se;
}
var ie, i7;
function Tz() {
  if (i7) return ie;
  i7 = 1;
  var l = je(), e = YH(), t = kz(), n = _z();
  function o(r, s) {
    return l(r) ? r : e(r, s) ? [r] : t(n(r));
  }
  return ie = o, ie;
}
var de, d7;
function Sz() {
  if (d7) return de;
  d7 = 1;
  var l = Ke();
  function e(t) {
    if (typeof t == "string" || l(t))
      return t;
    var n = t + "";
    return n == "0" && 1 / t == -1 / 0 ? "-0" : n;
  }
  return de = e, de;
}
var ue, u7;
function xz() {
  if (u7) return ue;
  u7 = 1;
  var l = Tz(), e = Sz();
  function t(n, o) {
    o = l(o, n);
    for (var r = 0, s = o.length; n != null && r < s; )
      n = n[e(o[r++])];
    return r && r == s ? n : void 0;
  }
  return ue = t, ue;
}
var ce, c7;
function Dz() {
  if (c7) return ce;
  c7 = 1;
  var l = xz();
  function e(t, n, o) {
    var r = t == null ? void 0 : l(t, n);
    return r === void 0 ? o : r;
  }
  return ce = e, ce;
}
var Ez = Dz();
const v7 = /* @__PURE__ */ GH(Ez), Rz = ({ key: l, mapValue: e }) => typeof e == "function" ? e : typeof e == "string" ? (t) => {
  const n = v7(t, e, void 0);
  return n ? String(n) : void 0;
} : (t) => {
  const n = v7(t, l, void 0);
  return n ? String(n) : void 0;
}, p7 = (l, e = !1) => ({
  key: l.key,
  label: l.label,
  isSide: e,
  isSortable: l.isSortable ?? !1,
  mapValue: Rz(l),
  tdSlotName: `td-${l.key}`,
  thSlotName: `th-${l.key}`
}), h7 = (l) => ({
  key: P5(),
  item: l
}), Oz = (l, e, t = !1) => [...l].sort((n, o) => {
  const r = e(n) ?? "", s = e(o) ?? "";
  return t ? s.localeCompare(r) : r.localeCompare(s);
}), Nz = (l, e, t, n, o) => {
  const r = $(() => {
    const b = e5(t), g = e5(e), y = b ? [p7(b, !0)] : [], z = g != null && g.length ? g.map((_) => p7(_)) : [];
    return [...y, ...z];
  }), s = $(() => {
    var b;
    return (b = o.value) != null && b.isDesc ? "arrow-up" : "arrow-down";
  }), c = ({ key: b, isSortable: g }) => {
    var y, z;
    g && (b !== ((y = o.value) == null ? void 0 : y.key) ? o.value = { key: b, isDesc: !1 } : o.value = { key: b, isDesc: !((z = o.value) != null && z.isDesc) });
  }, u = (b) => {
    var g;
    return b.isSortable && b.key === ((g = o.value) == null ? void 0 : g.key);
  }, v = $(() => {
    var b;
    if ((b = o.value) != null && b.key) {
      const g = r.value.find((y) => {
        var z;
        return y.key === ((z = o.value) == null ? void 0 : z.key);
      });
      return g != null && g.isSortable ? g : void 0;
    }
  }), h = $(() => e5(n) && v.value ? v.value : void 0);
  return {
    itemsMetadata: $(() => {
      var g;
      const b = e5(l) ?? [];
      return h.value ? Oz(b, h.value.mapValue, (g = o.value) == null ? void 0 : g.isDesc).map(h7) : b.map(h7);
    }),
    columnsMetadata: r,
    executeSort: c,
    isSorted: u,
    sortIconName: s
  };
}, Iz = { class: "totem-table" }, qz = { class: "totem-table__table" }, Fz = {
  key: 0,
  class: "totem-table__header"
}, Pz = { class: "totem-table__row totem-table__row--header" }, Zz = ["onClick"], Uz = { class: "totem-table__cell__content" }, jz = {
  key: 0,
  class: "totem-table__sortable-icon"
}, Gz = {
  key: 1,
  class: "totem-table__body"
}, Wz = { class: "totem-table__cell__content" }, Kz = {
  key: 2,
  class: "totem-table__body totem-table__body--no-data"
}, Xz = { class: "totem-table__row" }, Jz = ["colspan"], Yz = { class: "totem-table__cell__content" }, Qz = /* @__PURE__ */ R({
  __name: "TotemTable",
  props: /* @__PURE__ */ l5({
    items: {},
    columns: {},
    sideColumn: {},
    emptyMessage: {},
    emptyTdMessage: {},
    hideTopHeader: { type: Boolean },
    autoSortEnabled: { type: Boolean }
  }, {
    sort: {},
    sortModifiers: {}
  }),
  emits: ["update:sort"],
  setup(l) {
    const e = l, t = d5(l, "sort"), n = $(() => e.emptyMessage ?? "Aucune donnée"), o = $(() => e.emptyTdMessage ?? "-"), { itemsMetadata: r, columnsMetadata: s, executeSort: c, isSorted: u, sortIconName: v } = Nz(
      () => e.items,
      () => e.columns,
      () => e.sideColumn,
      () => e.autoSortEnabled,
      t
    );
    return (h, m) => (f(), M("div", Iz, [
      A("table", qz, [
        h.hideTopHeader ? C("", !0) : (f(), M("thead", Fz, [
          A("tr", Pz, [
            (f(!0), M(o5, null, c5(V(s), (b) => (f(), M("th", {
              key: b.key,
              class: J(["totem-table__cell", {
                "totem-table__cell--sortable": b.isSortable,
                "totem-table__cell--sorted": V(u)(b),
                "totem-table__cell--fixed": b.isSide
              }]),
              onClick: (g) => V(c)(b)
            }, [
              A("div", Uz, [
                p(h.$slots, "th", { columnMetadata: b }, () => [
                  p(h.$slots, b.thSlotName, { columnMetadata: b }, () => [
                    P(O(b.label), 1)
                  ], !0)
                ], !0),
                V(u)(b) ? (f(), M("span", jz, [
                  W(a5, { name: V(v) }, null, 8, ["name"])
                ])) : C("", !0)
              ])
            ], 10, Zz))), 128))
          ])
        ])),
        V(r).length > 0 ? (f(), M("tbody", Gz, [
          (f(!0), M(o5, null, c5(V(r), (b) => (f(), M("tr", {
            key: b.key,
            class: "totem-table__row"
          }, [
            (f(!0), M(o5, null, c5(V(s), (g) => (f(), M("td", {
              key: `${g.key}-${b.key}`,
              class: J(["totem-table__cell", {
                "totem-table__cell--side-column": g.isSide,
                "totem-table__cell--fixed": g.isSide
              }])
            }, [
              A("div", Wz, [
                p(h.$slots, "td", {
                  columnMetadata: g,
                  itemMetadata: b,
                  item: b.item
                }, () => [
                  p(h.$slots, g.tdSlotName, {
                    columnMetadata: g,
                    itemMetadata: b,
                    item: b.item
                  }, () => [
                    P(O(g.mapValue(b.item) ?? o.value), 1)
                  ], !0)
                ], !0)
              ])
            ], 2))), 128))
          ]))), 128))
        ])) : (f(), M("tbody", Kz, [
          A("tr", Xz, [
            A("td", {
              colspan: V(s).length,
              class: "totem-table__cell"
            }, [
              A("div", Yz, O(n.value), 1)
            ], 8, Jz)
          ])
        ]))
      ])
    ]));
  }
}), $B = /* @__PURE__ */ A1(Qz, [["__scopeId", "data-v-cd2f48bb"]]), ek = { class: "totem-tab-list" }, lk = { class: "totem-tab-list__rail" }, CB = /* @__PURE__ */ R({
  __name: "TotemTabList",
  props: {
    modelValue: { default: void 0 },
    items: { default: () => [] },
    mapLabel: { default: void 0 },
    mapDisabled: { default: void 0 },
    mapIconName: { default: void 0 },
    mapHref: { default: void 0 },
    mapTarget: { default: void 0 },
    mapTo: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(l, { emit: e }) {
    const t = l, n = e, o = $({
      get: () => t.modelValue,
      set: (H) => {
        n("update:modelValue", H);
      }
    }), r = $(
      () => t.items.map((H) => {
        var E, x, D, F, B, k;
        return {
          value: H.value,
          label: ((E = t.mapLabel) == null ? void 0 : E.call(t, H)) ?? H.label ?? void 0,
          iconName: ((x = t.mapIconName) == null ? void 0 : x.call(t, H)) ?? H.iconName ?? void 0,
          disabled: ((D = t.mapDisabled) == null ? void 0 : D.call(t, H)) ?? H.disabled ?? void 0,
          href: ((F = t.mapHref) == null ? void 0 : F.call(t, H)) ?? H.href ?? void 0,
          target: ((B = t.mapTarget) == null ? void 0 : B.call(t, H)) ?? H.target ?? void 0,
          to: ((k = t.mapTo) == null ? void 0 : k.call(t, H)) ?? H.to ?? void 0,
          selected: o.value === H.value
        };
      })
    ), s = (H) => {
      o.value = H.value;
    }, c = (H) => {
      var x, D;
      const E = H === r.value.length - 1;
      return !!((x = r.value[H]) != null && x.selected || !E && ((D = r.value[H + 1]) != null && D.selected));
    }, u = (H) => {
      if (c(H))
        return {
          "--totem-tab-list--divider-opacity": 0
        };
    }, v = q(), h = q([]), m = q([]), b = () => {
      var E;
      const H = ((E = v.value) == null ? void 0 : E.offsetLeft) ?? 0;
      return h.value.map(({ $el: x }) => {
        const D = x.offsetLeft - H, F = x.offsetWidth;
        return { x: D, width: F };
      });
    }, g = $(() => {
      const H = r.value.findIndex(({ selected: E }) => E);
      if (H !== -1 && m.value[H])
        return m.value[H];
    }), y = $(() => {
      if (g.value !== void 0) {
        const { x: H, width: E } = g.value;
        return {
          "--totem-tab-list--glider-x": `${H}px`,
          "--totem-tab-list--glider-width": `${E}px`
        };
      }
    });
    y1(() => {
      m.value = b();
    }), V1(v, () => {
      m.value = b();
    });
    const z = (H) => `label-${H}`, _ = (H) => `icon-${H}`;
    return (H, E) => (f(), M("div", ek, [
      A("div", lk, [
        A("div", {
          class: "totem-tab-list__glider",
          style: m5(y.value)
        }, null, 4)
      ]),
      A("div", {
        ref_key: "tabList",
        ref: v,
        class: "totem-tab-list__list"
      }, [
        p(H.$slots, "default", {}, () => [
          (f(!0), M(o5, null, c5(r.value, (x, D) => (f(), M(o5, {
            key: x.value
          }, [
            W(jH, {
              ref_for: !0,
              ref_key: "tabs",
              ref: h,
              "data-test": "tab",
              label: x.label,
              "icon-name": x.iconName,
              disabled: x.disabled,
              href: x.href,
              target: x.target,
              to: x.to,
              selected: x.selected,
              class: "totem-tab-list__tab",
              onClick: (F) => s(x)
            }, r5({ _: 2 }, [
              H.$slots.icon || H.$slots[_(x.value)] ? {
                name: "icon",
                fn: w(() => [
                  p(H.$slots, "icon", { item: x }, () => [
                    p(H.$slots, `icon-${x.value}`, { item: x })
                  ])
                ]),
                key: "0"
              } : void 0,
              H.$slots.label || H.$slots[z(x.value)] ? {
                name: "label",
                fn: w(() => [
                  p(H.$slots, "label", { item: x }, () => [
                    p(H.$slots, `label-${x.value}`, { item: x })
                  ])
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["label", "icon-name", "disabled", "href", "target", "to", "selected", "onClick"]),
            D !== r.value.length - 1 ? (f(), L(G1, {
              key: 0,
              vertical: "",
              class: "totem-tab-list__divider",
              style: m5(u(D))
            }, null, 8, ["style"])) : C("", !0)
          ], 64))), 128))
        ])
      ], 512)
    ]));
  }
}), tk = ["id"], HB = /* @__PURE__ */ R({
  __name: "TotemTeleportDestination",
  setup(l) {
    return (e, t) => (f(), M("div", {
      id: V(De).destinationId,
      ref_key: "totemTeleportDestinationInstance",
      ref: W7
    }, null, 8, tk));
  }
}), zB = ["primary", "secondary", "text"], kB = ["s", "m"], BB = ["default", "success", "warning", "error"], LB = ["button", "submit"], _B = ["_blank", "_self"], TB = ["a", "button", "RouterLink"], SB = ["default", "danger", "warning"], xB = ["s", "m"], DB = ["default", "info", "warning", "error", "success"];
function ak(l, e) {
  const t = document.getElementById(l);
  if (!t)
    throw new Error(`App element not found with id ${l}.`);
  const n = document.createElement("div");
  return n.id = e, t.appendChild(n), n;
}
function nk(l, e, t, n) {
  const o = u1(
    TH,
    {
      onClickOutside: () => {
        var s;
        const r = (s = t.listeners) == null ? void 0 : s.onClose;
        r ? r() : pe(null, l);
      }
    },
    {
      default: () => u1(e, {
        ...t.props,
        ...t.listeners
      })
    }
  );
  n && (o.appContext = n == null ? void 0 : n.app._context), pe(o, l);
}
const ok = (l, e) => (n, o = {}, r = []) => new Promise((s) => {
  const c = `container-modal-${P5()}`, u = ak(l, c), v = () => {
    pe(null, u);
  }, h = {
    onClose: () => {
      s(void 0), v();
    },
    onApprove: () => {
      s(!0), v();
    },
    onReject: () => {
      s(!1), v();
    }
  }, m = r.reduce((g, y) => (g[`on${Yl(y)}`] = () => {
    s(y), v();
  }, g), {}), b = { ...h, ...m };
  nk(
    u,
    n,
    {
      props: o,
      listeners: b
    },
    e
  );
});
function EB(l = De.destinationId) {
  var t;
  return {
    openModal: ok(l, (t = F1()) == null ? void 0 : t.appContext)
  };
}
const RB = ["s", "m", "l"], OB = ["primary", "secondary", "tertiary"], NB = ["default", "secondary", "tertiary", "success", "warning", "error"];
var rk = Object.defineProperty, m7 = Object.getOwnPropertySymbols, sk = Object.prototype.hasOwnProperty, ik = Object.prototype.propertyIsEnumerable, f7 = (l, e, t) => e in l ? rk(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t, Ml = (l, e) => {
  for (var t in e || (e = {}))
    sk.call(e, t) && f7(l, t, e[t]);
  if (m7)
    for (var t of m7(e))
      ik.call(e, t) && f7(l, t, e[t]);
  return l;
}, a0 = (l) => typeof l == "function", n0 = (l) => typeof l == "string", yl = (l) => n0(l) && l.trim().length > 0, dk = (l) => typeof l == "number", Z5 = (l) => typeof l > "u", b1 = (l) => typeof l == "object" && l !== null, uk = (l) => S5(l, "tag") && yl(l.tag), Vl = (l) => window.TouchEvent && l instanceof TouchEvent, Al = (l) => S5(l, "component") && $l(l.component), ck = (l) => a0(l) || b1(l), $l = (l) => !Z5(l) && (n0(l) || ck(l) || Al(l)), g7 = (l) => b1(l) && ["height", "width", "right", "left", "top", "bottom"].every((e) => dk(l[e])), S5 = (l, e) => (b1(l) || a0(l)) && e in l, vk = /* @__PURE__ */ ((l) => () => l++)(0);
function ve(l) {
  return Vl(l) ? l.targetTouches[0].clientX : l.clientX;
}
function w7(l) {
  return Vl(l) ? l.targetTouches[0].clientY : l.clientY;
}
var pk = (l) => {
  Z5(l.remove) ? l.parentNode && l.parentNode.removeChild(l) : l.remove();
}, k1 = (l) => Al(l) ? k1(l.component) : uk(l) ? R({
  render() {
    return l;
  }
}) : typeof l == "string" ? l : Kl(V(l)), hk = (l) => {
  if (typeof l == "string")
    return l;
  const e = S5(l, "props") && b1(l.props) ? l.props : {}, t = S5(l, "listeners") && b1(l.listeners) ? l.listeners : {};
  return { component: k1(l), props: e, listeners: t };
}, mk = () => typeof window < "u", Xe = class {
  constructor() {
    this.allHandlers = {};
  }
  getHandlers(l) {
    return this.allHandlers[l] || [];
  }
  on(l, e) {
    const t = this.getHandlers(l);
    t.push(e), this.allHandlers[l] = t;
  }
  off(l, e) {
    const t = this.getHandlers(l);
    t.splice(t.indexOf(e) >>> 0, 1);
  }
  emit(l, e) {
    this.getHandlers(l).forEach((n) => n(e));
  }
}, fk = (l) => ["on", "off", "emit"].every((e) => S5(l, e) && a0(l[e])), p5;
(function(l) {
  l.SUCCESS = "success", l.ERROR = "error", l.WARNING = "warning", l.INFO = "info", l.DEFAULT = "default";
})(p5 || (p5 = {}));
var M1;
(function(l) {
  l.TOP_LEFT = "top-left", l.TOP_CENTER = "top-center", l.TOP_RIGHT = "top-right", l.BOTTOM_LEFT = "bottom-left", l.BOTTOM_CENTER = "bottom-center", l.BOTTOM_RIGHT = "bottom-right";
})(M1 || (M1 = {}));
var g5;
(function(l) {
  l.ADD = "add", l.DISMISS = "dismiss", l.UPDATE = "update", l.CLEAR = "clear", l.UPDATE_DEFAULTS = "update_defaults";
})(g5 || (g5 = {}));
var k5 = "Vue-Toastification", $5 = {
  type: {
    type: String,
    default: p5.DEFAULT
  },
  classNames: {
    type: [String, Array],
    default: () => []
  },
  trueBoolean: {
    type: Boolean,
    default: !0
  }
}, Cl = {
  type: $5.type,
  customIcon: {
    type: [String, Boolean, Object, Function],
    default: !0
  }
}, S1 = {
  component: {
    type: [String, Object, Function, Boolean],
    default: "button"
  },
  classNames: $5.classNames,
  showOnHover: {
    type: Boolean,
    default: !1
  },
  ariaLabel: {
    type: String,
    default: "close"
  }
}, Ce = {
  timeout: {
    type: [Number, Boolean],
    default: 5e3
  },
  hideProgressBar: {
    type: Boolean,
    default: !1
  },
  isRunning: {
    type: Boolean,
    default: !1
  }
}, Hl = {
  transition: {
    type: [Object, String],
    default: `${k5}__bounce`
  }
}, gk = {
  position: {
    type: String,
    default: M1.TOP_RIGHT
  },
  draggable: $5.trueBoolean,
  draggablePercent: {
    type: Number,
    default: 0.6
  },
  pauseOnFocusLoss: $5.trueBoolean,
  pauseOnHover: $5.trueBoolean,
  closeOnClick: $5.trueBoolean,
  timeout: Ce.timeout,
  hideProgressBar: Ce.hideProgressBar,
  toastClassName: $5.classNames,
  bodyClassName: $5.classNames,
  icon: Cl.customIcon,
  closeButton: S1.component,
  closeButtonClassName: S1.classNames,
  showCloseButtonOnHover: S1.showOnHover,
  accessibility: {
    type: Object,
    default: () => ({
      toastRole: "alert",
      closeButtonLabel: "close"
    })
  },
  rtl: {
    type: Boolean,
    default: !1
  },
  eventBus: {
    type: Object,
    required: !1,
    default: () => new Xe()
  }
}, wk = {
  id: {
    type: [String, Number],
    required: !0,
    default: 0
  },
  type: $5.type,
  content: {
    type: [String, Object, Function],
    required: !0,
    default: ""
  },
  onClick: {
    type: Function,
    default: void 0
  },
  onClose: {
    type: Function,
    default: void 0
  }
}, bk = {
  container: {
    type: [
      Object,
      Function
    ],
    default: () => document.body
  },
  newestOnTop: $5.trueBoolean,
  maxToasts: {
    type: Number,
    default: 20
  },
  transition: Hl.transition,
  toastDefaults: Object,
  filterBeforeCreate: {
    type: Function,
    default: (l) => l
  },
  filterToasts: {
    type: Function,
    default: (l) => l
  },
  containerClassName: $5.classNames,
  onMounted: Function,
  shareAppContext: [Boolean, Object]
}, O5 = {
  CORE_TOAST: gk,
  TOAST: wk,
  CONTAINER: bk,
  PROGRESS_BAR: Ce,
  ICON: Cl,
  TRANSITION: Hl,
  CLOSE_BUTTON: S1
}, zl = R({
  name: "VtProgressBar",
  props: O5.PROGRESS_BAR,
  data() {
    return {
      hasClass: !0
    };
  },
  computed: {
    style() {
      return {
        animationDuration: `${this.timeout}ms`,
        animationPlayState: this.isRunning ? "running" : "paused",
        opacity: this.hideProgressBar ? 0 : 1
      };
    },
    cpClass() {
      return this.hasClass ? `${k5}__progress-bar` : "";
    }
  },
  watch: {
    timeout() {
      this.hasClass = !1, this.$nextTick(() => this.hasClass = !0);
    }
  },
  mounted() {
    this.$el.addEventListener("animationend", this.animationEnded);
  },
  beforeUnmount() {
    this.$el.removeEventListener("animationend", this.animationEnded);
  },
  methods: {
    animationEnded() {
      this.$emit("close-toast");
    }
  }
});
function Mk(l, e) {
  return f(), M("div", {
    style: m5(l.style),
    class: J(l.cpClass)
  }, null, 6);
}
zl.render = Mk;
var yk = zl, kl = R({
  name: "VtCloseButton",
  props: O5.CLOSE_BUTTON,
  computed: {
    buttonComponent() {
      return this.component !== !1 ? k1(this.component) : "button";
    },
    classes() {
      const l = [`${k5}__close-button`];
      return this.showOnHover && l.push("show-on-hover"), l.concat(this.classNames);
    }
  }
}), Vk = /* @__PURE__ */ P(" × ");
function Ak(l, e) {
  return f(), L(V5(l.buttonComponent), Q({
    "aria-label": l.ariaLabel,
    class: l.classes
  }, l.$attrs), {
    default: w(() => [
      Vk
    ]),
    _: 1
  }, 16, ["aria-label", "class"]);
}
kl.render = Ak;
var $k = kl, Bl = {}, Ck = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check-circle",
  class: "svg-inline--fa fa-check-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Hk = /* @__PURE__ */ A("path", {
  fill: "currentColor",
  d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
}, null, -1), zk = [
  Hk
];
function kk(l, e) {
  return f(), M("svg", Ck, zk);
}
Bl.render = kk;
var Bk = Bl, Ll = {}, Lk = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "info-circle",
  class: "svg-inline--fa fa-info-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, _k = /* @__PURE__ */ A("path", {
  fill: "currentColor",
  d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
}, null, -1), Tk = [
  _k
];
function Sk(l, e) {
  return f(), M("svg", Lk, Tk);
}
Ll.render = Sk;
var b7 = Ll, _l = {}, xk = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-circle",
  class: "svg-inline--fa fa-exclamation-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Dk = /* @__PURE__ */ A("path", {
  fill: "currentColor",
  d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), Ek = [
  Dk
];
function Rk(l, e) {
  return f(), M("svg", xk, Ek);
}
_l.render = Rk;
var Ok = _l, Tl = {}, Nk = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-triangle",
  class: "svg-inline--fa fa-exclamation-triangle fa-w-18",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, Ik = /* @__PURE__ */ A("path", {
  fill: "currentColor",
  d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), qk = [
  Ik
];
function Fk(l, e) {
  return f(), M("svg", Nk, qk);
}
Tl.render = Fk;
var Pk = Tl, Sl = R({
  name: "VtIcon",
  props: O5.ICON,
  computed: {
    customIconChildren() {
      return S5(this.customIcon, "iconChildren") ? this.trimValue(this.customIcon.iconChildren) : "";
    },
    customIconClass() {
      return n0(this.customIcon) ? this.trimValue(this.customIcon) : S5(this.customIcon, "iconClass") ? this.trimValue(this.customIcon.iconClass) : "";
    },
    customIconTag() {
      return S5(this.customIcon, "iconTag") ? this.trimValue(this.customIcon.iconTag, "i") : "i";
    },
    hasCustomIcon() {
      return this.customIconClass.length > 0;
    },
    component() {
      return this.hasCustomIcon ? this.customIconTag : $l(this.customIcon) ? k1(this.customIcon) : this.iconTypeComponent;
    },
    iconTypeComponent() {
      return {
        [p5.DEFAULT]: b7,
        [p5.INFO]: b7,
        [p5.SUCCESS]: Bk,
        [p5.ERROR]: Pk,
        [p5.WARNING]: Ok
      }[this.type];
    },
    iconClasses() {
      const l = [`${k5}__icon`];
      return this.hasCustomIcon ? l.concat(this.customIconClass) : l;
    }
  },
  methods: {
    trimValue(l, e = "") {
      return yl(l) ? l.trim() : e;
    }
  }
});
function Zk(l, e) {
  return f(), L(V5(l.component), {
    class: J(l.iconClasses)
  }, {
    default: w(() => [
      P(O(l.customIconChildren), 1)
    ]),
    _: 1
  }, 8, ["class"]);
}
Sl.render = Zk;
var Uk = Sl, xl = R({
  name: "VtToast",
  components: { ProgressBar: yk, CloseButton: $k, Icon: Uk },
  inheritAttrs: !1,
  props: Object.assign({}, O5.CORE_TOAST, O5.TOAST),
  data() {
    return {
      isRunning: !0,
      disableTransitions: !1,
      beingDragged: !1,
      dragStart: 0,
      dragPos: { x: 0, y: 0 },
      dragRect: {}
    };
  },
  computed: {
    classes() {
      const l = [
        `${k5}__toast`,
        `${k5}__toast--${this.type}`,
        `${this.position}`
      ].concat(this.toastClassName);
      return this.disableTransitions && l.push("disable-transition"), this.rtl && l.push(`${k5}__toast--rtl`), l;
    },
    bodyClasses() {
      return [
        `${k5}__toast-${n0(this.content) ? "body" : "component-body"}`
      ].concat(this.bodyClassName);
    },
    draggableStyle() {
      return this.dragStart === this.dragPos.x ? {} : this.beingDragged ? {
        transform: `translateX(${this.dragDelta}px)`,
        opacity: 1 - Math.abs(this.dragDelta / this.removalDistance)
      } : {
        transition: "transform 0.2s, opacity 0.2s",
        transform: "translateX(0)",
        opacity: 1
      };
    },
    dragDelta() {
      return this.beingDragged ? this.dragPos.x - this.dragStart : 0;
    },
    removalDistance() {
      return g7(this.dragRect) ? (this.dragRect.right - this.dragRect.left) * this.draggablePercent : 0;
    }
  },
  mounted() {
    this.draggable && this.draggableSetup(), this.pauseOnFocusLoss && this.focusSetup();
  },
  beforeUnmount() {
    this.draggable && this.draggableCleanup(), this.pauseOnFocusLoss && this.focusCleanup();
  },
  methods: {
    hasProp: S5,
    getVueComponentFromObj: k1,
    closeToast() {
      this.eventBus.emit(g5.DISMISS, this.id);
    },
    clickHandler() {
      this.onClick && this.onClick(this.closeToast), this.closeOnClick && (!this.beingDragged || this.dragStart === this.dragPos.x) && this.closeToast();
    },
    timeoutHandler() {
      this.closeToast();
    },
    hoverPause() {
      this.pauseOnHover && (this.isRunning = !1);
    },
    hoverPlay() {
      this.pauseOnHover && (this.isRunning = !0);
    },
    focusPause() {
      this.isRunning = !1;
    },
    focusPlay() {
      this.isRunning = !0;
    },
    focusSetup() {
      addEventListener("blur", this.focusPause), addEventListener("focus", this.focusPlay);
    },
    focusCleanup() {
      removeEventListener("blur", this.focusPause), removeEventListener("focus", this.focusPlay);
    },
    draggableSetup() {
      const l = this.$el;
      l.addEventListener("touchstart", this.onDragStart, {
        passive: !0
      }), l.addEventListener("mousedown", this.onDragStart), addEventListener("touchmove", this.onDragMove, { passive: !1 }), addEventListener("mousemove", this.onDragMove), addEventListener("touchend", this.onDragEnd), addEventListener("mouseup", this.onDragEnd);
    },
    draggableCleanup() {
      const l = this.$el;
      l.removeEventListener("touchstart", this.onDragStart), l.removeEventListener("mousedown", this.onDragStart), removeEventListener("touchmove", this.onDragMove), removeEventListener("mousemove", this.onDragMove), removeEventListener("touchend", this.onDragEnd), removeEventListener("mouseup", this.onDragEnd);
    },
    onDragStart(l) {
      this.beingDragged = !0, this.dragPos = { x: ve(l), y: w7(l) }, this.dragStart = ve(l), this.dragRect = this.$el.getBoundingClientRect();
    },
    onDragMove(l) {
      this.beingDragged && (l.preventDefault(), this.isRunning && (this.isRunning = !1), this.dragPos = { x: ve(l), y: w7(l) });
    },
    onDragEnd() {
      this.beingDragged && (Math.abs(this.dragDelta) >= this.removalDistance ? (this.disableTransitions = !0, this.$nextTick(() => this.closeToast())) : setTimeout(() => {
        this.beingDragged = !1, g7(this.dragRect) && this.pauseOnHover && this.dragRect.bottom >= this.dragPos.y && this.dragPos.y >= this.dragRect.top && this.dragRect.left <= this.dragPos.x && this.dragPos.x <= this.dragRect.right ? this.isRunning = !1 : this.isRunning = !0;
      }));
    }
  }
}), jk = ["role"];
function Gk(l, e) {
  const t = h1("Icon"), n = h1("CloseButton"), o = h1("ProgressBar");
  return f(), M("div", {
    class: J(l.classes),
    style: m5(l.draggableStyle),
    onClick: e[0] || (e[0] = (...r) => l.clickHandler && l.clickHandler(...r)),
    onMouseenter: e[1] || (e[1] = (...r) => l.hoverPause && l.hoverPause(...r)),
    onMouseleave: e[2] || (e[2] = (...r) => l.hoverPlay && l.hoverPlay(...r))
  }, [
    l.icon ? (f(), L(t, {
      key: 0,
      "custom-icon": l.icon,
      type: l.type
    }, null, 8, ["custom-icon", "type"])) : C("v-if", !0),
    A("div", {
      role: l.accessibility.toastRole || "alert",
      class: J(l.bodyClasses)
    }, [
      typeof l.content == "string" ? (f(), M(o5, { key: 0 }, [
        P(O(l.content), 1)
      ], 2112)) : (f(), L(V5(l.getVueComponentFromObj(l.content)), Q({
        key: 1,
        "toast-id": l.id
      }, l.hasProp(l.content, "props") ? l.content.props : {}, Xl(l.hasProp(l.content, "listeners") ? l.content.listeners : {}), { onCloseToast: l.closeToast }), null, 16, ["toast-id", "onCloseToast"]))
    ], 10, jk),
    l.closeButton ? (f(), L(n, {
      key: 1,
      component: l.closeButton,
      "class-names": l.closeButtonClassName,
      "show-on-hover": l.showCloseButtonOnHover,
      "aria-label": l.accessibility.closeButtonLabel,
      onClick: K5(l.closeToast, ["stop"])
    }, null, 8, ["component", "class-names", "show-on-hover", "aria-label", "onClick"])) : C("v-if", !0),
    l.timeout ? (f(), L(o, {
      key: 2,
      "is-running": l.isRunning,
      "hide-progress-bar": l.hideProgressBar,
      timeout: l.timeout,
      onCloseToast: l.timeoutHandler
    }, null, 8, ["is-running", "hide-progress-bar", "timeout", "onCloseToast"])) : C("v-if", !0)
  ], 38);
}
xl.render = Gk;
var Wk = xl, Dl = R({
  name: "VtTransition",
  props: O5.TRANSITION,
  emits: ["leave"],
  methods: {
    hasProp: S5,
    leave(l) {
      l instanceof HTMLElement && (l.style.left = l.offsetLeft + "px", l.style.top = l.offsetTop + "px", l.style.width = getComputedStyle(l).width, l.style.position = "absolute");
    }
  }
});
function Kk(l, e) {
  return f(), L(Jl, {
    tag: "div",
    "enter-active-class": l.transition.enter ? l.transition.enter : `${l.transition}-enter-active`,
    "move-class": l.transition.move ? l.transition.move : `${l.transition}-move`,
    "leave-active-class": l.transition.leave ? l.transition.leave : `${l.transition}-leave-active`,
    onLeave: l.leave
  }, {
    default: w(() => [
      p(l.$slots, "default")
    ]),
    _: 3
  }, 8, ["enter-active-class", "move-class", "leave-active-class", "onLeave"]);
}
Dl.render = Kk;
var Xk = Dl, El = R({
  name: "VueToastification",
  devtools: {
    hide: !0
  },
  components: { Toast: Wk, VtTransition: Xk },
  props: Object.assign({}, O5.CORE_TOAST, O5.CONTAINER, O5.TRANSITION),
  data() {
    return {
      count: 0,
      positions: Object.values(M1),
      toasts: {},
      defaults: {}
    };
  },
  computed: {
    toastArray() {
      return Object.values(this.toasts);
    },
    filteredToasts() {
      return this.defaults.filterToasts(this.toastArray);
    }
  },
  beforeMount() {
    const l = this.eventBus;
    l.on(g5.ADD, this.addToast), l.on(g5.CLEAR, this.clearToasts), l.on(g5.DISMISS, this.dismissToast), l.on(g5.UPDATE, this.updateToast), l.on(g5.UPDATE_DEFAULTS, this.updateDefaults), this.defaults = this.$props;
  },
  mounted() {
    this.setup(this.container);
  },
  methods: {
    async setup(l) {
      a0(l) && (l = await l()), pk(this.$el), l.appendChild(this.$el);
    },
    setToast(l) {
      Z5(l.id) || (this.toasts[l.id] = l);
    },
    addToast(l) {
      l.content = hk(l.content);
      const e = Object.assign({}, this.defaults, l.type && this.defaults.toastDefaults && this.defaults.toastDefaults[l.type], l), t = this.defaults.filterBeforeCreate(e, this.toastArray);
      t && this.setToast(t);
    },
    dismissToast(l) {
      const e = this.toasts[l];
      !Z5(e) && !Z5(e.onClose) && e.onClose(), delete this.toasts[l];
    },
    clearToasts() {
      Object.keys(this.toasts).forEach((l) => {
        this.dismissToast(l);
      });
    },
    getPositionToasts(l) {
      const e = this.filteredToasts.filter((t) => t.position === l).slice(0, this.defaults.maxToasts);
      return this.defaults.newestOnTop ? e.reverse() : e;
    },
    updateDefaults(l) {
      Z5(l.container) || this.setup(l.container), this.defaults = Object.assign({}, this.defaults, l);
    },
    updateToast({
      id: l,
      options: e,
      create: t
    }) {
      this.toasts[l] ? (e.timeout && e.timeout === this.toasts[l].timeout && e.timeout++, this.setToast(Object.assign({}, this.toasts[l], e))) : t && this.addToast(Object.assign({}, { id: l }, e));
    },
    getClasses(l) {
      return [`${k5}__container`, l].concat(this.defaults.containerClassName);
    }
  }
});
function Jk(l, e) {
  const t = h1("Toast"), n = h1("VtTransition");
  return f(), M("div", null, [
    (f(!0), M(o5, null, c5(l.positions, (o) => (f(), M("div", { key: o }, [
      W(n, {
        transition: l.defaults.transition,
        class: J(l.getClasses(o))
      }, {
        default: w(() => [
          (f(!0), M(o5, null, c5(l.getPositionToasts(o), (r) => (f(), L(t, Q({
            key: r.id
          }, r), null, 16))), 128))
        ]),
        _: 2
      }, 1032, ["transition", "class"])
    ]))), 128))
  ]);
}
El.render = Jk;
var Yk = El, M7 = (l = {}, e = !0) => {
  const t = l.eventBus = l.eventBus || new Xe();
  e && _5(() => {
    const r = Wl(Yk, Ml({}, l)), s = r.mount(document.createElement("div")), c = l.onMounted;
    if (Z5(c) || c(s, r), l.shareAppContext) {
      const u = l.shareAppContext;
      u === !0 ? console.warn(`[${k5}] App to share context with was not provided.`) : (r._context.components = u._context.components, r._context.directives = u._context.directives, r._context.mixins = u._context.mixins, r._context.provides = u._context.provides, r.config.globalProperties = u.config.globalProperties);
    }
  });
  const n = (r, s) => {
    const c = Object.assign({}, { id: vk(), type: p5.DEFAULT }, s, {
      content: r
    });
    return t.emit(g5.ADD, c), c.id;
  };
  n.clear = () => t.emit(g5.CLEAR, void 0), n.updateDefaults = (r) => {
    t.emit(g5.UPDATE_DEFAULTS, r);
  }, n.dismiss = (r) => {
    t.emit(g5.DISMISS, r);
  };
  function o(r, { content: s, options: c }, u = !1) {
    const v = Object.assign({}, c, { content: s });
    t.emit(g5.UPDATE, {
      id: r,
      options: v,
      create: u
    });
  }
  return n.update = o, n.success = (r, s) => n(r, Object.assign({}, s, { type: p5.SUCCESS })), n.info = (r, s) => n(r, Object.assign({}, s, { type: p5.INFO })), n.error = (r, s) => n(r, Object.assign({}, s, { type: p5.ERROR })), n.warning = (r, s) => n(r, Object.assign({}, s, { type: p5.WARNING })), n;
}, Qk = () => {
  const l = () => console.warn(`[${k5}] This plugin does not support SSR!`);
  return new Proxy(l, {
    get() {
      return l;
    }
  });
};
function Rl(l) {
  return mk() ? fk(l) ? M7({ eventBus: l }, !1) : M7(l, !0) : Qk();
}
var Ol = Symbol("VueToastification"), Nl = new Xe(), eB = (l, e) => {
  (e == null ? void 0 : e.shareAppContext) === !0 && (e.shareAppContext = l);
  const t = Rl(Ml({
    eventBus: Nl
  }, e));
  l.provide(Ol, t);
}, lB = (l) => {
  const e = F1() ? H7(Ol, void 0) : void 0;
  return e || Rl(Nl);
}, IB = eB;
const w5 = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info"
}, tB = {
  [w5.success]: "check",
  [w5.error]: "warning-triangle",
  [w5.warning]: "warning-circle",
  [w5.info]: "info-empty"
}, aB = {
  [w5.success]: p5.SUCCESS,
  [w5.error]: p5.ERROR,
  [w5.warning]: p5.WARNING,
  [w5.info]: p5.INFO
}, qB = (l = {}) => {
  const e = lB(), t = (c, u = {}) => {
    const { type: v = w5.info, ...h } = { ...l, ...u };
    return e(c, {
      position: M1.BOTTOM_CENTER,
      timeout: 4e3,
      type: aB[v],
      closeOnClick: !1,
      icon: u1(a5, { name: tB[v] }),
      closeButton: u1(a5, { name: "cancel" }),
      ...h
    });
  };
  return {
    open: t,
    success: (c, u = {}) => t(c, { ...u, type: w5.success }),
    error: (c, u = {}) => t(c, { ...u, type: w5.error }),
    warning: (c, u = {}) => t(c, { ...u, type: w5.warning }),
    info: (c, u = {}) => t(c, { ...u, type: w5.info })
  };
};
export {
  l2 as TOTEM_BADGE_LIMIT,
  qA as TotemAutoComplete,
  GV as TotemBadge,
  r2 as TotemButton,
  N5 as TotemButtonIcon,
  oB as TotemCard,
  Ee as TotemCheckbox,
  n2 as TotemChip,
  X7 as TotemChipList,
  C1 as TotemClickableElement,
  G1 as TotemDivider,
  ke as TotemDropdown,
  rB as TotemErrorPageAccessDenied,
  sB as TotemErrorPageDefault,
  iB as TotemErrorPageNotFound,
  l1 as TotemFormElement,
  cB as TotemFormElementAutoComplete,
  vB as TotemFormElementFile,
  hB as TotemFormElementRadioList,
  mB as TotemFormElementSelect,
  fB as TotemFormElementText,
  gB as TotemFormElementTextarea,
  wB as TotemFormElementToggle,
  a5 as TotemIcon,
  jV as TotemIconMap,
  H1 as TotemInput,
  Oe as TotemLayoutErrorPage,
  b$ as TotemLayoutHeader,
  bB as TotemLink,
  IA as TotemList,
  xe as TotemLoader,
  MB as TotemMessage,
  yB as TotemModal,
  TH as TotemModalOverlay,
  VB as TotemProgressBar,
  _C as TotemRadio,
  DC as TotemRadioButton,
  RC as TotemRadioList,
  $e as TotemRadioTypeMap,
  AB as TotemSection,
  KC as TotemSelect,
  lH as TotemSelectMultiple,
  jH as TotemTab,
  CB as TotemTabList,
  $B as TotemTable,
  XA as TotemTag,
  K7 as TotemTeleport,
  HB as TotemTeleportDestination,
  aH as TotemTextarea,
  IB as TotemToastPlugin,
  w5 as TotemToastTypeMap,
  fl as TotemToggle,
  cl as TotemTooltip,
  LB as buttonTypes,
  cA as isTotemTeleportDestinationMounted,
  _B as linkTargets,
  zB as totemButtonColorCodes,
  kB as totemButtonSizeCodes,
  BB as totemChipColorCodes,
  TB as totemClickableElementTags,
  SB as totemFormColorCodes,
  xB as totemLinkSizeCodes,
  DB as totemMessageColorCodes,
  RB as totemModalSizeCodes,
  pB as totemRadioTypeCodes,
  OB as totemSectionTypeCodes,
  NB as totemTagColorCodes,
  W7 as totemTeleportDestinationInstance,
  De as totemTeleportOptions,
  uB as totemTooltipMaxSizeCodes,
  dB as totemTooltipSideCodes,
  EB as useTotemModal,
  Ue as useTotemRotation,
  qB as useTotemToast,
  cC as useTotemTooltip
};
//# sourceMappingURL=totem-vue.es.js.map
